// GENERATED by `npm run buildings:compile` from packages/shared/src/buildings/*.ts. Do not edit by hand.
// catalogue 2dfa3b89
import type { KindManifest } from './schema';

/** One more than the highest kind code (family code) in the catalogue. */
export const CATALOGUE_KIND_COUNT = 16;
/** One more than the highest kind id; the per-kind tables have this many rows. */
export const CATALOGUE_KIND_ID_COUNT = 233;
/** Names by kind id (base kinds' ids equal their codes). */
export const CATALOGUE_KIND_NAMES: string[] = ["","residential","commercial","industrial","office","police station","fire station","hospital","builders' yard","parking lot","park","cinema","theatre","sports hall","library","airport terminal","bus depot","bus stop","rail halt","rail station","freight yard","motorway connection","metro entrance","metro station","jetty","marina","fishing harbour","ferry pier","cargo port","","","","","","","","","","","","GP surgery","health centre","walk-in centre","community hospital","general hospital","teaching hospital","police box","neighbourhood police post","divisional police station","police headquarters","fire post","large fire station","fire and rescue headquarters","handyman's workshop","builders' depot","construction company","kerbside bays","multi-storey car park","park and ride","lakeside park","botanical garden","café cinema","multiplex","studio theatre","opera house","leisure centre","arena","stadium","central library","museum","terrace row","mid-rise apartments","perimeter block","residential tower","tower estate","high-street parade","department store","shopping centre","hotel tower","business centre","office tower","corporate headquarters","workshop row","distribution centre","factory complex","heavy plant","deep-plot house","deep-plot shop","deep-plot office","deep-plot works","communal garden","the Gherkin","the Shard","the Walkie Talkie","One Canada Square","the Royal Opera House","the Houses of Parliament","the London Eye","the Tower of London","Buckingham Palace","Tower Bridge","nursery","primary school","secondary school","sixth-form college","further-education college","university campus","research institute","halls of residence","","","University College London","Imperial College London","King's College London","London School of Economics","","Piccadilly Circus","big screens corner","","","pioneer camp","the Empire State Building","the Chrysler Building","the Statue of Liberty","One World Trade Center","the Brooklyn Bridge","the Flatiron Building","Rockefeller Center","Radio City Music Hall","","local TV studio","broadcast centre","media centre","the Eiffel Tower","the Arc de Triomphe","Notre-Dame","the Louvre","the Opéra Garnier","the Sacré-Cœur","","","the Colosseum","St Peter's Basilica","the Pantheon","the Trevi Fountain","the Altare della Patria","Castel Sant'Angelo","","","","funeral director","churchyard","municipal cemetery","garden cemetery","crematorium","the Great Pyramid of Giza","the Sphinx","the Pyramid of Khafre","the Cairo Tower","the Sultan Hassan Mosque","substation","grid supply point","power depot","gas power station","coal power station","wind turbine","solar farm","the Burj Khalifa","the Burj Al Arab","the Dubai Frame","the Museum of the Future","the Jumeirah Mosque","the Oriental Pearl Tower","the Shanghai Tower","the Jin Mao Tower","the Shanghai World Financial Center","the Yu Garden","the Forbidden City","the Temple of Heaven","the Great Wall","Tiananmen Gate","the CCTV Headquarters","the Summer Palace","Christ the Redeemer","Sugarloaf Mountain","the Metropolitan Cathedral","the Maracana","the Sambadrome","the Opera House","the Harbour Bridge","Sydney Tower","St Mary's Cathedral","the Golden Gate Bridge","the Transamerica Pyramid","Coit Tower","the Ferry Building","Alcatraz","the Sagrada Familia","Casa Batllo","Camp Nou","Torre Glories","the Petronas Towers","the KL Tower","Merdeka 118","the Batu Caves","the CN Tower","Casa Loma","the Royal Ontario Museum","Old City Hall","the Space Needle","Pike Place Market","the Columbia Center","the Smith Tower","the Taj Mahal","the Agra Fort","Fatehpur Sikri","the Itimad-ud-Daulah","","","","","","","","","","","","","","landmark template","the town hall clock tower","the war memorial"];
/** Kind id by catalogue string id, for code that means one exact kind. */
export const KIND_ID = {"residential":1,"commercial":2,"industrial":3,"office":4,"police":5,"fire":6,"hospital":7,"yard":8,"parking":9,"park":10,"cinema":11,"theatre":12,"sports":13,"library":14,"airport":15,"bus-depot":16,"bus-stop":17,"rail-halt":18,"rail-station":19,"freight-yard":20,"motorway":21,"metro-entrance":22,"metro-station":23,"jetty":24,"marina":25,"fishing-harbour":26,"ferry-pier":27,"cargo-port":28,"gp-surgery":40,"health-centre":41,"walk-in-centre":42,"community-hospital":43,"general-hospital":44,"teaching-hospital":45,"police-box":46,"police-post":47,"divisional-station":48,"police-hq":49,"fire-post":50,"large-fire-station":51,"fire-hq":52,"handyman":53,"builders-depot":54,"construction-company":55,"kerbside-bays":56,"multi-storey":57,"park-and-ride":58,"lakeside-park":59,"botanical-garden":60,"cafe-cinema":61,"multiplex":62,"studio-theatre":63,"opera-house":64,"leisure-centre":65,"arena":66,"stadium":67,"central-library":68,"museum":69,"res-terrace":70,"res-midrise":71,"res-block":72,"res-tower":73,"res-estate":74,"com-parade":75,"com-store":76,"com-centre":77,"com-hotel":78,"off-centre":79,"off-tower":80,"off-hq":81,"ind-row":82,"ind-depot":83,"ind-works":84,"ind-plant":85,"res-deep":86,"com-deep":87,"off-deep":88,"ind-deep":89,"block-garden":90,"gherkin":91,"shard":92,"walkie-talkie":93,"one-canada-square":94,"royal-opera-house":95,"parliament":96,"london-eye":97,"tower-of-london":98,"buckingham-palace":99,"tower-bridge":100,"nursery":101,"primary-school":102,"secondary-school":103,"sixth-form":104,"fe-college":105,"university":106,"research-institute":107,"halls":108,"ucl":111,"imperial":112,"kings":113,"lse":114,"piccadilly-circus":116,"big-screens":117,"camp":120,"empire-state":121,"chrysler":122,"statue-of-liberty":123,"one-world-trade-center":124,"brooklyn-bridge":125,"flatiron":126,"rockefeller-center":127,"radio-city":128,"tv-studio":130,"broadcast-centre":131,"media-centre":132,"eiffel-tower":133,"arc-de-triomphe":134,"notre-dame":135,"louvre":136,"opera-garnier":137,"sacre-coeur":138,"colosseum":141,"st-peters":142,"pantheon":143,"trevi-fountain":144,"altare-della-patria":145,"castel-sant-angelo":146,"funeral-director":150,"churchyard":151,"municipal-cemetery":152,"garden-cemetery":153,"crematorium":154,"great-pyramid":155,"sphinx":156,"pyramid-of-khafre":157,"cairo-tower":158,"sultan-hassan":159,"substation":160,"grid-supply-point":161,"power-depot":162,"gas-plant":163,"coal-plant":164,"wind-turbine":165,"solar-farm":166,"burj-khalifa":167,"burj-al-arab":168,"dubai-frame":169,"museum-of-the-future":170,"jumeirah-mosque":171,"oriental-pearl":172,"shanghai-tower":173,"jin-mao":174,"swfc":175,"yu-garden":176,"forbidden-city":177,"temple-of-heaven":178,"great-wall":179,"tiananmen-gate":180,"cctv-tower":181,"summer-palace":182,"christ-the-redeemer":183,"sugarloaf":184,"rio-cathedral":185,"maracana":186,"sambadrome":187,"sydney-opera-house":188,"harbour-bridge":189,"sydney-tower":190,"st-marys-cathedral":191,"golden-gate":192,"transamerica-pyramid":193,"coit-tower":194,"ferry-building":195,"alcatraz":196,"sagrada-familia":197,"casa-batllo":198,"camp-nou":199,"torre-glories":200,"petronas-towers":201,"kl-tower":202,"merdeka-118":203,"batu-caves":204,"cn-tower":205,"casa-loma":206,"royal-ontario-museum":207,"old-city-hall":208,"space-needle":209,"pike-place":210,"columbia-center":211,"smith-tower":212,"taj-mahal":213,"agra-fort":214,"fatehpur-sikri":215,"itimad-ud-daulah":216,"landmark-template":230,"town-clock-tower":231,"war-memorial":232} as const;

// Tables below are indexed by kind id * 8 + level, one row per kind id 0-232 (ids 0-15 are the base kinds, id = code).
// Level 0 is an empty lot or a civic site; levels below a kind's first level repeat the first (merged zone kinds start higher), levels past its top level repeat the top level.
/** residents or jobs */
export const CAPACITY_TABLE = new Int16Array([
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 4, 8, 12, 12, 12, 12, 12,
  0, 3, 6, 9, 9, 9, 9, 9,
  0, 6, 12, 18, 18, 18, 18, 18,
  0, 8, 16, 24, 24, 24, 24, 24,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 9, 9, 9, 9, 9, 9, 9,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 5, 5, 5, 5, 5, 5, 5,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 28, 28, 28, 28, 28, 28, 28,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 26, 26, 26, 26, 26, 26, 26,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 18, 18, 18, 18, 18, 18, 18,
  0, 36, 36, 36, 36, 36, 36, 36,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 28, 28, 28, 28, 28, 28, 28,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 18, 18, 18, 18, 18, 18, 18,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 5, 5, 5, 5, 5, 5, 5,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 18, 18, 26, 26, 26, 26, 26,
  0, 64, 64, 64, 64, 64, 64, 64,
  0, 114, 114, 114, 114, 114, 114, 114,
  0, 96, 96, 96, 96, 96, 96, 120,
  0, 216, 216, 216, 216, 216, 216, 270,
  0, 14, 14, 20, 20, 20, 20, 20,
  0, 44, 44, 44, 44, 52, 52, 52,
  0, 100, 100, 100, 100, 100, 120, 120,
  0, 60, 60, 60, 60, 60, 60, 72,
  0, 36, 36, 52, 52, 52, 52, 52,
  0, 112, 112, 112, 112, 136, 136, 136,
  0, 310, 310, 310, 310, 310, 310, 360,
  0, 26, 26, 38, 38, 38, 38, 38,
  0, 76, 76, 76, 92, 92, 92, 92,
  0, 210, 210, 210, 210, 210, 210, 210,
  0, 380, 380, 380, 380, 380, 380, 420,
  0, 18, 18, 26, 32, 32, 32, 32,
  0, 14, 14, 20, 22, 22, 22, 22,
  0, 36, 36, 52, 56, 56, 56, 56,
  0, 26, 26, 38, 46, 46, 46, 46,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 240, 240, 240, 240, 240, 240, 240,
  0, 420, 420, 420, 420, 420, 420, 420,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 380, 380, 380, 380, 380, 380, 380,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 260, 260, 260, 260, 260, 260, 260,
  0, 36, 36, 36, 36, 36, 36, 36,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 18, 18, 18, 18, 18, 18, 18,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 36, 36, 36, 36, 36, 36, 36,
  0, 32, 32, 32, 32, 32, 32, 32,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 400, 400, 400, 400, 400, 400, 400,
  0, 320, 320, 320, 320, 320, 320, 320,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 380, 380, 380, 380, 380, 380, 380,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 240, 240, 240, 240, 240, 240, 240,
  0, 320, 320, 320, 320, 320, 320, 320,
  0, 35, 35, 35, 35, 35, 35, 35,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 45, 45, 45, 45, 45, 45, 45,
  0, 26, 26, 26, 26, 26, 26, 26,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 48, 48, 48, 48, 48, 48, 48,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 18, 18, 18, 18, 18, 18, 18,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 450, 450, 450, 450, 450, 450, 450,
  0, 340, 340, 340, 340, 340, 340, 340,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 32, 32, 32, 32, 32, 32, 32,
  0, 450, 450, 450, 450, 450, 450, 450,
  0, 360, 360, 360, 360, 360, 360, 360,
  0, 320, 320, 320, 320, 320, 320, 320,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 340, 340, 340, 340, 340, 340, 340,
  0, 28, 28, 28, 28, 28, 28, 28,
  0, 36, 36, 36, 36, 36, 36, 36,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 45, 45, 45, 45, 45, 45, 45,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 22, 22, 22, 22, 22, 22, 22,
  0, 26, 26, 26, 26, 26, 26, 26,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 260, 260, 260, 260, 260, 260, 260,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 52, 52, 52, 52, 52, 52, 52,
  0, 18, 18, 18, 18, 18, 18, 18,
  0, 65, 65, 65, 65, 65, 65, 65,
  0, 260, 260, 260, 260, 260, 260, 260,
  0, 520, 520, 520, 520, 520, 520, 520,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 560, 560, 560, 560, 560, 560, 560,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 320, 320, 320, 320, 320, 320, 320,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 340, 340, 340, 340, 340, 340, 340,
  0, 280, 280, 280, 280, 280, 280, 280,
  0, 28, 28, 28, 28, 28, 28, 28,
  0, 460, 460, 460, 460, 460, 460, 460,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 34, 34, 34, 34, 34, 34, 34,
  0, 22, 22, 22, 22, 22, 22, 22,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 2, 2, 2, 2, 2, 2, 2,
]);
/** pay per standard 8-hour shift */
export const WAGE_TABLE = new Float32Array([
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  10, 15, 20, 25, 25, 25, 25, 25,
  9, 14, 19, 24, 24, 24, 24, 24,
  14, 20, 26, 32, 32, 32, 32, 32,
  20, 20, 20, 20, 20, 20, 20, 20,
  20, 20, 20, 20, 20, 20, 20, 20,
  26, 26, 26, 26, 26, 26, 26, 26,
  16, 16, 16, 16, 16, 16, 16, 16,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  14, 14, 14, 14, 14, 14, 14, 14,
  18, 18, 18, 18, 18, 18, 18, 18,
  14, 14, 14, 14, 14, 14, 14, 14,
  16, 16, 16, 16, 16, 16, 16, 16,
  22, 22, 22, 22, 22, 22, 22, 22,
  19, 19, 19, 19, 19, 19, 19, 19,
  0, 0, 0, 0, 0, 0, 0, 0,
  18, 18, 18, 18, 18, 18, 18, 18,
  20, 20, 20, 20, 20, 20, 20, 20,
  21, 21, 21, 21, 21, 21, 21, 21,
  0, 0, 0, 0, 0, 0, 0, 0,
  20, 20, 20, 20, 20, 20, 20, 20,
  20, 20, 20, 20, 20, 20, 20, 20,
  14, 14, 14, 14, 14, 14, 14, 14,
  16, 16, 16, 16, 16, 16, 16, 16,
  19, 19, 19, 19, 19, 19, 19, 19,
  16, 16, 16, 16, 16, 16, 16, 16,
  22, 22, 22, 22, 22, 22, 22, 22,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  24, 24, 24, 24, 24, 24, 24, 24,
  25, 25, 25, 25, 25, 25, 25, 25,
  25, 25, 25, 25, 25, 25, 25, 25,
  27, 27, 27, 27, 27, 27, 27, 27,
  28, 28, 28, 28, 28, 28, 28, 28,
  30, 30, 30, 30, 30, 30, 30, 30,
  20, 20, 20, 20, 20, 20, 20, 20,
  20, 20, 20, 20, 20, 20, 20, 20,
  21, 21, 21, 21, 21, 21, 21, 21,
  22, 22, 22, 22, 22, 22, 22, 22,
  20, 20, 20, 20, 20, 20, 20, 20,
  21, 21, 21, 21, 21, 21, 21, 21,
  22, 22, 22, 22, 22, 22, 22, 22,
  15, 15, 15, 15, 15, 15, 15, 15,
  17, 17, 17, 17, 17, 17, 17, 17,
  18, 18, 18, 18, 18, 18, 18, 18,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  13, 13, 13, 13, 13, 13, 13, 13,
  14, 14, 14, 14, 14, 14, 14, 14,
  17, 17, 17, 17, 17, 17, 17, 17,
  20, 20, 20, 20, 20, 20, 20, 20,
  14, 14, 14, 14, 14, 14, 14, 14,
  15, 15, 15, 15, 15, 15, 15, 15,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  17, 17, 17, 17, 17, 17, 17, 17,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  10, 20, 20, 25, 25, 25, 25, 25,
  10, 27, 27, 27, 27, 29, 29, 29,
  10, 27, 27, 27, 27, 27, 29, 29,
  10, 30, 30, 30, 30, 30, 30, 32,
  14, 26, 26, 32, 32, 32, 32, 32,
  14, 36, 36, 36, 36, 38, 38, 38,
  14, 40, 40, 40, 40, 40, 40, 44,
  9, 19, 19, 24, 24, 24, 24, 24,
  9, 24, 24, 24, 27, 27, 27, 27,
  9, 28, 28, 28, 28, 28, 28, 28,
  9, 30, 30, 30, 30, 30, 30, 32,
  0, 0, 0, 0, 0, 0, 0, 0,
  10, 20, 20, 25, 27, 27, 27, 27,
  14, 26, 26, 32, 36, 36, 36, 36,
  9, 19, 19, 24, 27, 27, 27, 27,
  0, 0, 0, 0, 0, 0, 0, 0,
  14, 44, 44, 44, 44, 44, 44, 44,
  14, 46, 46, 46, 46, 46, 46, 46,
  14, 44, 44, 44, 44, 44, 44, 44,
  14, 46, 46, 46, 46, 46, 46, 46,
  21, 21, 21, 21, 21, 21, 21, 21,
  16, 30, 30, 30, 30, 30, 30, 30,
  16, 16, 16, 16, 16, 16, 16, 16,
  17, 17, 17, 17, 17, 17, 17, 17,
  18, 18, 18, 18, 18, 18, 18, 18,
  16, 16, 16, 16, 16, 16, 16, 16,
  24, 24, 24, 24, 24, 24, 24, 24,
  25, 25, 25, 25, 25, 25, 25, 25,
  26, 26, 26, 26, 26, 26, 26, 26,
  26, 26, 26, 26, 26, 26, 26, 26,
  26, 26, 26, 26, 26, 26, 26, 26,
  28, 28, 28, 28, 28, 28, 28, 28,
  32, 32, 32, 32, 32, 32, 32, 32,
  18, 18, 18, 18, 18, 18, 18, 18,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  28, 28, 28, 28, 28, 28, 28, 28,
  28, 28, 28, 28, 28, 28, 28, 28,
  28, 28, 28, 28, 28, 28, 28, 28,
  28, 28, 28, 28, 28, 28, 28, 28,
  0, 0, 0, 0, 0, 0, 0, 0,
  17, 17, 17, 17, 17, 17, 17, 17,
  15, 15, 15, 15, 15, 15, 15, 15,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  14, 46, 46, 46, 46, 46, 46, 46,
  14, 44, 44, 44, 44, 44, 44, 44,
  17, 17, 17, 17, 17, 17, 17, 17,
  14, 46, 46, 46, 46, 46, 46, 46,
  16, 16, 16, 16, 16, 16, 16, 16,
  14, 44, 44, 44, 44, 44, 44, 44,
  14, 46, 46, 46, 46, 46, 46, 46,
  19, 19, 19, 19, 19, 19, 19, 19,
  0, 0, 0, 0, 0, 0, 0, 0,
  14, 22, 22, 22, 22, 22, 22, 22,
  14, 26, 26, 26, 26, 26, 26, 26,
  14, 30, 30, 30, 30, 30, 30, 30,
  18, 18, 18, 18, 18, 18, 18, 18,
  16, 16, 16, 16, 16, 16, 16, 16,
  15, 15, 15, 15, 15, 15, 15, 15,
  19, 19, 19, 19, 19, 19, 19, 19,
  20, 20, 20, 20, 20, 20, 20, 20,
  15, 15, 15, 15, 15, 15, 15, 15,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  17, 17, 17, 17, 17, 17, 17, 17,
  16, 16, 16, 16, 16, 16, 16, 16,
  14, 14, 14, 14, 14, 14, 14, 14,
  14, 14, 14, 14, 14, 14, 14, 14,
  15, 15, 15, 15, 15, 15, 15, 15,
  15, 15, 15, 15, 15, 15, 15, 15,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  14, 18, 18, 18, 18, 18, 18, 18,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 45, 45, 45, 45, 45, 45, 45,
  16, 17, 17, 17, 17, 17, 17, 17,
  18, 20, 20, 20, 20, 20, 20, 20,
  18, 22, 22, 22, 22, 22, 22, 22,
  18, 21, 21, 21, 21, 21, 21, 21,
  18, 24, 24, 24, 24, 24, 24, 24,
  18, 23, 23, 23, 23, 23, 23, 23,
  18, 20, 20, 20, 20, 20, 20, 20,
  18, 20, 20, 20, 20, 20, 20, 20,
  14, 48, 48, 48, 48, 48, 48, 48,
  14, 45, 45, 45, 45, 45, 45, 45,
  16, 16, 16, 16, 16, 16, 16, 16,
  17, 17, 17, 17, 17, 17, 17, 17,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  14, 48, 48, 48, 48, 48, 48, 48,
  14, 46, 46, 46, 46, 46, 46, 46,
  14, 45, 45, 45, 45, 45, 45, 45,
  16, 16, 16, 16, 16, 16, 16, 16,
  17, 17, 17, 17, 17, 17, 17, 17,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  14, 14, 14, 14, 14, 14, 14, 14,
  14, 44, 44, 44, 44, 44, 44, 44,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  14, 14, 14, 14, 14, 14, 14, 14,
  17, 17, 17, 17, 17, 17, 17, 17,
  18, 18, 18, 18, 18, 18, 18, 18,
  20, 20, 20, 20, 20, 20, 20, 20,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  14, 14, 14, 14, 14, 14, 14, 14,
  16, 16, 16, 16, 16, 16, 16, 16,
  14, 42, 42, 42, 42, 42, 42, 42,
  14, 14, 14, 14, 14, 14, 14, 14,
  15, 15, 15, 15, 15, 15, 15, 15,
  16, 16, 16, 16, 16, 16, 16, 16,
  17, 17, 17, 17, 17, 17, 17, 17,
  16, 16, 16, 16, 16, 16, 16, 16,
  17, 17, 17, 17, 17, 17, 17, 17,
  14, 42, 42, 42, 42, 42, 42, 42,
  14, 46, 46, 46, 46, 46, 46, 46,
  14, 44, 44, 44, 44, 44, 44, 44,
  14, 48, 48, 48, 48, 48, 48, 48,
  15, 15, 15, 15, 15, 15, 15, 15,
  14, 45, 45, 45, 45, 45, 45, 45,
  16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16,
  14, 44, 44, 44, 44, 44, 44, 44,
  14, 44, 44, 44, 44, 44, 44, 44,
  15, 15, 15, 15, 15, 15, 15, 15,
  14, 47, 47, 47, 47, 47, 47, 47,
  14, 43, 43, 43, 43, 43, 43, 43,
  17, 17, 17, 17, 17, 17, 17, 17,
  16, 16, 16, 16, 16, 16, 16, 16,
  15, 15, 15, 15, 15, 15, 15, 15,
  15, 15, 15, 15, 15, 15, 15, 15,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  14, 20, 20, 20, 20, 20, 20, 20,
  14, 22, 22, 22, 22, 22, 22, 22,
  16, 16, 16, 16, 16, 16, 16, 16,
]);
/** daily upkeep paid by the parcel owner */
export const UPKEEP_TABLE = new Float32Array([
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 15, 15, 15, 15, 15, 15, 15,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 3, 5, 8, 8, 8, 8, 8,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 140, 140, 140, 140, 140, 140, 140,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 200, 200, 200, 200, 200, 200, 200,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 26, 26, 26, 26, 26, 26, 26,
  0, 36, 36, 36, 36, 36, 36, 36,
  0, 75, 75, 75, 75, 75, 75, 75,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 180, 180, 180, 180, 180, 180, 180,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 11, 11, 11, 11, 11, 11, 11,
  0, 42, 42, 42, 42, 42, 42, 42,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 9, 9, 9, 9, 9, 9, 9,
  0, 36, 36, 36, 36, 36, 36, 36,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 5, 5, 5, 5, 5, 5, 5,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 18, 18, 18, 18, 18, 18, 18,
  0, 22, 22, 22, 22, 22, 22, 22,
  0, 18, 18, 18, 18, 18, 18, 18,
  0, 34, 34, 34, 34, 34, 34, 34,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 26, 26, 26, 26, 26, 26, 26,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 22, 22, 22, 22, 22, 22, 22,
  0, 36, 36, 36, 36, 36, 36, 36,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 110, 110, 110, 110, 110, 110, 110,
  0, 130, 130, 130, 130, 130, 130, 130,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 110, 110, 110, 110, 110, 110, 110,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 180, 180, 180, 180, 180, 180, 180,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 25, 25, 25, 25, 25, 25, 25,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 110, 110, 110, 110, 110, 110, 110,
  0, 105, 105, 105, 105, 105, 105, 105,
  0, 100, 100, 100, 100, 100, 100, 100,
  0, 95, 95, 95, 95, 95, 95, 95,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 45, 45, 45, 45, 45, 45, 45,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 140, 140, 140, 140, 140, 140, 140,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 140, 140, 140, 140, 140, 140, 140,
  0, 65, 65, 65, 65, 65, 65, 65,
  0, 95, 95, 95, 95, 95, 95, 95,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 95, 95, 95, 95, 95, 95, 95,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 35, 35, 35, 35, 35, 35, 35,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 200, 200, 200, 200, 200, 200, 200,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 85, 85, 85, 85, 85, 85, 85,
  0, 100, 100, 100, 100, 100, 100, 100,
  0, 45, 45, 45, 45, 45, 45, 45,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 65, 65, 65, 65, 65, 65, 65,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 35, 35, 35, 35, 35, 35, 35,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 35, 35, 35, 35, 35, 35, 35,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 22, 22, 22, 22, 22, 22, 22,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 15, 15, 15, 15, 15, 15, 15,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 180, 180, 180, 180, 180, 180, 180,
  0, 250, 250, 250, 250, 250, 250, 250,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 15, 15, 15, 15, 15, 15, 15,
  0, 160, 160, 160, 160, 160, 160, 160,
  0, 130, 130, 130, 130, 130, 130, 130,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 160, 160, 160, 160, 160, 160, 160,
  0, 130, 130, 130, 130, 130, 130, 130,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 35, 35, 35, 35, 35, 35, 35,
  0, 130, 130, 130, 130, 130, 130, 130,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 100, 100, 100, 100, 100, 100, 100,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 35, 35, 35, 35, 35, 35, 35,
  0, 65, 65, 65, 65, 65, 65, 65,
  0, 110, 110, 110, 110, 110, 110, 110,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 45, 45, 45, 45, 45, 45, 45,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 85, 85, 85, 85, 85, 85, 85,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 160, 160, 160, 160, 160, 160, 160,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 130, 130, 130, 130, 130, 130, 130,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 110, 110, 110, 110, 110, 110, 110,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 140, 140, 140, 140, 140, 140, 140,
  0, 100, 100, 100, 100, 100, 100, 100,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 45, 45, 45, 45, 45, 45, 45,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 8, 8, 8, 8, 8, 8, 8,
]);
/** one-off placement price (0 for growable zones: they pay ZONE_COST per tile) */
export const COST_TABLE = new Float32Array([
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 400, 400, 400, 400, 400, 400, 400,
  0, 400, 400, 400, 400, 400, 400, 400,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 700, 700, 700, 700, 700, 700, 700,
  0, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 450, 450, 450, 450, 450, 450, 450,
  0, 6000, 6000, 6000, 6000, 6000, 6000, 6000,
  0, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 1500, 1500, 1500, 1500, 1500, 1500, 1500,
  0, 5000, 5000, 5000, 5000, 5000, 5000, 5000,
  0, 4000, 4000, 4000, 4000, 4000, 4000, 4000,
  0, 400, 400, 400, 400, 400, 400, 400,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 4000, 4000, 4000, 4000, 4000, 4000, 4000,
  0, 5000, 5000, 5000, 5000, 5000, 5000, 5000,
  0, 1500, 1500, 1500, 1500, 1500, 1500, 1500,
  0, 14000, 14000, 14000, 14000, 14000, 14000, 14000,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 350, 350, 350, 350, 350, 350, 350,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 800, 800, 800, 800, 800, 800, 800,
  0, 1800, 1800, 1800, 1800, 1800, 1800, 1800,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 5500, 5500, 5500, 5500, 5500, 5500, 5500,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 250, 250, 250, 250, 250, 250, 250,
  0, 1100, 1100, 1100, 1100, 1100, 1100, 1100,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 220, 220, 220, 220, 220, 220, 220,
  0, 1000, 1000, 1000, 1000, 1000, 1000, 1000,
  0, 2400, 2400, 2400, 2400, 2400, 2400, 2400,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 2200, 2200, 2200, 2200, 2200, 2200, 2200,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
  0, 1600, 1600, 1600, 1600, 1600, 1600, 1600,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 2200, 2200, 2200, 2200, 2200, 2200, 2200,
  0, 350, 350, 350, 350, 350, 350, 350,
  0, 1800, 1800, 1800, 1800, 1800, 1800, 1800,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 4800, 4800, 4800, 4800, 4800, 4800, 4800,
  0, 1500, 1500, 1500, 1500, 1500, 1500, 1500,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 6000, 6000, 6000, 6000, 6000, 6000, 6000,
  0, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
  0, 2400, 2400, 2400, 2400, 2400, 2400, 2400,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 16000, 16000, 16000, 16000, 16000, 16000, 16000,
  0, 30000, 30000, 30000, 30000, 30000, 30000, 30000,
  0, 20000, 20000, 20000, 20000, 20000, 20000, 20000,
  0, 26000, 26000, 26000, 26000, 26000, 26000, 26000,
  0, 9000, 9000, 9000, 9000, 9000, 9000, 9000,
  0, 24000, 24000, 24000, 24000, 24000, 24000, 24000,
  0, 14000, 14000, 14000, 14000, 14000, 14000, 14000,
  0, 12000, 12000, 12000, 12000, 12000, 12000, 12000,
  0, 20000, 20000, 20000, 20000, 20000, 20000, 20000,
  0, 16000, 16000, 16000, 16000, 16000, 16000, 16000,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 2000, 2000, 2000, 2000, 2000, 2000, 2000,
  0, 1400, 1400, 1400, 1400, 1400, 1400, 1400,
  0, 2400, 2400, 2400, 2400, 2400, 2400, 2400,
  0, 7000, 7000, 7000, 7000, 7000, 7000, 7000,
  0, 5000, 5000, 5000, 5000, 5000, 5000, 5000,
  0, 1500, 1500, 1500, 1500, 1500, 1500, 1500,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 9000, 9000, 9000, 9000, 9000, 9000, 9000,
  0, 8500, 8500, 8500, 8500, 8500, 8500, 8500,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 7500, 7500, 7500, 7500, 7500, 7500, 7500,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 12000, 12000, 12000, 12000, 12000, 12000, 12000,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 28000, 28000, 28000, 28000, 28000, 28000, 28000,
  0, 22000, 22000, 22000, 22000, 22000, 22000, 22000,
  0, 13000, 13000, 13000, 13000, 13000, 13000, 13000,
  0, 26000, 26000, 26000, 26000, 26000, 26000, 26000,
  0, 15000, 15000, 15000, 15000, 15000, 15000, 15000,
  0, 15000, 15000, 15000, 15000, 15000, 15000, 15000,
  0, 24000, 24000, 24000, 24000, 24000, 24000, 24000,
  0, 12000, 12000, 12000, 12000, 12000, 12000, 12000,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 7500, 7500, 7500, 7500, 7500, 7500, 7500,
  0, 16000, 16000, 16000, 16000, 16000, 16000, 16000,
  0, 11000, 11000, 11000, 11000, 11000, 11000, 11000,
  0, 12000, 12000, 12000, 12000, 12000, 12000, 12000,
  0, 20000, 20000, 20000, 20000, 20000, 20000, 20000,
  0, 14000, 14000, 14000, 14000, 14000, 14000, 14000,
  0, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 15000, 15000, 15000, 15000, 15000, 15000, 15000,
  0, 18000, 18000, 18000, 18000, 18000, 18000, 18000,
  0, 9000, 9000, 9000, 9000, 9000, 9000, 9000,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 9000, 9000, 9000, 9000, 9000, 9000, 9000,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 700, 700, 700, 700, 700, 700, 700,
  0, 1400, 1400, 1400, 1400, 1400, 1400, 1400,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 2200, 2200, 2200, 2200, 2200, 2200, 2200,
  0, 9000, 9000, 9000, 9000, 9000, 9000, 9000,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 9500, 9500, 9500, 9500, 9500, 9500, 9500,
  0, 18000, 18000, 18000, 18000, 18000, 18000, 18000,
  0, 13000, 13000, 13000, 13000, 13000, 13000, 13000,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 6000, 6000, 6000, 6000, 6000, 6000, 6000,
  0, 2500, 2500, 2500, 2500, 2500, 2500, 2500,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 15000, 15000, 15000, 15000, 15000, 15000, 15000,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 30000, 30000, 30000, 30000, 30000, 30000, 30000,
  0, 24000, 24000, 24000, 24000, 24000, 24000, 24000,
  0, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  0, 18000, 18000, 18000, 18000, 18000, 18000, 18000,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 15000, 15000, 15000, 15000, 15000, 15000, 15000,
  0, 30000, 30000, 30000, 30000, 30000, 30000, 30000,
  0, 24000, 24000, 24000, 24000, 24000, 24000, 24000,
  0, 22000, 22000, 22000, 22000, 22000, 22000, 22000,
  0, 14000, 14000, 14000, 14000, 14000, 14000, 14000,
  0, 16000, 16000, 16000, 16000, 16000, 16000, 16000,
  0, 12000, 12000, 12000, 12000, 12000, 12000, 12000,
  0, 11000, 11000, 11000, 11000, 11000, 11000, 11000,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 24000, 24000, 24000, 24000, 24000, 24000, 24000,
  0, 12000, 12000, 12000, 12000, 12000, 12000, 12000,
  0, 14000, 14000, 14000, 14000, 14000, 14000, 14000,
  0, 13000, 13000, 13000, 13000, 13000, 13000, 13000,
  0, 7000, 7000, 7000, 7000, 7000, 7000, 7000,
  0, 17000, 17000, 17000, 17000, 17000, 17000, 17000,
  0, 14000, 14000, 14000, 14000, 14000, 14000, 14000,
  0, 15000, 15000, 15000, 15000, 15000, 15000, 15000,
  0, 13000, 13000, 13000, 13000, 13000, 13000, 13000,
  0, 12000, 12000, 12000, 12000, 12000, 12000, 12000,
  0, 8000, 8000, 8000, 8000, 8000, 8000, 8000,
  0, 14000, 14000, 14000, 14000, 14000, 14000, 14000,
  0, 20000, 20000, 20000, 20000, 20000, 20000, 20000,
  0, 7000, 7000, 7000, 7000, 7000, 7000, 7000,
  0, 9000, 9000, 9000, 9000, 9000, 9000, 9000,
  0, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  0, 16000, 16000, 16000, 16000, 16000, 16000, 16000,
  0, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  0, 19000, 19000, 19000, 19000, 19000, 19000, 19000,
  0, 21000, 21000, 21000, 21000, 21000, 21000, 21000,
  0, 26000, 26000, 26000, 26000, 26000, 26000, 26000,
  0, 18000, 18000, 18000, 18000, 18000, 18000, 18000,
  0, 28000, 28000, 28000, 28000, 28000, 28000, 28000,
  0, 13000, 13000, 13000, 13000, 13000, 13000, 13000,
  0, 20000, 20000, 20000, 20000, 20000, 20000, 20000,
  0, 11000, 11000, 11000, 11000, 11000, 11000, 11000,
  0, 13000, 13000, 13000, 13000, 13000, 13000, 13000,
  0, 19000, 19000, 19000, 19000, 19000, 19000, 19000,
  0, 19000, 19000, 19000, 19000, 19000, 19000, 19000,
  0, 12000, 12000, 12000, 12000, 12000, 12000, 12000,
  0, 25000, 25000, 25000, 25000, 25000, 25000, 25000,
  0, 17000, 17000, 17000, 17000, 17000, 17000, 17000,
  0, 20000, 20000, 20000, 20000, 20000, 20000, 20000,
  0, 15000, 15000, 15000, 15000, 15000, 15000, 15000,
  0, 14000, 14000, 14000, 14000, 14000, 14000, 14000,
  0, 11000, 11000, 11000, 11000, 11000, 11000, 11000,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 4000, 4000, 4000, 4000, 4000, 4000, 4000,
  0, 800, 800, 800, 800, 800, 800, 800,
]);
/** builder work units to build the level */
export const WORK_TABLE = new Int16Array([
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 20, 120, 180, 180, 180, 180, 180,
  0, 60, 120, 180, 180, 180, 180, 180,
  0, 60, 120, 180, 180, 180, 180, 180,
  0, 60, 120, 180, 180, 180, 180, 180,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 200, 200, 200, 200, 200, 200, 200,
  0, 400, 400, 400, 400, 400, 400, 400,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 650, 650, 650, 650, 650, 650, 650,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 250, 250, 250, 250, 250, 250, 250,
  0, 1600, 1600, 1600, 1600, 1600, 1600, 1600,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 180, 180, 180, 180, 180, 180, 180,
  0, 400, 400, 400, 400, 400, 400, 400,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 1500, 1500, 1500, 1500, 1500, 1500, 1500,
  0, 2200, 2200, 2200, 2200, 2200, 2200, 2200,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 200, 200, 200, 200, 200, 200, 200,
  0, 700, 700, 700, 700, 700, 700, 700,
  0, 1300, 1300, 1300, 1300, 1300, 1300, 1300,
  0, 180, 180, 180, 180, 180, 180, 180,
  0, 650, 650, 650, 650, 650, 650, 650,
  0, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 800, 800, 800, 800, 800, 800, 800,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 1600, 1600, 1600, 1600, 1600, 1600, 1600,
  0, 200, 200, 200, 200, 200, 200, 200,
  0, 650, 650, 650, 650, 650, 650, 650,
  0, 200, 200, 200, 200, 200, 200, 200,
  0, 1300, 1300, 1300, 1300, 1300, 1300, 1300,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
  0, 2000, 2000, 2000, 2000, 2000, 2000, 2000,
  0, 600, 600, 600, 600, 600, 600, 600,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 144, 144, 216, 216, 216, 216, 216,
  0, 576, 576, 576, 576, 576, 576, 576,
  0, 1080, 1080, 1080, 1080, 1080, 1080, 1080,
  0, 864, 864, 864, 864, 864, 864, 1008,
  0, 1944, 1944, 1944, 1944, 1944, 1944, 2268,
  0, 144, 144, 216, 216, 216, 216, 216,
  0, 576, 576, 576, 576, 720, 720, 720,
  0, 1620, 1620, 1620, 1620, 1620, 1944, 1944,
  0, 864, 864, 864, 864, 864, 864, 1008,
  0, 144, 144, 216, 216, 216, 216, 216,
  0, 576, 576, 576, 576, 720, 720, 720,
  0, 1944, 1944, 1944, 1944, 1944, 1944, 2268,
  0, 144, 144, 216, 216, 216, 216, 216,
  0, 432, 432, 432, 576, 576, 576, 576,
  0, 1620, 1620, 1620, 1620, 1620, 1620, 1620,
  0, 3456, 3456, 3456, 3456, 3456, 3456, 4032,
  0, 144, 144, 216, 288, 288, 288, 288,
  0, 144, 144, 216, 288, 288, 288, 288,
  0, 144, 144, 216, 288, 288, 288, 288,
  0, 144, 144, 216, 288, 288, 288, 288,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 5200, 5200, 5200, 5200, 5200, 5200, 5200,
  0, 3600, 3600, 3600, 3600, 3600, 3600, 3600,
  0, 4600, 4600, 4600, 4600, 4600, 4600, 4600,
  0, 2200, 2200, 2200, 2200, 2200, 2200, 2200,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 3600, 3600, 3600, 3600, 3600, 3600, 3600,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 750, 750, 750, 750, 750, 750, 750,
  0, 1500, 1500, 1500, 1500, 1500, 1500, 1500,
  0, 750, 750, 750, 750, 750, 750, 750,
  0, 1050, 1050, 1050, 1050, 1050, 1050, 1050,
  0, 5550, 5550, 5550, 5550, 5550, 5550, 5550,
  0, 1500, 1500, 1500, 1500, 1500, 1500, 1500,
  0, 750, 750, 750, 750, 750, 750, 750,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 2700, 2700, 2700, 2700, 2700, 2700, 2700,
  0, 2500, 2500, 2500, 2500, 2500, 2500, 2500,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2400, 2400, 2400, 2400, 2400, 2400, 2400,
  0, 800, 800, 800, 800, 800, 800, 800,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 5000, 5000, 5000, 5000, 5000, 5000, 5000,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 4800, 4800, 4800, 4800, 4800, 4800, 4800,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 260, 260, 260, 260, 260, 260, 260,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 2000, 2000, 2000, 2000, 2000, 2000, 2000,
  0, 3400, 3400, 3400, 3400, 3400, 3400, 3400,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 2200, 2200, 2200, 2200, 2200, 2200, 2200,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 3600, 3600, 3600, 3600, 3600, 3600, 3600,
  0, 2000, 2000, 2000, 2000, 2000, 2000, 2000,
  0, 1600, 1600, 1600, 1600, 1600, 1600, 1600,
  0, 1800, 1800, 1800, 1800, 1800, 1800, 1800,
  0, 1600, 1600, 1600, 1600, 1600, 1600, 1600,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 360, 360, 360, 360, 360, 360, 360,
  0, 620, 620, 620, 620, 620, 620, 620,
  0, 1150, 1150, 1150, 1150, 1150, 1150, 1150,
  0, 560, 560, 560, 560, 560, 560, 560,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 180, 180, 180, 180, 180, 180, 180,
  0, 520, 520, 520, 520, 520, 520, 520,
  0, 340, 340, 340, 340, 340, 340, 340,
  0, 900, 900, 900, 900, 900, 900, 900,
  0, 1400, 1400, 1400, 1400, 1400, 1400, 1400,
  0, 160, 160, 160, 160, 160, 160, 160,
  0, 300, 300, 300, 300, 300, 300, 300,
  0, 5400, 5400, 5400, 5400, 5400, 5400, 5400,
  0, 4400, 4400, 4400, 4400, 4400, 4400, 4400,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 5400, 5400, 5400, 5400, 5400, 5400, 5400,
  0, 4600, 4600, 4600, 4600, 4600, 4600, 4600,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 3400, 3400, 3400, 3400, 3400, 3400, 3400,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 2400, 2400, 2400, 2400, 2400, 2400, 2400,
  0, 1600, 1600, 1600, 1600, 1600, 1600, 1600,
  0, 4600, 4600, 4600, 4600, 4600, 4600, 4600,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 1400, 1400, 1400, 1400, 1400, 1400, 1400,
  0, 3800, 3800, 3800, 3800, 3800, 3800, 3800,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 1600, 1600, 1600, 1600, 1600, 1600, 1600,
  0, 3200, 3200, 3200, 3200, 3200, 3200, 3200,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 1400, 1400, 1400, 1400, 1400, 1400, 1400,
  0, 1800, 1800, 1800, 1800, 1800, 1800, 1800,
  0, 2000, 2000, 2000, 2000, 2000, 2000, 2000,
  0, 3400, 3400, 3400, 3400, 3400, 3400, 3400,
  0, 2200, 2200, 2200, 2200, 2200, 2200, 2200,
  0, 4000, 4000, 4000, 4000, 4000, 4000, 4000,
  0, 4400, 4400, 4400, 4400, 4400, 4400, 4400,
  0, 4800, 4800, 4800, 4800, 4800, 4800, 4800,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 5000, 5000, 5000, 5000, 5000, 5000, 5000,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 4400, 4400, 4400, 4400, 4400, 4400, 4400,
  0, 2400, 2400, 2400, 2400, 2400, 2400, 2400,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 4200, 4200, 4200, 4200, 4200, 4200, 4200,
  0, 2600, 2600, 2600, 2600, 2600, 2600, 2600,
  0, 4700, 4700, 4700, 4700, 4700, 4700, 4700,
  0, 4000, 4000, 4000, 4000, 4000, 4000, 4000,
  0, 3600, 3600, 3600, 3600, 3600, 3600, 3600,
  0, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
  0, 2800, 2800, 2800, 2800, 2800, 2800, 2800,
  0, 2400, 2400, 2400, 2400, 2400, 2400, 2400,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 800, 800, 800, 800, 800, 800, 800,
  0, 1000, 1000, 1000, 1000, 1000, 1000, 1000,
  0, 300, 300, 300, 300, 300, 300, 300,
]);
/** parking spaces without Deep foundations */
export const PARK_SURFACE_TABLE = new Int16Array([
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 4, 8, 12, 12, 12, 12, 12,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 6, 6, 6, 6, 6, 6, 6,
  12, 12, 12, 12, 12, 12, 12, 12,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 12, 12, 12, 12, 12, 12, 12,
  6, 6, 6, 6, 6, 6, 6, 6,
  0, 96, 96, 96, 96, 96, 96, 96,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 13, 13, 18, 18, 18, 18, 18,
  0, 45, 45, 45, 45, 45, 45, 45,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 67, 67, 67, 67, 67, 67, 84,
  0, 151, 151, 151, 151, 151, 151, 189,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 24, 24, 24, 24, 24, 30, 30,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 30, 30, 30, 30, 30, 30, 10,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 8, 8, 8, 10, 10, 10, 10,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 13, 13, 18, 22, 22, 22, 22,
  0, 2, 2, 2, 3, 3, 3, 3,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 4, 4, 4, 5, 5, 5, 5,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 0, 0, 0, 0, 0, 0, 0,
]);
/** parking spaces with Deep foundations */
export const PARK_UNDERGROUND_TABLE = new Int16Array([
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 4, 8, 12, 12, 12, 12, 12,
  0, 3, 6, 9, 9, 9, 9, 9,
  0, 4, 8, 12, 12, 12, 12, 12,
  0, 5, 10, 15, 15, 15, 15, 15,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 10, 10, 10, 10, 10, 10, 10,
  12, 12, 12, 12, 12, 12, 12, 12,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 5, 5, 5, 5, 5, 5, 5,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 2, 2, 2, 2, 2, 2, 2,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 20, 20, 20, 20, 20, 20, 20,
  6, 6, 6, 6, 6, 6, 6, 6,
  0, 128, 128, 128, 128, 128, 128, 128,
  0, 150, 150, 150, 150, 150, 150, 150,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 16, 16, 16, 16, 16, 16, 16,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 18, 18, 26, 26, 26, 26, 26,
  0, 64, 64, 64, 64, 64, 64, 64,
  0, 114, 114, 114, 114, 114, 114, 114,
  0, 96, 96, 96, 96, 96, 96, 120,
  0, 216, 216, 216, 216, 216, 216, 270,
  0, 12, 12, 18, 18, 18, 18, 18,
  0, 40, 40, 40, 40, 48, 48, 48,
  0, 60, 60, 60, 60, 60, 90, 90,
  0, 50, 50, 50, 50, 50, 50, 60,
  0, 20, 20, 30, 30, 30, 30, 30,
  0, 60, 60, 60, 60, 75, 75, 75,
  0, 150, 150, 150, 150, 150, 150, 190,
  0, 16, 16, 24, 24, 24, 24, 24,
  0, 40, 40, 40, 50, 50, 50, 50,
  0, 100, 100, 100, 100, 100, 100, 100,
  0, 170, 170, 170, 170, 170, 170, 200,
  0, 18, 18, 26, 32, 32, 32, 32,
  0, 12, 12, 18, 20, 20, 20, 20,
  0, 20, 20, 30, 30, 30, 30, 30,
  0, 16, 16, 24, 25, 25, 25, 25,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 10, 10, 10, 10, 10, 10, 10,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 120, 120, 120, 120, 120, 120, 120,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 8, 8, 8, 8, 8, 8, 8,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 75, 75, 75, 75, 75, 75, 75,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 80, 80, 80, 80, 80, 80, 80,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 24, 24, 24, 24, 24, 24, 24,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 4, 4, 4, 4, 4, 4, 4,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 65, 65, 65, 65, 65, 65, 65,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 3, 3, 3, 3, 3, 3, 3,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 12, 12, 12, 12, 12, 12, 12,
  0, 14, 14, 14, 14, 14, 14, 14,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 1, 1, 1, 1, 1, 1, 1,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 65, 65, 65, 65, 65, 65, 65,
  0, 15, 15, 15, 15, 15, 15, 15,
  0, 25, 25, 25, 25, 25, 25, 25,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 20, 20, 20, 20, 20, 20, 20,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 65, 65, 65, 65, 65, 65, 65,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 30, 30, 30, 30, 30, 30, 30,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 40, 40, 40, 40, 40, 40, 40,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 55, 55, 55, 55, 55, 55, 55,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 100, 100, 100, 100, 100, 100, 100,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 70, 70, 70, 70, 70, 70, 70,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 50, 50, 50, 50, 50, 50, 50,
  0, 60, 60, 60, 60, 60, 60, 60,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 90, 90, 90, 90, 90, 90, 90,
  0, 45, 45, 45, 45, 45, 45, 45,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 6, 6, 6, 6, 6, 6, 6,
  0, 0, 0, 0, 0, 0, 0, 0,
]);
/** live (non-draft) designs a tile can pick from */
export const DESIGN_COUNT_TABLE = new Uint8Array([
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 38, 37, 37, 0, 0, 0, 0,
  0, 37, 37, 36, 0, 0, 0, 0,
  0, 35, 36, 34, 0, 0, 0, 0,
  0, 4, 4, 4, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 2, 2, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 3, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 0, 3, 2, 0, 0, 0, 0,
  0, 0, 0, 0, 2, 0, 0, 0,
  0, 0, 0, 0, 0, 2, 0, 0,
  0, 0, 0, 0, 0, 0, 2, 2,
  0, 0, 0, 0, 0, 0, 2, 2,
  0, 0, 2, 2, 0, 0, 0, 0,
  0, 0, 0, 0, 2, 2, 0, 0,
  0, 0, 0, 0, 0, 2, 2, 0,
  0, 0, 0, 0, 0, 0, 2, 2,
  0, 0, 2, 2, 0, 0, 0, 0,
  0, 0, 0, 0, 2, 2, 0, 0,
  0, 0, 0, 0, 0, 0, 2, 2,
  0, 0, 2, 2, 0, 0, 0, 0,
  0, 0, 0, 2, 2, 0, 0, 0,
  0, 0, 0, 0, 0, 2, 0, 0,
  0, 0, 0, 0, 0, 0, 2, 2,
  0, 0, 2, 2, 2, 0, 0, 0,
  0, 0, 2, 2, 2, 0, 0, 0,
  0, 0, 2, 2, 2, 0, 0, 0,
  0, 0, 2, 2, 2, 0, 0, 0,
  0, 4, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 2, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 1, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0,
]);
/** KIND_FLAG bits per kind id. */
export const KIND_FLAGS_TABLE = new Uint8Array([0, 1, 41, 9, 9, 14, 14, 14, 10, 16, 34, 42, 42, 42, 42, 10, 10, 0, 10, 10, 10, 2, 10, 10, 42, 42, 10, 10, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 10, 10, 10, 18, 18, 18, 34, 34, 42, 42, 42, 42, 42, 42, 42, 42, 42, 1, 1, 1, 1, 1, 41, 41, 41, 41, 9, 9, 9, 9, 9, 9, 9, 1, 41, 9, 9, 34, 10, 10, 10, 10, 42, 10, 42, 42, 42, 42, 10, 10, 10, 10, 10, 10, 10, 10, 0, 0, 10, 10, 10, 10, 0, 42, 42, 0, 0, 2, 10, 10, 42, 10, 42, 10, 10, 42, 0, 10, 10, 10, 42, 42, 42, 42, 42, 42, 0, 0, 42, 42, 42, 42, 42, 42, 0, 0, 0, 10, 34, 34, 34, 34, 42, 42, 42, 10, 42, 10, 10, 10, 10, 10, 10, 10, 10, 10, 42, 42, 42, 42, 10, 10, 10, 42, 42, 42, 42, 42, 10, 42, 42, 42, 42, 42, 42, 42, 42, 42, 42, 42, 10, 42, 42, 42, 42, 42, 42, 10, 10, 10, 10, 42, 10, 42, 42, 10, 10, 42, 10, 10, 42, 42, 42, 42, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 10, 42]);
/** Highest level per kind id. */
export const TOP_LEVEL_TABLE = new Uint8Array([0, 3, 3, 3, 3, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 4, 5, 7, 7, 3, 5, 6, 7, 3, 5, 7, 3, 4, 5, 7, 4, 4, 4, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1]);
/** Family code (the 4-bit kind field written into the tile word) per kind id. */
export const KIND_FAMILY_TABLE = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 7, 7, 7, 7, 7, 5, 5, 5, 5, 6, 6, 6, 8, 8, 8, 9, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 3, 3, 3, 3, 1, 2, 4, 3, 10, 4, 4, 4, 4, 12, 4, 13, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 0, 0, 14, 14, 14, 14, 0, 12, 11, 0, 0, 1, 4, 4, 14, 4, 14, 4, 4, 12, 0, 4, 4, 4, 14, 14, 14, 14, 12, 14, 0, 0, 14, 14, 14, 14, 14, 14, 0, 0, 0, 4, 10, 10, 10, 10, 14, 14, 14, 4, 14, 15, 15, 15, 15, 15, 15, 15, 4, 4, 14, 14, 14, 13, 4, 4, 4, 14, 14, 14, 14, 14, 4, 14, 14, 14, 14, 14, 12, 12, 14, 14, 14, 14, 4, 14, 14, 14, 14, 14, 14, 4, 4, 4, 4, 14, 4, 14, 14, 4, 4, 14, 4, 4, 14, 14, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 14]);
/** Base kind id per family code 0-15: what a tile of that code is when its sub byte is 0. */
export const FAMILY_BASE_TABLE = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
/** Footprint per kind id, four bytes each: w, h, door dx, door dy (1, 1, 0, 0 for a single tile). See structures.ts. */
export const FOOTPRINT_TABLE = new Uint8Array([1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 8, 7, 4, 6, 3, 2, 1, 1, 1, 1, 0, 0, 4, 2, 1, 1, 6, 3, 2, 2, 6, 3, 2, 2, 2, 3, 1, 2, 1, 1, 0, 0, 2, 1, 0, 0, 1, 2, 0, 1, 4, 4, 1, 3, 4, 3, 1, 2, 2, 2, 0, 1, 8, 6, 3, 5, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 2, 1, 1, 0, 2, 2, 1, 1, 3, 2, 1, 1, 3, 4, 1, 3, 4, 4, 2, 3, 1, 1, 0, 0, 1, 1, 0, 0, 2, 2, 0, 1, 3, 3, 1, 2, 1, 1, 0, 0, 2, 2, 1, 1, 3, 3, 1, 2, 1, 1, 0, 0, 2, 2, 1, 1, 3, 2, 0, 1, 1, 1, 0, 0, 2, 2, 1, 1, 3, 3, 1, 2, 3, 3, 1, 2, 4, 4, 2, 3, 1, 1, 0, 0, 2, 2, 1, 1, 1, 1, 0, 0, 3, 3, 1, 2, 2, 2, 1, 1, 3, 3, 1, 2, 4, 4, 2, 3, 2, 2, 1, 1, 3, 2, 1, 1, 2, 1, 0, 0, 2, 2, 1, 1, 3, 2, 1, 1, 2, 2, 1, 1, 3, 3, 1, 2, 2, 1, 0, 0, 2, 2, 1, 1, 3, 3, 1, 2, 2, 2, 1, 1, 2, 1, 0, 0, 2, 2, 1, 1, 3, 3, 1, 2, 2, 1, 0, 0, 2, 2, 1, 1, 3, 3, 1, 2, 4, 4, 1, 3, 1, 2, 0, 1, 1, 2, 0, 1, 1, 2, 0, 1, 1, 2, 0, 1, 2, 2, 0, 1, 2, 2, 1, 1, 3, 3, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 4, 3, 2, 2, 4, 4, 1, 3, 4, 4, 2, 3, 4, 3, 2, 2, 4, 4, 2, 3, 1, 4, 0, 3, 1, 1, 0, 0, 2, 2, 0, 1, 3, 3, 1, 2, 2, 2, 0, 1, 3, 2, 1, 1, 6, 6, 3, 5, 3, 3, 1, 2, 2, 2, 1, 1, 1, 1, 0, 0, 1, 1, 0, 0, 4, 3, 2, 2, 3, 3, 1, 2, 4, 3, 2, 2, 3, 3, 1, 2, 1, 1, 0, 0, 4, 2, 1, 1, 2, 2, 1, 1, 1, 1, 0, 0, 1, 1, 0, 0, 2, 2, 0, 1, 3, 3, 1, 2, 3, 3, 1, 2, 2, 2, 1, 1, 3, 3, 1, 2, 1, 4, 0, 3, 3, 3, 1, 2, 4, 4, 1, 3, 4, 3, 2, 2, 1, 1, 0, 0, 1, 1, 0, 0, 2, 2, 0, 1, 3, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 1, 1, 0, 0, 1, 1, 0, 0, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 2, 2, 0, 1, 3, 3, 1, 2, 4, 4, 1, 3, 3, 2, 1, 1, 4, 4, 1, 3, 3, 3, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 1, 1, 0, 0, 2, 2, 0, 1, 2, 1, 0, 0, 3, 3, 1, 2, 4, 4, 1, 3, 1, 1, 0, 0, 2, 2, 1, 1, 3, 3, 1, 2, 3, 3, 1, 2, 2, 2, 1, 1, 3, 3, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 2, 2, 1, 1, 2, 2, 1, 1, 1, 4, 0, 3, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 1, 4, 0, 3, 2, 2, 1, 1, 1, 4, 0, 3, 2, 2, 1, 1, 2, 2, 1, 1, 1, 4, 0, 3, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 2, 2, 0, 1, 2, 2, 0, 1, 1, 1, 0, 0]);
/** Ad slots per design key (and helper key, 'site'), buildings/adslot.ts: face, size code, poster centre x y z and w h in model space, per slot. Designs without slots are absent. */
export const AD_SLOTS: Record<string, number[]> = {"2:1:4":[1,1,0.3425,0.14,0.2,0.16,0.21,1.5708],"2:1:5":[1,1,0.3225,0.15,-0.16,0.16,0.21,1.5708],"2:1:10":[0,3,0,0.575,0.1125,0.44,0.22,0],"2:1:12":[1,1,0.3125,0.15,-0.17,0.16,0.21,1.5708],"2:1:13":[3,1,-0.3125,0.15,0.135,0.16,0.21,-1.5708],"2:1:14":[3,1,-0.4125,0.15,0.075,0.16,0.21,-1.5708],"2:1:15":[1,1,0.2425,0.15,0.058,0.16,0.21,1.5708],"2:1:16":[0,3,0,0.595,0.1125,0.44,0.22,0],"2:1:17":[1,1,0.1925,0.13,0.028,0.16,0.21,1.5708],"2:1:19":[1,1,0.3025,0.13,-0.165,0.16,0.21,1.5708],"2:1:21":[3,1,-0.3425,0.15,0.065,0.16,0.21,-1.5708],"2:1:22":[3,1,-0.3125,0.15,0.065,0.16,0.21,-1.5708],"2:1:26":[1,1,0.3425,0.15,-0.17,0.16,0.21,1.5708],"2:1:33":[1,1,0.3725,0.12,0.065,0.16,0.21,1.5708],"2:2:1":[0,3,0,0.695,0.0125,0.44,0.22,0],"2:2:6":[0,3,0,0.715,0.2425,0.44,0.22,0],"2:2:9":[1,1,0.4325,0.135,0.0875,0.16,0.21,1.5708],"2:2:13":[0,3,0,0.935,0.2125,0.44,0.22,0],"2:2:29":[0,3,0,0.735,0.1925,0.44,0.22,0],"2:2:30":[1,1,0.4125,0.13,0.225,0.16,0.21,1.5708],"2:2:32":[1,1,0.3625,0.12,0,0.16,0.21,1.5708],"2:2:33":[1,1,0.4125,0.125,0.0825,0.16,0.21,1.5708],"2:2:34":[0,3,0,0.855,0.1925,0.44,0.22,0],"2:3:4":[3,1,-0.4125,0.15,0.2625,0.16,0.21,-1.5708],"2:3:7":[3,1,-0.4525,0.15,0.28,0.16,0.21,-1.5708],"2:3:17":[3,1,-0.4025,0.125,0.22,0.16,0.21,-1.5708],"2:3:20":[3,1,-0.4525,0.15,0.28,0.16,0.21,-1.5708],"2:3:21":[3,1,-0.4425,0.125,0.2625,0.16,0.21,-1.5708],"2:3:26":[1,1,-0.0475,0.135,0,0.16,0.21,1.5708],"2:3:27":[1,1,0.4325,0.15,0.0875,0.16,0.21,1.5708],"2:3:31":[3,1,-0.4325,0.15,0.2625,0.16,0.21,-1.5708],"2:3:32":[1,1,0.4325,0.15,0.0825,0.16,0.21,1.5708],"2:3:34":[1,1,0.3325,0.1214,0,0.16,0.21,1.5708],"9:1:1":[0,3,0,0.294,-0.3795,0.4306,0.2153,0],"11:1:1":[0,3,-0.06,0.515,0.2825,0.44,0.22,0],"12:1:0":[0,3,0,0.695,0.0525,0.44,0.22,0],"13:1:1":[0,3,-0.24,0.605,0.3325,0.4,0.2,0],"17:1:0":[1,0,0.2725,0.17,0.08,0.12,0.16,1.5708],"63:1:0":[0,3,0,0.815,0.1425,0.44,0.22,0],"67:1:0":[0,4,-1.48,0.243,1.8005,0.1013,0.267,0,0,4,1.48,0.243,1.8005,0.1013,0.267,0],"67:1:1":[0,4,-0.35,0.243,1.9205,0.1013,0.267,0,0,4,1.35,0.243,1.9205,0.1013,0.267,0],"76:4:1":[0,3,0,0.745,-0.0375,0.44,0.22,0],"77:5:1":[0,3,0,0.334,1.4605,0.4306,0.2153,0],"78:7:1":[0,3,0,1.095,0.5625,0.44,0.22,0],"87:2:0":[1,1,0.4625,0.155,0.6,0.16,0.21,1.5708],"116:1:0":[3,5,-0.3536,0.423,0.1385,0.3762,0.222,-1.309,3,5,-0.1651,0.423,0.4651,0.3762,0.222,-0.7854,0,5,0.1615,0.423,0.6536,0.3762,0.222,-0.2618,3,5,-0.3536,0.657,0.1385,0.3762,0.222,-1.309,3,5,-0.1651,0.657,0.4651,0.3762,0.222,-0.7854,0,5,0.1615,0.657,0.6536,0.3762,0.222,-0.2618],"117:1:0":[0,5,0.416,0.428,0.8423,0.3089,0.232,0.2618,1,5,0.6863,0.428,0.6863,0.3089,0.232,0.7854,1,5,0.8423,0.428,0.416,0.3089,0.232,1.309,0,5,0.416,0.672,0.8423,0.3089,0.232,0.2618,1,5,0.6863,0.672,0.6863,0.3089,0.232,0.7854,1,5,0.8423,0.672,0.416,0.3089,0.232,1.309],"117:1:1":[0,5,0.416,0.428,0.8423,0.3089,0.232,0.2618,1,5,0.6863,0.428,0.6863,0.3089,0.232,0.7854,1,5,0.8423,0.428,0.416,0.3089,0.232,1.309,0,5,0.416,0.672,0.8423,0.3089,0.232,0.2618,1,5,0.6863,0.672,0.6863,0.3089,0.232,0.7854,1,5,0.8423,0.672,0.416,0.3089,0.232,1.309,3,4,-0.9525,0.195,0.5475,0.11,0.29,-1.5708],"151:1:1":[1,1,0.7325,0.142,-0.585,0.16,0.21,1.5708],"154:1:0":[1,1,-0.4075,0.22,-0.515,0.16,0.21,1.5708],"154:1:1":[0,3,-0.72,0.535,-0.2875,0.44,0.22,0],"site":[0,2,0,0.09,0.4625,0.3938,0.1313,0]};

export type KindToolId = "res" | "com" | "ind" | "off" | "police" | "fire" | "hospital" | "yard" | "park" | "citypark" | "cinema" | "theatre" | "sports" | "library" | "airport" | "busdepot" | "busstop" | "railhalt" | "railstation" | "freightyard" | "motorway" | "metroentrance" | "metrostation" | "jetty" | "marina" | "fishharbour" | "ferrypier" | "cargoport" | "gp" | "healthcentre" | "walkin" | "commhospital" | "genhospital" | "teachhospital" | "policebox" | "policepost" | "divstation" | "policehq" | "firepost" | "bigfire" | "firehq" | "handyman" | "depot" | "buildco" | "kerbbays" | "multistorey" | "parkride" | "lakepark" | "botanic" | "cafecinema" | "multiplex" | "studiotheatre" | "opera" | "leisurecentre" | "arena" | "stadium" | "centrallibrary" | "museum" | "gherkin" | "shard" | "walkietalkie" | "canadasquare" | "royalopera" | "bigben" | "londoneye" | "toweroflondon" | "buckingham" | "towerbridge" | "nursery" | "primary" | "secondary" | "sixthform" | "fecollege" | "university" | "research" | "halls" | "ucl" | "imperial" | "kings" | "lse" | "piccadilly" | "bigscreens" | "camp" | "empirestate" | "chrysler" | "liberty" | "onewtc" | "brooklyn" | "flatiron" | "rockefeller" | "radiocity" | "tvstudio" | "broadcast" | "mediacentre" | "eiffeltower" | "arcdetriomphe" | "notredame" | "louvre" | "operagarnier" | "sacrecoeur" | "colosseum" | "stpeters" | "pantheon" | "trevi" | "altare" | "castelsangelo" | "funeral" | "churchyard" | "cemetery" | "gardencemetery" | "crematorium" | "greatpyramid" | "sphinx" | "khafre" | "cairotower" | "sultanhassan" | "substation" | "gridsupply" | "powerdepot" | "gasplant" | "coalplant" | "windturbine" | "solarfarm" | "burjkhalifa" | "burjalarab" | "dubaiframe" | "motf" | "jumeirah" | "orientalpearl" | "shanghaitower" | "jinmao" | "swfc" | "yugarden" | "forbiddencity" | "templeofheaven" | "greatwall" | "tiananmen" | "cctv" | "summerpalace" | "christredeemer" | "sugarloaf" | "riocathedral" | "maracana" | "sambadrome" | "operahouse" | "harbourbridge" | "sydneytower" | "stmarys" | "goldengate" | "transamerica" | "coittower" | "ferrybuilding" | "alcatraz" | "sagradafamilia" | "casabatllol" | "campnou" | "torreglories" | "petronas" | "kltower" | "merdeka118" | "batucaves" | "cntower" | "casaloma" | "rom" | "oldcityhall" | "spaceneedle" | "pikeplace" | "columbiacenter" | "smithtower" | "tajmahal" | "agrafort" | "fatehpursikri" | "itimad";
/** Tool id -> kind id, for every kind that has a tool. */
export const KIND_TOOLS: Record<KindToolId, number> = { "res": 1, "com": 2, "ind": 3, "off": 4, "police": 5, "fire": 6, "hospital": 7, "yard": 8, "park": 9, "citypark": 10, "cinema": 11, "theatre": 12, "sports": 13, "library": 14, "airport": 15, "busdepot": 16, "busstop": 17, "railhalt": 18, "railstation": 19, "freightyard": 20, "motorway": 21, "metroentrance": 22, "metrostation": 23, "jetty": 24, "marina": 25, "fishharbour": 26, "ferrypier": 27, "cargoport": 28, "gp": 40, "healthcentre": 41, "walkin": 42, "commhospital": 43, "genhospital": 44, "teachhospital": 45, "policebox": 46, "policepost": 47, "divstation": 48, "policehq": 49, "firepost": 50, "bigfire": 51, "firehq": 52, "handyman": 53, "depot": 54, "buildco": 55, "kerbbays": 56, "multistorey": 57, "parkride": 58, "lakepark": 59, "botanic": 60, "cafecinema": 61, "multiplex": 62, "studiotheatre": 63, "opera": 64, "leisurecentre": 65, "arena": 66, "stadium": 67, "centrallibrary": 68, "museum": 69, "gherkin": 91, "shard": 92, "walkietalkie": 93, "canadasquare": 94, "royalopera": 95, "bigben": 96, "londoneye": 97, "toweroflondon": 98, "buckingham": 99, "towerbridge": 100, "nursery": 101, "primary": 102, "secondary": 103, "sixthform": 104, "fecollege": 105, "university": 106, "research": 107, "halls": 108, "ucl": 111, "imperial": 112, "kings": 113, "lse": 114, "piccadilly": 116, "bigscreens": 117, "camp": 120, "empirestate": 121, "chrysler": 122, "liberty": 123, "onewtc": 124, "brooklyn": 125, "flatiron": 126, "rockefeller": 127, "radiocity": 128, "tvstudio": 130, "broadcast": 131, "mediacentre": 132, "eiffeltower": 133, "arcdetriomphe": 134, "notredame": 135, "louvre": 136, "operagarnier": 137, "sacrecoeur": 138, "colosseum": 141, "stpeters": 142, "pantheon": 143, "trevi": 144, "altare": 145, "castelsangelo": 146, "funeral": 150, "churchyard": 151, "cemetery": 152, "gardencemetery": 153, "crematorium": 154, "greatpyramid": 155, "sphinx": 156, "khafre": 157, "cairotower": 158, "sultanhassan": 159, "substation": 160, "gridsupply": 161, "powerdepot": 162, "gasplant": 163, "coalplant": 164, "windturbine": 165, "solarfarm": 166, "burjkhalifa": 167, "burjalarab": 168, "dubaiframe": 169, "motf": 170, "jumeirah": 171, "orientalpearl": 172, "shanghaitower": 173, "jinmao": 174, "swfc": 175, "yugarden": 176, "forbiddencity": 177, "templeofheaven": 178, "greatwall": 179, "tiananmen": 180, "cctv": 181, "summerpalace": 182, "christredeemer": 183, "sugarloaf": 184, "riocathedral": 185, "maracana": 186, "sambadrome": 187, "operahouse": 188, "harbourbridge": 189, "sydneytower": 190, "stmarys": 191, "goldengate": 192, "transamerica": 193, "coittower": 194, "ferrybuilding": 195, "alcatraz": 196, "sagradafamilia": 197, "casabatllol": 198, "campnou": 199, "torreglories": 200, "petronas": 201, "kltower": 202, "merdeka118": 203, "batucaves": 204, "cntower": 205, "casaloma": 206, "rom": 207, "oldcityhall": 208, "spaceneedle": 209, "pikeplace": 210, "columbiacenter": 211, "smithtower": 212, "tajmahal": 213, "agrafort": 214, "fatehpursikri": 215, "itimad": 216 };
/** Tools that zone land for a growable kind. */
export const ZONE_TOOLS: Record<string, number> = { "res": 1, "com": 2, "ind": 3, "off": 4 };
/** Tools that place a civic building (a site that builders raise). */
export const CIVIC_TOOLS: Record<string, number> = { "police": 5, "fire": 6, "hospital": 7, "yard": 8, "citypark": 10, "cinema": 11, "theatre": 12, "sports": 13, "library": 14, "airport": 15, "busdepot": 16, "railhalt": 18, "railstation": 19, "freightyard": 20, "motorway": 21, "metroentrance": 22, "metrostation": 23, "jetty": 24, "marina": 25, "fishharbour": 26, "ferrypier": 27, "cargoport": 28, "gp": 40, "healthcentre": 41, "walkin": 42, "commhospital": 43, "genhospital": 44, "teachhospital": 45, "policebox": 46, "policepost": 47, "divstation": 48, "policehq": 49, "firepost": 50, "bigfire": 51, "firehq": 52, "handyman": 53, "depot": 54, "buildco": 55, "kerbbays": 56, "multistorey": 57, "parkride": 58, "lakepark": 59, "botanic": 60, "cafecinema": 61, "multiplex": 62, "studiotheatre": 63, "opera": 64, "leisurecentre": 65, "arena": 66, "stadium": 67, "centrallibrary": 68, "museum": 69, "gherkin": 91, "shard": 92, "walkietalkie": 93, "canadasquare": 94, "royalopera": 95, "bigben": 96, "londoneye": 97, "toweroflondon": 98, "buckingham": 99, "towerbridge": 100, "nursery": 101, "primary": 102, "secondary": 103, "sixthform": 104, "fecollege": 105, "university": 106, "research": 107, "halls": 108, "ucl": 111, "imperial": 112, "kings": 113, "lse": 114, "piccadilly": 116, "bigscreens": 117, "camp": 120, "empirestate": 121, "chrysler": 122, "liberty": 123, "onewtc": 124, "brooklyn": 125, "flatiron": 126, "rockefeller": 127, "radiocity": 128, "tvstudio": 130, "broadcast": 131, "mediacentre": 132, "eiffeltower": 133, "arcdetriomphe": 134, "notredame": 135, "louvre": 136, "operagarnier": 137, "sacrecoeur": 138, "colosseum": 141, "stpeters": 142, "pantheon": 143, "trevi": 144, "altare": 145, "castelsangelo": 146, "funeral": 150, "churchyard": 151, "cemetery": 152, "gardencemetery": 153, "crematorium": 154, "greatpyramid": 155, "sphinx": 156, "khafre": 157, "cairotower": 158, "sultanhassan": 159, "substation": 160, "gridsupply": 161, "powerdepot": 162, "gasplant": 163, "coalplant": 164, "windturbine": 165, "solarfarm": 166, "burjkhalifa": 167, "burjalarab": 168, "dubaiframe": 169, "motf": 170, "jumeirah": 171, "orientalpearl": 172, "shanghaitower": 173, "jinmao": 174, "swfc": 175, "yugarden": 176, "forbiddencity": 177, "templeofheaven": 178, "greatwall": 179, "tiananmen": 180, "cctv": 181, "summerpalace": 182, "christredeemer": 183, "sugarloaf": 184, "riocathedral": 185, "maracana": 186, "sambadrome": 187, "operahouse": 188, "harbourbridge": 189, "sydneytower": 190, "stmarys": 191, "goldengate": 192, "transamerica": 193, "coittower": 194, "ferrybuilding": 195, "alcatraz": 196, "sagradafamilia": 197, "casabatllol": 198, "campnou": 199, "torreglories": 200, "petronas": 201, "kltower": 202, "merdeka118": 203, "batucaves": 204, "cntower": 205, "casaloma": 206, "rom": 207, "oldcityhall": 208, "spaceneedle": 209, "pikeplace": 210, "columbiacenter": 211, "smithtower": 212, "tajmahal": 213, "agrafort": 214, "fatehpursikri": 215, "itimad": 216 };

/** Everything about every kind, for tooltips, tool lists and the building viewer. Not for hot paths. */
export const MANIFEST: KindManifest[] = [
  {
    "id": "residential",
    "name": "residential",
    "kindId": 1,
    "code": 1,
    "family": "residential",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tool": {
      "id": "res",
      "key": "4",
      "label": "Residential",
      "color": "var(--res)",
      "cost": 25
    },
    "tech": [],
    "attrs": {
      "style": "mixed",
      "rentBand": "low"
    },
    "tints": [
      16777215,
      16767416,
      16773299,
      13624311,
      14085065,
      16240591,
      15918847,
      16770244
    ],
    "lotTint": 9429114,
    "levels": [
      {
        "level": 1,
        "capacity": 4,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 20,
        "parking": {
          "surface": 4,
          "underground": 4
        },
        "tech": [],
        "attrs": {
          "style": "house",
          "rentBand": "low"
        },
        "designs": [
          {
            "key": "1:1:0",
            "index": 0,
            "name": "cottage, pitched roof and chimney",
            "height": 0.52,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            }
          },
          {
            "key": "1:1:1",
            "index": 1,
            "name": "bungalow with carport",
            "height": 0.44,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            }
          },
          {
            "key": "1:1:2",
            "index": 2,
            "name": "tall narrow cottage, steep roof, dormer, porch",
            "height": 0.66,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            }
          },
          {
            "key": "1:1:3",
            "index": 3,
            "name": "L-shaped brick house",
            "height": 0.5,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            }
          },
          {
            "key": "1:1:4",
            "index": 4,
            "name": "pebbledash cottage, central door",
            "height": 0.5,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:5",
            "index": 5,
            "name": "thatched-look cottage, tan roof to the eaves",
            "height": 0.56,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:6",
            "index": 6,
            "name": "brick bungalow, sash windows and a central door",
            "height": 0.46,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:7",
            "index": 7,
            "name": "ranch house, long and low, garage wing",
            "height": 0.46,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:8",
            "index": 8,
            "name": "A-frame cabin, glazed gable and a deck",
            "height": 0.6,
            "draft": false,
            "ops": 4,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:9",
            "index": 9,
            "name": "log cabin with a porch canopy",
            "height": 0.48,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:10",
            "index": 10,
            "name": "two-storey chalet with a glazed balcony",
            "height": 0.7,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:11",
            "index": 11,
            "name": "beach house on a low plinth",
            "height": 0.58,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:12",
            "index": 12,
            "name": "shotgun house, one room deep",
            "height": 0.48,
            "draft": false,
            "ops": 4,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:13",
            "index": 13,
            "name": "cape cod with dormers",
            "height": 0.5,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:14",
            "index": 14,
            "name": "prefab modernist cube, ribbon windows",
            "height": 0.45,
            "draft": false,
            "ops": 4,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:15",
            "index": 15,
            "name": "flat-roof modern house with a roof terrace",
            "height": 0.53,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:16",
            "index": 16,
            "name": "L-shaped bungalow with a garden wing",
            "height": 0.46,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:17",
            "index": 17,
            "name": "farmhouse with a porch and gabled front",
            "height": 0.48,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:18",
            "index": 18,
            "name": "tiny house, one room under a steep roof",
            "height": 0.46,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:19",
            "index": 19,
            "name": "coach house, roller doors and a loft",
            "height": 0.7,
            "draft": false,
            "ops": 2,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:20",
            "index": 20,
            "name": "house with a glass conservatory, clear of the walls",
            "height": 0.48,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:21",
            "index": 21,
            "name": "Dutch gable house, tall gable front",
            "height": 0.6,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:22",
            "index": 22,
            "name": "mansard cottage, steep roof with dormers",
            "height": 0.56,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:23",
            "index": 23,
            "name": "split-level, two floors on one side",
            "height": 0.56,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:24",
            "index": 24,
            "name": "Japanese-style low house, deep eaves",
            "height": 0.46,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:25",
            "index": 25,
            "name": "Mediterranean white house, terracotta roof",
            "height": 0.46,
            "draft": false,
            "ops": 4,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:26",
            "index": 26,
            "name": "house with carport and a parked car",
            "height": 0.46,
            "draft": false,
            "ops": 10,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:27",
            "index": 27,
            "name": "bungalow with a forward garage",
            "height": 0.46,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:28",
            "index": 28,
            "name": "house with a round tower, clear of the windows",
            "height": 0.58,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:29",
            "index": 29,
            "name": "mobile-home style long box, pitched tin roof",
            "height": 0.46,
            "draft": false,
            "ops": 4,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:30",
            "index": 30,
            "name": "stone croft, porch over the door",
            "height": 0.5,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:31",
            "index": 31,
            "name": "timber cabin on stilts, open underneath",
            "height": 0.64,
            "draft": false,
            "ops": 10,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:32",
            "index": 32,
            "name": "eco house with a green roof",
            "height": 0.46,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:33",
            "index": 33,
            "name": "dome house, round walls and a domed cap",
            "height": 0.5,
            "draft": false,
            "ops": 4,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:34",
            "index": 34,
            "name": "semi-detached pair under one gable roof",
            "height": 0.48,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:35",
            "index": 35,
            "name": "brick cottage with a bay and a porch",
            "height": 0.48,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:36",
            "index": 36,
            "name": "red Scandinavian cottage, white trim",
            "height": 0.52,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:37",
            "index": 37,
            "name": "stone bungalow with a bay window",
            "height": 0.46,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:38",
            "index": 38,
            "name": "cottage with bay window",
            "height": 0.48,
            "draft": true,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:39",
            "index": 39,
            "name": "gabled farmhouse with corrugated shed",
            "height": 0.54,
            "draft": true,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:40",
            "index": 40,
            "name": "modern flat-roof bungalow",
            "height": 0.41,
            "draft": true,
            "ops": 8,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:41",
            "index": 41,
            "name": "house with side garage",
            "height": 0.5,
            "draft": true,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:1:42",
            "index": 42,
            "name": "cottage with bay window",
            "height": 0.48,
            "draft": true,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5 (raw)"
          },
          {
            "key": "1:1:43",
            "index": 43,
            "name": "gabled farmhouse with corrugated shed",
            "height": 0.54,
            "draft": true,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5 (raw)"
          },
          {
            "key": "1:1:44",
            "index": 44,
            "name": "modern flat-roof bungalow",
            "height": 0.41,
            "draft": true,
            "ops": 6,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5 (raw)"
          },
          {
            "key": "1:1:45",
            "index": 45,
            "name": "house with side garage",
            "height": 0.5,
            "draft": true,
            "ops": 7,
            "attrs": {
              "style": "house",
              "rentBand": "low"
            },
            "author": "claude-haiku-5-5 (raw)"
          }
        ]
      },
      {
        "level": 2,
        "capacity": 8,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 120,
        "parking": {
          "surface": 8,
          "underground": 8
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "style": "townhouse",
          "rentBand": "mid"
        },
        "designs": [
          {
            "key": "1:2:0",
            "index": 0,
            "name": "brick townhouse",
            "height": 0.66,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            }
          },
          {
            "key": "1:2:1",
            "index": 1,
            "name": "duplex, two tones, flat parapet roof",
            "height": 0.56,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            }
          },
          {
            "key": "1:2:2",
            "index": 2,
            "name": "timber-framed gable with cross wing",
            "height": 0.72,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            }
          },
          {
            "key": "1:2:3",
            "index": 3,
            "name": "modern stacked boxes with picture window",
            "height": 0.63,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            }
          },
          {
            "key": "1:2:4",
            "index": 4,
            "name": "terrace of three, brick, pale and cream",
            "height": 0.7,
            "draft": false,
            "ops": 12,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:5",
            "index": 5,
            "name": "victorian townhouse, brick with ground bay windows",
            "height": 0.72,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:6",
            "index": 6,
            "name": "georgian townhouse with stone cornices",
            "height": 0.7,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:7",
            "index": 7,
            "name": "edwardian villa with bay windows and gable",
            "height": 0.7,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:8",
            "index": 8,
            "name": "craftsman house with deep porch and dormer",
            "height": 0.58,
            "draft": false,
            "ops": 13,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:9",
            "index": 9,
            "name": "queen anne house with stone turret",
            "height": 0.7,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:10",
            "index": 10,
            "name": "mews house with garage and loft door",
            "height": 0.72,
            "draft": false,
            "ops": 4,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:11",
            "index": 11,
            "name": "duplex with two front doors and a cornice",
            "height": 0.7,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:12",
            "index": 12,
            "name": "over-and-under flats with upper balcony",
            "height": 0.64,
            "draft": false,
            "ops": 10,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:13",
            "index": 13,
            "name": "dutch canal house with stepped gable",
            "height": 0.67,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:14",
            "index": 14,
            "name": "brownstone with stoop and cornice",
            "height": 0.64,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:15",
            "index": 15,
            "name": "parisian house with mansard and dormers",
            "height": 0.6,
            "draft": false,
            "ops": 15,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:16",
            "index": 16,
            "name": "spanish colonial house with twin balconies",
            "height": 0.66,
            "draft": false,
            "ops": 12,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:17",
            "index": 17,
            "name": "new england clapboard house with central chimney",
            "height": 0.7,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:18",
            "index": 18,
            "name": "art deco villa with round corner tower",
            "height": 0.59,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:19",
            "index": 19,
            "name": "bauhaus white box with balcony and penthouse",
            "height": 0.69,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:20",
            "index": 20,
            "name": "split-level family house, high and low wings",
            "height": 0.64,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:21",
            "index": 21,
            "name": "stone manor house with three storeys",
            "height": 0.74,
            "draft": false,
            "ops": 11,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:22",
            "index": 22,
            "name": "half-timbered tudor house, gable front",
            "height": 0.7,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:23",
            "index": 23,
            "name": "townhouse with roof garden and hedges",
            "height": 0.68,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:24",
            "index": 24,
            "name": "end-of-terrace house with side extension",
            "height": 0.7,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:25",
            "index": 25,
            "name": "house with garage annex and room above",
            "height": 0.7,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:26",
            "index": 26,
            "name": "back-to-back cottages, front and rear",
            "height": 0.7,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:27",
            "index": 27,
            "name": "scandinavian black timber house with dormer",
            "height": 0.74,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:28",
            "index": 28,
            "name": "cantilever house, upper box on a steel column",
            "height": 0.58,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:29",
            "index": 29,
            "name": "courtyard house, U-shape around a court",
            "height": 0.66,
            "draft": false,
            "ops": 11,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:30",
            "index": 30,
            "name": "twin gables over a double-fronted house",
            "height": 0.68,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:31",
            "index": 31,
            "name": "house with wraparound balcony on three sides",
            "height": 0.7,
            "draft": false,
            "ops": 16,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:32",
            "index": 32,
            "name": "garden-flat conversion with side entrance and patio",
            "height": 0.7,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:33",
            "index": 33,
            "name": "shingled craftsman with gable front and dormer",
            "height": 0.72,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:34",
            "index": 34,
            "name": "haussmann house with iron balconies and low mansard",
            "height": 0.62,
            "draft": false,
            "ops": 12,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:35",
            "index": 35,
            "name": "falu red timber house with white corner boards",
            "height": 0.72,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:36",
            "index": 36,
            "name": "victorian double-bay villa with gable",
            "height": 0.7,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:37",
            "index": 37,
            "name": "terrace pair, brick and cream, gable fronts",
            "height": 0.68,
            "draft": true,
            "ops": 8,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:38",
            "index": 38,
            "name": "townhouse with first-floor balcony",
            "height": 0.7,
            "draft": true,
            "ops": 8,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:39",
            "index": 39,
            "name": "corner house with turret",
            "height": 0.7,
            "draft": true,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:2:40",
            "index": 40,
            "name": "terrace pair, brick and cream, gable fronts",
            "height": 0.68,
            "draft": true,
            "ops": 8,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5 (raw)"
          },
          {
            "key": "1:2:41",
            "index": 41,
            "name": "townhouse with first-floor balcony",
            "height": 0.7,
            "draft": true,
            "ops": 7,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5 (raw)"
          },
          {
            "key": "1:2:42",
            "index": 42,
            "name": "corner house with turret",
            "height": 0.7,
            "draft": true,
            "ops": 6,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "claude-haiku-5-5 (raw)"
          },
          {
            "key": "1:2:43",
            "index": 43,
            "name": "example: brick semi with a bay and a balcony",
            "height": 0.74,
            "draft": true,
            "ops": 12,
            "attrs": {
              "style": "townhouse",
              "rentBand": "mid"
            },
            "author": "docs example"
          }
        ]
      },
      {
        "level": 3,
        "capacity": 12,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 180,
        "parking": {
          "surface": 12,
          "underground": 12
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "style": "apartments",
          "rentBand": "high"
        },
        "designs": [
          {
            "key": "1:3:0",
            "index": 0,
            "name": "cream block with rooftop setback",
            "height": 1.36,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            }
          },
          {
            "key": "1:3:1",
            "index": 1,
            "name": "brick walk-up with water tank",
            "height": 1.2,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            }
          },
          {
            "key": "1:3:2",
            "index": 2,
            "name": "slab with balconies and a lift room",
            "height": 1.4,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            }
          },
          {
            "key": "1:3:3",
            "index": 3,
            "name": "tower on a podium with a dark service core",
            "height": 1.65,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            }
          },
          {
            "key": "1:3:4",
            "index": 4,
            "name": "brick mansion block, stone cornices, slate roof",
            "height": 1.6,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:5",
            "index": 5,
            "name": "Art Deco apartments, stepped top, gold trim",
            "height": 1.62,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:6",
            "index": 6,
            "name": "brutalist concrete slab, roof plant",
            "height": 1.42,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:7",
            "index": 7,
            "name": "deck-access block, open walkways",
            "height": 1.32,
            "draft": false,
            "ops": 20,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:8",
            "index": 8,
            "name": "stepped terrace block, roof gardens",
            "height": 1.38,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:9",
            "index": 9,
            "name": "courtyard block, U shape around a garden",
            "height": 1.43,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:10",
            "index": 10,
            "name": "Haussmann block, mansard with dormers",
            "height": 1.46,
            "draft": false,
            "ops": 16,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:11",
            "index": 11,
            "name": "apartment block with corner tower",
            "height": 1.54,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:12",
            "index": 12,
            "name": "twin towers on a shared podium",
            "height": 1.55,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:13",
            "index": 13,
            "name": "Soviet panel block, two entrances",
            "height": 1.53,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:14",
            "index": 14,
            "name": "block with balconies on every floor",
            "height": 1.44,
            "draft": false,
            "ops": 24,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:15",
            "index": 15,
            "name": "warehouse loft conversion, gable and dormers",
            "height": 1.42,
            "draft": false,
            "ops": 11,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:16",
            "index": 16,
            "name": "tenement with stacked bay windows",
            "height": 1.6,
            "draft": false,
            "ops": 14,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:17",
            "index": 17,
            "name": "garden apartments, green roof terraces",
            "height": 1.4,
            "draft": false,
            "ops": 14,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:18",
            "index": 18,
            "name": "point block, slim tower with stair housing",
            "height": 1.74,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:19",
            "index": 19,
            "name": "Victorian mansion flats, gable and bays",
            "height": 1.54,
            "draft": false,
            "ops": 16,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:20",
            "index": 20,
            "name": "1930s modernist block, ribbon bands",
            "height": 1.33,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:21",
            "index": 21,
            "name": "co-op block with water tank on the roof",
            "height": 1.65,
            "draft": false,
            "ops": 8,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:22",
            "index": 22,
            "name": "student housing block, bright bands",
            "height": 1.33,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:23",
            "index": 23,
            "name": "senior housing, porch over the entrance",
            "height": 1.45,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:24",
            "index": 24,
            "name": "cantilevered upper floors over a narrow base",
            "height": 1.34,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:25",
            "index": 25,
            "name": "crescent of stepped boxes",
            "height": 1.6,
            "draft": false,
            "ops": 12,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:26",
            "index": 26,
            "name": "block over ground-floor shops",
            "height": 1.36,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:27",
            "index": 27,
            "name": "split towers joined by a glass bridge",
            "height": 1.54,
            "draft": false,
            "ops": 9,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:28",
            "index": 28,
            "name": "red brick block, white cornices",
            "height": 1.42,
            "draft": false,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:29",
            "index": 29,
            "name": "pastel Miami block, white balconies",
            "height": 1.44,
            "draft": false,
            "ops": 15,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:30",
            "index": 30,
            "name": "timber-clad mid-rise",
            "height": 1.45,
            "draft": false,
            "ops": 13,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:31",
            "index": 31,
            "name": "glass tower on a steel podium",
            "height": 1.64,
            "draft": false,
            "ops": 3,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:32",
            "index": 32,
            "name": "brutalist stacked slabs, concrete",
            "height": 1.44,
            "draft": false,
            "ops": 6,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:33",
            "index": 33,
            "name": "point block with stepped crown",
            "height": 1.64,
            "draft": false,
            "ops": 5,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:34",
            "index": 34,
            "name": "alternating balconies on a stone frame",
            "height": 1.44,
            "draft": false,
            "ops": 20,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:35",
            "index": 35,
            "name": "corner tenement with shop and stacked bays",
            "height": 1.53,
            "draft": false,
            "ops": 10,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:36",
            "index": 36,
            "name": "sawtooth block, stepped roofs",
            "height": 1.72,
            "draft": false,
            "ops": 12,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:37",
            "index": 37,
            "name": "brick mansion block, stone cornice, slate attic",
            "height": 1.26,
            "draft": true,
            "ops": 9,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:38",
            "index": 38,
            "name": "balcony block with rooftop garden",
            "height": 1.42,
            "draft": true,
            "ops": 18,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:39",
            "index": 39,
            "name": "narrow tower with water tank",
            "height": 1.76,
            "draft": true,
            "ops": 7,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "1:3:40",
            "index": 40,
            "name": "brick mansion block, stone cornice, slate attic",
            "height": 1.26,
            "draft": true,
            "ops": 6,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5 (raw)"
          },
          {
            "key": "1:3:41",
            "index": 41,
            "name": "balcony block with rooftop garden",
            "height": 1.42,
            "draft": true,
            "ops": 8,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5 (raw)"
          },
          {
            "key": "1:3:42",
            "index": 42,
            "name": "narrow tower with water tank",
            "height": 1.76,
            "draft": true,
            "ops": 6,
            "attrs": {
              "style": "apartments",
              "rentBand": "high"
            },
            "author": "claude-haiku-5-5 (raw)"
          }
        ]
      }
    ],
    "blurb": "Homes. Zoned land grows into houses, then terraces, then apartment blocks (levels 1 to 3) when there are more jobs than people and builders can reach it. Each resident takes the nearest job anywhere on the road network and pays property tax to whoever owns the land they live on.",
    "howTo": "Drag Residential (4) over land you own beside a road; there is nothing to place. A builders' yard must reach the lots by road. Levels 2 and 3 need Masonry and Steel frame, and the top level wants police, fire or health cover nearby; parks and venues help it grow."
  },
  {
    "id": "commercial",
    "name": "commercial",
    "kindId": 2,
    "code": 2,
    "family": "commercial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tool": {
      "id": "com",
      "key": "5",
      "label": "Commercial",
      "color": "var(--com)",
      "cost": 25
    },
    "tech": [
      "zon1"
    ],
    "occupation": {
      "name": "shop worker",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 12,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 6,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "commerceType": "shop",
      "openHours": [
        7,
        22
      ]
    },
    "tints": [
      16777215,
      16774112,
      15659767,
      16247016,
      16054252
    ],
    "lotTint": 8042239,
    "levels": [
      {
        "level": 1,
        "capacity": 3,
        "wage": 15,
        "upkeep": 0,
        "cost": 0,
        "work": 60,
        "parking": {
          "surface": 1,
          "underground": 3
        },
        "tech": [
          "zon1"
        ],
        "attrs": {
          "commerceType": "shop",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 6
        },
        "designs": [
          {
            "key": "2:1:0",
            "index": 0,
            "name": "white shop with awning and sign",
            "height": 0.5,
            "draft": false,
            "ops": 4,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            }
          },
          {
            "key": "2:1:1",
            "index": 1,
            "name": "brick corner store with striped awning",
            "height": 0.48,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            }
          },
          {
            "key": "2:1:2",
            "index": 2,
            "name": "café with pavement umbrellas",
            "height": 0.4,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "café",
              "openHours": [
                6,
                19
              ],
              "visitorCapacity": 6
            }
          },
          {
            "key": "2:1:3",
            "index": 3,
            "name": "chrome diner with a tall sign",
            "height": 0.64,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "restaurant",
              "openHours": [
                7,
                24
              ],
              "visitorCapacity": 6
            }
          },
          {
            "key": "2:1:4",
            "index": 4,
            "name": "corner shop with a flat above",
            "height": 0.6,
            "draft": false,
            "ops": 11,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:5",
            "index": 5,
            "name": "village bakery",
            "height": 0.45,
            "draft": false,
            "ops": 11,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:6",
            "index": 6,
            "name": "café with terrace tables",
            "height": 0.39,
            "draft": false,
            "ops": 14,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:7",
            "index": 7,
            "name": "diner with a rounded end",
            "height": 0.34,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:8",
            "index": 8,
            "name": "launderette with a roof vent",
            "height": 0.44,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:9",
            "index": 9,
            "name": "pharmacy with a green cross",
            "height": 0.45,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:10",
            "index": 10,
            "name": "florist with plant boxes out front",
            "height": 0.41,
            "draft": false,
            "ops": 16,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:11",
            "index": 11,
            "name": "butcher with a striped awning",
            "height": 0.47,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:12",
            "index": 12,
            "name": "greengrocer with crates outside",
            "height": 0.41,
            "draft": false,
            "ops": 12,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:13",
            "index": 13,
            "name": "bookshop under a pitched roof",
            "height": 0.56,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:14",
            "index": 14,
            "name": "hardware store with a timber yard",
            "height": 0.43,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:15",
            "index": 15,
            "name": "barber with a striped pole",
            "height": 0.45,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:16",
            "index": 16,
            "name": "takeaway with a flue",
            "height": 0.63,
            "draft": false,
            "ops": 14,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:17",
            "index": 17,
            "name": "ice-cream kiosk with a cone roof",
            "height": 0.46,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:18",
            "index": 18,
            "name": "petrol station shop with a canopy",
            "height": 0.46,
            "draft": false,
            "ops": 12,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:19",
            "index": 19,
            "name": "newsagent with a board sign",
            "height": 0.39,
            "draft": false,
            "ops": 11,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:20",
            "index": 20,
            "name": "village pub with a hanging sign",
            "height": 0.58,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:21",
            "index": 21,
            "name": "bank branch with a portico",
            "height": 0.44,
            "draft": false,
            "ops": 11,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:22",
            "index": 22,
            "name": "post office with a postbox",
            "height": 0.44,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:23",
            "index": 23,
            "name": "tailor with a rail of suits",
            "height": 0.41,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:24",
            "index": 24,
            "name": "hairdresser with a mint awning",
            "height": 0.46,
            "draft": false,
            "ops": 6,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:25",
            "index": 25,
            "name": "bike shop with a rack outside",
            "height": 0.41,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:26",
            "index": 26,
            "name": "small supermarket with a wide front",
            "height": 0.42,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:27",
            "index": 27,
            "name": "garden centre with a greenhouse",
            "height": 0.41,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:28",
            "index": 28,
            "name": "gallery in a white cube",
            "height": 0.42,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:29",
            "index": 29,
            "name": "music shop with a drum sign",
            "height": 0.53,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:30",
            "index": 30,
            "name": "pawn shop with three gold balls",
            "height": 0.43,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:31",
            "index": 31,
            "name": "Victorian shop with a timber front",
            "height": 0.62,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:32",
            "index": 32,
            "name": "shop with a clock tower",
            "height": 0.63,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:33",
            "index": 33,
            "name": "small market hall",
            "height": 0.5,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:34",
            "index": 34,
            "name": "dry cleaner with a steam vent",
            "height": 0.54,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:35",
            "index": 35,
            "name": "tea room in a cottage",
            "height": 0.6,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:36",
            "index": 36,
            "name": "sweet shop with a bow front",
            "height": 0.41,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:1:37",
            "index": 37,
            "name": "news kiosk with a striped canopy",
            "height": 0.34,
            "draft": true,
            "ops": 12,
            "attrs": {
              "commerceType": "kiosk",
              "openHours": [
                6,
                20
              ],
              "visitorCapacity": 2
            }
          },
          {
            "key": "2:1:38",
            "index": 38,
            "name": "example: corner shop with a flat above",
            "height": 0.56,
            "draft": true,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 6
            },
            "author": "docs example"
          }
        ]
      },
      {
        "level": 2,
        "capacity": 6,
        "wage": 20,
        "upkeep": 0,
        "cost": 0,
        "work": 120,
        "parking": {
          "surface": 1,
          "underground": 6
        },
        "tech": [
          "zon1",
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "commerceType": "shop",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 12
        },
        "designs": [
          {
            "key": "2:2:0",
            "index": 0,
            "name": "stone two-storey with glass ground floor",
            "height": 0.91,
            "draft": false,
            "ops": 4,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            }
          },
          {
            "key": "2:2:1",
            "index": 1,
            "name": "supermarket with entrance canopy and rooftop plant",
            "height": 0.66,
            "draft": false,
            "ops": 12,
            "attrs": {
              "commerceType": "supermarket",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            }
          },
          {
            "key": "2:2:2",
            "index": 2,
            "name": "shop below, flats above, mansard roof",
            "height": 0.94,
            "draft": false,
            "ops": 6,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            }
          },
          {
            "key": "2:2:3",
            "index": 3,
            "name": "two-block mall with canopy and flags",
            "height": 0.8,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "mall",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            }
          },
          {
            "key": "2:2:4",
            "index": 4,
            "name": "high-street block with offices over shops",
            "height": 0.88,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:5",
            "index": 5,
            "name": "bank with a porch and pediment",
            "height": 0.73,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:6",
            "index": 6,
            "name": "corner pub with a turret",
            "height": 0.82,
            "draft": false,
            "ops": 16,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:7",
            "index": 7,
            "name": "small cinema with a marquee",
            "height": 0.67,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:8",
            "index": 8,
            "name": "arcade with a glass roof",
            "height": 0.73,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:9",
            "index": 9,
            "name": "small department store",
            "height": 0.91,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:10",
            "index": 10,
            "name": "coaching inn with a carriage arch",
            "height": 0.77,
            "draft": false,
            "ops": 13,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:11",
            "index": 11,
            "name": "art deco shop parade with a stepped crown",
            "height": 0.85,
            "draft": false,
            "ops": 13,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:12",
            "index": 12,
            "name": "victorian shop terrace with a fascia",
            "height": 0.91,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:13",
            "index": 13,
            "name": "italianate block with bracketed eaves",
            "height": 0.77,
            "draft": false,
            "ops": 18,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:14",
            "index": 14,
            "name": "brick office block with a steel porch",
            "height": 0.83,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:15",
            "index": 15,
            "name": "medical centre with a red cross",
            "height": 0.69,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:16",
            "index": 16,
            "name": "small guest house with dormers",
            "height": 0.86,
            "draft": false,
            "ops": 13,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:17",
            "index": 17,
            "name": "restaurant with a roof terrace and pergola",
            "height": 0.83,
            "draft": false,
            "ops": 12,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:18",
            "index": 18,
            "name": "supermarket with a car-park canopy on posts",
            "height": 0.69,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:19",
            "index": 19,
            "name": "gym with a blue fascia",
            "height": 0.67,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:20",
            "index": 20,
            "name": "car showroom with a glass front",
            "height": 0.65,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:21",
            "index": 21,
            "name": "furniture store with a wide sign band",
            "height": 0.65,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:22",
            "index": 22,
            "name": "office block with a clock tower",
            "height": 0.92,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:23",
            "index": 23,
            "name": "post-modern office with coloured panels",
            "height": 0.9,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:24",
            "index": 24,
            "name": "timber market house on stilts",
            "height": 0.9,
            "draft": false,
            "ops": 14,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:25",
            "index": 25,
            "name": "cafe-bookshop with dormers",
            "height": 0.78,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:26",
            "index": 26,
            "name": "1960s concrete shops with a flat roof",
            "height": 0.7,
            "draft": false,
            "ops": 12,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:27",
            "index": 27,
            "name": "glazed corner cafe with a lantern",
            "height": 0.69,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:28",
            "index": 28,
            "name": "bakery chain store with a red fascia",
            "height": 0.73,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:29",
            "index": 29,
            "name": "local radio station with a mast",
            "height": 0.9,
            "draft": false,
            "ops": 13,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:30",
            "index": 30,
            "name": "library-style commercial block with columns",
            "height": 0.72,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:31",
            "index": 31,
            "name": "two shops under a shared mansard",
            "height": 0.73,
            "draft": false,
            "ops": 18,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:32",
            "index": 32,
            "name": "shop with apartment balconies above",
            "height": 0.79,
            "draft": false,
            "ops": 17,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:33",
            "index": 33,
            "name": "garage workshop with a showroom",
            "height": 0.66,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:34",
            "index": 34,
            "name": "travel agency with a globe sign",
            "height": 0.87,
            "draft": false,
            "ops": 15,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:35",
            "index": 35,
            "name": "nightclub with a neon band",
            "height": 0.67,
            "draft": false,
            "ops": 5,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:2:36",
            "index": 36,
            "name": "corner pharmacy with a green fascia",
            "height": 0.69,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 12
            },
            "author": "claude-haiku-5-5"
          }
        ]
      },
      {
        "level": 3,
        "capacity": 9,
        "wage": 25,
        "upkeep": 0,
        "cost": 0,
        "work": 180,
        "parking": {
          "surface": 1,
          "underground": 9
        },
        "tech": [
          "zon1",
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "commerceType": "shop",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 18
        },
        "designs": [
          {
            "key": "2:3:0",
            "index": 0,
            "name": "glass tower on a podium",
            "height": 2.25,
            "draft": false,
            "ops": 4,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            }
          },
          {
            "key": "2:3:1",
            "index": 1,
            "name": "hotel with vertical fins and a roof sign",
            "height": 2.1,
            "draft": false,
            "ops": 12,
            "attrs": {
              "commerceType": "hotel",
              "openHours": [
                0,
                24
              ],
              "visitorCapacity": 18
            }
          },
          {
            "key": "2:3:2",
            "index": 2,
            "name": "stepped department store",
            "height": 1.9,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "department store",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            }
          },
          {
            "key": "2:3:3",
            "index": 3,
            "name": "stacked offset cubes",
            "height": 2.14,
            "draft": false,
            "ops": 4,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            }
          },
          {
            "key": "2:3:4",
            "index": 4,
            "name": "glass curtain-wall tower",
            "height": 2.08,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:5",
            "index": 5,
            "name": "Art Deco setback tower with spire",
            "height": 2.15,
            "draft": false,
            "ops": 4,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:6",
            "index": 6,
            "name": "twin towers on a podium",
            "height": 2.04,
            "draft": false,
            "ops": 5,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:7",
            "index": 7,
            "name": "tower on a wide shopfront podium",
            "height": 2.04,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:8",
            "index": 8,
            "name": "hotel tower with rooftop sign",
            "height": 1.98,
            "draft": false,
            "ops": 5,
            "attrs": {
              "commerceType": "hotel",
              "openHours": [
                0,
                24
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:9",
            "index": 9,
            "name": "corporate HQ with crown",
            "height": 2.22,
            "draft": false,
            "ops": 6,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:10",
            "index": 10,
            "name": "Chicago-school brick office",
            "height": 2.02,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:11",
            "index": 11,
            "name": "International-style slab on piloti",
            "height": 2.04,
            "draft": false,
            "ops": 6,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:12",
            "index": 12,
            "name": "brutalist office with heavy top",
            "height": 2.1,
            "draft": false,
            "ops": 5,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:13",
            "index": 13,
            "name": "tower with helipad",
            "height": 1.96,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:14",
            "index": 14,
            "name": "cylindrical tower on a shopfront base",
            "height": 2.12,
            "draft": false,
            "ops": 4,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:15",
            "index": 15,
            "name": "tower with sky garden",
            "height": 2.04,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:16",
            "index": 16,
            "name": "office with rooftop water tanks",
            "height": 2.12,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:17",
            "index": 17,
            "name": "stacked offset glass boxes",
            "height": 2.09,
            "draft": false,
            "ops": 6,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:18",
            "index": 18,
            "name": "L-shaped office block",
            "height": 1.94,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:19",
            "index": 19,
            "name": "bank tower on a colonnade",
            "height": 2.05,
            "draft": false,
            "ops": 11,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:20",
            "index": 20,
            "name": "department store tower",
            "height": 2.14,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "department store",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:21",
            "index": 21,
            "name": "convention-centre hotel",
            "height": 2.04,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "hotel",
              "openHours": [
                0,
                24
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:22",
            "index": 22,
            "name": "media tower with mast",
            "height": 2.22,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:23",
            "index": 23,
            "name": "slender green-glass tower",
            "height": 2.15,
            "draft": false,
            "ops": 5,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:24",
            "index": 24,
            "name": "Gothic-revival office with pinnacles",
            "height": 2,
            "draft": false,
            "ops": 12,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:25",
            "index": 25,
            "name": "postmodern tower with pediment roof",
            "height": 2,
            "draft": false,
            "ops": 6,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:26",
            "index": 26,
            "name": "mirror-glass twin slabs with skybridge",
            "height": 1.9,
            "draft": false,
            "ops": 5,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:27",
            "index": 27,
            "name": "mixed-use tower with flats above",
            "height": 2.03,
            "draft": false,
            "ops": 13,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:28",
            "index": 28,
            "name": "tower with clock face",
            "height": 2.24,
            "draft": false,
            "ops": 6,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:29",
            "index": 29,
            "name": "telecom office with mast and dish",
            "height": 2.08,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:30",
            "index": 30,
            "name": "tech campus with glass atrium",
            "height": 2.02,
            "draft": false,
            "ops": 6,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:31",
            "index": 31,
            "name": "insurance tower with dome",
            "height": 2.23,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:32",
            "index": 32,
            "name": "stock exchange with portico",
            "height": 1.94,
            "draft": false,
            "ops": 11,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:33",
            "index": 33,
            "name": "terracotta office with pier caps",
            "height": 1.9,
            "draft": false,
            "ops": 9,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:34",
            "index": 34,
            "name": "Art Deco stepped spire with gold bands",
            "height": 2.12,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "2:3:35",
            "index": 35,
            "name": "office with pitched copper roof and dormers",
            "height": 1.95,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 18
            },
            "author": "claude-haiku-5-5"
          }
        ]
      }
    ],
    "blurb": "Shops, cafés, bars and restaurants. They employ people on early, day and late shifts, take deliveries from industry, and double as somewhere to go: residents stop for a coffee or a meal, and visitors drive in from the edge of town.",
    "howTo": "Drag Commercial (5) over your own land beside a road; it grows when there are more people than jobs. Put shops where people pass and within a short drive of factories, whose trucks deliver to the nearest shop (or by train, through a freight line)."
  },
  {
    "id": "industrial",
    "name": "industrial",
    "kindId": 3,
    "code": 3,
    "family": "industrial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tool": {
      "id": "ind",
      "key": "6",
      "label": "Industrial",
      "color": "var(--ind)",
      "cost": 25
    },
    "tech": [
      "zon2"
    ],
    "occupation": {
      "name": "factory worker",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "goodsType": "manufactured"
    },
    "tints": [
      16777215,
      15920096,
      15264750,
      16181718,
      15331046
    ],
    "lotTint": 15777888,
    "levels": [
      {
        "level": 1,
        "capacity": 6,
        "wage": 14,
        "upkeep": 0,
        "cost": 0,
        "work": 60,
        "parking": {
          "surface": 2,
          "underground": 4
        },
        "tech": [
          "zon2"
        ],
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 1,
          "noise": 2
        },
        "designs": [
          {
            "key": "3:1:0",
            "index": 0,
            "name": "corrugated warehouse",
            "height": 0.54,
            "draft": false,
            "ops": 4,
            "attrs": {
              "goodsType": "storage",
              "pollution": 1,
              "noise": 2
            }
          },
          {
            "key": "3:1:1",
            "index": 1,
            "name": "brick workshop with sawtooth roof and roller door",
            "height": 0.5,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            }
          },
          {
            "key": "3:1:2",
            "index": 2,
            "name": "container yard with a shed",
            "height": 0.36,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "freight",
              "pollution": 1,
              "noise": 3
            }
          },
          {
            "key": "3:1:3",
            "index": 3,
            "name": "depot with three bay doors and a tank",
            "height": 0.4,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "freight",
              "pollution": 1,
              "noise": 2
            }
          },
          {
            "key": "3:1:4",
            "index": 4,
            "name": "brick works with a yard office",
            "height": 0.55,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:5",
            "index": 5,
            "name": "car repair garage with office",
            "height": 0.42,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:6",
            "index": 6,
            "name": "joinery workshop with flue",
            "height": 0.53,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:7",
            "index": 7,
            "name": "sawmill with log pile",
            "height": 0.42,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:8",
            "index": 8,
            "name": "blacksmith with chimney",
            "height": 0.57,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:9",
            "index": 9,
            "name": "small print works with roof vent",
            "height": 0.48,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:10",
            "index": 10,
            "name": "bakery works with flue",
            "height": 0.49,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:11",
            "index": 11,
            "name": "metal fabrication shed",
            "height": 0.5,
            "draft": false,
            "ops": 4,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:12",
            "index": 12,
            "name": "scrap yard with crane mast",
            "height": 0.53,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:13",
            "index": 13,
            "name": "tyre depot with tyre stacks",
            "height": 0.38,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:14",
            "index": 14,
            "name": "small brewery with copper vessel",
            "height": 0.46,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:15",
            "index": 15,
            "name": "dairy with milk tank",
            "height": 0.44,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:16",
            "index": 16,
            "name": "cold store with office",
            "height": 0.51,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:17",
            "index": 17,
            "name": "quonset hut",
            "height": 0.42,
            "draft": false,
            "ops": 4,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:18",
            "index": 18,
            "name": "timber yard shed on posts",
            "height": 0.42,
            "draft": false,
            "ops": 11,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:19",
            "index": 19,
            "name": "pottery with bottle kiln",
            "height": 0.48,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:20",
            "index": 20,
            "name": "boat builders shed with hull",
            "height": 0.44,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:21",
            "index": 21,
            "name": "small bus garage",
            "height": 0.38,
            "draft": false,
            "ops": 5,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:22",
            "index": 22,
            "name": "small warehouse with dock doors",
            "height": 0.48,
            "draft": false,
            "ops": 4,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:23",
            "index": 23,
            "name": "workshop with sawtooth roof",
            "height": 0.48,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:24",
            "index": 24,
            "name": "electrical substation in a fence",
            "height": 0.38,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:25",
            "index": 25,
            "name": "water pump house",
            "height": 0.4,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:26",
            "index": 26,
            "name": "laundry works with steam stack",
            "height": 0.59,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:27",
            "index": 27,
            "name": "textile workshop with bales",
            "height": 0.42,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:28",
            "index": 28,
            "name": "smoke house with flue",
            "height": 0.59,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:29",
            "index": 29,
            "name": "small foundry with tall chimney",
            "height": 0.57,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:30",
            "index": 30,
            "name": "container office stack",
            "height": 0.42,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:31",
            "index": 31,
            "name": "fuel depot with tanks",
            "height": 0.43,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:32",
            "index": 32,
            "name": "stonemasons yard",
            "height": 0.36,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:33",
            "index": 33,
            "name": "pallet works with stacked yard",
            "height": 0.4,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:34",
            "index": 34,
            "name": "spray paint shop with flue",
            "height": 0.5,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:1:35",
            "index": 35,
            "name": "example: brick works with loading doors",
            "height": 0.62,
            "draft": true,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 1,
              "noise": 2
            },
            "author": "docs example"
          }
        ]
      },
      {
        "level": 2,
        "capacity": 12,
        "wage": 19,
        "upkeep": 0,
        "cost": 0,
        "work": 120,
        "parking": {
          "surface": 2,
          "underground": 8
        },
        "tech": [
          "zon2",
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 2,
          "noise": 3
        },
        "designs": [
          {
            "key": "3:2:0",
            "index": 0,
            "name": "sawtooth factory with chimney",
            "height": 1.26,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            }
          },
          {
            "key": "3:2:1",
            "index": 1,
            "name": "grain silos and a shed",
            "height": 1,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "food",
              "pollution": 1,
              "noise": 3
            }
          },
          {
            "key": "3:2:2",
            "index": 2,
            "name": "gabled warehouse with loading dock and vents",
            "height": 0.95,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "storage",
              "pollution": 2,
              "noise": 3
            }
          },
          {
            "key": "3:2:3",
            "index": 3,
            "name": "brick mill with two stacks",
            "height": 1.2,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "textiles",
              "pollution": 2,
              "noise": 3
            }
          },
          {
            "key": "3:2:4",
            "index": 4,
            "name": "sawtooth factory with four roof bays",
            "height": 1,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:5",
            "index": 5,
            "name": "sawtooth works with glazed north roofs",
            "height": 1.05,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:6",
            "index": 6,
            "name": "Victorian cotton mill with tall chimney",
            "height": 1.1,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:7",
            "index": 7,
            "name": "brewery with a copper kettle tower",
            "height": 1.1,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:8",
            "index": 8,
            "name": "bottling plant with a storage tower",
            "height": 1.14,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:9",
            "index": 9,
            "name": "warehouse with three silos",
            "height": 1.05,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:10",
            "index": 10,
            "name": "cold store with refrigeration units",
            "height": 1.05,
            "draft": false,
            "ops": 10,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:11",
            "index": 11,
            "name": "food processing plant with stacks",
            "height": 1,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:12",
            "index": 12,
            "name": "printing works with a press hall",
            "height": 0.98,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:13",
            "index": 13,
            "name": "car parts factory with a gatehouse",
            "height": 1,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:14",
            "index": 14,
            "name": "textile mill with a water tower",
            "height": 0.96,
            "draft": false,
            "ops": 10,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:15",
            "index": 15,
            "name": "flour mill with a tall grain bin",
            "height": 1,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:16",
            "index": 16,
            "name": "packaging plant with a conveyor gantry",
            "height": 0.98,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:17",
            "index": 17,
            "name": "furniture factory with a dust extractor",
            "height": 1.05,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:18",
            "index": 18,
            "name": "paint works with storage tanks",
            "height": 1.08,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:19",
            "index": 19,
            "name": "plastics plant with pipework",
            "height": 1,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:20",
            "index": 20,
            "name": "rail-side goods shed with a water column",
            "height": 0.96,
            "draft": false,
            "ops": 5,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:21",
            "index": 21,
            "name": "tram depot with overhead masts",
            "height": 1,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:22",
            "index": 22,
            "name": "brick kiln works with beehive kilns",
            "height": 1,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:23",
            "index": 23,
            "name": "glassworks with a cone furnace",
            "height": 0.98,
            "draft": false,
            "ops": 5,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:24",
            "index": 24,
            "name": "pharmaceutical lab with a clean white hall",
            "height": 0.96,
            "draft": false,
            "ops": 5,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:25",
            "index": 25,
            "name": "electronics plant with a glazed front",
            "height": 0.96,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:26",
            "index": 26,
            "name": "dairy processing with steel tanks",
            "height": 0.96,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:27",
            "index": 27,
            "name": "timber treatment plant with a tank",
            "height": 1,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:28",
            "index": 28,
            "name": "distillery with pagoda roof vents",
            "height": 1,
            "draft": false,
            "ops": 10,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:29",
            "index": 29,
            "name": "water treatment works with round tanks",
            "height": 0.98,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:30",
            "index": 30,
            "name": "chemical drum store with a vent mast",
            "height": 1,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:31",
            "index": 31,
            "name": "rope works with a long thin shed",
            "height": 1,
            "draft": false,
            "ops": 5,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:32",
            "index": 32,
            "name": "cannery with a sealed steel tank",
            "height": 0.96,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:33",
            "index": 33,
            "name": "tannery with a drying tower",
            "height": 0.96,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:34",
            "index": 34,
            "name": "power substation with transformers",
            "height": 1,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:2:35",
            "index": 35,
            "name": "bakery works with a tall flue",
            "height": 0.98,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            },
            "author": "claude-haiku-5-5"
          }
        ]
      },
      {
        "level": 3,
        "capacity": 18,
        "wage": 24,
        "upkeep": 0,
        "cost": 0,
        "work": 180,
        "parking": {
          "surface": 2,
          "underground": 12
        },
        "tech": [
          "zon2",
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 4,
          "noise": 4
        },
        "designs": [
          {
            "key": "3:3:0",
            "index": 0,
            "name": "plant with chimney and tanks",
            "height": 2.1,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "chemicals",
              "pollution": 4,
              "noise": 4
            }
          },
          {
            "key": "3:3:1",
            "index": 1,
            "name": "refinery towers, pipework and flare",
            "height": 2.1,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "fuel",
              "pollution": 5,
              "noise": 4
            }
          },
          {
            "key": "3:3:2",
            "index": 2,
            "name": "heavy works with three stacks",
            "height": 1.95,
            "draft": false,
            "ops": 11,
            "attrs": {
              "goodsType": "steel",
              "pollution": 4,
              "noise": 5
            }
          },
          {
            "key": "3:3:3",
            "index": 3,
            "name": "cooling towers beside a hall",
            "height": 1.66,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "power",
              "pollution": 4,
              "noise": 4
            }
          },
          {
            "key": "3:3:4",
            "index": 4,
            "name": "steel works: blast furnace, hot stove and stack",
            "height": 1.8,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:5",
            "index": 5,
            "name": "steel mill: conveyor up to a tall bin",
            "height": 1.7,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:6",
            "index": 6,
            "name": "oil refinery: distillation columns and pipe bridge",
            "height": 1.9,
            "draft": false,
            "ops": 12,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:7",
            "index": 7,
            "name": "refinery tank farm with a tall flare",
            "height": 1.77,
            "draft": false,
            "ops": 12,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:8",
            "index": 8,
            "name": "grain elevator: row of silos and a head house",
            "height": 1.8,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:9",
            "index": 9,
            "name": "cement works: kiln hall, preheater tower and silos",
            "height": 1.8,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:10",
            "index": 10,
            "name": "coal-fired power hall with a chimney",
            "height": 1.98,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:11",
            "index": 11,
            "name": "chemical plant with spheres and a flare",
            "height": 1.65,
            "draft": false,
            "ops": 11,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:12",
            "index": 12,
            "name": "car assembly plant with sawtooth roofs",
            "height": 1.6,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:13",
            "index": 13,
            "name": "shipyard fabrication hall with gantry crane",
            "height": 1.81,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:14",
            "index": 14,
            "name": "paper mill with two steam stacks",
            "height": 1.67,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:15",
            "index": 15,
            "name": "aluminium smelter: two pot lines and a gas stack",
            "height": 1.7,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:16",
            "index": 16,
            "name": "fertiliser plant with a prilling tower",
            "height": 1.9,
            "draft": false,
            "ops": 5,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:17",
            "index": 17,
            "name": "container terminal stack with a gantry crane",
            "height": 1.9,
            "draft": false,
            "ops": 11,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:18",
            "index": 18,
            "name": "sugar refinery with a tall tower",
            "height": 2,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:19",
            "index": 19,
            "name": "brewery: brewhouse tower and fermenting tanks",
            "height": 1.84,
            "draft": false,
            "ops": 12,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:20",
            "index": 20,
            "name": "bakery mega-plant with a row of silos",
            "height": 1.64,
            "draft": false,
            "ops": 10,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:21",
            "index": 21,
            "name": "pharmaceutical complex: two towers over a podium",
            "height": 2,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:22",
            "index": 22,
            "name": "textile mega-mill with a stack",
            "height": 1.6,
            "draft": false,
            "ops": 5,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:23",
            "index": 23,
            "name": "aircraft hangar with garage doors across the front",
            "height": 1.62,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:24",
            "index": 24,
            "name": "coke ovens with a quench tower",
            "height": 1.86,
            "draft": false,
            "ops": 6,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:25",
            "index": 25,
            "name": "tyre factory with twin mixing towers",
            "height": 1.96,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:26",
            "index": 26,
            "name": "mining head-frame over a winding house",
            "height": 1.99,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:27",
            "index": 27,
            "name": "salt works: evaporation ponds, salt store and hoist",
            "height": 1.6,
            "draft": false,
            "ops": 10,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:28",
            "index": 28,
            "name": "lumber mill with drying kilns",
            "height": 1.9,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:29",
            "index": 29,
            "name": "water tower complex with pump house",
            "height": 1.7,
            "draft": false,
            "ops": 11,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:30",
            "index": 30,
            "name": "LNG storage tanks with compressor house and flare",
            "height": 1.66,
            "draft": false,
            "ops": 10,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:31",
            "index": 31,
            "name": "hydrogen plant with spheres and a stack",
            "height": 1.84,
            "draft": false,
            "ops": 11,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:32",
            "index": 32,
            "name": "rolling mill hall with overhead crane beam",
            "height": 1.65,
            "draft": false,
            "ops": 7,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "3:3:33",
            "index": 33,
            "name": "electric arc furnace shop with ladle crane",
            "height": 1.76,
            "draft": false,
            "ops": 9,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 4,
              "noise": 4
            },
            "author": "claude-haiku-5-5"
          }
        ]
      }
    ],
    "blurb": "Factories and warehouses: well-paid shift work round the clock, and the delivery trucks that keep the shops stocked. Industry is noisy and dirty, and its trucks fill the roads by day.",
    "howTo": "Drag Industrial (6) over your own land beside a road. Keep it a little away from homes but within a short drive of shops; a freight yard within 12 tiles lets its deliveries go by train."
  },
  {
    "id": "office",
    "name": "office",
    "kindId": 4,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "off",
      "key": "7",
      "label": "Office",
      "color": "#9b7fe0",
      "cost": 25
    },
    "tech": [
      "zon3"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "tints": [
      16777215,
      15397112,
      16053488,
      15002871,
      15855352
    ],
    "lotTint": 13215999,
    "levels": [
      {
        "level": 1,
        "capacity": 8,
        "wage": 20,
        "upkeep": 0,
        "cost": 0,
        "work": 60,
        "parking": {
          "surface": 1,
          "underground": 5
        },
        "tech": [
          "zon3"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "4:1:0",
            "index": 0,
            "name": "glass box on a dark plinth",
            "height": 1.17,
            "draft": false,
            "ops": 3,
            "attrs": {}
          },
          {
            "key": "4:1:1",
            "index": 1,
            "name": "brick office with window bands and a canopy",
            "height": 0.94,
            "draft": false,
            "ops": 5,
            "attrs": {}
          },
          {
            "key": "4:1:2",
            "index": 2,
            "name": "white concrete with dark glass columns",
            "height": 1.04,
            "draft": false,
            "ops": 12,
            "attrs": {}
          },
          {
            "key": "4:1:3",
            "index": 3,
            "name": "low campus pair with a link",
            "height": 0.83,
            "draft": false,
            "ops": 5,
            "attrs": {}
          }
        ]
      },
      {
        "level": 2,
        "capacity": 16,
        "wage": 26,
        "upkeep": 0,
        "cost": 0,
        "work": 120,
        "parking": {
          "surface": 1,
          "underground": 10
        },
        "tech": [
          "zon3",
          "con1"
        ],
        "feature": "level2",
        "attrs": {},
        "designs": [
          {
            "key": "4:2:0",
            "index": 0,
            "name": "pale tower with a dark crown",
            "height": 2.3,
            "draft": false,
            "ops": 3,
            "attrs": {}
          },
          {
            "key": "4:2:1",
            "index": 1,
            "name": "twin towers with a bridge",
            "height": 1.65,
            "draft": false,
            "ops": 5,
            "attrs": {}
          },
          {
            "key": "4:2:2",
            "index": 2,
            "name": "stone ziggurat",
            "height": 2.4,
            "draft": false,
            "ops": 5,
            "attrs": {}
          },
          {
            "key": "4:2:3",
            "index": 3,
            "name": "dark glass slab with a white spine",
            "height": 2.4,
            "draft": false,
            "ops": 4,
            "attrs": {}
          }
        ]
      },
      {
        "level": 3,
        "capacity": 24,
        "wage": 32,
        "upkeep": 0,
        "cost": 0,
        "work": 180,
        "parking": {
          "surface": 1,
          "underground": 15
        },
        "tech": [
          "zon3",
          "con2"
        ],
        "feature": "level3",
        "attrs": {},
        "designs": [
          {
            "key": "4:3:0",
            "index": 0,
            "name": "dark glass tower with a lit crown and mast",
            "height": 3.4,
            "draft": false,
            "ops": 4,
            "attrs": {}
          },
          {
            "key": "4:3:1",
            "index": 1,
            "name": "tapered tower with a spire",
            "height": 3.7,
            "draft": false,
            "ops": 5,
            "attrs": {}
          },
          {
            "key": "4:3:2",
            "index": 2,
            "name": "paired wings with a sky bridge",
            "height": 3.05,
            "draft": false,
            "ops": 5,
            "attrs": {}
          },
          {
            "key": "4:3:3",
            "index": 3,
            "name": "wide slab on a podium with a helipad",
            "height": 2.97,
            "draft": false,
            "ops": 10,
            "attrs": {}
          }
        ]
      }
    ],
    "blurb": "Office towers: the most jobs per tile, mostly nine to five on weekdays, so the heaviest commuter rush in the morning and the evening.",
    "howTo": "Drag Office (7) over your own land beside a road; it needs Office zoning. Offices pull commuters from far away, so give them good roads, parking or a bus line."
  },
  {
    "id": "police",
    "name": "police station",
    "kindId": 5,
    "code": 5,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "police",
      "key": "8",
      "label": "Police station",
      "color": "#3454a8",
      "cost": 400
    },
    "tech": [
      "civ1"
    ],
    "occupation": {
      "name": "police officer",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 12,
        "wage": 20,
        "upkeep": 20,
        "cost": 400,
        "work": 300,
        "parking": {
          "surface": 4,
          "underground": 10
        },
        "tech": [
          "civ1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "5:1:0",
            "index": 0,
            "name": "station with a navy band and radio mast",
            "height": 0.63,
            "draft": false,
            "ops": 5,
            "attrs": {}
          }
        ]
      }
    ],
    "group": "police",
    "tier": 3,
    "blurb": "The town police station: a dozen officers on rotating shifts, a front counter and patrol cars. A full police service for the homes around it.",
    "howTo": "One tile beside a road. Smaller posts and boxes fill gaps; a divisional station or headquarters covers more."
  },
  {
    "id": "fire",
    "name": "fire station",
    "kindId": 6,
    "code": 6,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "fire",
      "key": "9",
      "label": "Fire station",
      "color": "#d6453a",
      "cost": 400
    },
    "tech": [
      "civ1"
    ],
    "occupation": {
      "name": "firefighter",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 24,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 9,
        "wage": 20,
        "upkeep": 20,
        "cost": 400,
        "work": 300,
        "parking": {
          "surface": 3,
          "underground": 6
        },
        "tech": [
          "civ1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "6:1:0",
            "index": 0,
            "name": "red station with two bay doors and a drill tower",
            "height": 1,
            "draft": false,
            "ops": 5,
            "attrs": {}
          }
        ]
      }
    ],
    "group": "fire",
    "tier": 2,
    "blurb": "Two appliance bays, a drill tower and a watch on 24-hour shifts. A full fire service for the homes around it.",
    "howTo": "One tile beside a road. Fire posts fill gaps cheaply; a large station covers more."
  },
  {
    "id": "hospital",
    "name": "hospital",
    "kindId": 7,
    "code": 7,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "hospital",
      "key": "0",
      "label": "Hospital",
      "color": "#f4f4f4",
      "cost": 900
    },
    "tech": [
      "civ2"
    ],
    "occupation": {
      "name": "hospital staff",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 12,
          "weight": 1
        },
        {
          "start": 19,
          "hours": 12,
          "weight": 0.8
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 26,
        "upkeep": 50,
        "cost": 900,
        "work": 300,
        "parking": {
          "surface": 6,
          "underground": 20
        },
        "tech": [
          "civ2"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "7:1:0",
            "index": 0,
            "name": "white block with a roof cross and helipad",
            "height": 1.15,
            "draft": false,
            "ops": 11,
            "attrs": {}
          }
        ]
      }
    ],
    "group": "health",
    "tier": 4,
    "blurb": "A compact city hospital stacked on one plot: wards, a casualty door and a helipad, with ambulances out. A full health service for the homes around it.",
    "howTo": "One tile beside a road. Space-efficient but cramped; the community and general hospitals reach further."
  },
  {
    "id": "yard",
    "name": "builders' yard",
    "kindId": 8,
    "code": 8,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "yard",
      "key": "Y",
      "label": "Builders' yard",
      "color": "#a8713f",
      "cost": 300
    },
    "tech": [],
    "occupation": {
      "name": "builder",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 10,
        "wage": 16,
        "upkeep": 15,
        "cost": 300,
        "work": 300,
        "parking": {
          "surface": 6,
          "underground": 10
        },
        "tech": [],
        "attrs": {},
        "designs": [
          {
            "key": "8:1:0",
            "index": 0,
            "name": "shed, material heaps and a tower crane",
            "height": 1,
            "draft": false,
            "ops": 12,
            "attrs": {}
          }
        ]
      }
    ],
    "group": "builders",
    "tier": 2,
    "blurb": "Ten builders, a shed and a tower crane. Builders go to the most urgent site anywhere on the road network and earn the yard's owner a fee.",
    "howTo": "One tile beside a road. Nothing gets built without builders; place one early."
  },
  {
    "id": "parking",
    "name": "parking lot",
    "kindId": 9,
    "code": 9,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": true,
      "leisureReady": false
    },
    "windows": "shop",
    "tool": {
      "id": "park",
      "key": "P",
      "label": "Parking lot",
      "color": "#5c6270",
      "cost": 150
    },
    "tech": [
      "tr1"
    ],
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 2,
        "cost": 150,
        "work": 0,
        "parking": {
          "surface": 12,
          "underground": 12
        },
        "tech": [
          "tr1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "9:1:0",
            "index": 0,
            "name": "kerb, bay lines, a booth and a sign (the cars come from live occupancy)",
            "height": 0.3,
            "draft": false,
            "ops": 23,
            "attrs": {}
          },
          {
            "key": "9:1:1",
            "index": 1,
            "name": "the lot with a billboard over the back row",
            "height": 0.5,
            "draft": false,
            "ops": 28,
            "attrs": {},
            "author": "claude-opus-5-5"
          }
        ]
      }
    ],
    "group": "parking",
    "tier": 2,
    "blurb": "A surface lot with a dozen bays, painted and paved at once. Drivers who find no space at their destination park here, walk on and pay you a fee.",
    "howTo": "One tile beside a road near shops and offices that fill up. No builders needed."
  },
  {
    "id": "park",
    "name": "park",
    "kindId": 10,
    "code": 10,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tool": {
      "id": "citypark",
      "key": "G",
      "label": "Park",
      "color": "#4f9a5c",
      "cost": 120
    },
    "tech": [],
    "attrs": {
      "venueType": "park",
      "openHours": [
        6,
        22
      ],
      "ticket": 0,
      "stay": [
        0.5,
        1.5
      ],
      "dayAppeal": 1.2,
      "eveningAppeal": 0.35,
      "retireeAppeal": 1.8,
      "childAppeal": 2
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 3,
        "cost": 120,
        "work": 300,
        "parking": {
          "surface": 2,
          "underground": 2
        },
        "tech": [],
        "attrs": {
          "venueType": "park",
          "openHours": [
            6,
            22
          ],
          "ticket": 0,
          "stay": [
            0.5,
            1.5
          ],
          "dayAppeal": 1.2,
          "eveningAppeal": 0.35,
          "retireeAppeal": 1.8,
          "childAppeal": 2,
          "title": "pocket park",
          "visitorCapacity": 12,
          "leisureValue": 3,
          "radius": 8,
          "upgradeVisits": 24
        },
        "designs": [
          {
            "key": "10:1:0",
            "index": 0,
            "name": "pocket park with cross paths and a flower bed",
            "height": 0.1,
            "draft": false,
            "ops": 16,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1.2,
              "eveningAppeal": 0.35,
              "retireeAppeal": 1.8,
              "childAppeal": 2,
              "title": "pocket park",
              "visitorCapacity": 12,
              "leisureValue": 3,
              "radius": 8,
              "upgradeVisits": 24,
              "paths": "cross",
              "trees": 4,
              "benches": 2
            }
          },
          {
            "key": "10:1:1",
            "index": 1,
            "name": "pocket park with a ring path and a sandpit",
            "height": 0.16,
            "draft": false,
            "ops": 12,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1.2,
              "eveningAppeal": 0.35,
              "retireeAppeal": 1.8,
              "childAppeal": 2,
              "title": "pocket park",
              "visitorCapacity": 12,
              "leisureValue": 3,
              "radius": 8,
              "upgradeVisits": 24,
              "paths": "ring",
              "trees": 5,
              "benches": 2
            }
          }
        ]
      },
      {
        "level": 2,
        "capacity": 0,
        "wage": 0,
        "upkeep": 5,
        "cost": 120,
        "work": 300,
        "parking": {
          "surface": 2,
          "underground": 2
        },
        "tech": [],
        "attrs": {
          "venueType": "park",
          "openHours": [
            6,
            22
          ],
          "ticket": 0,
          "stay": [
            0.5,
            1.5
          ],
          "dayAppeal": 1.2,
          "eveningAppeal": 0.35,
          "retireeAppeal": 1.8,
          "childAppeal": 2,
          "title": "park",
          "visitorCapacity": 24,
          "leisureValue": 5,
          "radius": 10,
          "upgradeVisits": 50
        },
        "designs": [
          {
            "key": "10:2:0",
            "index": 0,
            "name": "park with cross paths, hedges and a fountain",
            "height": 0.2,
            "draft": false,
            "ops": 18,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1.2,
              "eveningAppeal": 0.35,
              "retireeAppeal": 1.8,
              "childAppeal": 2,
              "title": "park",
              "visitorCapacity": 24,
              "leisureValue": 5,
              "radius": 10,
              "upgradeVisits": 50,
              "paths": "cross",
              "trees": 7,
              "benches": 4
            }
          },
          {
            "key": "10:2:1",
            "index": 1,
            "name": "park with a ring path and a bandstand",
            "height": 0.32,
            "draft": false,
            "ops": 15,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1.2,
              "eveningAppeal": 0.35,
              "retireeAppeal": 1.8,
              "childAppeal": 2,
              "title": "park",
              "visitorCapacity": 24,
              "leisureValue": 5,
              "radius": 10,
              "upgradeVisits": 50,
              "paths": "ring",
              "trees": 7,
              "benches": 4,
              "eventNights": [
                6
              ],
              "eventStart": 15
            }
          }
        ]
      },
      {
        "level": 3,
        "capacity": 0,
        "wage": 0,
        "upkeep": 8,
        "cost": 120,
        "work": 300,
        "parking": {
          "surface": 2,
          "underground": 2
        },
        "tech": [],
        "attrs": {
          "venueType": "park",
          "openHours": [
            6,
            22
          ],
          "ticket": 0,
          "stay": [
            0.5,
            1.5
          ],
          "dayAppeal": 1.2,
          "eveningAppeal": 0.35,
          "retireeAppeal": 1.8,
          "childAppeal": 2,
          "title": "large park",
          "visitorCapacity": 40,
          "leisureValue": 8,
          "radius": 12
        },
        "designs": [
          {
            "key": "10:3:0",
            "index": 0,
            "name": "large park: plaza, tiered fountain and a tea pavilion",
            "height": 0.36,
            "draft": false,
            "ops": 23,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1.2,
              "eveningAppeal": 0.35,
              "retireeAppeal": 1.8,
              "childAppeal": 2,
              "title": "large park",
              "visitorCapacity": 40,
              "leisureValue": 8,
              "radius": 12,
              "paths": "plaza",
              "trees": 9,
              "benches": 6,
              "eventNights": [
                6
              ],
              "eventStart": 14
            }
          },
          {
            "key": "10:3:1",
            "index": 1,
            "name": "large park with a boating pond, footbridge and kiosk",
            "height": 0.22,
            "draft": false,
            "ops": 13,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1.2,
              "eveningAppeal": 0.35,
              "retireeAppeal": 1.8,
              "childAppeal": 2,
              "title": "large park",
              "visitorCapacity": 40,
              "leisureValue": 8,
              "radius": 12,
              "paths": "pond",
              "trees": 9,
              "benches": 4
            }
          }
        ]
      }
    ],
    "group": "park",
    "tier": 1,
    "blurb": "A one-tile park that grows with use: a pocket park becomes a park with a fountain or a bandstand, then a large park with a tea pavilion or a boating pond.",
    "howTo": "Drop one beside a road among homes; no technology needed. The busier it is, the sooner the builders add to it."
  },
  {
    "id": "cinema",
    "name": "cinema",
    "kindId": 11,
    "code": 11,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "cinema",
      "key": "",
      "label": "Cinema",
      "color": "#b8434f",
      "cost": 700
    },
    "tech": [
      "cul2"
    ],
    "occupation": {
      "name": "cinema usher",
      "rotate": true,
      "shifts": [
        {
          "start": 12,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "cinema",
      "openHours": [
        12,
        24
      ],
      "visitorCapacity": 30,
      "ticket": 8,
      "stay": [
        2,
        2.6
      ],
      "leisureValue": 4,
      "radius": 14,
      "eventNights": [
        4,
        5
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.25,
      "eveningAppeal": 1.6,
      "retireeAppeal": 0.7,
      "childAppeal": 1.2
    },
    "levels": [
      {
        "level": 1,
        "capacity": 6,
        "wage": 14,
        "upkeep": 12,
        "cost": 700,
        "work": 300,
        "parking": {
          "surface": 6,
          "underground": 16
        },
        "tech": [
          "cul2"
        ],
        "attrs": {
          "venueType": "cinema",
          "openHours": [
            12,
            24
          ],
          "visitorCapacity": 30,
          "ticket": 8,
          "stay": [
            2,
            2.6
          ],
          "leisureValue": 4,
          "radius": 14,
          "eventNights": [
            4,
            5
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.25,
          "eveningAppeal": 1.6,
          "retireeAppeal": 0.7,
          "childAppeal": 1.2
        },
        "designs": [
          {
            "key": "11:1:0",
            "index": 0,
            "name": "art-deco picture house with a bulb marquee and a sign blade",
            "height": 0.86,
            "draft": false,
            "ops": 16,
            "attrs": {
              "venueType": "cinema",
              "openHours": [
                12,
                24
              ],
              "visitorCapacity": 30,
              "ticket": 8,
              "stay": [
                2,
                2.6
              ],
              "leisureValue": 4,
              "radius": 14,
              "eventNights": [
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.25,
              "eveningAppeal": 1.6,
              "retireeAppeal": 0.7,
              "childAppeal": 1.2
            }
          },
          {
            "key": "11:1:1",
            "index": 1,
            "name": "multiplex with a glass foyer and a poster wall",
            "height": 0.74,
            "draft": false,
            "ops": 17,
            "attrs": {
              "venueType": "cinema",
              "openHours": [
                12,
                24
              ],
              "visitorCapacity": 30,
              "ticket": 8,
              "stay": [
                2,
                2.6
              ],
              "leisureValue": 4,
              "radius": 14,
              "eventNights": [
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.25,
              "eveningAppeal": 1.6,
              "retireeAppeal": 0.7,
              "childAppeal": 1.2
            }
          }
        ]
      }
    ],
    "group": "cinema",
    "tier": 2,
    "blurb": "A picture house of a few screens with premieres on Friday and Saturday nights. Evening crowds and ticket sales taxed in your parcel.",
    "howTo": "One tile on a busy street; give it parking nearby for premiere nights."
  },
  {
    "id": "theatre",
    "name": "theatre",
    "kindId": 12,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "theatre",
      "key": "V",
      "label": "Theatre",
      "color": "#7a3e8f",
      "cost": 1200
    },
    "tech": [
      "cul3"
    ],
    "occupation": {
      "name": "theatre staff",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        14,
        24
      ],
      "visitorCapacity": 40,
      "ticket": 14,
      "stay": [
        2.4,
        3
      ],
      "leisureValue": 6,
      "radius": 18,
      "eventNights": [
        3,
        4,
        5
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.15,
      "eveningAppeal": 1.2,
      "retireeAppeal": 1.3,
      "childAppeal": 0.4
    },
    "levels": [
      {
        "level": 1,
        "capacity": 10,
        "wage": 18,
        "upkeep": 20,
        "cost": 1200,
        "work": 300,
        "parking": {
          "surface": 6,
          "underground": 20
        },
        "tech": [
          "cul3"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            14,
            24
          ],
          "visitorCapacity": 40,
          "ticket": 14,
          "stay": [
            2.4,
            3
          ],
          "leisureValue": 6,
          "radius": 18,
          "eventNights": [
            3,
            4,
            5
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.15,
          "eveningAppeal": 1.2,
          "retireeAppeal": 1.3,
          "childAppeal": 0.4
        },
        "designs": [
          {
            "key": "12:1:0",
            "index": 0,
            "name": "classical playhouse with a portico and a fly tower",
            "height": 0.96,
            "draft": false,
            "ops": 21,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                14,
                24
              ],
              "visitorCapacity": 40,
              "ticket": 14,
              "stay": [
                2.4,
                3
              ],
              "leisureValue": 6,
              "radius": 18,
              "eventNights": [
                3,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.2,
              "retireeAppeal": 1.3,
              "childAppeal": 0.4
            }
          },
          {
            "key": "12:1:1",
            "index": 1,
            "name": "modern theatre with a glass drum foyer and banners",
            "height": 0.84,
            "draft": false,
            "ops": 11,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                14,
                24
              ],
              "visitorCapacity": 40,
              "ticket": 14,
              "stay": [
                2.4,
                3
              ],
              "leisureValue": 6,
              "radius": 18,
              "eventNights": [
                3,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.2,
              "retireeAppeal": 1.3,
              "childAppeal": 0.4
            }
          }
        ]
      }
    ],
    "group": "theatre",
    "tier": 2,
    "blurb": "A playhouse with performances three nights a week. The best night out in town until the opera house, drawing people from far away.",
    "howTo": "One tile near restaurants and bars, where theatre-goers eat before the show."
  },
  {
    "id": "sports",
    "name": "sports hall",
    "kindId": 13,
    "code": 13,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "sports",
      "key": "B",
      "label": "Sports hall",
      "color": "#2f6fb5",
      "cost": 600
    },
    "tech": [
      "cul2"
    ],
    "occupation": {
      "name": "leisure attendant",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "sports",
      "openHours": [
        7,
        22
      ],
      "visitorCapacity": 24,
      "ticket": 5,
      "stay": [
        1.2,
        2.2
      ],
      "leisureValue": 4,
      "radius": 12,
      "eventNights": [
        2,
        5
      ],
      "eventStart": 19,
      "dayAppeal": 0.6,
      "eveningAppeal": 1.2,
      "retireeAppeal": 0.4,
      "childAppeal": 1.4
    },
    "levels": [
      {
        "level": 1,
        "capacity": 5,
        "wage": 14,
        "upkeep": 10,
        "cost": 600,
        "work": 300,
        "parking": {
          "surface": 6,
          "underground": 14
        },
        "tech": [
          "cul2"
        ],
        "attrs": {
          "venueType": "sports",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 24,
          "ticket": 5,
          "stay": [
            1.2,
            2.2
          ],
          "leisureValue": 4,
          "radius": 12,
          "eventNights": [
            2,
            5
          ],
          "eventStart": 19,
          "dayAppeal": 0.6,
          "eveningAppeal": 1.2,
          "retireeAppeal": 0.4,
          "childAppeal": 1.4
        },
        "designs": [
          {
            "key": "13:1:0",
            "index": 0,
            "name": "sports hall with a long pitched roof and a blue entrance",
            "height": 0.62,
            "draft": false,
            "ops": 7,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 24,
              "ticket": 5,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 4,
              "radius": 12,
              "eventNights": [
                2,
                5
              ],
              "eventStart": 19,
              "dayAppeal": 0.6,
              "eveningAppeal": 1.2,
              "retireeAppeal": 0.4,
              "childAppeal": 1.4
            }
          },
          {
            "key": "13:1:1",
            "index": 1,
            "name": "brick hall beside a floodlit five-a-side court",
            "height": 0.82,
            "draft": false,
            "ops": 19,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 24,
              "ticket": 5,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 4,
              "radius": 12,
              "eventNights": [
                2,
                5
              ],
              "eventStart": 19,
              "dayAppeal": 0.6,
              "eveningAppeal": 1.2,
              "retireeAppeal": 0.4,
              "childAppeal": 1.4
            }
          }
        ]
      }
    ],
    "group": "sports",
    "tier": 1,
    "blurb": "A hall or a floodlit five-a-side court with match nights twice a week. Popular with children and anyone after work.",
    "howTo": "One tile among homes. A leisure centre adds a pool; arenas and stadiums bring the big crowds."
  },
  {
    "id": "library",
    "name": "library",
    "kindId": 14,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "office",
    "tool": {
      "id": "library",
      "key": "L",
      "label": "Library",
      "color": "#a8875a",
      "cost": 450
    },
    "tech": [
      "cul1"
    ],
    "occupation": {
      "name": "librarian",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        19
      ],
      "visitorCapacity": 16,
      "ticket": 0,
      "stay": [
        0.6,
        1.8
      ],
      "leisureValue": 3,
      "radius": 10,
      "dayAppeal": 1,
      "eveningAppeal": 0.3,
      "retireeAppeal": 2,
      "childAppeal": 1.6
    },
    "levels": [
      {
        "level": 1,
        "capacity": 4,
        "wage": 16,
        "upkeep": 10,
        "cost": 450,
        "work": 300,
        "parking": {
          "surface": 3,
          "underground": 6
        },
        "tech": [
          "cul1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            19
          ],
          "visitorCapacity": 16,
          "ticket": 0,
          "stay": [
            0.6,
            1.8
          ],
          "leisureValue": 3,
          "radius": 10,
          "dayAppeal": 1,
          "eveningAppeal": 0.3,
          "retireeAppeal": 2,
          "childAppeal": 1.6
        },
        "designs": [
          {
            "key": "14:1:0",
            "index": 0,
            "name": "stone library with steps, columns and a dome",
            "height": 0.78,
            "draft": false,
            "ops": 12,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 16,
              "ticket": 0,
              "stay": [
                0.6,
                1.8
              ],
              "leisureValue": 3,
              "radius": 10,
              "dayAppeal": 1,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2,
              "childAppeal": 1.6
            }
          },
          {
            "key": "14:1:1",
            "index": 1,
            "name": "timber community hall with a porch and a noticeboard",
            "height": 0.62,
            "draft": false,
            "ops": 12,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                22
              ],
              "visitorCapacity": 20,
              "ticket": 2,
              "stay": [
                0.6,
                1.8
              ],
              "leisureValue": 3,
              "radius": 10,
              "dayAppeal": 1,
              "eveningAppeal": 0.8,
              "retireeAppeal": 2,
              "childAppeal": 1.6,
              "title": "community hall",
              "eventNights": [
                1
              ],
              "eventStart": 19
            }
          }
        ]
      }
    ],
    "group": "library",
    "tier": 1,
    "blurb": "A library or a community hall: free daytime outings that retirees and children love, and a quiz night at the hall.",
    "howTo": "One tile in a neighbourhood; free places close to home are where children go on their own."
  },
  {
    "id": "airport",
    "name": "airport terminal",
    "kindId": 15,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "airport",
      "key": "J",
      "label": "Airport terminal (8×7)",
      "color": "#5d8fc9",
      "cost": 6000
    },
    "tech": [
      "tr4"
    ],
    "occupation": {
      "name": "ground crew",
      "rotate": true,
      "shifts": [
        {
          "start": 5,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 9,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 28,
        "wage": 22,
        "upkeep": 140,
        "cost": 6000,
        "work": 300,
        "parking": {
          "surface": 14,
          "underground": 40
        },
        "tech": [
          "tr4"
        ],
        "attrs": {
          "gates": 2,
          "noise": 4,
          "gateway": "air",
          "gatewayModes": [
            "taxi",
            "foot"
          ],
          "arrivalsPerHour": 6
        },
        "designs": [
          {
            "key": "15:1:0",
            "index": 0,
            "name": "glass hall with jet bridges and a control tower",
            "height": 2.42,
            "draft": false,
            "ops": 79,
            "attrs": {
              "gates": 2,
              "noise": 4,
              "gateway": "air",
              "gatewayModes": [
                "taxi",
                "foot"
              ],
              "arrivalsPerHour": 6
            }
          },
          {
            "key": "15:1:1",
            "index": 1,
            "name": "regional terminal with a brick tower and boarding stairs",
            "height": 1.94,
            "draft": false,
            "ops": 72,
            "attrs": {
              "gates": 2,
              "noise": 4,
              "gateway": "air",
              "gatewayModes": [
                "taxi",
                "foot"
              ],
              "arrivalsPerHour": 6
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 8,
      "h": 7,
      "door": [
        4,
        6
      ],
      "marks": [
        {
          "kind": "apron",
          "at": {
            "edge": "back",
            "depth": 4
          },
          "label": "apron"
        },
        {
          "kind": "stand",
          "at": [
            2,
            2
          ],
          "label": "stand 1"
        },
        {
          "kind": "stand",
          "at": [
            5,
            2
          ],
          "label": "stand 2"
        },
        {
          "kind": "gate",
          "at": {
            "edge": "back"
          },
          "label": "airside edge (runway 5 tiles behind)"
        }
      ]
    },
    "blurb": "An airport terminal with two gates and an apron for parked planes, staffed by ground crew on early and late shifts. With a runway behind it, it is an airport: planes land and take off on a timetable, and every landing pays the owner a fee.",
    "howTo": "Eight tiles across and seven deep: click the door tile (the middle of the front row) beside a road; Z and C turn it. Then paint a runway (U) of 10 or more tiles, five rows behind its back row and spanning its whole width. Needs Aviation."
  },
  {
    "id": "bus-depot",
    "name": "bus depot",
    "kindId": 16,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "busdepot",
      "key": "K",
      "label": "Bus depot (3×2)",
      "color": "#e0a92e",
      "cost": 1200
    },
    "tech": [
      "tr5"
    ],
    "occupation": {
      "name": "bus driver",
      "rotate": true,
      "shifts": [
        {
          "start": 5,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 9,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.25
        },
        {
          "start": 17,
          "hours": 8,
          "weight": 0.25
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "gateway": "bus",
      "gatewayModes": [
        "foot",
        "taxi"
      ],
      "arrivalsPerHour": 10
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 19,
        "upkeep": 30,
        "cost": 1200,
        "work": 300,
        "parking": {
          "surface": 6,
          "underground": 12
        },
        "tech": [
          "tr5"
        ],
        "attrs": {
          "gateway": "bus",
          "gatewayModes": [
            "foot",
            "taxi"
          ],
          "arrivalsPerHour": 10
        },
        "designs": [
          {
            "key": "16:1:0",
            "index": 0,
            "name": "three-bay bus shed with an office and buses on the forecourt",
            "height": 0.76,
            "draft": false,
            "ops": 24,
            "attrs": {
              "gateway": "bus",
              "gatewayModes": [
                "foot",
                "taxi"
              ],
              "arrivalsPerHour": 10
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 2,
      "door": [
        1,
        1
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 1,
            "to": 2
          },
          "label": "vehicle gate"
        }
      ]
    },
    "blurb": "Where the buses live. Its staff are mostly drivers (the rest are mechanics), and every driver on shift takes a bus out onto a line between 05:30 and 00:30.",
    "howTo": "Three tiles across and two deep, the door facing a road (Z and C turn it). Put it near the lines it serves: buses drive from the depot to their first stop. Make lines in the lines panel; needs Public transport."
  },
  {
    "id": "bus-stop",
    "name": "bus stop",
    "kindId": 17,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "busstop",
      "key": "",
      "label": "Bus stop",
      "color": "#f0c419",
      "cost": 120
    },
    "tech": [
      "tr5"
    ],
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 1,
        "cost": 120,
        "work": 0,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "tr5"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "17:1:0",
            "index": 0,
            "name": "glass shelter with a bench, a timetable post and a flag sign at the kerb",
            "height": 0.5,
            "draft": false,
            "ops": 21,
            "attrs": {}
          }
        ]
      }
    ],
    "blurb": "A shelter where riders wait. A citizen whose car is at home weighs a bus ride against walking and driving when a stop of one line is within 5 tiles of both ends of the trip.",
    "howTo": "Place it on your land beside a plain stretch of road, not facing a junction: the bus pulls in on that road tile. One a block along a line covers a street; then add it to a line in the lines panel."
  },
  {
    "id": "rail-halt",
    "name": "rail halt",
    "kindId": 18,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "railhalt",
      "key": "[",
      "label": "Rail halt (4×2)",
      "color": "#b0563d",
      "cost": 1500
    },
    "tech": [
      "tr6"
    ],
    "occupation": {
      "name": "station staff",
      "rotate": true,
      "shifts": [
        {
          "start": 5,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 17,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 3,
        "wage": 18,
        "upkeep": 20,
        "cost": 1500,
        "work": 300,
        "parking": {
          "surface": 2,
          "underground": 6
        },
        "tech": [
          "tr6"
        ],
        "attrs": {
          "platformTiles": 4,
          "title": "rail halt",
          "gateway": "rail",
          "gatewayModes": [
            "foot",
            "taxi"
          ],
          "arrivalsPerHour": 8
        },
        "designs": [
          {
            "key": "18:1:0",
            "index": 0,
            "name": "country halt: timber shelter, gravel path and a ticket hut by the road",
            "height": 0.7,
            "draft": false,
            "ops": 38,
            "attrs": {
              "platformTiles": 4,
              "title": "rail halt",
              "gateway": "rail",
              "gatewayModes": [
                "foot",
                "taxi"
              ],
              "arrivalsPerHour": 8
            }
          },
          {
            "key": "18:1:1",
            "index": 1,
            "name": "concrete halt: glass shelter, ticket machine, covered bike racks",
            "height": 0.62,
            "draft": false,
            "ops": 43,
            "attrs": {
              "platformTiles": 4,
              "title": "rail halt",
              "gateway": "rail",
              "gatewayModes": [
                "foot",
                "taxi"
              ],
              "arrivalsPerHour": 8
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 2,
      "door": [
        1,
        1
      ],
      "marks": [
        {
          "kind": "platform",
          "at": {
            "edge": "back",
            "depth": 1
          },
          "label": "platform, track behind"
        }
      ]
    },
    "blurb": "A small station with a four-tile platform and three staff. Trains of the lines that call here stop with their middle at the platform's middle, and riders get on and off.",
    "howTo": "Four tiles across and two deep: the door faces a road and the back row is the platform. Lay track along the row just behind it, the whole width, joined tile to tile; then add it to a rail line. Needs Rail."
  },
  {
    "id": "rail-station",
    "name": "rail station",
    "kindId": 19,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "railstation",
      "key": "]",
      "label": "Rail station (6×3)",
      "color": "#8c3b2b",
      "cost": 5000
    },
    "tech": [
      "tr6"
    ],
    "occupation": {
      "name": "station staff",
      "rotate": true,
      "shifts": [
        {
          "start": 5,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 17,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 12,
        "wage": 20,
        "upkeep": 80,
        "cost": 5000,
        "work": 300,
        "parking": {
          "surface": 8,
          "underground": 24
        },
        "tech": [
          "tr6"
        ],
        "attrs": {
          "platformTiles": 6,
          "title": "rail station",
          "gateway": "rail",
          "gatewayModes": [
            "foot",
            "taxi"
          ],
          "arrivalsPerHour": 24
        },
        "designs": [
          {
            "key": "19:1:0",
            "index": 0,
            "name": "brick station: clock tower, ironwork canopy over the platform, taxi forecourt",
            "height": 1.65,
            "draft": false,
            "ops": 56,
            "attrs": {
              "platformTiles": 6,
              "title": "rail station",
              "gateway": "rail",
              "gatewayModes": [
                "foot",
                "taxi"
              ],
              "arrivalsPerHour": 24
            }
          },
          {
            "key": "19:1:1",
            "index": 1,
            "name": "glass concourse: long steel canopy, glazed hall, bus and taxi forecourt",
            "height": 1.2,
            "draft": false,
            "ops": 65,
            "attrs": {
              "platformTiles": 6,
              "title": "rail station",
              "gateway": "rail",
              "gatewayModes": [
                "foot",
                "taxi"
              ],
              "arrivalsPerHour": 24
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 6,
      "h": 3,
      "door": [
        2,
        2
      ],
      "marks": [
        {
          "kind": "platform",
          "at": {
            "edge": "back",
            "depth": 1
          },
          "label": "platform, track behind"
        }
      ]
    },
    "blurb": "A town station with a six-tile platform, a concourse and a clock tower, staffed on early, late and evening turns. Longer platforms take longer trains: a train is as long as the shortest platform on its line allows.",
    "howTo": "Six tiles across and three deep, the door facing a road and the platform along the back row. Lay track along the row behind the platform for its whole width; consecutive stations of a line must be joined by track. Needs Rail."
  },
  {
    "id": "freight-yard",
    "name": "freight yard",
    "kindId": 20,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tool": {
      "id": "freightyard",
      "key": "\\",
      "label": "Freight yard (6×3)",
      "color": "#c2762e",
      "cost": 4000
    },
    "tech": [
      "tr6"
    ],
    "occupation": {
      "name": "yard crew",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 10,
        "wage": 21,
        "upkeep": 60,
        "cost": 4000,
        "work": 300,
        "parking": {
          "surface": 4,
          "underground": 10
        },
        "tech": [
          "tr6"
        ],
        "attrs": {
          "platformTiles": 6,
          "title": "freight yard",
          "noise": 3
        },
        "designs": [
          {
            "key": "20:1:0",
            "index": 0,
            "name": "container terminal: a gantry crane over the dock, container stacks, a gatehouse on the road",
            "height": 1.24,
            "draft": false,
            "ops": 59,
            "attrs": {
              "platformTiles": 6,
              "title": "freight yard",
              "noise": 3
            }
          },
          {
            "key": "20:1:1",
            "index": 1,
            "name": "goods yard: brick goods shed with a canopy over the dock, a siding, grain silos and a yard crane",
            "height": 1.2,
            "draft": false,
            "ops": 53,
            "attrs": {
              "platformTiles": 6,
              "title": "freight yard",
              "noise": 3
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 6,
      "h": 3,
      "door": [
        2,
        2
      ],
      "marks": [
        {
          "kind": "dock",
          "at": {
            "edge": "back",
            "depth": 1
          },
          "label": "loading dock, track behind"
        },
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 1,
            "to": 3
          },
          "label": "truck gate"
        }
      ]
    },
    "blurb": "A container yard with a loading dock along the back. Delivery trucks from factories within 12 tiles leave containers here; a freight train takes them to another yard, and a truck delivers the last mile to the shop.",
    "howTo": "Six tiles across and three deep, the door and truck gate facing a road, the dock along the back row with track behind it. Put one near industry and another near shops at least 14 tiles away, and join them with a freight line."
  },
  {
    "id": "motorway",
    "name": "motorway connection",
    "kindId": 21,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "motorway",
      "key": "",
      "label": "Motorway connection (2×3)",
      "color": "#2f8fd6",
      "cost": 400
    },
    "tech": [],
    "attrs": {
      "gateway": "motorway",
      "gatewayModes": [
        "car",
        "taxi"
      ],
      "arrivalsPerHour": 30
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 6,
        "cost": 400,
        "work": 300,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [],
        "attrs": {
          "gateway": "motorway",
          "gatewayModes": [
            "car",
            "taxi"
          ],
          "arrivalsPerHour": 30
        },
        "designs": [
          {
            "key": "21:1:0",
            "index": 0,
            "name": "dual carriageway end under a blue gantry, lamp columns on the reservation",
            "height": 0.82,
            "draft": false,
            "ops": 53,
            "attrs": {
              "gateway": "motorway",
              "gatewayModes": [
                "car",
                "taxi"
              ],
              "arrivalsPerHour": 30
            }
          },
          {
            "key": "21:1:1",
            "index": 1,
            "name": "motorway spur with a roadside direction board and chevrons at the slip",
            "height": 0.6,
            "draft": false,
            "ops": 47,
            "attrs": {
              "gateway": "motorway",
              "gatewayModes": [
                "car",
                "taxi"
              ],
              "arrivalsPerHour": 30
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 3,
      "door": [
        1,
        2
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "back"
          },
          "label": "to the motorway"
        },
        {
          "kind": "gate",
          "at": {
            "edge": "front"
          },
          "label": "slip roads"
        }
      ]
    },
    "blurb": "The road out of town. Newcomers with a car drive in here, people leaving drive out, and visitors and inter-city freight trucks come and go through it instead of appearing at the edge of the road network.",
    "howTo": "Two tiles across and three deep, the junction facing the end of a road on the edge of town (Z and C turn it). One is enough to start; a second on another side brings more visitors in. No technology needed."
  },
  {
    "id": "metro-entrance",
    "name": "metro entrance",
    "kindId": 22,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "metroentrance",
      "key": "",
      "label": "Metro entrance (1×1)",
      "color": "#dc241f",
      "cost": 3000
    },
    "tech": [
      "tr9"
    ],
    "occupation": {
      "name": "station staff",
      "rotate": true,
      "shifts": [
        {
          "start": 5,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 17,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 4,
        "wage": 20,
        "upkeep": 40,
        "cost": 3000,
        "work": 200,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "tr9"
        ],
        "attrs": {
          "platformTiles": 4,
          "title": "metro entrance"
        },
        "designs": [
          {
            "key": "22:1:0",
            "index": 0,
            "name": "stair kiosk in oxblood terracotta with railings round the stairwell and a roundel on a post",
            "height": 0.6,
            "draft": false,
            "ops": 28,
            "attrs": {
              "platformTiles": 4,
              "title": "metro entrance"
            }
          },
          {
            "key": "22:1:1",
            "index": 1,
            "name": "glass escalator canopy on a steel frame, a roundel totem at the kerb",
            "height": 0.56,
            "draft": false,
            "ops": 26,
            "attrs": {
              "platformTiles": 4,
              "title": "metro entrance"
            }
          }
        ]
      }
    ],
    "group": "metro",
    "tier": 1,
    "blurb": "A stair kiosk down to a four-tile platform under the street, with four staff. Trains of the metro lines that call here stop with their middle under the door, and riders get on and off.",
    "howTo": "One tile on your land beside a road. The four-tile platform lies under the kiosk door and runs along the street (Z and C turn it a quarter), so it needs clear ground or a plain tunnel for four tiles. Then add it to a metro line in the Lines panel. Needs Underground railway."
  },
  {
    "id": "metro-station",
    "name": "metro station",
    "kindId": 23,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "metrostation",
      "key": "",
      "label": "Metro station (2×1)",
      "color": "#a3141a",
      "cost": 8000
    },
    "tech": [
      "tr9"
    ],
    "occupation": {
      "name": "station staff",
      "rotate": true,
      "shifts": [
        {
          "start": 5,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 17,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 14,
        "wage": 20,
        "upkeep": 120,
        "cost": 8000,
        "work": 400,
        "parking": {
          "surface": 2,
          "underground": 6
        },
        "tech": [
          "tr9"
        ],
        "attrs": {
          "platformTiles": 6,
          "title": "metro station"
        },
        "designs": [
          {
            "key": "23:1:0",
            "index": 0,
            "name": "oxblood terracotta hall with arched windows, a faience cornice and a roundel over the door",
            "height": 0.66,
            "draft": false,
            "ops": 49,
            "attrs": {
              "platformTiles": 6,
              "title": "metro station"
            }
          },
          {
            "key": "23:1:1",
            "index": 1,
            "name": "brick drum under a copper dome with a glazed frieze and roundels, a booking hall beside it",
            "height": 0.74,
            "draft": false,
            "ops": 22,
            "attrs": {
              "platformTiles": 6,
              "title": "metro station"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 1,
      "door": [
        0,
        0
      ]
    },
    "group": "metro",
    "tier": 2,
    "blurb": "A station hall over a six-tile platform, with fourteen staff and room for the longest trains. A train is as long as the shortest platform on its line allows.",
    "howTo": "Two tiles across and one deep: the door is the left tile when you face the road, and the six-tile platform lies under the door and runs along the street (Z and C turn it). Needs clear ground or a plain tunnel for six tiles. Needs Underground railway."
  },
  {
    "id": "jetty",
    "name": "jetty",
    "kindId": 24,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "jetty",
      "key": "",
      "label": "Jetty (1×2)",
      "color": "#7aa6c2",
      "cost": 600
    },
    "tech": [
      "tr10"
    ],
    "occupation": {
      "name": "boat hirer",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.5
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "harbour": "jetty",
      "title": "jetty"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 2,
        "wage": 14,
        "upkeep": 8,
        "cost": 600,
        "work": 150,
        "parking": {
          "surface": 1,
          "underground": 0
        },
        "tech": [
          "tr10"
        ],
        "attrs": {
          "harbour": "jetty",
          "title": "jetty"
        },
        "designs": [
          {
            "key": "24:1:0",
            "index": 0,
            "name": "timber jetty on piles with a boathouse, slipway, ladder and lifebuoy",
            "height": 0.42,
            "draft": false,
            "ops": 82,
            "attrs": {
              "harbour": "jetty",
              "title": "jetty"
            }
          },
          {
            "key": "24:1:1",
            "index": 1,
            "name": "floating hire pontoon on a gangway with a tackle hut, racked dinghies and a flagstaff",
            "height": 0.42,
            "draft": false,
            "ops": 73,
            "attrs": {
              "harbour": "jetty",
              "title": "jetty"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 2,
      "door": [
        0,
        1
      ],
      "marks": [
        {
          "kind": "berth",
          "at": [
            0,
            0
          ],
          "label": "two boat slots by the planks"
        },
        {
          "kind": "quay",
          "at": [
            0,
            1
          ],
          "label": "slipway"
        }
      ],
      "wet": 1,
      "fairwayClearance": 1
    },
    "group": "harbour",
    "tier": 1,
    "blurb": "A timber jetty with a slipway and a boathouse. One or two dinghies or a motor cruiser are based here, and people come down to hire a boat for an outing.",
    "howTo": "One tile on the bank facing a road and one over the water behind it, which must be open water at least a channel wide. Needs Harbours."
  },
  {
    "id": "marina",
    "name": "marina",
    "kindId": 25,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "marina",
      "key": "",
      "label": "Marina (4×4)",
      "color": "#3b8fc0",
      "cost": 4000
    },
    "tech": [
      "tr10"
    ],
    "occupation": {
      "name": "marina staff",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.55
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.45
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "harbour": "marina",
      "title": "marina",
      "berthFee": 4
    },
    "levels": [
      {
        "level": 1,
        "capacity": 8,
        "wage": 16,
        "upkeep": 60,
        "cost": 4000,
        "work": 650,
        "parking": {
          "surface": 6,
          "underground": 0
        },
        "tech": [
          "tr10"
        ],
        "attrs": {
          "harbour": "marina",
          "title": "marina",
          "berthFee": 4
        },
        "designs": [
          {
            "key": "25:1:0",
            "index": 0,
            "name": "pontoon marina with a harbourmaster's office and lookout, a quayside café and a fuel dock",
            "height": 0.7,
            "draft": false,
            "ops": 125,
            "attrs": {
              "harbour": "marina",
              "title": "marina",
              "berthFee": 4
            }
          },
          {
            "key": "25:1:1",
            "index": 1,
            "name": "sailing club with a verandah over the water, a rigged dinghy park, a boat hoist and timber pontoons",
            "height": 0.72,
            "draft": false,
            "ops": 203,
            "attrs": {
              "harbour": "marina",
              "title": "marina",
              "berthFee": 4
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        1,
        3
      ],
      "marks": [
        {
          "kind": "berth",
          "at": {
            "edge": "back",
            "depth": 2
          },
          "label": "ten berths on the pontoons"
        },
        {
          "kind": "quay",
          "at": [
            0,
            2
          ],
          "label": "quay"
        },
        {
          "kind": "quay",
          "at": [
            1,
            2
          ]
        },
        {
          "kind": "quay",
          "at": [
            2,
            2
          ]
        },
        {
          "kind": "quay",
          "at": [
            3,
            2
          ]
        }
      ],
      "wet": 2,
      "fairwayClearance": 1
    },
    "group": "harbour",
    "tier": 3,
    "blurb": "Pontoons with ten berths, a harbourmaster and a café. Six to ten pleasure boats are based here, sized to the water, and their owners pay berth fees; people visit it as an outing.",
    "howTo": "Four tiles across and four deep: the front two rows on the bank facing a road, the back two over open water at least a channel wide. Narrowboats suit a river, sailboats want wider water. Needs Harbours."
  },
  {
    "id": "fishing-harbour",
    "name": "fishing harbour",
    "kindId": 26,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tool": {
      "id": "fishharbour",
      "key": "",
      "label": "Fishing harbour (4×3)",
      "color": "#2f6f8f",
      "cost": 5000
    },
    "tech": [
      "tr10"
    ],
    "occupation": {
      "name": "fishing crew",
      "rotate": false,
      "shifts": [
        {
          "start": 4,
          "hours": 12,
          "weight": 0.77
        },
        {
          "start": 5,
          "hours": 8,
          "weight": 0.23
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "harbour": "fishing",
      "title": "fishing harbour",
      "noise": 2
    },
    "levels": [
      {
        "level": 1,
        "capacity": 26,
        "wage": 19,
        "upkeep": 80,
        "cost": 5000,
        "work": 600,
        "parking": {
          "surface": 4,
          "underground": 0
        },
        "tech": [
          "tr10"
        ],
        "attrs": {
          "harbour": "fishing",
          "title": "fishing harbour",
          "noise": 2
        },
        "designs": [
          {
            "key": "26:1:0",
            "index": 0,
            "name": "stone fish quay with an open auction canopy, a market hall, an ice plant and a derrick",
            "height": 0.7,
            "draft": false,
            "ops": 140,
            "attrs": {
              "harbour": "fishing",
              "title": "fishing harbour",
              "noise": 2
            }
          },
          {
            "key": "26:1:1",
            "index": 1,
            "name": "harbour arms with a lighthouse, tarred net lofts, a smokehouse and a café with market stalls",
            "height": 0.9,
            "draft": false,
            "ops": 156,
            "attrs": {
              "harbour": "fishing",
              "title": "fishing harbour",
              "noise": 2
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 3,
      "door": [
        1,
        2
      ],
      "marks": [
        {
          "kind": "berth",
          "at": {
            "edge": "back",
            "depth": 1
          },
          "label": "three trawler berths"
        },
        {
          "kind": "quay",
          "at": [
            0,
            1
          ],
          "label": "fish quay"
        },
        {
          "kind": "quay",
          "at": [
            1,
            1
          ]
        },
        {
          "kind": "quay",
          "at": [
            2,
            1
          ]
        },
        {
          "kind": "quay",
          "at": [
            3,
            1
          ]
        }
      ],
      "wet": 1,
      "fairwayClearance": 2
    },
    "group": "harbour",
    "tier": 4,
    "blurb": "A fish quay with three trawlers, a fish market and an ice plant. The trawlers sail before dawn, fish for half a day and land their catch, which goes to cafés, restaurants and food works.",
    "howTo": "Four tiles across and three deep: two rows on the bank facing a road, the back row over open water at least three tiles wide behind it. Needs Harbours."
  },
  {
    "id": "ferry-pier",
    "name": "ferry pier",
    "kindId": 27,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "ferrypier",
      "key": "",
      "label": "Ferry pier (2×2)",
      "color": "#1f8a8a",
      "cost": 1500
    },
    "tech": [
      "tr11"
    ],
    "occupation": {
      "name": "pier staff",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.5
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "harbour": "pier",
      "title": "ferry pier"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 3,
        "wage": 16,
        "upkeep": 20,
        "cost": 1500,
        "work": 250,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "tr11"
        ],
        "attrs": {
          "harbour": "pier",
          "title": "ferry pier"
        },
        "designs": [
          {
            "key": "27:1:0",
            "index": 0,
            "name": "covered floating pontoon on a gangway, a ticket kiosk and roundel signs",
            "height": 0.52,
            "draft": false,
            "ops": 75,
            "attrs": {
              "harbour": "pier",
              "title": "ferry pier"
            }
          },
          {
            "key": "27:1:1",
            "index": 1,
            "name": "timber pier head on piles with a cast-iron pavilion, a gangway bridge and a clock-turret ticket office",
            "height": 0.72,
            "draft": false,
            "ops": 126,
            "attrs": {
              "harbour": "pier",
              "title": "ferry pier"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ],
      "marks": [
        {
          "kind": "quay",
          "at": {
            "edge": "back",
            "depth": 1
          },
          "label": "pontoon"
        },
        {
          "kind": "berth",
          "at": {
            "edge": "back"
          },
          "label": "ferries call behind the pontoon"
        }
      ],
      "wet": 1,
      "fairwayClearance": 1
    },
    "group": "harbour",
    "tier": 2,
    "blurb": "A pontoon with a gangway and a ticket office: a stop for a river bus line. Boats call on the water just behind the pontoon, one line to a pier.",
    "howTo": "Two tiles across and two deep: the front row on the bank facing a road, the pontoon row over the water, with open water behind it for the boats to lie in. Add it to a ferry line in the Lines panel. Needs River buses."
  },
  {
    "id": "cargo-port",
    "name": "cargo port",
    "kindId": 28,
    "code": 15,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tool": {
      "id": "cargoport",
      "key": "",
      "label": "Cargo port (8×6)",
      "color": "#24506e",
      "cost": 14000
    },
    "tech": [
      "tr12"
    ],
    "occupation": {
      "name": "docker",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.42
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.38
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "harbour": "port",
      "title": "cargo port",
      "noise": 4,
      "gateway": "sea",
      "gatewayModes": [
        "foot",
        "taxi"
      ],
      "arrivalsPerHour": 6,
      "needsWater": true
    },
    "levels": [
      {
        "level": 1,
        "capacity": 70,
        "wage": 22,
        "upkeep": 200,
        "cost": 14000,
        "work": 1600,
        "parking": {
          "surface": 10,
          "underground": 0
        },
        "tech": [
          "tr12"
        ],
        "attrs": {
          "harbour": "port",
          "title": "cargo port",
          "noise": 4,
          "gateway": "sea",
          "gatewayModes": [
            "foot",
            "taxi"
          ],
          "arrivalsPerHour": 6,
          "needsWater": true
        },
        "designs": [
          {
            "key": "28:1:0",
            "index": 0,
            "name": "container quay with two gantry cranes, stacks, straddle carriers, a transit shed and a control tower",
            "height": 1.8,
            "draft": false,
            "ops": 228,
            "attrs": {
              "harbour": "port",
              "title": "cargo port",
              "noise": 4,
              "gateway": "sea",
              "gatewayModes": [
                "foot",
                "taxi"
              ],
              "arrivalsPerHour": 6,
              "needsWater": true
            }
          },
          {
            "key": "28:1:1",
            "index": 1,
            "name": "general cargo quay with two harbour cranes, grain silos and a gallery, sawtooth warehouses, log piles and a rail siding",
            "height": 1.6,
            "draft": false,
            "ops": 191,
            "attrs": {
              "harbour": "port",
              "title": "cargo port",
              "noise": 4,
              "gateway": "sea",
              "gatewayModes": [
                "foot",
                "taxi"
              ],
              "arrivalsPerHour": 6,
              "needsWater": true
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 8,
      "h": 6,
      "door": [
        3,
        5
      ],
      "marks": [
        {
          "kind": "berth",
          "at": {
            "edge": "back",
            "from": 0,
            "to": 4,
            "depth": 1
          },
          "label": "big berth (5 tiles)"
        },
        {
          "kind": "berth",
          "at": {
            "edge": "back",
            "from": 5,
            "to": 7,
            "depth": 1
          },
          "label": "small berth (2.4 tiles) and the tug"
        },
        {
          "kind": "quay",
          "at": [
            0,
            1
          ],
          "label": "quay and cranes"
        },
        {
          "kind": "quay",
          "at": [
            1,
            1
          ]
        },
        {
          "kind": "quay",
          "at": [
            2,
            1
          ]
        },
        {
          "kind": "quay",
          "at": [
            3,
            1
          ]
        },
        {
          "kind": "quay",
          "at": [
            4,
            1
          ]
        },
        {
          "kind": "quay",
          "at": [
            5,
            1
          ]
        },
        {
          "kind": "quay",
          "at": [
            6,
            1
          ]
        },
        {
          "kind": "quay",
          "at": [
            7,
            1
          ]
        },
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 2,
            "to": 4
          },
          "label": "truck gate"
        }
      ],
      "wet": 1,
      "fairwayClearance": 3
    },
    "group": "harbour",
    "tier": 5,
    "blurb": "A container quay with two gantry cranes, a big and a small berth and a truck gate: the city's seaport. Ships bring containers in and take exports out, and ferries bring newcomers.",
    "howTo": "Eight tiles across and six deep: five rows on the bank with the truck gate facing a road, the back row over open water at least five tiles wide that reaches the sea. Needs Seaport."
  },
  {
    "id": "gp-surgery",
    "name": "GP surgery",
    "kindId": 40,
    "code": 7,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "gp",
      "key": "",
      "label": "GP surgery",
      "color": "#e9f4ec",
      "cost": 350
    },
    "tech": [
      "civ2"
    ],
    "occupation": {
      "name": "GP practice staff",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 9,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 9,
      "serviceStrength": 0.5,
      "patrolRate": 0
    },
    "levels": [
      {
        "level": 1,
        "capacity": 6,
        "wage": 24,
        "upkeep": 14,
        "cost": 350,
        "work": 180,
        "parking": {
          "surface": 3,
          "underground": 6
        },
        "tech": [
          "civ2"
        ],
        "attrs": {
          "serviceRadius": 9,
          "serviceStrength": 0.5,
          "patrolRate": 0
        },
        "designs": [
          {
            "key": "40:1:0",
            "index": 0,
            "name": "brick surgery with a pitched roof, a porch and a green cross",
            "height": 0.56,
            "draft": false,
            "ops": 15,
            "attrs": {
              "serviceRadius": 9,
              "serviceStrength": 0.5,
              "patrolRate": 0
            }
          },
          {
            "key": "40:1:1",
            "index": 1,
            "name": "rendered villa practice with a bay window and a sign on posts",
            "height": 0.6,
            "draft": false,
            "ops": 20,
            "attrs": {
              "serviceRadius": 9,
              "serviceStrength": 0.5,
              "patrolRate": 0
            }
          },
          {
            "key": "40:1:2",
            "index": 2,
            "name": "single-storey timber practice with a long canopy and a pharmacy hatch",
            "height": 0.4,
            "draft": false,
            "ops": 18,
            "attrs": {
              "serviceRadius": 9,
              "serviceStrength": 0.5,
              "patrolRate": 0
            }
          }
        ]
      }
    ],
    "group": "health",
    "tier": 1,
    "blurb": "A family doctor, a nurse and a receptionist on one plot. People nearby see a doctor without crossing town, but there is no ward and no ambulance.",
    "howTo": "Put one in each neighbourhood, beside a road. It counts as half a health service for the homes around it; grow into a health centre where the queue gets long."
  },
  {
    "id": "health-centre",
    "name": "health centre",
    "kindId": 41,
    "code": 7,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "healthcentre",
      "key": "",
      "label": "Health centre",
      "color": "#d9efe0",
      "cost": 600
    },
    "tech": [
      "civ2"
    ],
    "occupation": {
      "name": "health centre staff",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 9,
          "weight": 1
        },
        {
          "start": 12,
          "hours": 9,
          "weight": 0.5
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 11,
      "serviceStrength": 0.75,
      "patrolRate": 0.25
    },
    "levels": [
      {
        "level": 1,
        "capacity": 12,
        "wage": 25,
        "upkeep": 26,
        "cost": 600,
        "work": 400,
        "parking": {
          "surface": 6,
          "underground": 12
        },
        "tech": [
          "civ2"
        ],
        "attrs": {
          "serviceRadius": 11,
          "serviceStrength": 0.75,
          "patrolRate": 0.25
        },
        "designs": [
          {
            "key": "41:1:0",
            "index": 0,
            "name": "two-storey health centre with a glass drum entrance and a green band",
            "height": 0.66,
            "draft": false,
            "ops": 28,
            "attrs": {
              "serviceRadius": 11,
              "serviceStrength": 0.75,
              "patrolRate": 0.25
            }
          },
          {
            "key": "41:1:1",
            "index": 1,
            "name": "brick and timber wings round a glass link, with a planted roof",
            "height": 0.58,
            "draft": false,
            "ops": 23,
            "attrs": {
              "serviceRadius": 11,
              "serviceStrength": 0.75,
              "patrolRate": 0.25
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 1,
      "door": [
        1,
        0
      ]
    },
    "group": "health",
    "tier": 2,
    "blurb": "Several GP practices, a dentist and a pharmacy under one long roof. Covers a wider patch than a surgery and sends the odd ambulance.",
    "howTo": "Two tiles wide along a road (Z and C turn it). Good for a district centre where several neighbourhoods meet."
  },
  {
    "id": "walk-in-centre",
    "name": "walk-in centre",
    "kindId": 42,
    "code": 7,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "walkin",
      "key": "",
      "label": "Walk-in centre",
      "color": "#cfe8d6",
      "cost": 800
    },
    "tech": [
      "civ2"
    ],
    "occupation": {
      "name": "walk-in centre staff",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.9
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.3
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 13,
      "serviceStrength": 0.9,
      "patrolRate": 0.5
    },
    "levels": [
      {
        "level": 1,
        "capacity": 18,
        "wage": 25,
        "upkeep": 36,
        "cost": 800,
        "work": 600,
        "parking": {
          "surface": 10,
          "underground": 20
        },
        "tech": [
          "civ2"
        ],
        "attrs": {
          "serviceRadius": 13,
          "serviceStrength": 0.9,
          "patrolRate": 0.5
        },
        "designs": [
          {
            "key": "42:1:0",
            "index": 0,
            "name": "three-storey clinic with a drop-off canopy and an ambulance bay",
            "height": 0.98,
            "draft": false,
            "ops": 40,
            "attrs": {
              "serviceRadius": 13,
              "serviceStrength": 0.9,
              "patrolRate": 0.5
            }
          },
          {
            "key": "42:1:1",
            "index": 1,
            "name": "two pavilions round a garden atrium, with a green cross tower",
            "height": 1.1,
            "draft": false,
            "ops": 37,
            "attrs": {
              "serviceRadius": 13,
              "serviceStrength": 0.9,
              "patrolRate": 0.5
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 0,
            "to": 0
          },
          "label": "ambulance bay"
        }
      ]
    },
    "group": "health",
    "tier": 3,
    "blurb": "Minor injuries seen without an appointment, day and evening, with an X-ray room and its own ambulances. Nearly a full health service for a whole district.",
    "howTo": "A 2×2 lot with the door on a busy road; the ambulance bay is the left of the frontage. Pairs well with GP surgeries further out."
  },
  {
    "id": "community-hospital",
    "name": "community hospital",
    "kindId": 43,
    "code": 7,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "commhospital",
      "key": "",
      "label": "Community hospital",
      "color": "#e4eef0",
      "cost": 1800
    },
    "tech": [
      "civ4"
    ],
    "occupation": {
      "name": "hospital staff",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 12,
          "weight": 1
        },
        {
          "start": 19,
          "hours": 12,
          "weight": 0.8
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 17,
      "serviceStrength": 1.2,
      "patrolRate": 1.3
    },
    "levels": [
      {
        "level": 1,
        "capacity": 36,
        "wage": 27,
        "upkeep": 75,
        "cost": 1800,
        "work": 900,
        "parking": {
          "surface": 14,
          "underground": 30
        },
        "tech": [
          "civ4"
        ],
        "attrs": {
          "serviceRadius": 17,
          "serviceStrength": 1.2,
          "patrolRate": 1.3
        },
        "designs": [
          {
            "key": "43:1:0",
            "index": 0,
            "name": "ward block across the back, an outpatients wing and an ambulance bay",
            "height": 1.08,
            "draft": false,
            "ops": 43,
            "attrs": {
              "serviceRadius": 17,
              "serviceStrength": 1.2,
              "patrolRate": 1.3
            }
          },
          {
            "key": "43:1:1",
            "index": 1,
            "name": "brick cottage hospital ranges round a garden, with a clock tower",
            "height": 1.22,
            "draft": false,
            "ops": 27,
            "attrs": {
              "serviceRadius": 17,
              "serviceStrength": 1.2,
              "patrolRate": 1.3
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 2,
      "door": [
        1,
        1
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 0,
            "to": 0
          },
          "label": "ambulance bay"
        }
      ]
    },
    "group": "health",
    "tier": 5,
    "blurb": "Wards, an outpatients wing and a round-the-clock minor injuries unit. A stronger service than the city hospital that reaches further, with more ambulances out.",
    "howTo": "Three tiles across and two deep, door in the middle of the frontage, ambulances out of the left tile. Needs Regional services."
  },
  {
    "id": "general-hospital",
    "name": "general hospital",
    "kindId": 44,
    "code": 7,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "genhospital",
      "key": "",
      "label": "General hospital",
      "color": "#dfe7ef",
      "cost": 3200
    },
    "tech": [
      "civ5"
    ],
    "occupation": {
      "name": "hospital staff",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 12,
          "weight": 1
        },
        {
          "start": 19,
          "hours": 12,
          "weight": 0.8
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 20,
      "serviceStrength": 1.4,
      "patrolRate": 2
    },
    "levels": [
      {
        "level": 1,
        "capacity": 60,
        "wage": 28,
        "upkeep": 120,
        "cost": 3200,
        "work": 1500,
        "parking": {
          "surface": 24,
          "underground": 50
        },
        "tech": [
          "civ5"
        ],
        "attrs": {
          "serviceRadius": 20,
          "serviceStrength": 1.4,
          "patrolRate": 2
        },
        "designs": [
          {
            "key": "44:1:0",
            "index": 0,
            "name": "ward tower with a rooftop helipad over a podium and an A&E canopy",
            "height": 2.02,
            "draft": false,
            "ops": 89,
            "attrs": {
              "serviceRadius": 20,
              "serviceStrength": 1.4,
              "patrolRate": 2
            }
          },
          {
            "key": "44:1:1",
            "index": 1,
            "name": "cruciform ward blocks, a boiler chimney and a helipad on the lawn",
            "height": 1.72,
            "draft": false,
            "ops": 57,
            "attrs": {
              "serviceRadius": 20,
              "serviceStrength": 1.4,
              "patrolRate": 2
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 4,
      "door": [
        1,
        3
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 0,
            "to": 0
          },
          "label": "A&E ambulances"
        },
        {
          "kind": "stand",
          "at": [
            2,
            0
          ],
          "label": "helipad"
        }
      ]
    },
    "group": "health",
    "tier": 6,
    "blurb": "A district general hospital: accident and emergency, theatres, maternity and a helipad on the roof. Covers a large part of town and keeps ambulances moving all day.",
    "howTo": "Three tiles across and four deep; the A&E entrance is the left of the frontage. Leave road access all round for ambulances. Needs Metropolitan services."
  },
  {
    "id": "teaching-hospital",
    "name": "teaching hospital",
    "kindId": 45,
    "code": 7,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "teachhospital",
      "key": "",
      "label": "Teaching hospital",
      "color": "#d6e2ee",
      "cost": 5500
    },
    "tech": [
      "civ6"
    ],
    "occupation": {
      "name": "hospital staff",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 12,
          "weight": 1
        },
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 19,
          "hours": 12,
          "weight": 0.8
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 24,
      "serviceStrength": 1.6,
      "patrolRate": 2.5
    },
    "levels": [
      {
        "level": 1,
        "capacity": 90,
        "wage": 30,
        "upkeep": 180,
        "cost": 5500,
        "work": 2200,
        "parking": {
          "surface": 30,
          "underground": 70
        },
        "tech": [
          "civ6"
        ],
        "attrs": {
          "serviceRadius": 24,
          "serviceStrength": 1.6,
          "patrolRate": 2.5
        },
        "designs": [
          {
            "key": "45:1:0",
            "index": 0,
            "name": "campus: ward tower, glass research wing, lecture drum and a quad",
            "height": 2.42,
            "draft": false,
            "ops": 65,
            "attrs": {
              "serviceRadius": 24,
              "serviceStrength": 1.6,
              "patrolRate": 2.5
            }
          },
          {
            "key": "45:1:1",
            "index": 1,
            "name": "domed stone main hall, a research tower and glass link bridges",
            "height": 2.62,
            "draft": false,
            "ops": 81,
            "attrs": {
              "serviceRadius": 24,
              "serviceStrength": 1.6,
              "patrolRate": 2.5
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        2,
        3
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 0,
            "to": 0
          },
          "label": "A&E ambulances"
        },
        {
          "kind": "stand",
          "at": [
            3,
            0
          ],
          "label": "helipad"
        }
      ]
    },
    "group": "health",
    "tier": 7,
    "blurb": "A university hospital campus: specialist wards, a research wing and a medical school. The strongest health service there is, reaching across much of a city.",
    "howTo": "A whole 4×4 block; the main entrance is right of centre and A&E is on the left corner. Late game: needs the Medical school technology."
  },
  {
    "id": "police-box",
    "name": "police box",
    "kindId": 46,
    "code": 5,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "policebox",
      "key": "",
      "label": "Police box",
      "color": "#3d5fb8",
      "cost": 150
    },
    "tech": [
      "civ1"
    ],
    "occupation": {
      "name": "beat officer",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 8,
      "serviceStrength": 0.4,
      "patrolRate": 0.4
    },
    "levels": [
      {
        "level": 1,
        "capacity": 3,
        "wage": 20,
        "upkeep": 6,
        "cost": 150,
        "work": 120,
        "parking": {
          "surface": 0,
          "underground": 2
        },
        "tech": [
          "civ1"
        ],
        "attrs": {
          "serviceRadius": 8,
          "serviceStrength": 0.4,
          "patrolRate": 0.4
        },
        "designs": [
          {
            "key": "46:1:0",
            "index": 0,
            "name": "blue police box on a paved corner with a lamp and a bench",
            "height": 0.46,
            "draft": false,
            "ops": 21,
            "attrs": {
              "serviceRadius": 8,
              "serviceStrength": 0.4,
              "patrolRate": 0.4
            }
          },
          {
            "key": "46:1:1",
            "index": 1,
            "name": "glass police point kiosk with a blue band and two patrol bikes",
            "height": 0.42,
            "draft": false,
            "ops": 17,
            "attrs": {
              "serviceRadius": 8,
              "serviceStrength": 0.4,
              "patrolRate": 0.4
            }
          }
        ]
      }
    ],
    "group": "police",
    "tier": 1,
    "blurb": "A blue box on a street corner with a telephone, a desk and a couple of beat officers. A light police presence for a few streets around it.",
    "howTo": "One tile beside any road. Cheap enough to dot about; counts as under half a police service for the homes nearby."
  },
  {
    "id": "police-post",
    "name": "neighbourhood police post",
    "kindId": 47,
    "code": 5,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "policepost",
      "key": "",
      "label": "Neighbourhood police post",
      "color": "#3a58ac",
      "cost": 250
    },
    "tech": [
      "civ1"
    ],
    "occupation": {
      "name": "police officer",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 11,
      "serviceStrength": 0.7,
      "patrolRate": 0.7
    },
    "levels": [
      {
        "level": 1,
        "capacity": 6,
        "wage": 20,
        "upkeep": 11,
        "cost": 250,
        "work": 200,
        "parking": {
          "surface": 2,
          "underground": 5
        },
        "tech": [
          "civ1"
        ],
        "attrs": {
          "serviceRadius": 11,
          "serviceStrength": 0.7,
          "patrolRate": 0.7
        },
        "designs": [
          {
            "key": "47:1:0",
            "index": 0,
            "name": "two-storey shopfront post with a navy fascia, a blue lamp and a car",
            "height": 0.66,
            "draft": false,
            "ops": 14,
            "attrs": {
              "serviceRadius": 11,
              "serviceStrength": 0.7,
              "patrolRate": 0.7
            }
          },
          {
            "key": "47:1:1",
            "index": 1,
            "name": "single-storey post with a chequered band and a radio mast",
            "height": 0.84,
            "draft": false,
            "ops": 28,
            "attrs": {
              "serviceRadius": 11,
              "serviceStrength": 0.7,
              "patrolRate": 0.7
            }
          }
        ]
      }
    ],
    "group": "police",
    "tier": 2,
    "blurb": "A front counter, an interview room and a neighbourhood team with a car. Most of a police station for a neighbourhood, at a little over half the running cost.",
    "howTo": "One tile on a high street. Put a full station or a divisional station further out to cover the gaps."
  },
  {
    "id": "divisional-station",
    "name": "divisional police station",
    "kindId": 48,
    "code": 5,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "divstation",
      "key": "",
      "label": "Divisional police station",
      "color": "#2f4e9e",
      "cost": 1100
    },
    "tech": [
      "civ4"
    ],
    "occupation": {
      "name": "police officer",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 18,
      "serviceStrength": 1.25,
      "patrolRate": 1.8
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 21,
        "upkeep": 42,
        "cost": 1100,
        "work": 700,
        "parking": {
          "surface": 12,
          "underground": 24
        },
        "tech": [
          "civ4"
        ],
        "attrs": {
          "serviceRadius": 18,
          "serviceStrength": 1.25,
          "patrolRate": 1.8
        },
        "designs": [
          {
            "key": "48:1:0",
            "index": 0,
            "name": "three-storey station with a radio mast beside a fenced car pound",
            "height": 1.4,
            "draft": false,
            "ops": 68,
            "attrs": {
              "serviceRadius": 18,
              "serviceStrength": 1.25,
              "patrolRate": 1.8
            }
          },
          {
            "key": "48:1:1",
            "index": 1,
            "name": "red-brick station with gables, a custody block and a pound at the front",
            "height": 1.08,
            "draft": false,
            "ops": 50,
            "attrs": {
              "serviceRadius": 18,
              "serviceStrength": 1.25,
              "patrolRate": 1.8
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 1,
            "to": 1
          },
          "label": "car pound gate"
        }
      ]
    },
    "group": "police",
    "tier": 4,
    "blurb": "Custody cells, detectives and a fenced car pound for towed and seized cars. Covers a whole division and keeps twice the patrols of a station on the road.",
    "howTo": "A 2×2 lot with the front counter on the left and the pound gate on the right of the frontage. Needs Regional services."
  },
  {
    "id": "police-hq",
    "name": "police headquarters",
    "kindId": 49,
    "code": 5,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "policehq",
      "key": "",
      "label": "Police headquarters",
      "color": "#243f86",
      "cost": 2600
    },
    "tech": [
      "civ5"
    ],
    "occupation": {
      "name": "police officer",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 1
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 22,
      "serviceStrength": 1.5,
      "patrolRate": 2.6
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 22,
        "upkeep": 80,
        "cost": 2600,
        "work": 1300,
        "parking": {
          "surface": 20,
          "underground": 40
        },
        "tech": [
          "civ5"
        ],
        "attrs": {
          "serviceRadius": 22,
          "serviceStrength": 1.5,
          "patrolRate": 2.6
        },
        "designs": [
          {
            "key": "49:1:0",
            "index": 0,
            "name": "glass headquarters tower with a lattice radio mast and a training yard",
            "height": 2.5,
            "draft": false,
            "ops": 60,
            "attrs": {
              "serviceRadius": 22,
              "serviceStrength": 1.5,
              "patrolRate": 2.6
            }
          },
          {
            "key": "49:1:1",
            "index": 1,
            "name": "stone headquarters round a parade ground, with a mast on the roof",
            "height": 1.9,
            "draft": false,
            "ops": 44,
            "attrs": {
              "serviceRadius": 22,
              "serviceStrength": 1.5,
              "patrolRate": 2.6
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ],
      "marks": [
        {
          "kind": "apron",
          "at": {
            "edge": "back",
            "from": 1,
            "to": 2,
            "depth": 1
          },
          "label": "training yard"
        }
      ]
    },
    "group": "police",
    "tier": 5,
    "blurb": "The force headquarters: a control room, specialist squads, a training yard and a tall radio mast. The strongest police cover in town and patrols in every direction.",
    "howTo": "A 3×3 block with the door in the middle of the frontage; the training yard takes the back right. Late game: needs Metropolitan services."
  },
  {
    "id": "fire-post",
    "name": "fire post",
    "kindId": 50,
    "code": 6,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "firepost",
      "key": "",
      "label": "Fire post",
      "color": "#e0584c",
      "cost": 220
    },
    "tech": [
      "civ1"
    ],
    "occupation": {
      "name": "firefighter",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 24,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 9,
      "serviceStrength": 0.6,
      "patrolRate": 0.5
    },
    "levels": [
      {
        "level": 1,
        "capacity": 4,
        "wage": 20,
        "upkeep": 9,
        "cost": 220,
        "work": 180,
        "parking": {
          "surface": 1,
          "underground": 3
        },
        "tech": [
          "civ1"
        ],
        "attrs": {
          "serviceRadius": 9,
          "serviceStrength": 0.6,
          "patrolRate": 0.5
        },
        "designs": [
          {
            "key": "50:1:0",
            "index": 0,
            "name": "single-bay brick fire post with an engine out front and a hose tower",
            "height": 0.86,
            "draft": false,
            "ops": 12,
            "attrs": {
              "serviceRadius": 9,
              "serviceStrength": 0.6,
              "patrolRate": 0.5
            }
          },
          {
            "key": "50:1:1",
            "index": 1,
            "name": "corrugated retained-crew shed with a roller door and a siren pole",
            "height": 0.72,
            "draft": false,
            "ops": 18,
            "attrs": {
              "serviceRadius": 9,
              "serviceStrength": 0.6,
              "patrolRate": 0.5
            }
          }
        ]
      }
    ],
    "group": "fire",
    "tier": 1,
    "blurb": "One engine and a retained crew in a single-bay garage. Covers the streets around it and turns out now and then; a full station covers more.",
    "howTo": "One tile beside a road, bay door to the road. Use them to fill gaps between stations."
  },
  {
    "id": "large-fire-station",
    "name": "large fire station",
    "kindId": 51,
    "code": 6,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "bigfire",
      "key": "",
      "label": "Large fire station",
      "color": "#c83c31",
      "cost": 1000
    },
    "tech": [
      "civ4"
    ],
    "occupation": {
      "name": "firefighter",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 24,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 18,
      "serviceStrength": 1.25,
      "patrolRate": 1.7
    },
    "levels": [
      {
        "level": 1,
        "capacity": 16,
        "wage": 21,
        "upkeep": 36,
        "cost": 1000,
        "work": 650,
        "parking": {
          "surface": 6,
          "underground": 12
        },
        "tech": [
          "civ4"
        ],
        "attrs": {
          "serviceRadius": 18,
          "serviceStrength": 1.25,
          "patrolRate": 1.7
        },
        "designs": [
          {
            "key": "51:1:0",
            "index": 0,
            "name": "four-bay brick station with a drill tower and engines on the apron",
            "height": 1.52,
            "draft": false,
            "ops": 29,
            "attrs": {
              "serviceRadius": 18,
              "serviceStrength": 1.25,
              "patrolRate": 1.7
            }
          },
          {
            "key": "51:1:1",
            "index": 1,
            "name": "steel and glass station with a curved roof and a lattice drill tower",
            "height": 1.6,
            "draft": false,
            "ops": 31,
            "attrs": {
              "serviceRadius": 18,
              "serviceStrength": 1.25,
              "patrolRate": 1.7
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front"
          },
          "label": "appliance bays"
        },
        {
          "kind": "stand",
          "at": [
            0,
            0
          ],
          "label": "training tower"
        }
      ]
    },
    "group": "fire",
    "tier": 3,
    "blurb": "Four appliance bays, a rescue tender and a drill tower for training. Wider cover than a station and nearly twice the call-outs.",
    "howTo": "A 2×2 lot with every bay facing the road; the drill tower stands at the back left. Needs Regional services."
  },
  {
    "id": "fire-hq",
    "name": "fire and rescue headquarters",
    "kindId": 52,
    "code": 6,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": true,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "firehq",
      "key": "",
      "label": "Fire and rescue HQ",
      "color": "#b0342a",
      "cost": 2400
    },
    "tech": [
      "civ5"
    ],
    "occupation": {
      "name": "firefighter",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 24,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "serviceRadius": 22,
      "serviceStrength": 1.5,
      "patrolRate": 2.5
    },
    "levels": [
      {
        "level": 1,
        "capacity": 28,
        "wage": 22,
        "upkeep": 70,
        "cost": 2400,
        "work": 1200,
        "parking": {
          "surface": 12,
          "underground": 24
        },
        "tech": [
          "civ5"
        ],
        "attrs": {
          "serviceRadius": 22,
          "serviceStrength": 1.5,
          "patrolRate": 2.5
        },
        "designs": [
          {
            "key": "52:1:0",
            "index": 0,
            "name": "six-bay appliance hall, control block with a mast, drill tower and smoke house",
            "height": 2,
            "draft": false,
            "ops": 41,
            "attrs": {
              "serviceRadius": 22,
              "serviceStrength": 1.5,
              "patrolRate": 2.5
            }
          },
          {
            "key": "52:1:1",
            "index": 1,
            "name": "modern headquarters with a glass control room over a bay hall and a steel tower",
            "height": 2.1,
            "draft": false,
            "ops": 45,
            "attrs": {
              "serviceRadius": 22,
              "serviceStrength": 1.5,
              "patrolRate": 2.5
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front"
          },
          "label": "appliance bays"
        },
        {
          "kind": "apron",
          "at": {
            "edge": "back",
            "depth": 1
          },
          "label": "training ground"
        }
      ]
    },
    "group": "fire",
    "tier": 4,
    "blurb": "The brigade headquarters: a six-bay appliance hall, the control room, a training tower and a smoke house. The strongest fire cover there is, with engines out across a large area.",
    "howTo": "A 3×3 block, bays along the front; the training ground fills the back row. Late game: needs Metropolitan services."
  },
  {
    "id": "handyman",
    "name": "handyman's workshop",
    "kindId": 53,
    "code": 8,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "handyman",
      "key": "",
      "label": "Handyman's workshop",
      "color": "#b98352",
      "cost": 120
    },
    "tech": [],
    "occupation": {
      "name": "builder",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "workRate": 0.9
    },
    "levels": [
      {
        "level": 1,
        "capacity": 2,
        "wage": 15,
        "upkeep": 5,
        "cost": 120,
        "work": 150,
        "parking": {
          "surface": 2,
          "underground": 2
        },
        "tech": [],
        "attrs": {
          "workRate": 0.9
        },
        "designs": [
          {
            "key": "53:1:0",
            "index": 0,
            "name": "timber workshop with a van, a ladder rack and a stack of planks",
            "height": 0.44,
            "draft": false,
            "ops": 14,
            "attrs": {
              "workRate": 0.9
            }
          },
          {
            "key": "53:1:1",
            "index": 1,
            "name": "brick garage with a roller door, a cement mixer and a skip",
            "height": 0.4,
            "draft": false,
            "ops": 14,
            "attrs": {
              "workRate": 0.9
            }
          }
        ]
      }
    ],
    "group": "builders",
    "tier": 1,
    "blurb": "Two builders and a van. Enough to put up the first houses and keep a village going, at a fraction of a yard's upkeep.",
    "howTo": "One tile beside a road, anywhere on the network. Builders go wherever there is a site, so a handyman helps any part of town."
  },
  {
    "id": "builders-depot",
    "name": "builders' depot",
    "kindId": 54,
    "code": 8,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "depot",
      "key": "",
      "label": "Builders' depot",
      "color": "#9a6232",
      "cost": 900
    },
    "tech": [
      "con2"
    ],
    "occupation": {
      "name": "builder",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "workRate": 1.25
    },
    "levels": [
      {
        "level": 1,
        "capacity": 18,
        "wage": 17,
        "upkeep": 30,
        "cost": 900,
        "work": 600,
        "parking": {
          "surface": 8,
          "underground": 14
        },
        "tech": [
          "con2"
        ],
        "attrs": {
          "workRate": 1.25
        },
        "designs": [
          {
            "key": "54:1:0",
            "index": 0,
            "name": "materials shed, aggregate bays, two lorries and a tower crane",
            "height": 1.6,
            "draft": false,
            "ops": 24,
            "attrs": {
              "workRate": 1.25
            }
          },
          {
            "key": "54:1:1",
            "index": 1,
            "name": "open yard with pipe stacks, scaffold racks and a mobile crane",
            "height": 1.3,
            "draft": false,
            "ops": 34,
            "attrs": {
              "workRate": 1.25
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 1,
            "to": 1
          },
          "label": "lorry gate"
        }
      ]
    },
    "group": "builders",
    "tier": 3,
    "blurb": "A tower crane, flatbed lorries and a covered materials store. Nearly twice a yard's crews, each a quarter faster at their work.",
    "howTo": "A 2×2 lot with the lorry gate on the right of the frontage. Needs Steel frame."
  },
  {
    "id": "construction-company",
    "name": "construction company",
    "kindId": 55,
    "code": 8,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "buildco",
      "key": "",
      "label": "Construction company",
      "color": "#8a5326",
      "cost": 2200
    },
    "tech": [
      "con4"
    ],
    "occupation": {
      "name": "builder",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "workRate": 1.6
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 18,
        "upkeep": 55,
        "cost": 2200,
        "work": 900,
        "parking": {
          "surface": 12,
          "underground": 20
        },
        "tech": [
          "con4"
        ],
        "attrs": {
          "workRate": 1.6
        },
        "designs": [
          {
            "key": "55:1:0",
            "index": 0,
            "name": "office block, batching plant silos with a conveyor, mixer trucks and a crane",
            "height": 1.9,
            "draft": false,
            "ops": 35,
            "attrs": {
              "workRate": 1.6
            }
          },
          {
            "key": "55:1:1",
            "index": 1,
            "name": "precast panel works with a gantry crane, stacked panels and silos",
            "height": 1.36,
            "draft": false,
            "ops": 28,
            "attrs": {
              "workRate": 1.6
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 2,
      "door": [
        0,
        1
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 1,
            "to": 2
          },
          "label": "mixer trucks"
        }
      ]
    },
    "group": "builders",
    "tier": 4,
    "blurb": "Head office, a concrete batching plant and a fleet of mixer trucks. Three times a yard's crews, each working sixty per cent faster: towers go up in days.",
    "howTo": "Three tiles across and two deep, offices on the left of the frontage, trucks out of the right. Late game: needs Industrialised building."
  },
  {
    "id": "kerbside-bays",
    "name": "kerbside bays",
    "kindId": 56,
    "code": 9,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": true,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "kerbbays",
      "key": "",
      "label": "Kerbside bays",
      "color": "#7a808c",
      "cost": 60
    },
    "tech": [
      "tr1"
    ],
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 1,
        "cost": 60,
        "work": 60,
        "parking": {
          "surface": 6,
          "underground": 6
        },
        "tech": [
          "tr1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "56:1:0",
            "index": 0,
            "name": "paved court with bays, tree pits and a pay-and-display machine",
            "height": 0.3,
            "draft": false,
            "ops": 27,
            "attrs": {}
          },
          {
            "key": "56:1:1",
            "index": 1,
            "name": "cobbled bays between planters, with a parking sign",
            "height": 0.3,
            "draft": false,
            "ops": 21,
            "attrs": {}
          }
        ]
      }
    ],
    "group": "parking",
    "tier": 1,
    "blurb": "Half a dozen marked bays on a paved court with a pay-and-display machine. Takes the overflow off a busy street for very little upkeep.",
    "howTo": "One tile beside a road, next to the shops or offices that fill up. Builders mark it out in no time."
  },
  {
    "id": "multi-storey",
    "name": "multi-storey car park",
    "kindId": 57,
    "code": 9,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": true,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "multistorey",
      "key": "",
      "label": "Multi-storey car park",
      "color": "#4e535e",
      "cost": 1200
    },
    "tech": [
      "con2"
    ],
    "attrs": {
      "decks": 4
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 18,
        "cost": 1200,
        "work": 800,
        "parking": {
          "surface": 96,
          "underground": 128
        },
        "tech": [
          "con2"
        ],
        "attrs": {
          "decks": 4
        },
        "designs": [
          {
            "key": "57:1:0",
            "index": 0,
            "name": "four concrete decks with a corner ramp drum and a glazed stair tower",
            "height": 1.12,
            "draft": false,
            "ops": 144,
            "attrs": {
              "decks": 4
            }
          },
          {
            "key": "57:1:1",
            "index": 1,
            "name": "timber-clad decks behind a green wall, with solar panels on top",
            "height": 1.08,
            "draft": false,
            "ops": 172,
            "attrs": {
              "decks": 4
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ],
      "marks": [
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 1,
            "to": 1
          },
          "label": "barrier and ramp"
        }
      ]
    },
    "group": "parking",
    "tier": 3,
    "blurb": "Four decks of bays over a 2×2 plot with a spiral ramp and a stair tower. Takes eight times a surface lot's cars off the street, more again with deep foundations.",
    "howTo": "A 2×2 lot by a busy centre; cars come and go through the barrier on the right of the frontage. Needs Steel frame."
  },
  {
    "id": "park-and-ride",
    "name": "park and ride",
    "kindId": 58,
    "code": 9,
    "family": "transport",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": true,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "parkride",
      "key": "",
      "label": "Park and ride",
      "color": "#3f6f8f",
      "cost": 1600
    },
    "tech": [
      "tr5"
    ],
    "attrs": {
      "busStop": true
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 22,
        "cost": 1600,
        "work": 900,
        "parking": {
          "surface": 120,
          "underground": 150
        },
        "tech": [
          "tr5"
        ],
        "attrs": {
          "busStop": true
        },
        "designs": [
          {
            "key": "58:1:0",
            "index": 0,
            "name": "lit surface car park with a ticket hall and a bus shelter at the gate",
            "height": 0.62,
            "draft": false,
            "ops": 159,
            "attrs": {
              "busStop": true
            }
          },
          {
            "key": "58:1:1",
            "index": 1,
            "name": "two-level deck beside a surface lot, a canopy walkway to the stop",
            "height": 0.66,
            "draft": false,
            "ops": 138,
            "attrs": {
              "busStop": true
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ],
      "marks": [
        {
          "kind": "stand",
          "at": [
            0,
            2
          ],
          "label": "bus stop (later)"
        },
        {
          "kind": "gate",
          "at": {
            "edge": "front",
            "from": 1,
            "to": 1
          },
          "label": "entrance"
        }
      ]
    },
    "group": "parking",
    "tier": 4,
    "blurb": "A big lit car park on the edge of town with a ticket hall and room for a bus stop at the gate. Drivers leave the car and ride in; for now it is the largest lot there is.",
    "howTo": "A 3×3 lot on a road into town. The front-left tile is kept for a bus stop that a later card will run buses through. Needs Public transport."
  },
  {
    "id": "lakeside-park",
    "name": "lakeside park",
    "kindId": 59,
    "code": 10,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tool": {
      "id": "lakepark",
      "key": "",
      "label": "Lakeside park",
      "color": "#3f8f6a",
      "cost": 900
    },
    "tech": [
      "cul1"
    ],
    "attrs": {
      "venueType": "park",
      "openHours": [
        6,
        22
      ],
      "ticket": 0,
      "stay": [
        0.8,
        2.2
      ],
      "dayAppeal": 1.4,
      "eveningAppeal": 0.4,
      "retireeAppeal": 1.9,
      "childAppeal": 2.2,
      "trees": 0,
      "benches": 0,
      "title": "lakeside park"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 18,
        "cost": 900,
        "work": 900,
        "parking": {
          "surface": 6,
          "underground": 6
        },
        "tech": [
          "cul1"
        ],
        "attrs": {
          "venueType": "park",
          "openHours": [
            6,
            22
          ],
          "ticket": 0,
          "stay": [
            0.8,
            2.2
          ],
          "dayAppeal": 1.4,
          "eveningAppeal": 0.4,
          "retireeAppeal": 1.9,
          "childAppeal": 2.2,
          "trees": 0,
          "benches": 0,
          "title": "lakeside park",
          "visitorCapacity": 80,
          "leisureValue": 10,
          "radius": 16,
          "eventNights": [
            6
          ],
          "eventStart": 14
        },
        "designs": [
          {
            "key": "59:1:0",
            "index": 0,
            "name": "boating lake with an island, a boathouse, a bandstand and woods",
            "height": 0.4,
            "draft": false,
            "ops": 92,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.8,
                2.2
              ],
              "dayAppeal": 1.4,
              "eveningAppeal": 0.4,
              "retireeAppeal": 1.9,
              "childAppeal": 2.2,
              "trees": 0,
              "benches": 0,
              "title": "lakeside park",
              "visitorCapacity": 80,
              "leisureValue": 10,
              "radius": 16,
              "eventNights": [
                6
              ],
              "eventStart": 14
            }
          },
          {
            "key": "59:1:1",
            "index": 1,
            "name": "country park with a meadow, a long lake and a jetty café",
            "height": 0.36,
            "draft": false,
            "ops": 64,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.8,
                2.2
              ],
              "dayAppeal": 1.4,
              "eveningAppeal": 0.4,
              "retireeAppeal": 1.9,
              "childAppeal": 2.2,
              "trees": 0,
              "benches": 0,
              "title": "lakeside park",
              "visitorCapacity": 80,
              "leisureValue": 10,
              "radius": 16,
              "eventNights": [
                6
              ],
              "eventStart": 14
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "park",
    "tier": 2,
    "blurb": "Nine tiles of lawns, woods and a boating lake with an island, a boathouse and a bandstand. Far more visitors than any single park, and homes much further away count it.",
    "howTo": "A 3×3 block with the gate in the middle of the frontage. Free to visit; children walk here on their own if it is close to home."
  },
  {
    "id": "botanical-garden",
    "name": "botanical garden",
    "kindId": 60,
    "code": 10,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tool": {
      "id": "botanic",
      "key": "",
      "label": "Botanical garden",
      "color": "#2f7f55",
      "cost": 2200
    },
    "tech": [
      "cul5"
    ],
    "attrs": {
      "venueType": "park",
      "openHours": [
        8,
        20
      ],
      "ticket": 2,
      "stay": [
        1.2,
        3
      ],
      "dayAppeal": 1.6,
      "eveningAppeal": 0.2,
      "retireeAppeal": 2.4,
      "childAppeal": 1.6,
      "trees": 0,
      "benches": 0,
      "title": "botanical garden"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 34,
        "cost": 2200,
        "work": 1600,
        "parking": {
          "surface": 10,
          "underground": 16
        },
        "tech": [
          "cul5"
        ],
        "attrs": {
          "venueType": "park",
          "openHours": [
            8,
            20
          ],
          "ticket": 2,
          "stay": [
            1.2,
            3
          ],
          "dayAppeal": 1.6,
          "eveningAppeal": 0.2,
          "retireeAppeal": 2.4,
          "childAppeal": 1.6,
          "trees": 0,
          "benches": 0,
          "title": "botanical garden",
          "visitorCapacity": 120,
          "leisureValue": 12,
          "radius": 20
        },
        "designs": [
          {
            "key": "60:1:0",
            "index": 0,
            "name": "palm house glasshouse over formal beds, an arboretum and a lake garden",
            "height": 1.1,
            "draft": false,
            "ops": 99,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 2,
              "stay": [
                1.2,
                3
              ],
              "dayAppeal": 1.6,
              "eveningAppeal": 0.2,
              "retireeAppeal": 2.4,
              "childAppeal": 1.6,
              "trees": 0,
              "benches": 0,
              "title": "botanical garden",
              "visitorCapacity": 120,
              "leisureValue": 12,
              "radius": 20
            }
          },
          {
            "key": "60:1:1",
            "index": 1,
            "name": "walled garden with a domed conservatory, a rock garden and a long canal",
            "height": 1,
            "draft": false,
            "ops": 91,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 2,
              "stay": [
                1.2,
                3
              ],
              "dayAppeal": 1.6,
              "eveningAppeal": 0.2,
              "retireeAppeal": 2.4,
              "childAppeal": 1.6,
              "trees": 0,
              "benches": 0,
              "title": "botanical garden",
              "visitorCapacity": 120,
              "leisureValue": 12,
              "radius": 20
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        2,
        3
      ]
    },
    "group": "park",
    "tier": 3,
    "blurb": "A great glasshouse of palms, formal beds, an arboretum and a lake garden over a whole block. The finest park in town, worth a trip from anywhere.",
    "howTo": "A 4×4 block; the gate is right of the middle of the frontage. A small entry charge pays towards the upkeep. Late game: needs Landmarks."
  },
  {
    "id": "cafe-cinema",
    "name": "café cinema",
    "kindId": 61,
    "code": 11,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "cafecinema",
      "key": "",
      "label": "Café cinema",
      "color": "#c55a63",
      "cost": 350
    },
    "tech": [
      "cul2"
    ],
    "occupation": {
      "name": "café cinema staff",
      "rotate": true,
      "shifts": [
        {
          "start": 12,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "cinema",
      "openHours": [
        11,
        24
      ],
      "visitorCapacity": 14,
      "ticket": 6,
      "stay": [
        2,
        2.6
      ],
      "leisureValue": 3,
      "radius": 10,
      "eventNights": [
        4
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.5,
      "eveningAppeal": 1.6,
      "retireeAppeal": 0.7,
      "childAppeal": 1.2,
      "eventSize": 0.8,
      "title": "café cinema"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 3,
        "wage": 13,
        "upkeep": 6,
        "cost": 350,
        "work": 200,
        "parking": {
          "surface": 2,
          "underground": 6
        },
        "tech": [
          "cul2"
        ],
        "attrs": {
          "venueType": "cinema",
          "openHours": [
            11,
            24
          ],
          "visitorCapacity": 14,
          "ticket": 6,
          "stay": [
            2,
            2.6
          ],
          "leisureValue": 3,
          "radius": 10,
          "eventNights": [
            4
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.5,
          "eveningAppeal": 1.6,
          "retireeAppeal": 0.7,
          "childAppeal": 1.2,
          "eventSize": 0.8,
          "title": "café cinema"
        },
        "designs": [
          {
            "key": "61:1:0",
            "index": 0,
            "name": "corner café cinema with a striped awning and a lit name board",
            "height": 0.62,
            "draft": false,
            "ops": 17,
            "attrs": {
              "venueType": "cinema",
              "openHours": [
                11,
                24
              ],
              "visitorCapacity": 14,
              "ticket": 6,
              "stay": [
                2,
                2.6
              ],
              "leisureValue": 3,
              "radius": 10,
              "eventNights": [
                4
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.5,
              "eveningAppeal": 1.6,
              "retireeAppeal": 0.7,
              "childAppeal": 1.2,
              "eventSize": 0.8,
              "title": "café cinema"
            }
          },
          {
            "key": "61:1:1",
            "index": 1,
            "name": "converted chapel cinema with a rose window and a poster case",
            "height": 0.84,
            "draft": false,
            "ops": 10,
            "attrs": {
              "venueType": "cinema",
              "openHours": [
                11,
                24
              ],
              "visitorCapacity": 14,
              "ticket": 6,
              "stay": [
                2,
                2.6
              ],
              "leisureValue": 3,
              "radius": 10,
              "eventNights": [
                4
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.5,
              "eveningAppeal": 1.6,
              "retireeAppeal": 0.7,
              "childAppeal": 1.2,
              "eventSize": 0.8,
              "title": "café cinema"
            }
          }
        ]
      }
    ],
    "group": "cinema",
    "tier": 1,
    "blurb": "A single screen of forty seats behind a café bar: films with a glass of wine. Small, cheap to run and good for a neighbourhood.",
    "howTo": "One tile on a street with shops. Ticket sales are taxed in your parcel like a bar."
  },
  {
    "id": "multiplex",
    "name": "multiplex",
    "kindId": 62,
    "code": 11,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "multiplex",
      "key": "",
      "label": "Multiplex",
      "color": "#a3323e",
      "cost": 1800
    },
    "tech": [
      "cul4"
    ],
    "occupation": {
      "name": "cinema usher",
      "rotate": true,
      "shifts": [
        {
          "start": 12,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "cinema",
      "openHours": [
        12,
        24
      ],
      "visitorCapacity": 90,
      "ticket": 9,
      "stay": [
        2,
        2.6
      ],
      "leisureValue": 6,
      "radius": 20,
      "eventNights": [
        3,
        4,
        5
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.25,
      "eveningAppeal": 1.6,
      "retireeAppeal": 0.7,
      "childAppeal": 1.2,
      "eventSize": 1.4,
      "title": "multiplex"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 14,
        "wage": 14,
        "upkeep": 30,
        "cost": 1800,
        "work": 650,
        "parking": {
          "surface": 16,
          "underground": 40
        },
        "tech": [
          "cul4"
        ],
        "attrs": {
          "venueType": "cinema",
          "openHours": [
            12,
            24
          ],
          "visitorCapacity": 90,
          "ticket": 9,
          "stay": [
            2,
            2.6
          ],
          "leisureValue": 6,
          "radius": 20,
          "eventNights": [
            3,
            4,
            5
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.25,
          "eveningAppeal": 1.6,
          "retireeAppeal": 0.7,
          "childAppeal": 1.2,
          "eventSize": 1.4,
          "title": "multiplex"
        },
        "designs": [
          {
            "key": "62:1:0",
            "index": 0,
            "name": "dark screen box with a glass foyer, a poster wall and a sign blade",
            "height": 1.3,
            "draft": false,
            "ops": 40,
            "attrs": {
              "venueType": "cinema",
              "openHours": [
                12,
                24
              ],
              "visitorCapacity": 90,
              "ticket": 9,
              "stay": [
                2,
                2.6
              ],
              "leisureValue": 6,
              "radius": 20,
              "eventNights": [
                3,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.25,
              "eveningAppeal": 1.6,
              "retireeAppeal": 0.7,
              "childAppeal": 1.2,
              "eventSize": 1.4,
              "title": "multiplex"
            }
          },
          {
            "key": "62:1:1",
            "index": 1,
            "name": "leisure box with a curved glass front and neon bands",
            "height": 1.06,
            "draft": false,
            "ops": 22,
            "attrs": {
              "venueType": "cinema",
              "openHours": [
                12,
                24
              ],
              "visitorCapacity": 90,
              "ticket": 9,
              "stay": [
                2,
                2.6
              ],
              "leisureValue": 6,
              "radius": 20,
              "eventNights": [
                3,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.25,
              "eveningAppeal": 1.6,
              "retireeAppeal": 0.7,
              "childAppeal": 1.2,
              "eventSize": 1.4,
              "title": "multiplex"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "cinema",
    "tier": 3,
    "blurb": "Ten screens, an IMAX and a car park full on a Friday. Three times a cinema's audience from twice as far, and premieres that draw a crowd.",
    "howTo": "A 2×2 lot on a main road; it brings evening traffic, so give it parking nearby. Needs Big nights out."
  },
  {
    "id": "studio-theatre",
    "name": "studio theatre",
    "kindId": 63,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "studiotheatre",
      "key": "",
      "label": "Studio theatre",
      "color": "#8a4e9e",
      "cost": 600
    },
    "tech": [
      "cul3"
    ],
    "occupation": {
      "name": "theatre staff",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        14,
        24
      ],
      "visitorCapacity": 18,
      "ticket": 10,
      "stay": [
        2.4,
        3
      ],
      "leisureValue": 4,
      "radius": 12,
      "eventNights": [
        3,
        5
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.15,
      "eveningAppeal": 1.2,
      "retireeAppeal": 1.3,
      "childAppeal": 0.4,
      "eventSize": 0.8,
      "title": "studio theatre"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 5,
        "wage": 17,
        "upkeep": 10,
        "cost": 600,
        "work": 200,
        "parking": {
          "surface": 2,
          "underground": 6
        },
        "tech": [
          "cul3"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            14,
            24
          ],
          "visitorCapacity": 18,
          "ticket": 10,
          "stay": [
            2.4,
            3
          ],
          "leisureValue": 4,
          "radius": 12,
          "eventNights": [
            3,
            5
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.15,
          "eveningAppeal": 1.2,
          "retireeAppeal": 1.3,
          "childAppeal": 0.4,
          "eventSize": 0.8,
          "title": "studio theatre"
        },
        "designs": [
          {
            "key": "63:1:0",
            "index": 0,
            "name": "warehouse studio with a black box, a neon sign and a fire escape",
            "height": 0.74,
            "draft": false,
            "ops": 21,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                14,
                24
              ],
              "visitorCapacity": 18,
              "ticket": 10,
              "stay": [
                2.4,
                3
              ],
              "leisureValue": 4,
              "radius": 12,
              "eventNights": [
                3,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.2,
              "retireeAppeal": 1.3,
              "childAppeal": 0.4,
              "eventSize": 0.8,
              "title": "studio theatre"
            }
          },
          {
            "key": "63:1:1",
            "index": 1,
            "name": "fringe theatre over a corner pub, with a hanging sign",
            "height": 0.78,
            "draft": false,
            "ops": 11,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                14,
                24
              ],
              "visitorCapacity": 18,
              "ticket": 10,
              "stay": [
                2.4,
                3
              ],
              "leisureValue": 4,
              "radius": 12,
              "eventNights": [
                3,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.2,
              "retireeAppeal": 1.3,
              "childAppeal": 0.4,
              "eventSize": 0.8,
              "title": "studio theatre"
            }
          }
        ]
      }
    ],
    "group": "theatre",
    "tier": 1,
    "blurb": "A black-box studio of eighty seats for new writing and comedy nights. Cheaper than a playhouse and a reason for a neighbourhood to go out.",
    "howTo": "One tile near cafés and bars. Performance nights pull people from a little further than a café cinema."
  },
  {
    "id": "opera-house",
    "name": "opera house",
    "kindId": 64,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "opera",
      "key": "",
      "label": "Opera house",
      "color": "#5e2a72",
      "cost": 4800
    },
    "tech": [
      "cul5"
    ],
    "occupation": {
      "name": "opera house staff",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        14,
        24
      ],
      "visitorCapacity": 160,
      "ticket": 24,
      "stay": [
        2.8,
        3.6
      ],
      "leisureValue": 10,
      "radius": 24,
      "eventNights": [
        2,
        4,
        5
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.15,
      "eveningAppeal": 1.2,
      "retireeAppeal": 1.6,
      "childAppeal": 0.4,
      "eventSize": 1.8,
      "title": "opera house"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 20,
        "upkeep": 70,
        "cost": 4800,
        "work": 1300,
        "parking": {
          "surface": 20,
          "underground": 50
        },
        "tech": [
          "cul5"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            14,
            24
          ],
          "visitorCapacity": 160,
          "ticket": 24,
          "stay": [
            2.8,
            3.6
          ],
          "leisureValue": 10,
          "radius": 24,
          "eventNights": [
            2,
            4,
            5
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.15,
          "eveningAppeal": 1.2,
          "retireeAppeal": 1.6,
          "childAppeal": 0.4,
          "eventSize": 1.8,
          "title": "opera house"
        },
        "designs": [
          {
            "key": "64:1:0",
            "index": 0,
            "name": "classical opera house with a fly tower, a colonnade and a fountain piazza",
            "height": 1.86,
            "draft": false,
            "ops": 42,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                14,
                24
              ],
              "visitorCapacity": 160,
              "ticket": 24,
              "stay": [
                2.8,
                3.6
              ],
              "leisureValue": 10,
              "radius": 24,
              "eventNights": [
                2,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.2,
              "retireeAppeal": 1.6,
              "childAppeal": 0.4,
              "eventSize": 1.8,
              "title": "opera house"
            }
          },
          {
            "key": "64:1:1",
            "index": 1,
            "name": "harbour-style opera house of stacked white shells on a stepped podium",
            "height": 1.62,
            "draft": false,
            "ops": 22,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                14,
                24
              ],
              "visitorCapacity": 160,
              "ticket": 24,
              "stay": [
                2.8,
                3.6
              ],
              "leisureValue": 10,
              "radius": 24,
              "eventNights": [
                2,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.2,
              "retireeAppeal": 1.6,
              "childAppeal": 0.4,
              "eventSize": 1.8,
              "title": "opera house"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "theatre",
    "tier": 3,
    "blurb": "A grand house for opera and ballet with a fly tower, a colonnade and a piazza. Gala nights fill it from all over the city; tickets are dear and worth it.",
    "howTo": "A 3×3 block with the doors in the middle of the frontage and the piazza in front. Late game: needs Landmarks."
  },
  {
    "id": "leisure-centre",
    "name": "leisure centre",
    "kindId": 65,
    "code": 13,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "leisurecentre",
      "key": "",
      "label": "Leisure centre",
      "color": "#2a86c8",
      "cost": 1500
    },
    "tech": [
      "cul3"
    ],
    "occupation": {
      "name": "leisure attendant",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "sports",
      "openHours": [
        6,
        22
      ],
      "visitorCapacity": 60,
      "ticket": 5,
      "stay": [
        1.2,
        2.2
      ],
      "leisureValue": 6,
      "radius": 16,
      "eventNights": [
        2,
        5
      ],
      "eventStart": 19,
      "dayAppeal": 0.9,
      "eveningAppeal": 1.2,
      "retireeAppeal": 0.9,
      "childAppeal": 1.8,
      "eventSize": 1.1,
      "title": "leisure centre"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 12,
        "wage": 14,
        "upkeep": 26,
        "cost": 1500,
        "work": 600,
        "parking": {
          "surface": 10,
          "underground": 24
        },
        "tech": [
          "cul3"
        ],
        "attrs": {
          "venueType": "sports",
          "openHours": [
            6,
            22
          ],
          "visitorCapacity": 60,
          "ticket": 5,
          "stay": [
            1.2,
            2.2
          ],
          "leisureValue": 6,
          "radius": 16,
          "eventNights": [
            2,
            5
          ],
          "eventStart": 19,
          "dayAppeal": 0.9,
          "eveningAppeal": 1.2,
          "retireeAppeal": 0.9,
          "childAppeal": 1.8,
          "eventSize": 1.1,
          "title": "leisure centre"
        },
        "designs": [
          {
            "key": "65:1:0",
            "index": 0,
            "name": "glazed pool hall beside a sports hall, with a flume tower",
            "height": 1,
            "draft": false,
            "ops": 23,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                6,
                22
              ],
              "visitorCapacity": 60,
              "ticket": 5,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 6,
              "radius": 16,
              "eventNights": [
                2,
                5
              ],
              "eventStart": 19,
              "dayAppeal": 0.9,
              "eveningAppeal": 1.2,
              "retireeAppeal": 0.9,
              "childAppeal": 1.8,
              "eventSize": 1.1,
              "title": "leisure centre"
            }
          },
          {
            "key": "65:1:1",
            "index": 1,
            "name": "open-air lido with deck chairs, a diving board and a gym block",
            "height": 0.66,
            "draft": false,
            "ops": 39,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                6,
                22
              ],
              "visitorCapacity": 60,
              "ticket": 5,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 6,
              "radius": 16,
              "eventNights": [
                2,
                5
              ],
              "eventStart": 19,
              "dayAppeal": 0.9,
              "eveningAppeal": 1.2,
              "retireeAppeal": 0.9,
              "childAppeal": 1.8,
              "eventSize": 1.1,
              "title": "leisure centre"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "sports",
    "tier": 2,
    "blurb": "A swimming pool, a sports hall and a gym under one roof. Busy from the early swim to the evening classes, with galas on match nights.",
    "howTo": "A 2×2 lot beside homes and schools: children and families love it. Needs Theatre (the third Culture tier)."
  },
  {
    "id": "arena",
    "name": "arena",
    "kindId": 66,
    "code": 13,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "arena",
      "key": "",
      "label": "Arena",
      "color": "#24609f",
      "cost": 3200
    },
    "tech": [
      "cul4"
    ],
    "occupation": {
      "name": "arena staff",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "sports",
      "openHours": [
        10,
        24
      ],
      "visitorCapacity": 160,
      "ticket": 12,
      "stay": [
        1.2,
        2.2
      ],
      "leisureValue": 8,
      "radius": 22,
      "eventNights": [
        2,
        4,
        5
      ],
      "eventStart": 19,
      "dayAppeal": 0.3,
      "eveningAppeal": 1.5,
      "retireeAppeal": 0.4,
      "childAppeal": 1.4,
      "eventSize": 1.6,
      "title": "arena"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 15,
        "upkeep": 50,
        "cost": 3200,
        "work": 1200,
        "parking": {
          "surface": 20,
          "underground": 50
        },
        "tech": [
          "cul4"
        ],
        "attrs": {
          "venueType": "sports",
          "openHours": [
            10,
            24
          ],
          "visitorCapacity": 160,
          "ticket": 12,
          "stay": [
            1.2,
            2.2
          ],
          "leisureValue": 8,
          "radius": 22,
          "eventNights": [
            2,
            4,
            5
          ],
          "eventStart": 19,
          "dayAppeal": 0.3,
          "eveningAppeal": 1.5,
          "retireeAppeal": 0.4,
          "childAppeal": 1.4,
          "eventSize": 1.6,
          "title": "arena"
        },
        "designs": [
          {
            "key": "66:1:0",
            "index": 0,
            "name": "oval arena under a shallow dome with a ring of lights",
            "height": 1.1,
            "draft": false,
            "ops": 25,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                10,
                24
              ],
              "visitorCapacity": 160,
              "ticket": 12,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 8,
              "radius": 22,
              "eventNights": [
                2,
                4,
                5
              ],
              "eventStart": 19,
              "dayAppeal": 0.3,
              "eveningAppeal": 1.5,
              "retireeAppeal": 0.4,
              "childAppeal": 1.4,
              "eventSize": 1.6,
              "title": "arena"
            }
          },
          {
            "key": "66:1:1",
            "index": 1,
            "name": "box arena with a curved roof, glazed concourse and a big screen",
            "height": 1.24,
            "draft": false,
            "ops": 46,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                10,
                24
              ],
              "visitorCapacity": 160,
              "ticket": 12,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 8,
              "radius": 22,
              "eventNights": [
                2,
                4,
                5
              ],
              "eventStart": 19,
              "dayAppeal": 0.3,
              "eveningAppeal": 1.5,
              "retireeAppeal": 0.4,
              "childAppeal": 1.4,
              "eventSize": 1.6,
              "title": "arena"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "sports",
    "tier": 3,
    "blurb": "An indoor arena for basketball, ice hockey and concerts, with a big screen outside. Match nights fill it from across town.",
    "howTo": "A 3×3 block with the doors in the middle of the frontage. Event nights bring a rush of traffic, so plan roads and parking. Needs Big nights out."
  },
  {
    "id": "stadium",
    "name": "stadium",
    "kindId": 67,
    "code": 13,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "stadium",
      "key": "",
      "label": "Stadium",
      "color": "#1f4f88",
      "cost": 6000
    },
    "tech": [
      "cul5"
    ],
    "occupation": {
      "name": "stadium staff",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "sports",
      "openHours": [
        10,
        23
      ],
      "visitorCapacity": 300,
      "ticket": 18,
      "stay": [
        2,
        3
      ],
      "leisureValue": 10,
      "radius": 24,
      "eventNights": [
        5,
        6
      ],
      "eventStart": 15,
      "dayAppeal": 0.4,
      "eveningAppeal": 1.3,
      "retireeAppeal": 0.6,
      "childAppeal": 1.4,
      "eventSize": 2.2,
      "title": "stadium"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 16,
        "upkeep": 90,
        "cost": 6000,
        "work": 2000,
        "parking": {
          "surface": 40,
          "underground": 80
        },
        "tech": [
          "cul5"
        ],
        "attrs": {
          "venueType": "sports",
          "openHours": [
            10,
            23
          ],
          "visitorCapacity": 300,
          "ticket": 18,
          "stay": [
            2,
            3
          ],
          "leisureValue": 10,
          "radius": 24,
          "eventNights": [
            5,
            6
          ],
          "eventStart": 15,
          "dayAppeal": 0.4,
          "eveningAppeal": 1.3,
          "retireeAppeal": 0.6,
          "childAppeal": 1.4,
          "eventSize": 2.2,
          "title": "stadium"
        },
        "designs": [
          {
            "key": "67:1:0",
            "index": 0,
            "name": "four-stand football ground with corner floodlight pylons",
            "height": 2.14,
            "draft": false,
            "ops": 71,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                10,
                23
              ],
              "visitorCapacity": 300,
              "ticket": 18,
              "stay": [
                2,
                3
              ],
              "leisureValue": 10,
              "radius": 24,
              "eventNights": [
                5,
                6
              ],
              "eventStart": 15,
              "dayAppeal": 0.4,
              "eveningAppeal": 1.3,
              "retireeAppeal": 0.6,
              "childAppeal": 1.4,
              "eventSize": 2.2,
              "title": "stadium"
            }
          },
          {
            "key": "67:1:1",
            "index": 1,
            "name": "bowl stadium with a running track and a cantilevered roof ring",
            "height": 1.42,
            "draft": false,
            "ops": 43,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                10,
                23
              ],
              "visitorCapacity": 300,
              "ticket": 18,
              "stay": [
                2,
                3
              ],
              "leisureValue": 10,
              "radius": 24,
              "eventNights": [
                5,
                6
              ],
              "eventStart": 15,
              "dayAppeal": 0.4,
              "eveningAppeal": 1.3,
              "retireeAppeal": 0.6,
              "childAppeal": 1.4,
              "eventSize": 2.2,
              "title": "stadium"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        2,
        3
      ]
    },
    "group": "sports",
    "tier": 4,
    "blurb": "A football stadium with four stands and floodlights you can see across the city. Match days are the biggest crowds in town and the busiest roads.",
    "howTo": "A whole 4×4 block with the main gate right of centre. Put it by a main road with parking and, later, rail or buses. Late game: needs Landmarks."
  },
  {
    "id": "central-library",
    "name": "central library",
    "kindId": 68,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "office",
    "tool": {
      "id": "centrallibrary",
      "key": "",
      "label": "Central library",
      "color": "#94744a",
      "cost": 1200
    },
    "tech": [
      "cul2"
    ],
    "occupation": {
      "name": "librarian",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        21
      ],
      "visitorCapacity": 50,
      "ticket": 0,
      "stay": [
        0.6,
        1.8
      ],
      "leisureValue": 5,
      "radius": 16,
      "dayAppeal": 1,
      "eveningAppeal": 0.6,
      "retireeAppeal": 2,
      "childAppeal": 1.6,
      "eventNights": [
        1
      ],
      "eventStart": 19,
      "title": "central library"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 10,
        "wage": 16,
        "upkeep": 22,
        "cost": 1200,
        "work": 600,
        "parking": {
          "surface": 6,
          "underground": 16
        },
        "tech": [
          "cul2"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            21
          ],
          "visitorCapacity": 50,
          "ticket": 0,
          "stay": [
            0.6,
            1.8
          ],
          "leisureValue": 5,
          "radius": 16,
          "dayAppeal": 1,
          "eveningAppeal": 0.6,
          "retireeAppeal": 2,
          "childAppeal": 1.6,
          "eventNights": [
            1
          ],
          "eventStart": 19,
          "title": "central library"
        },
        "designs": [
          {
            "key": "68:1:0",
            "index": 0,
            "name": "stacked glass library of offset floors with a roof terrace",
            "height": 1.42,
            "draft": false,
            "ops": 25,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 50,
              "ticket": 0,
              "stay": [
                0.6,
                1.8
              ],
              "leisureValue": 5,
              "radius": 16,
              "dayAppeal": 1,
              "eveningAppeal": 0.6,
              "retireeAppeal": 2,
              "childAppeal": 1.6,
              "eventNights": [
                1
              ],
              "eventStart": 19,
              "title": "central library"
            }
          },
          {
            "key": "68:1:1",
            "index": 1,
            "name": "domed classical library with two wings and a stepped entrance",
            "height": 1.16,
            "draft": false,
            "ops": 25,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 50,
              "ticket": 0,
              "stay": [
                0.6,
                1.8
              ],
              "leisureValue": 5,
              "radius": 16,
              "dayAppeal": 1,
              "eveningAppeal": 0.6,
              "retireeAppeal": 2,
              "childAppeal": 1.6,
              "eventNights": [
                1
              ],
              "eventStart": 19,
              "title": "central library"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "library",
    "tier": 2,
    "blurb": "Five floors of books, study rooms, a children's floor and a roof terrace. Open late and free: retirees and children come from across the district.",
    "howTo": "A 2×2 lot near a high street. Quiz nights on Tuesdays bring an evening crowd. Needs Cinemas and sports halls."
  },
  {
    "id": "museum",
    "name": "museum",
    "kindId": 69,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "office",
    "tool": {
      "id": "museum",
      "key": "",
      "label": "Museum",
      "color": "#8a6a3c",
      "cost": 2400
    },
    "tech": [
      "cul4"
    ],
    "occupation": {
      "name": "museum staff",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        10,
        18
      ],
      "visitorCapacity": 90,
      "ticket": 6,
      "stay": [
        1.5,
        3
      ],
      "leisureValue": 7,
      "radius": 20,
      "dayAppeal": 1.2,
      "eveningAppeal": 0.3,
      "retireeAppeal": 2.2,
      "childAppeal": 1.7,
      "title": "museum"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 14,
        "wage": 17,
        "upkeep": 36,
        "cost": 2400,
        "work": 900,
        "parking": {
          "surface": 10,
          "underground": 24
        },
        "tech": [
          "cul4"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            10,
            18
          ],
          "visitorCapacity": 90,
          "ticket": 6,
          "stay": [
            1.5,
            3
          ],
          "leisureValue": 7,
          "radius": 20,
          "dayAppeal": 1.2,
          "eveningAppeal": 0.3,
          "retireeAppeal": 2.2,
          "childAppeal": 1.7,
          "title": "museum"
        },
        "designs": [
          {
            "key": "69:1:0",
            "index": 0,
            "name": "neoclassical museum with a pedimented portico and two gallery wings",
            "height": 1.1,
            "draft": false,
            "ops": 24,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                18
              ],
              "visitorCapacity": 90,
              "ticket": 6,
              "stay": [
                1.5,
                3
              ],
              "leisureValue": 7,
              "radius": 20,
              "dayAppeal": 1.2,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2.2,
              "childAppeal": 1.7,
              "title": "museum"
            }
          },
          {
            "key": "69:1:1",
            "index": 1,
            "name": "modern museum of angled galleries round a glass atrium, with a sculpture",
            "height": 1.24,
            "draft": false,
            "ops": 19,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                18
              ],
              "visitorCapacity": 90,
              "ticket": 6,
              "stay": [
                1.5,
                3
              ],
              "leisureValue": 7,
              "radius": 20,
              "dayAppeal": 1.2,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2.2,
              "childAppeal": 1.7,
              "title": "museum"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "library",
    "tier": 3,
    "blurb": "Galleries of art, history and natural history, with a café and a shop. A long day out for families and retirees, drawing visitors from far away.",
    "howTo": "Three tiles across and two deep, doors in the middle of the frontage. A small ticket pays towards the upkeep. Needs Big nights out."
  },
  {
    "id": "res-terrace",
    "name": "terrace row",
    "kindId": 70,
    "code": 1,
    "family": "residential",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tech": [],
    "attrs": {},
    "tints": [
      16777215,
      16767416,
      16773299,
      13624311,
      14085065,
      16240591,
      15918847,
      16770244
    ],
    "lotTint": 9429114,
    "levels": [
      {
        "level": 2,
        "capacity": 18,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 144,
        "parking": {
          "surface": 13,
          "underground": 18
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "style": "terrace",
          "rentBand": "mid"
        },
        "designs": [
          {
            "key": "70:2:0",
            "index": 0,
            "name": "four brick houses with front gardens and chimneys",
            "height": 0.62,
            "draft": false,
            "ops": 28,
            "attrs": {
              "style": "terrace",
              "rentBand": "mid"
            }
          },
          {
            "key": "70:2:1",
            "index": 1,
            "name": "semi-detached pair with porches and a shared drive",
            "height": 0.7,
            "draft": false,
            "ops": 24,
            "attrs": {
              "style": "terrace",
              "rentBand": "mid"
            }
          },
          {
            "key": "70:2:2",
            "index": 2,
            "name": "mews of three cottages on a gravel yard",
            "height": 0.6,
            "draft": false,
            "ops": 21,
            "attrs": {
              "style": "terrace",
              "rentBand": "mid"
            }
          }
        ]
      },
      {
        "level": 3,
        "capacity": 26,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 216,
        "parking": {
          "surface": 18,
          "underground": 26
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "style": "townhouses",
          "rentBand": "high"
        },
        "designs": [
          {
            "key": "70:3:0",
            "index": 0,
            "name": "Georgian terrace of five stucco townhouses with railings",
            "height": 0.9,
            "draft": false,
            "ops": 33,
            "attrs": {
              "style": "townhouses",
              "rentBand": "high"
            }
          },
          {
            "key": "70:3:1",
            "index": 1,
            "name": "modern townhouses with roof terraces and timber screens",
            "height": 0.82,
            "draft": false,
            "ops": 38,
            "attrs": {
              "style": "townhouses",
              "rentBand": "high"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 1,
      "door": [
        0,
        0
      ]
    }
  },
  {
    "id": "res-midrise",
    "name": "mid-rise apartments",
    "kindId": 71,
    "code": 1,
    "family": "residential",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tech": [],
    "attrs": {},
    "tints": [
      16777215,
      16767416,
      16773299,
      13624311,
      14085065,
      16240591,
      15918847,
      16770244
    ],
    "lotTint": 9429114,
    "levels": [
      {
        "level": 4,
        "capacity": 64,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 576,
        "parking": {
          "surface": 45,
          "underground": 64
        },
        "tech": [
          "con5"
        ],
        "feature": "level4",
        "attrs": {
          "style": "mid-rise apartments",
          "rentBand": "mid"
        },
        "designs": [
          {
            "key": "71:4:0",
            "index": 0,
            "name": "brick courtyard apartments round a garden, with an arched gateway",
            "height": 1.45,
            "draft": false,
            "ops": 29,
            "attrs": {
              "style": "mid-rise apartments",
              "rentBand": "mid"
            }
          },
          {
            "key": "71:4:1",
            "index": 1,
            "name": "stepped cream mid-rise with balconies and a roof garden",
            "height": 1.7,
            "draft": false,
            "ops": 35,
            "attrs": {
              "style": "mid-rise apartments",
              "rentBand": "mid"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    }
  },
  {
    "id": "res-block",
    "name": "perimeter block",
    "kindId": 72,
    "code": 1,
    "family": "residential",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tech": [],
    "attrs": {},
    "tints": [
      16777215,
      16767416,
      16773299,
      13624311,
      14085065,
      16240591,
      15918847,
      16770244
    ],
    "lotTint": 9429114,
    "levels": [
      {
        "level": 5,
        "capacity": 114,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 1080,
        "parking": {
          "surface": 80,
          "underground": 114
        },
        "tech": [
          "con5"
        ],
        "feature": "level5",
        "attrs": {
          "style": "perimeter block",
          "rentBand": "high"
        },
        "designs": [
          {
            "key": "72:5:0",
            "index": 0,
            "name": "stone perimeter block round a garden court, with a corner turret",
            "height": 2.25,
            "draft": false,
            "ops": 31,
            "attrs": {
              "style": "perimeter block",
              "rentBand": "high"
            }
          },
          {
            "key": "72:5:1",
            "index": 1,
            "name": "brick mansion block with bay windows and a fountain court",
            "height": 1.97,
            "draft": false,
            "ops": 36,
            "attrs": {
              "style": "perimeter block",
              "rentBand": "high"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 2,
      "door": [
        1,
        1
      ]
    }
  },
  {
    "id": "res-tower",
    "name": "residential tower",
    "kindId": 73,
    "code": 1,
    "family": "residential",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tech": [],
    "attrs": {},
    "tints": [
      16777215,
      16767416,
      16773299,
      13624311,
      14085065,
      16240591,
      15918847,
      16770244
    ],
    "lotTint": 9429114,
    "levels": [
      {
        "level": 6,
        "capacity": 96,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 864,
        "parking": {
          "surface": 67,
          "underground": 96
        },
        "tech": [
          "con5"
        ],
        "feature": "level6",
        "attrs": {
          "style": "tower flats",
          "rentBand": "mid"
        },
        "designs": [
          {
            "key": "73:6:0",
            "index": 0,
            "name": "slab tower with balcony stripes on a stone podium",
            "height": 3.2,
            "draft": false,
            "ops": 38,
            "attrs": {
              "style": "tower flats",
              "rentBand": "mid"
            }
          },
          {
            "key": "73:6:1",
            "index": 1,
            "name": "twin-core tower with a bridge and a garden podium",
            "height": 3.35,
            "draft": false,
            "ops": 37,
            "attrs": {
              "style": "tower flats",
              "rentBand": "mid"
            }
          }
        ]
      },
      {
        "level": 7,
        "capacity": 120,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 1008,
        "parking": {
          "surface": 84,
          "underground": 120
        },
        "tech": [
          "con5"
        ],
        "feature": "level7",
        "attrs": {
          "style": "tower flats",
          "rentBand": "high"
        },
        "designs": [
          {
            "key": "73:7:0",
            "index": 0,
            "name": "slender glass tower with a finned crown and a spire",
            "height": 4.8,
            "draft": false,
            "ops": 46,
            "attrs": {
              "style": "tower flats",
              "rentBand": "high"
            }
          },
          {
            "key": "73:7:1",
            "index": 1,
            "name": "stepped tower with sky gardens on every setback",
            "height": 4.6,
            "draft": false,
            "ops": 48,
            "attrs": {
              "style": "tower flats",
              "rentBand": "high"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    }
  },
  {
    "id": "res-estate",
    "name": "tower estate",
    "kindId": 74,
    "code": 1,
    "family": "residential",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tech": [],
    "attrs": {},
    "tints": [
      16777215,
      16767416,
      16773299,
      13624311,
      14085065,
      16240591,
      15918847,
      16770244
    ],
    "lotTint": 9429114,
    "levels": [
      {
        "level": 6,
        "capacity": 216,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 1944,
        "parking": {
          "surface": 151,
          "underground": 216
        },
        "tech": [
          "con5"
        ],
        "feature": "level6",
        "attrs": {
          "style": "tower estate",
          "rentBand": "mid"
        },
        "designs": [
          {
            "key": "74:6:0",
            "index": 0,
            "name": "two towers on a landscaped podium with a playground",
            "height": 2.95,
            "draft": false,
            "ops": 72,
            "attrs": {
              "style": "tower estate",
              "rentBand": "mid"
            }
          },
          {
            "key": "74:6:1",
            "index": 1,
            "name": "stepped crescent of flats round a park with a pond",
            "height": 2.95,
            "draft": false,
            "ops": 39,
            "attrs": {
              "style": "tower estate",
              "rentBand": "mid"
            }
          }
        ]
      },
      {
        "level": 7,
        "capacity": 270,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 2268,
        "parking": {
          "surface": 189,
          "underground": 270
        },
        "tech": [
          "con5"
        ],
        "feature": "level7",
        "attrs": {
          "style": "tower estate",
          "rentBand": "high"
        },
        "designs": [
          {
            "key": "74:7:0",
            "index": 0,
            "name": "three towers of different heights round a podium garden",
            "height": 4.95,
            "draft": false,
            "ops": 54,
            "attrs": {
              "style": "tower estate",
              "rentBand": "high"
            }
          },
          {
            "key": "74:7:1",
            "index": 1,
            "name": "tall tower beside a terrace wing and a podium pool deck",
            "height": 4.85,
            "draft": false,
            "ops": 39,
            "attrs": {
              "style": "tower estate",
              "rentBand": "high"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    }
  },
  {
    "id": "com-parade",
    "name": "high-street parade",
    "kindId": 75,
    "code": 2,
    "family": "commercial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tech": [],
    "occupation": {
      "name": "shop worker",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 12,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 6,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "commerceType": "shop",
      "openHours": [
        7,
        22
      ]
    },
    "tints": [
      16777215,
      16774112,
      15659767,
      16247016,
      16054252
    ],
    "lotTint": 8042239,
    "levels": [
      {
        "level": 2,
        "capacity": 14,
        "wage": 20,
        "upkeep": 0,
        "cost": 0,
        "work": 144,
        "parking": {
          "surface": 2,
          "underground": 12
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "commerceType": "shop",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 24
        },
        "designs": [
          {
            "key": "75:2:0",
            "index": 0,
            "name": "parade of four shopfronts with awnings and flats above",
            "height": 0.72,
            "draft": false,
            "ops": 29,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 24
            }
          },
          {
            "key": "75:2:1",
            "index": 1,
            "name": "corner pub with a hanging sign beside a bakery",
            "height": 0.72,
            "draft": false,
            "ops": 27,
            "attrs": {
              "commerceType": "pub",
              "openHours": [
                11,
                24
              ],
              "visitorCapacity": 24
            }
          }
        ]
      },
      {
        "level": 3,
        "capacity": 20,
        "wage": 25,
        "upkeep": 0,
        "cost": 0,
        "work": 216,
        "parking": {
          "surface": 2,
          "underground": 18
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "commerceType": "shop",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 36
        },
        "designs": [
          {
            "key": "75:3:0",
            "index": 0,
            "name": "three-storey stone high-street block with a clock turret",
            "height": 1.34,
            "draft": false,
            "ops": 21,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 36
            }
          },
          {
            "key": "75:3:1",
            "index": 1,
            "name": "glazed shopping arcade between two cream blocks",
            "height": 0.9,
            "draft": false,
            "ops": 18,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 36
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 1,
      "door": [
        0,
        0
      ]
    }
  },
  {
    "id": "com-store",
    "name": "department store",
    "kindId": 76,
    "code": 2,
    "family": "commercial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tech": [],
    "occupation": {
      "name": "shop worker",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 12,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 6,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "commerceType": "department store",
      "openHours": [
        9,
        21
      ]
    },
    "tints": [
      16777215,
      16774112,
      15659767,
      16247016,
      16054252
    ],
    "lotTint": 8042239,
    "levels": [
      {
        "level": 4,
        "capacity": 44,
        "wage": 27,
        "upkeep": 0,
        "cost": 0,
        "work": 576,
        "parking": {
          "surface": 6,
          "underground": 40
        },
        "tech": [
          "con5"
        ],
        "feature": "level4",
        "attrs": {
          "commerceType": "department store",
          "openHours": [
            9,
            21
          ],
          "visitorCapacity": 60
        },
        "designs": [
          {
            "key": "76:4:0",
            "index": 0,
            "name": "department store with a corner rotunda and roof flags",
            "height": 1.8,
            "draft": false,
            "ops": 19,
            "attrs": {
              "commerceType": "department store",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 60
            }
          },
          {
            "key": "76:4:1",
            "index": 1,
            "name": "supermarket with an entrance canopy and its own car park",
            "height": 0.67,
            "draft": false,
            "ops": 79,
            "attrs": {
              "commerceType": "supermarket",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 60
            }
          }
        ]
      },
      {
        "level": 5,
        "capacity": 52,
        "wage": 29,
        "upkeep": 0,
        "cost": 0,
        "work": 720,
        "parking": {
          "surface": 6,
          "underground": 48
        },
        "tech": [
          "con5"
        ],
        "feature": "level5",
        "attrs": {
          "commerceType": "department store",
          "openHours": [
            9,
            21
          ],
          "visitorCapacity": 72
        },
        "designs": [
          {
            "key": "76:5:0",
            "index": 0,
            "name": "cream department store with a glass atrium roof",
            "height": 2.25,
            "draft": false,
            "ops": 17,
            "attrs": {
              "commerceType": "department store",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 72
            }
          },
          {
            "key": "76:5:1",
            "index": 1,
            "name": "fashion house with a finned facade and a roof-terrace café",
            "height": 1.75,
            "draft": false,
            "ops": 33,
            "attrs": {
              "commerceType": "department store",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 72
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    }
  },
  {
    "id": "com-centre",
    "name": "shopping centre",
    "kindId": 77,
    "code": 2,
    "family": "commercial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tech": [],
    "occupation": {
      "name": "shop worker",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 12,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 6,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "commerceType": "mall",
      "openHours": [
        9,
        21
      ]
    },
    "tints": [
      16777215,
      16774112,
      15659767,
      16247016,
      16054252
    ],
    "lotTint": 8042239,
    "levels": [
      {
        "level": 5,
        "capacity": 100,
        "wage": 27,
        "upkeep": 0,
        "cost": 0,
        "work": 1620,
        "parking": {
          "surface": 24,
          "underground": 60
        },
        "tech": [
          "con5"
        ],
        "feature": "level5",
        "attrs": {
          "commerceType": "mall",
          "openHours": [
            9,
            21
          ],
          "visitorCapacity": 150
        },
        "designs": [
          {
            "key": "77:5:0",
            "index": 0,
            "name": "mall with a glass-roofed atrium, two anchor stores and a car park",
            "height": 1,
            "draft": false,
            "ops": 115,
            "attrs": {
              "commerceType": "mall",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 150
            }
          },
          {
            "key": "77:5:1",
            "index": 1,
            "name": "retail park of three sheds round a car park",
            "height": 0.65,
            "draft": false,
            "ops": 139,
            "attrs": {
              "commerceType": "mall",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 150
            }
          }
        ]
      },
      {
        "level": 6,
        "capacity": 120,
        "wage": 29,
        "upkeep": 0,
        "cost": 0,
        "work": 1944,
        "parking": {
          "surface": 30,
          "underground": 90
        },
        "tech": [
          "con5"
        ],
        "feature": "level6",
        "attrs": {
          "commerceType": "mall",
          "openHours": [
            9,
            21
          ],
          "visitorCapacity": 180
        },
        "designs": [
          {
            "key": "77:6:0",
            "index": 0,
            "name": "mall with a rooftop car-park deck and an office tower",
            "height": 3.05,
            "draft": false,
            "ops": 65,
            "attrs": {
              "commerceType": "mall",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 180
            }
          },
          {
            "key": "77:6:1",
            "index": 1,
            "name": "white shopping centre with a glass dome and a fountain plaza",
            "height": 1.98,
            "draft": false,
            "ops": 24,
            "attrs": {
              "commerceType": "mall",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 180
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    }
  },
  {
    "id": "com-hotel",
    "name": "hotel tower",
    "kindId": 78,
    "code": 2,
    "family": "commercial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tech": [],
    "occupation": {
      "name": "hotel worker",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.25
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "commerceType": "hotel",
      "openHours": [
        0,
        24
      ]
    },
    "tints": [
      16777215,
      16774112,
      15659767,
      16247016,
      16054252
    ],
    "lotTint": 8042239,
    "levels": [
      {
        "level": 6,
        "capacity": 60,
        "wage": 30,
        "upkeep": 0,
        "cost": 0,
        "work": 864,
        "parking": {
          "surface": 8,
          "underground": 50
        },
        "tech": [
          "con5"
        ],
        "feature": "level6",
        "attrs": {
          "commerceType": "hotel",
          "openHours": [
            0,
            24
          ],
          "visitorCapacity": 60
        },
        "designs": [
          {
            "key": "78:6:0",
            "index": 0,
            "name": "cream hotel tower with white fins, a porte-cochère and a red roof sign",
            "height": 3.4,
            "draft": false,
            "ops": 24,
            "attrs": {
              "commerceType": "hotel",
              "openHours": [
                0,
                24
              ],
              "visitorCapacity": 60
            }
          },
          {
            "key": "78:6:1",
            "index": 1,
            "name": "art-deco hotel with gold bands and a stepped crown",
            "height": 3.65,
            "draft": false,
            "ops": 23,
            "attrs": {
              "commerceType": "hotel",
              "openHours": [
                0,
                24
              ],
              "visitorCapacity": 60
            }
          }
        ]
      },
      {
        "level": 7,
        "capacity": 72,
        "wage": 32,
        "upkeep": 0,
        "cost": 0,
        "work": 1008,
        "parking": {
          "surface": 8,
          "underground": 60
        },
        "tech": [
          "con5"
        ],
        "feature": "level7",
        "attrs": {
          "commerceType": "hotel",
          "openHours": [
            0,
            24
          ],
          "visitorCapacity": 80
        },
        "designs": [
          {
            "key": "78:7:0",
            "index": 0,
            "name": "dark glass hotel tower with a lit sky bar and a spire",
            "height": 5.05,
            "draft": false,
            "ops": 26,
            "attrs": {
              "commerceType": "hotel",
              "openHours": [
                0,
                24
              ],
              "visitorCapacity": 80
            }
          },
          {
            "key": "78:7:1",
            "index": 1,
            "name": "white sail-shaped resort tower over a lagoon",
            "height": 5,
            "draft": false,
            "ops": 21,
            "attrs": {
              "commerceType": "hotel",
              "openHours": [
                0,
                24
              ],
              "visitorCapacity": 80
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    }
  },
  {
    "id": "off-centre",
    "name": "business centre",
    "kindId": 79,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tech": [],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "tints": [
      16777215,
      15397112,
      16053488,
      15002871,
      15855352
    ],
    "lotTint": 13215999,
    "levels": [
      {
        "level": 2,
        "capacity": 36,
        "wage": 26,
        "upkeep": 0,
        "cost": 0,
        "work": 144,
        "parking": {
          "surface": 2,
          "underground": 20
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {},
        "designs": [
          {
            "key": "79:2:0",
            "index": 0,
            "name": "two-storey business centre with a glass entrance hall",
            "height": 0.84,
            "draft": false,
            "ops": 17,
            "attrs": {}
          },
          {
            "key": "79:2:1",
            "index": 1,
            "name": "converted brick warehouse offices under a slate roof",
            "height": 1.12,
            "draft": false,
            "ops": 12,
            "attrs": {}
          }
        ]
      },
      {
        "level": 3,
        "capacity": 52,
        "wage": 32,
        "upkeep": 0,
        "cost": 0,
        "work": 216,
        "parking": {
          "surface": 2,
          "underground": 30
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {},
        "designs": [
          {
            "key": "79:3:0",
            "index": 0,
            "name": "glass and white office pair joined by a bridge",
            "height": 1.33,
            "draft": false,
            "ops": 14,
            "attrs": {}
          },
          {
            "key": "79:3:1",
            "index": 1,
            "name": "stone chambers with a columned portico",
            "height": 1.13,
            "draft": false,
            "ops": 16,
            "attrs": {}
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 1,
      "door": [
        0,
        0
      ]
    }
  },
  {
    "id": "off-tower",
    "name": "office tower",
    "kindId": 80,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tech": [],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "tints": [
      16777215,
      15397112,
      16053488,
      15002871,
      15855352
    ],
    "lotTint": 13215999,
    "levels": [
      {
        "level": 4,
        "capacity": 112,
        "wage": 36,
        "upkeep": 0,
        "cost": 0,
        "work": 576,
        "parking": {
          "surface": 4,
          "underground": 60
        },
        "tech": [
          "con5"
        ],
        "feature": "level4",
        "attrs": {},
        "designs": [
          {
            "key": "80:4:0",
            "index": 0,
            "name": "dark glass tower on a stone podium",
            "height": 3.75,
            "draft": false,
            "ops": 37,
            "attrs": {}
          },
          {
            "key": "80:4:1",
            "index": 1,
            "name": "stepped stone tower with a short spire",
            "height": 3.95,
            "draft": false,
            "ops": 33,
            "attrs": {}
          }
        ]
      },
      {
        "level": 5,
        "capacity": 136,
        "wage": 38,
        "upkeep": 0,
        "cost": 0,
        "work": 720,
        "parking": {
          "surface": 4,
          "underground": 75
        },
        "tech": [
          "con5"
        ],
        "feature": "level5",
        "attrs": {},
        "designs": [
          {
            "key": "80:5:0",
            "index": 0,
            "name": "twin glass towers with a steel sky bridge",
            "height": 4.5,
            "draft": false,
            "ops": 55,
            "attrs": {}
          },
          {
            "key": "80:5:1",
            "index": 1,
            "name": "diagrid tower with a lit white crown",
            "height": 4.46,
            "draft": false,
            "ops": 49,
            "attrs": {}
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    }
  },
  {
    "id": "off-hq",
    "name": "corporate headquarters",
    "kindId": 81,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tech": [],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "tints": [
      16777215,
      15397112,
      16053488,
      15002871,
      15855352
    ],
    "lotTint": 13215999,
    "levels": [
      {
        "level": 6,
        "capacity": 310,
        "wage": 40,
        "upkeep": 0,
        "cost": 0,
        "work": 1944,
        "parking": {
          "surface": 30,
          "underground": 150
        },
        "tech": [
          "con5"
        ],
        "feature": "level6",
        "attrs": {},
        "designs": [
          {
            "key": "81:6:0",
            "index": 0,
            "name": "corporate campus: glass wings round a lawn and a lake",
            "height": 2.1,
            "draft": false,
            "ops": 120,
            "attrs": {}
          },
          {
            "key": "81:6:1",
            "index": 1,
            "name": "headquarters ring round a court with a helipad tower",
            "height": 2.5,
            "draft": false,
            "ops": 31,
            "attrs": {}
          }
        ]
      },
      {
        "level": 7,
        "capacity": 360,
        "wage": 44,
        "upkeep": 0,
        "cost": 0,
        "work": 2268,
        "parking": {
          "surface": 10,
          "underground": 190
        },
        "tech": [
          "con5"
        ],
        "feature": "level7",
        "attrs": {},
        "designs": [
          {
            "key": "81:7:0",
            "index": 0,
            "name": "supertall in dark glass with setbacks and a spire",
            "height": 8.05,
            "draft": false,
            "ops": 63,
            "attrs": {}
          },
          {
            "key": "81:7:1",
            "index": 1,
            "name": "pale setback supertall with a helipad crown",
            "height": 6.65,
            "draft": false,
            "ops": 64,
            "attrs": {}
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    }
  },
  {
    "id": "ind-row",
    "name": "workshop row",
    "kindId": 82,
    "code": 3,
    "family": "industrial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tech": [],
    "occupation": {
      "name": "factory worker",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "goodsType": "manufactured"
    },
    "tints": [
      16777215,
      15920096,
      15264750,
      16181718,
      15331046
    ],
    "lotTint": 15777888,
    "levels": [
      {
        "level": 2,
        "capacity": 26,
        "wage": 19,
        "upkeep": 0,
        "cost": 0,
        "work": 144,
        "parking": {
          "surface": 4,
          "underground": 16
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 2,
          "noise": 3
        },
        "designs": [
          {
            "key": "82:2:0",
            "index": 0,
            "name": "row of four corrugated workshops with roller doors",
            "height": 0.55,
            "draft": false,
            "ops": 15,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            }
          },
          {
            "key": "82:2:1",
            "index": 1,
            "name": "brick sawtooth workshops beside a fenced yard",
            "height": 0.6,
            "draft": false,
            "ops": 16,
            "attrs": {
              "goodsType": "repairs",
              "pollution": 2,
              "noise": 3
            }
          }
        ]
      },
      {
        "level": 3,
        "capacity": 38,
        "wage": 24,
        "upkeep": 0,
        "cost": 0,
        "work": 216,
        "parking": {
          "surface": 4,
          "underground": 24
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 3,
          "noise": 3
        },
        "designs": [
          {
            "key": "82:3:0",
            "index": 0,
            "name": "light-industrial units with a sawtooth roof and an office end",
            "height": 0.8,
            "draft": false,
            "ops": 18,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 3,
              "noise": 3
            }
          },
          {
            "key": "82:3:1",
            "index": 1,
            "name": "bottling works with steel tanks and a chimney",
            "height": 1.04,
            "draft": false,
            "ops": 18,
            "attrs": {
              "goodsType": "food",
              "pollution": 3,
              "noise": 3
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 1,
      "door": [
        0,
        0
      ]
    }
  },
  {
    "id": "ind-depot",
    "name": "distribution centre",
    "kindId": 83,
    "code": 3,
    "family": "industrial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tech": [],
    "occupation": {
      "name": "factory worker",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "goodsType": "freight"
    },
    "tints": [
      16777215,
      15920096,
      15264750,
      16181718,
      15331046
    ],
    "lotTint": 15777888,
    "levels": [
      {
        "level": 3,
        "capacity": 76,
        "wage": 24,
        "upkeep": 0,
        "cost": 0,
        "work": 432,
        "parking": {
          "surface": 8,
          "underground": 40
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "goodsType": "freight",
          "pollution": 2,
          "noise": 4
        },
        "designs": [
          {
            "key": "83:3:0",
            "index": 0,
            "name": "corrugated warehouse with loading docks and lorries",
            "height": 0.83,
            "draft": false,
            "ops": 18,
            "attrs": {
              "goodsType": "storage",
              "pollution": 2,
              "noise": 4
            }
          },
          {
            "key": "83:3:1",
            "index": 1,
            "name": "cold store beside a container yard",
            "height": 0.8,
            "draft": false,
            "ops": 35,
            "attrs": {
              "goodsType": "freight",
              "pollution": 2,
              "noise": 4
            }
          }
        ]
      },
      {
        "level": 4,
        "capacity": 92,
        "wage": 27,
        "upkeep": 0,
        "cost": 0,
        "work": 576,
        "parking": {
          "surface": 10,
          "underground": 50
        },
        "tech": [
          "con5"
        ],
        "feature": "level4",
        "attrs": {
          "goodsType": "freight",
          "pollution": 2,
          "noise": 4
        },
        "designs": [
          {
            "key": "83:4:0",
            "index": 0,
            "name": "distribution centre with eight dock doors and a truck yard",
            "height": 0.83,
            "draft": false,
            "ops": 24,
            "attrs": {
              "goodsType": "freight",
              "pollution": 2,
              "noise": 4
            }
          },
          {
            "key": "83:4:1",
            "index": 1,
            "name": "high-bay warehouse with a gantry crane over its containers",
            "height": 1.22,
            "draft": false,
            "ops": 36,
            "attrs": {
              "goodsType": "storage",
              "pollution": 2,
              "noise": 4
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    }
  },
  {
    "id": "ind-works",
    "name": "factory complex",
    "kindId": 84,
    "code": 3,
    "family": "industrial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tech": [],
    "occupation": {
      "name": "factory worker",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "goodsType": "manufactured"
    },
    "tints": [
      16777215,
      15920096,
      15264750,
      16181718,
      15331046
    ],
    "lotTint": 15777888,
    "levels": [
      {
        "level": 5,
        "capacity": 210,
        "wage": 28,
        "upkeep": 0,
        "cost": 0,
        "work": 1620,
        "parking": {
          "surface": 16,
          "underground": 100
        },
        "tech": [
          "con5"
        ],
        "feature": "level5",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 5,
          "noise": 5
        },
        "designs": [
          {
            "key": "84:5:0",
            "index": 0,
            "name": "factory complex: sawtooth halls, two chimneys and a tank farm",
            "height": 1.98,
            "draft": false,
            "ops": 45,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 5,
              "noise": 5
            }
          },
          {
            "key": "84:5:1",
            "index": 1,
            "name": "car plant with assembly halls and a test track",
            "height": 1.3,
            "draft": false,
            "ops": 95,
            "attrs": {
              "goodsType": "vehicles",
              "pollution": 4,
              "noise": 5
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    }
  },
  {
    "id": "ind-plant",
    "name": "heavy plant",
    "kindId": 85,
    "code": 3,
    "family": "industrial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tech": [],
    "occupation": {
      "name": "factory worker",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "goodsType": "manufactured"
    },
    "tints": [
      16777215,
      15920096,
      15264750,
      16181718,
      15331046
    ],
    "lotTint": 15777888,
    "levels": [
      {
        "level": 6,
        "capacity": 380,
        "wage": 30,
        "upkeep": 0,
        "cost": 0,
        "work": 3456,
        "parking": {
          "surface": 24,
          "underground": 170
        },
        "tech": [
          "con5"
        ],
        "feature": "level6",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 8,
          "noise": 6
        },
        "designs": [
          {
            "key": "85:6:0",
            "index": 0,
            "name": "steelworks with a blast furnace, three stacks and ore heaps",
            "height": 3,
            "draft": false,
            "ops": 27,
            "attrs": {
              "goodsType": "steel",
              "pollution": 8,
              "noise": 6
            }
          },
          {
            "key": "85:6:1",
            "index": 1,
            "name": "chemical plant with distillation columns, pipe racks and a flare",
            "height": 2.82,
            "draft": false,
            "ops": 58,
            "attrs": {
              "goodsType": "chemicals",
              "pollution": 8,
              "noise": 6
            }
          }
        ]
      },
      {
        "level": 7,
        "capacity": 420,
        "wage": 32,
        "upkeep": 0,
        "cost": 0,
        "work": 4032,
        "parking": {
          "surface": 24,
          "underground": 200
        },
        "tech": [
          "con5"
        ],
        "feature": "level7",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 9,
          "noise": 6
        },
        "designs": [
          {
            "key": "85:7:0",
            "index": 0,
            "name": "power station with two cooling towers and a tall chimney",
            "height": 3.54,
            "draft": false,
            "ops": 28,
            "attrs": {
              "goodsType": "power",
              "pollution": 9,
              "noise": 6
            }
          },
          {
            "key": "85:7:1",
            "index": 1,
            "name": "refinery with cracking columns, a tank farm and a flare stack",
            "height": 3.48,
            "draft": false,
            "ops": 62,
            "attrs": {
              "goodsType": "fuel",
              "pollution": 9,
              "noise": 6
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        1,
        3
      ]
    }
  },
  {
    "id": "res-deep",
    "name": "deep-plot house",
    "kindId": 86,
    "code": 1,
    "family": "residential",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tech": [],
    "attrs": {},
    "tints": [
      16777215,
      16767416,
      16773299,
      13624311,
      14085065,
      16240591,
      15918847,
      16770244
    ],
    "lotTint": 9429114,
    "levels": [
      {
        "level": 2,
        "capacity": 18,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 144,
        "parking": {
          "surface": 13,
          "underground": 18
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "style": "house with a back wing",
          "rentBand": "mid"
        },
        "designs": [
          {
            "key": "86:2:0",
            "index": 0,
            "name": "brick house with a two-storey back wing, a shed and a side path",
            "height": 0.66,
            "draft": false,
            "ops": 19,
            "attrs": {
              "style": "house with a back wing",
              "rentBand": "mid"
            }
          },
          {
            "key": "86:2:1",
            "index": 1,
            "name": "cottage at the front and a backland cottage down a side passage",
            "height": 0.64,
            "draft": false,
            "ops": 20,
            "attrs": {
              "style": "house with a back wing",
              "rentBand": "mid"
            }
          }
        ]
      },
      {
        "level": 3,
        "capacity": 26,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 216,
        "parking": {
          "surface": 18,
          "underground": 26
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "style": "deep townhouse",
          "rentBand": "high"
        },
        "designs": [
          {
            "key": "86:3:0",
            "index": 0,
            "name": "brick townhouse and rear block round a planted light well",
            "height": 1.08,
            "draft": false,
            "ops": 17,
            "attrs": {
              "style": "deep townhouse",
              "rentBand": "high"
            }
          },
          {
            "key": "86:3:1",
            "index": 1,
            "name": "cream mansion flats with a rear wing and a roof garden",
            "height": 1.03,
            "draft": false,
            "ops": 23,
            "attrs": {
              "style": "deep townhouse",
              "rentBand": "high"
            }
          }
        ]
      },
      {
        "level": 4,
        "capacity": 32,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 288,
        "parking": {
          "surface": 22,
          "underground": 32
        },
        "tech": [
          "con5"
        ],
        "feature": "level4",
        "attrs": {
          "style": "deep mansion block",
          "rentBand": "high"
        },
        "designs": [
          {
            "key": "86:4:0",
            "index": 0,
            "name": "four-storey brick mansion block and rear range round a garden court",
            "height": 1.25,
            "draft": false,
            "ops": 17,
            "attrs": {
              "style": "deep mansion block",
              "rentBand": "high"
            }
          },
          {
            "key": "86:4:1",
            "index": 1,
            "name": "cream apartment block running deep with balconies down its side",
            "height": 1.17,
            "draft": false,
            "ops": 20,
            "attrs": {
              "style": "deep mansion block",
              "rentBand": "high"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 2,
      "door": [
        0,
        1
      ]
    }
  },
  {
    "id": "com-deep",
    "name": "deep-plot shop",
    "kindId": 87,
    "code": 2,
    "family": "commercial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tech": [],
    "occupation": {
      "name": "shop worker",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 12,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 6,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          0,
          1,
          1,
          1,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "commerceType": "shop",
      "openHours": [
        7,
        22
      ]
    },
    "tints": [
      16777215,
      16774112,
      15659767,
      16247016,
      16054252
    ],
    "lotTint": 8042239,
    "levels": [
      {
        "level": 2,
        "capacity": 14,
        "wage": 20,
        "upkeep": 0,
        "cost": 0,
        "work": 144,
        "parking": {
          "surface": 2,
          "underground": 12
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "commerceType": "shop",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 24
        },
        "designs": [
          {
            "key": "87:2:0",
            "index": 0,
            "name": "corner shop with a long stockroom and a loading bay behind",
            "height": 0.56,
            "draft": false,
            "ops": 15,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 24
            }
          },
          {
            "key": "87:2:1",
            "index": 1,
            "name": "pub with a beer garden and a skittle alley out the back",
            "height": 0.82,
            "draft": false,
            "ops": 21,
            "attrs": {
              "commerceType": "pub",
              "openHours": [
                11,
                24
              ],
              "visitorCapacity": 24
            }
          }
        ]
      },
      {
        "level": 3,
        "capacity": 20,
        "wage": 25,
        "upkeep": 0,
        "cost": 0,
        "work": 216,
        "parking": {
          "surface": 2,
          "underground": 18
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "commerceType": "shop",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 36
        },
        "designs": [
          {
            "key": "87:3:0",
            "index": 0,
            "name": "covered market hall reaching back from a stone shopfront",
            "height": 0.92,
            "draft": false,
            "ops": 10,
            "attrs": {
              "commerceType": "market",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 36
            }
          },
          {
            "key": "87:3:1",
            "index": 1,
            "name": "small supermarket with a service yard behind",
            "height": 0.5,
            "draft": false,
            "ops": 13,
            "attrs": {
              "commerceType": "supermarket",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 36
            }
          }
        ]
      },
      {
        "level": 4,
        "capacity": 22,
        "wage": 27,
        "upkeep": 0,
        "cost": 0,
        "work": 288,
        "parking": {
          "surface": 3,
          "underground": 20
        },
        "tech": [
          "con5"
        ],
        "feature": "level4",
        "attrs": {
          "commerceType": "shop",
          "openHours": [
            7,
            22
          ],
          "visitorCapacity": 30
        },
        "designs": [
          {
            "key": "87:4:0",
            "index": 0,
            "name": "three-storey store with a top-lit hall behind",
            "height": 0.92,
            "draft": false,
            "ops": 8,
            "attrs": {
              "commerceType": "department",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 30
            }
          },
          {
            "key": "87:4:1",
            "index": 1,
            "name": "glass-roofed shopping arcade running back from the street",
            "height": 0.69,
            "draft": false,
            "ops": 7,
            "attrs": {
              "commerceType": "shop",
              "openHours": [
                7,
                22
              ],
              "visitorCapacity": 30
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 2,
      "door": [
        0,
        1
      ]
    }
  },
  {
    "id": "off-deep",
    "name": "deep-plot office",
    "kindId": 88,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tech": [],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "tints": [
      16777215,
      15397112,
      16053488,
      15002871,
      15855352
    ],
    "lotTint": 13215999,
    "levels": [
      {
        "level": 2,
        "capacity": 36,
        "wage": 26,
        "upkeep": 0,
        "cost": 0,
        "work": 144,
        "parking": {
          "surface": 2,
          "underground": 20
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {},
        "designs": [
          {
            "key": "88:2:0",
            "index": 0,
            "name": "office with a glass link to a white annexe behind",
            "height": 0.66,
            "draft": false,
            "ops": 14,
            "attrs": {}
          },
          {
            "key": "88:2:1",
            "index": 1,
            "name": "Georgian front office with a converted coach house behind",
            "height": 0.86,
            "draft": false,
            "ops": 14,
            "attrs": {}
          }
        ]
      },
      {
        "level": 3,
        "capacity": 52,
        "wage": 32,
        "upkeep": 0,
        "cost": 0,
        "work": 216,
        "parking": {
          "surface": 2,
          "underground": 30
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {},
        "designs": [
          {
            "key": "88:3:0",
            "index": 0,
            "name": "deep-plan office with fins and a glazed atrium roof",
            "height": 1.19,
            "draft": false,
            "ops": 8,
            "attrs": {}
          },
          {
            "key": "88:3:1",
            "index": 1,
            "name": "stone chambers with a glass block reaching back",
            "height": 1.14,
            "draft": false,
            "ops": 10,
            "attrs": {}
          }
        ]
      },
      {
        "level": 4,
        "capacity": 56,
        "wage": 36,
        "upkeep": 0,
        "cost": 0,
        "work": 288,
        "parking": {
          "surface": 2,
          "underground": 30
        },
        "tech": [
          "con5"
        ],
        "feature": "level4",
        "attrs": {},
        "designs": [
          {
            "key": "88:4:0",
            "index": 0,
            "name": "deep office slab, dark glass on a stone base",
            "height": 1.25,
            "draft": false,
            "ops": 9,
            "attrs": {}
          },
          {
            "key": "88:4:1",
            "index": 1,
            "name": "twin-gabled brick mill converted to offices",
            "height": 1.38,
            "draft": false,
            "ops": 8,
            "attrs": {}
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 2,
      "door": [
        0,
        1
      ]
    }
  },
  {
    "id": "ind-deep",
    "name": "deep-plot works",
    "kindId": 89,
    "code": 3,
    "family": "industrial",
    "flags": {
      "growable": true,
      "civic": false,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tech": [],
    "occupation": {
      "name": "factory worker",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "goodsType": "manufactured"
    },
    "tints": [
      16777215,
      15920096,
      15264750,
      16181718,
      15331046
    ],
    "lotTint": 15777888,
    "levels": [
      {
        "level": 2,
        "capacity": 26,
        "wage": 19,
        "upkeep": 0,
        "cost": 0,
        "work": 144,
        "parking": {
          "surface": 4,
          "underground": 16
        },
        "tech": [
          "con1"
        ],
        "feature": "level2",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 2,
          "noise": 3
        },
        "designs": [
          {
            "key": "89:2:0",
            "index": 0,
            "name": "roller-door workshop with a fenced yard and a store behind",
            "height": 0.48,
            "draft": false,
            "ops": 15,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 3
            }
          },
          {
            "key": "89:2:1",
            "index": 1,
            "name": "garage with a spray shop and its extractor behind",
            "height": 0.73,
            "draft": false,
            "ops": 10,
            "attrs": {
              "goodsType": "repairs",
              "pollution": 2,
              "noise": 3
            }
          }
        ]
      },
      {
        "level": 3,
        "capacity": 38,
        "wage": 24,
        "upkeep": 0,
        "cost": 0,
        "work": 216,
        "parking": {
          "surface": 4,
          "underground": 24
        },
        "tech": [
          "con2"
        ],
        "feature": "level3",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 3,
          "noise": 3
        },
        "designs": [
          {
            "key": "89:3:0",
            "index": 0,
            "name": "long sawtooth works shed with a gantry over the back",
            "height": 0.99,
            "draft": false,
            "ops": 10,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 3,
              "noise": 3
            }
          },
          {
            "key": "89:3:1",
            "index": 1,
            "name": "bakery works with flour silos behind",
            "height": 0.81,
            "draft": false,
            "ops": 12,
            "attrs": {
              "goodsType": "food",
              "pollution": 3,
              "noise": 3
            }
          }
        ]
      },
      {
        "level": 4,
        "capacity": 46,
        "wage": 27,
        "upkeep": 0,
        "cost": 0,
        "work": 288,
        "parking": {
          "surface": 5,
          "underground": 25
        },
        "tech": [
          "con5"
        ],
        "feature": "level4",
        "attrs": {
          "goodsType": "manufactured",
          "pollution": 2,
          "noise": 4
        },
        "designs": [
          {
            "key": "89:4:0",
            "index": 0,
            "name": "deep crane-bay works with a gantry over the yard door",
            "height": 1.09,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "manufactured",
              "pollution": 2,
              "noise": 4
            }
          },
          {
            "key": "89:4:1",
            "index": 1,
            "name": "cold store: a loading front and an insulated block behind",
            "height": 0.83,
            "draft": false,
            "ops": 8,
            "attrs": {
              "goodsType": "food",
              "pollution": 2,
              "noise": 4
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 2,
      "door": [
        0,
        1
      ]
    }
  },
  {
    "id": "block-garden",
    "name": "communal garden",
    "kindId": 90,
    "code": 10,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": true
    },
    "windows": "shop",
    "tech": [],
    "attrs": {
      "venueType": "park",
      "openHours": [
        6,
        22
      ],
      "ticket": 0,
      "stay": [
        0.5,
        1.5
      ],
      "dayAppeal": 1,
      "eveningAppeal": 0.5,
      "retireeAppeal": 1.5,
      "childAppeal": 1.8,
      "trees": 0,
      "benches": 0,
      "title": "communal garden",
      "blockOnly": true
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 0,
        "cost": 0,
        "work": 300,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [],
        "attrs": {
          "venueType": "park",
          "openHours": [
            6,
            22
          ],
          "ticket": 0,
          "stay": [
            0.5,
            1.5
          ],
          "dayAppeal": 1,
          "eveningAppeal": 0.5,
          "retireeAppeal": 1.5,
          "childAppeal": 1.8,
          "trees": 0,
          "benches": 0,
          "title": "communal garden",
          "blockOnly": true,
          "visitorCapacity": 1,
          "leisureValue": 3,
          "radius": 4
        },
        "designs": [
          {
            "key": "90:1:0",
            "index": 0,
            "name": "communal lawn with fruit trees, benches, a washing line and a tool shed",
            "height": 0.25,
            "draft": false,
            "ops": 36,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.5,
              "childAppeal": 1.8,
              "trees": 0,
              "benches": 0,
              "title": "communal garden",
              "blockOnly": true,
              "visitorCapacity": 1,
              "leisureValue": 3,
              "radius": 4
            }
          },
          {
            "key": "90:1:1",
            "index": 1,
            "name": "allotment beds with a greenhouse, a water butt and a compost bay",
            "height": 0.29,
            "draft": false,
            "ops": 57,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.5,
              "childAppeal": 1.8,
              "trees": 0,
              "benches": 0,
              "title": "communal garden",
              "blockOnly": true,
              "visitorCapacity": 1,
              "leisureValue": 3,
              "radius": 4
            }
          },
          {
            "key": "90:1:2",
            "index": 2,
            "name": "play garden with a sandpit, swings and a climbing frame under big trees",
            "height": 0.3,
            "draft": false,
            "ops": 36,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.5,
              "childAppeal": 1.8,
              "trees": 0,
              "benches": 0,
              "title": "communal garden",
              "blockOnly": true,
              "visitorCapacity": 1,
              "leisureValue": 3,
              "radius": 4
            }
          },
          {
            "key": "90:1:3",
            "index": 3,
            "name": "courtyard garden with a pergola, a lily pond and flower borders",
            "height": 0.29,
            "draft": false,
            "ops": 49,
            "attrs": {
              "venueType": "park",
              "openHours": [
                6,
                22
              ],
              "ticket": 0,
              "stay": [
                0.5,
                1.5
              ],
              "dayAppeal": 1,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.5,
              "childAppeal": 1.8,
              "trees": 0,
              "benches": 0,
              "title": "communal garden",
              "blockOnly": true,
              "visitorCapacity": 1,
              "leisureValue": 3,
              "radius": 4
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ]
    }
  },
  {
    "id": "gherkin",
    "name": "the Gherkin",
    "kindId": 91,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "gherkin",
      "key": "",
      "label": "The Gherkin",
      "color": "#3f6f5a",
      "cost": 16000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 240,
        "wage": 44,
        "upkeep": 90,
        "cost": 16000,
        "work": 2600,
        "parking": {
          "surface": 0,
          "underground": 60
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "91:1:0",
            "index": 0,
            "name": "tapered glass bullet with dark spiral glazing bands",
            "height": 5.42,
            "draft": false,
            "ops": 12,
            "attrs": {}
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "london",
    "tier": 1,
    "blurb": "30 St Mary Axe: the City's glass bullet with its dark spiral bands. A landmark office tower of 40 storeys.",
    "howTo": "A 2×2 plot in the City, among other offices; it draws commuters like any office tower. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "shard",
    "name": "the Shard",
    "kindId": 92,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "shard",
      "key": "",
      "label": "The Shard",
      "color": "#7fa3bf",
      "cost": 30000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 420,
        "wage": 46,
        "upkeep": 150,
        "cost": 30000,
        "work": 5200,
        "parking": {
          "surface": 0,
          "underground": 80
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "92:1:0",
            "index": 0,
            "name": "faceted glass pyramid of eight shards with a splayed crown",
            "height": 9.62,
            "draft": false,
            "ops": 26,
            "attrs": {}
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "london",
    "tier": 2,
    "blurb": "London Bridge's glass pyramid of eight leaning shards, the tallest building in the city: offices, a hotel and a viewing gallery under its broken crown.",
    "howTo": "A 3×3 plot by a station: it holds the most jobs of any building, so give it rail or buses. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "walkie-talkie",
    "name": "the Walkie Talkie",
    "kindId": 93,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "walkietalkie",
      "key": "",
      "label": "The Walkie Talkie",
      "color": "#5d86a6",
      "cost": 20000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 300,
        "wage": 44,
        "upkeep": 110,
        "cost": 20000,
        "work": 3600,
        "parking": {
          "surface": 0,
          "underground": 70
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "93:1:0",
            "index": 0,
            "name": "curved slab widening to the top with a sky garden under a glass roof",
            "height": 5.02,
            "draft": false,
            "ops": 44,
            "attrs": {}
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "london",
    "tier": 3,
    "blurb": "20 Fenchurch Street: the top-heavy tower that bulges outwards as it rises, with a public sky garden under its glass roof.",
    "howTo": "A 3×3 plot in the City; its top floors overhang the plot, so leave the street in front clear. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "one-canada-square",
    "name": "One Canada Square",
    "kindId": 94,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "canadasquare",
      "key": "",
      "label": "One Canada Square",
      "color": "#a7afb8",
      "cost": 26000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 380,
        "wage": 46,
        "upkeep": 130,
        "cost": 26000,
        "work": 4600,
        "parking": {
          "surface": 0,
          "underground": 90
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "94:1:0",
            "index": 0,
            "name": "stainless steel tower with a pyramid roof, an aircraft light and a park in front",
            "height": 7.22,
            "draft": false,
            "ops": 28,
            "attrs": {}
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "london",
    "tier": 4,
    "blurb": "Canary Wharf's stainless steel tower with its pyramid roof and blinking aircraft light: fifty storeys of banks and newspapers.",
    "howTo": "A 3×3 plot with its park in front; set it among offices at the heart of a business district. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "royal-opera-house",
    "name": "the Royal Opera House",
    "kindId": 95,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "royalopera",
      "key": "",
      "label": "Royal Opera House",
      "color": "#8c1d2b",
      "cost": 9000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "opera house staff",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        14,
        24
      ],
      "visitorCapacity": 200,
      "ticket": 28,
      "stay": [
        2.8,
        3.8
      ],
      "leisureValue": 11,
      "radius": 30,
      "eventNights": [
        1,
        2,
        4,
        5
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.15,
      "eveningAppeal": 1.2,
      "retireeAppeal": 1.7,
      "childAppeal": 0.4,
      "eventSize": 2,
      "title": "Royal Opera House"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 21,
        "upkeep": 90,
        "cost": 9000,
        "work": 2200,
        "parking": {
          "surface": 0,
          "underground": 40
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            14,
            24
          ],
          "visitorCapacity": 200,
          "ticket": 28,
          "stay": [
            2.8,
            3.8
          ],
          "leisureValue": 11,
          "radius": 30,
          "eventNights": [
            1,
            2,
            4,
            5
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.15,
          "eveningAppeal": 1.2,
          "retireeAppeal": 1.7,
          "childAppeal": 0.4,
          "eventSize": 2,
          "title": "Royal Opera House"
        },
        "designs": [
          {
            "key": "95:1:0",
            "index": 0,
            "name": "neoclassical portico beside the glass barrel vault of the Floral Hall",
            "height": 1.72,
            "draft": false,
            "ops": 33,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                14,
                24
              ],
              "visitorCapacity": 200,
              "ticket": 28,
              "stay": [
                2.8,
                3.8
              ],
              "leisureValue": 11,
              "radius": 30,
              "eventNights": [
                1,
                2,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.2,
              "retireeAppeal": 1.7,
              "childAppeal": 0.4,
              "eventSize": 2,
              "title": "Royal Opera House"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 3,
      "door": [
        2,
        2
      ]
    },
    "group": "london",
    "tier": 5,
    "blurb": "Covent Garden's opera and ballet house: a portico of six columns on Bow Street and the glass Floral Hall beside it. Gala nights draw the whole city.",
    "howTo": "A 4×3 plot facing a street, near restaurants and bars for the pre-theatre crowd. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "parliament",
    "name": "the Houses of Parliament",
    "kindId": 96,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "bigben",
      "key": "",
      "label": "Big Ben and Parliament",
      "color": "#b8a06a",
      "cost": 24000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "parliamentary staff",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 260,
        "wage": 30,
        "upkeep": 120,
        "cost": 24000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 40
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "96:1:0",
            "index": 0,
            "name": "Gothic river front with the Victoria Tower, Westminster Hall and Elizabeth Tower",
            "height": 3.21,
            "draft": false,
            "ops": 146,
            "attrs": {}
          },
          {
            "key": "96:1:1",
            "index": 1,
            "name": "a clockmaker’s Gothic palace with lancet pairs, oversized four-face dials and a forest of pinnacles",
            "height": 3.2,
            "draft": true,
            "ops": 134,
            "attrs": {},
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        1,
        3
      ]
    },
    "group": "london",
    "tier": 6,
    "blurb": "The Palace of Westminster on the Thames: the long Gothic river front, the Victoria Tower, Westminster Hall and Elizabeth Tower, whose clock lights up at night and keeps the city's time.",
    "howTo": "A 4×4 block on the river, its door on the street at the clock tower end. A workplace for government staff and the most famous clock in the world. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "london-eye",
    "name": "the London Eye",
    "kindId": 97,
    "code": 13,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "londoneye",
      "key": "",
      "label": "London Eye",
      "color": "#4f86c6",
      "cost": 14000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "wheel crew",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "sports",
      "openHours": [
        10,
        23
      ],
      "visitorCapacity": 160,
      "ticket": 18,
      "stay": [
        0.8,
        1.4
      ],
      "leisureValue": 10,
      "radius": 34,
      "eventNights": [],
      "eventStart": 19,
      "dayAppeal": 1.2,
      "eveningAppeal": 1.3,
      "retireeAppeal": 0.9,
      "childAppeal": 1.9,
      "title": "London Eye"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 36,
        "wage": 16,
        "upkeep": 80,
        "cost": 14000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {
          "venueType": "sports",
          "openHours": [
            10,
            23
          ],
          "visitorCapacity": 160,
          "ticket": 18,
          "stay": [
            0.8,
            1.4
          ],
          "leisureValue": 10,
          "radius": 34,
          "eventNights": [],
          "eventStart": 19,
          "dayAppeal": 1.2,
          "eveningAppeal": 1.3,
          "retireeAppeal": 0.9,
          "childAppeal": 1.9,
          "title": "London Eye"
        },
        "designs": [
          {
            "key": "97:1:0",
            "index": 0,
            "name": "observation wheel on a leaning A-frame over Jubilee Gardens",
            "height": 4.2,
            "draft": false,
            "ops": 37,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                10,
                23
              ],
              "visitorCapacity": 160,
              "ticket": 18,
              "stay": [
                0.8,
                1.4
              ],
              "leisureValue": 10,
              "radius": 34,
              "eventNights": [],
              "eventStart": 19,
              "dayAppeal": 1.2,
              "eveningAppeal": 1.3,
              "retireeAppeal": 0.9,
              "childAppeal": 1.9,
              "title": "London Eye"
            }
          },
          {
            "key": "97:1:1",
            "index": 1,
            "name": "a four-leg white cradle over a circular boarding plaza, glass terminal and garden rill",
            "height": 4.2,
            "draft": true,
            "ops": 36,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                10,
                23
              ],
              "visitorCapacity": 160,
              "ticket": 18,
              "stay": [
                0.8,
                1.4
              ],
              "leisureValue": 10,
              "radius": 34,
              "eventNights": [],
              "eventStart": 19,
              "dayAppeal": 1.2,
              "eveningAppeal": 1.3,
              "retireeAppeal": 0.9,
              "childAppeal": 1.9,
              "title": "London Eye"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        2,
        3
      ]
    },
    "group": "london",
    "tier": 7,
    "blurb": "The giant observation wheel on the South Bank: thirty-two glass capsules turning slowly over the river, lit blue and white at night. Everyone in town wants a ride.",
    "howTo": "A 4×4 plot on the river bank, the wheel towards the street. It turns while it is open and draws visitors from across the city, day and evening. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "tower-of-london",
    "name": "the Tower of London",
    "kindId": 98,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "toweroflondon",
      "key": "",
      "label": "Tower of London",
      "color": "#8d8573",
      "cost": 12000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "Yeoman Warder",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17.5
      ],
      "visitorCapacity": 180,
      "ticket": 22,
      "stay": [
        2,
        3.5
      ],
      "leisureValue": 9,
      "radius": 32,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.1,
      "retireeAppeal": 2.2,
      "childAppeal": 1.9,
      "title": "Tower of London"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 17,
        "upkeep": 70,
        "cost": 12000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 20
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17.5
          ],
          "visitorCapacity": 180,
          "ticket": 22,
          "stay": [
            2,
            3.5
          ],
          "leisureValue": 9,
          "radius": 32,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.1,
          "retireeAppeal": 2.2,
          "childAppeal": 1.9,
          "title": "Tower of London"
        },
        "designs": [
          {
            "key": "98:1:0",
            "index": 0,
            "name": "Norman keep with four lead cupolas inside two rings of walls and a grassed moat",
            "height": 1.38,
            "draft": false,
            "ops": 283,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 180,
              "ticket": 22,
              "stay": [
                2,
                3.5
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.1,
              "retireeAppeal": 2.2,
              "childAppeal": 1.9,
              "title": "Tower of London"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 3,
      "door": [
        2,
        2
      ]
    },
    "group": "london",
    "tier": 8,
    "blurb": "The Norman White Tower with its four lead-capped turrets inside two rings of walls and towers and a grassed moat: the Crown Jewels, the Beefeaters and nine hundred years of history.",
    "howTo": "A 4×3 plot by the river, the gate on the street. A day out that draws families, retirees and visitors from the whole city. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "buckingham-palace",
    "name": "Buckingham Palace",
    "kindId": 99,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "buckingham",
      "key": "",
      "label": "Buckingham Palace",
      "color": "#c9b37a",
      "cost": 20000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "royal household staff",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9.5,
        17.5
      ],
      "visitorCapacity": 150,
      "ticket": 30,
      "stay": [
        1.5,
        2.5
      ],
      "leisureValue": 9,
      "radius": 30,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.05,
      "retireeAppeal": 2.4,
      "childAppeal": 1.3,
      "title": "Buckingham Palace"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 60,
        "wage": 18,
        "upkeep": 110,
        "cost": 20000,
        "work": 3600,
        "parking": {
          "surface": 0,
          "underground": 20
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9.5,
            17.5
          ],
          "visitorCapacity": 150,
          "ticket": 30,
          "stay": [
            1.5,
            2.5
          ],
          "leisureValue": 9,
          "radius": 30,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.05,
          "retireeAppeal": 2.4,
          "childAppeal": 1.3,
          "title": "Buckingham Palace"
        },
        "designs": [
          {
            "key": "99:1:0",
            "index": 0,
            "name": "Portland stone east front with a portico and balcony, the forecourt and the Victoria Memorial",
            "height": 1.21,
            "draft": false,
            "ops": 125,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9.5,
                17.5
              ],
              "visitorCapacity": 150,
              "ticket": 30,
              "stay": [
                1.5,
                2.5
              ],
              "leisureValue": 9,
              "radius": 30,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.05,
              "retireeAppeal": 2.4,
              "childAppeal": 1.3,
              "title": "Buckingham Palace"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        2,
        3
      ]
    },
    "group": "london",
    "tier": 9,
    "blurb": "The monarch's London home: the pale stone east front and its balcony, the forecourt and the guards, and the gilded Victoria Memorial at the end of the Mall. The state rooms open to visitors.",
    "howTo": "A 4×4 block at the end of a long avenue, the front and the memorial towards the street. Tours of the state rooms draw visitors by day. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "tower-bridge",
    "name": "Tower Bridge",
    "kindId": 100,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "towerbridge",
      "key": "",
      "label": "Tower Bridge",
      "color": "#86b2da",
      "cost": 16000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "bridge master",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9.5,
        18
      ],
      "visitorCapacity": 70,
      "ticket": 12,
      "stay": [
        0.8,
        1.5
      ],
      "leisureValue": 7,
      "radius": 26,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.2,
      "retireeAppeal": 1.4,
      "childAppeal": 1.6,
      "title": "Tower Bridge"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 20,
        "wage": 16,
        "upkeep": 70,
        "cost": 16000,
        "work": 3200,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9.5,
            18
          ],
          "visitorCapacity": 70,
          "ticket": 12,
          "stay": [
            0.8,
            1.5
          ],
          "leisureValue": 7,
          "radius": 26,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.2,
          "retireeAppeal": 1.4,
          "childAppeal": 1.6,
          "title": "Tower Bridge"
        },
        "designs": [
          {
            "key": "100:1:0",
            "index": 0,
            "name": "two Gothic towers with high walkways and blue suspension chains over the river",
            "height": 2.03,
            "draft": false,
            "ops": 124,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9.5,
                18
              ],
              "visitorCapacity": 70,
              "ticket": 12,
              "stay": [
                0.8,
                1.5
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.2,
              "retireeAppeal": 1.4,
              "childAppeal": 1.6,
              "title": "Tower Bridge"
            }
          },
          {
            "key": "100:1:1",
            "index": 1,
            "name": "open road portals, eight conical turrets and white-chorded blue walkways over the bascule gap",
            "height": 2.15,
            "draft": true,
            "ops": 130,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9.5,
                18
              ],
              "visitorCapacity": 70,
              "ticket": 12,
              "stay": [
                0.8,
                1.5
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.2,
              "retireeAppeal": 1.4,
              "childAppeal": 1.6,
              "title": "Tower Bridge"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 4,
      "door": [
        0,
        3
      ]
    },
    "group": "london",
    "tier": 10,
    "blurb": "The Victorian bascule bridge by the Tower: two Gothic towers joined by high walkways, blue suspension chains, and a road that lifts in two halves to let tall ships through. Visitors cross the walkways for the view.",
    "howTo": "In the London demo it is a real crossing: a bascule road bridge over the Thames whose traffic waits at the barriers while the bascules rise for passing ships, a few times a day. Placed with its tool it is a 1×4 landmark on dry land, its door on the bank road at one end, whose deck carries no traffic. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "nursery",
    "name": "nursery",
    "kindId": 101,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "nursery",
      "key": "",
      "label": "Nursery",
      "color": "#f0c85a",
      "cost": 300
    },
    "tech": [
      "edu1"
    ],
    "occupation": {
      "name": "nursery nurse",
      "rotate": false,
      "shifts": [
        {
          "start": 7.5,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8.5,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "stage": 1,
      "pupilCapacity": 30,
      "catchment": 8,
      "ages": [
        3,
        4
      ],
      "teachersShare": 0.5,
      "title": "nursery"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 6,
        "wage": 24,
        "upkeep": 10,
        "cost": 300,
        "work": 300,
        "parking": {
          "surface": 2,
          "underground": 4
        },
        "tech": [
          "edu1"
        ],
        "attrs": {
          "stage": 1,
          "pupilCapacity": 30,
          "catchment": 8,
          "ages": [
            3,
            4
          ],
          "teachersShare": 0.5,
          "title": "nursery"
        },
        "designs": [
          {
            "key": "101:1:0",
            "index": 0,
            "name": "single-storey nursery with coloured cladding pods, a fenced garden with a sandpit and a buggy shelter",
            "height": 0.32,
            "draft": false,
            "ops": 109,
            "attrs": {
              "stage": 1,
              "pupilCapacity": 30,
              "catchment": 8,
              "ages": [
                3,
                4
              ],
              "teachersShare": 0.5,
              "title": "nursery"
            }
          },
          {
            "key": "101:1:1",
            "index": 1,
            "name": "converted Victorian villa with a canopy, a bay window, a painted picket fence and a trike track",
            "height": 0.69,
            "draft": false,
            "ops": 141,
            "attrs": {
              "stage": 1,
              "pupilCapacity": 30,
              "catchment": 8,
              "ages": [
                3,
                4
              ],
              "teachersShare": 0.5,
              "title": "nursery"
            }
          }
        ]
      }
    ],
    "group": "education",
    "tier": 1,
    "blurb": "Thirty places for three- and four-year-olds, a few nursery nurses and a fenced garden with a sandpit. A nursery year gives children a better chance at primary school.",
    "howTo": "One tile in a residential street, beside a road. Children from homes within eight tiles are admitted; families like one close by. Needs Schools."
  },
  {
    "id": "primary-school",
    "name": "primary school",
    "kindId": 102,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "primary",
      "key": "",
      "label": "Primary school (2×2)",
      "color": "#e0a83a",
      "cost": 900
    },
    "tech": [
      "edu1"
    ],
    "occupation": {
      "name": "primary teacher",
      "rotate": false,
      "shifts": [
        {
          "start": 8,
          "hours": 8,
          "weight": 0.7
        },
        {
          "start": 8.5,
          "hours": 8,
          "weight": 0.3
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "stage": 2,
      "pupilCapacity": 120,
      "catchment": 12,
      "ages": [
        4,
        11
      ],
      "teachersShare": 0.6,
      "title": "primary school"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 10,
        "wage": 25,
        "upkeep": 30,
        "cost": 900,
        "work": 750,
        "parking": {
          "surface": 6,
          "underground": 10
        },
        "tech": [
          "edu1"
        ],
        "attrs": {
          "stage": 2,
          "pupilCapacity": 120,
          "catchment": 12,
          "ages": [
            4,
            11
          ],
          "teachersShare": 0.6,
          "title": "primary school"
        },
        "designs": [
          {
            "key": "102:1:0",
            "index": 0,
            "name": "London board school in yellow stock brick with gables, a bell cupola and BOYS and GIRLS entrances on a tarmac playground",
            "height": 0.92,
            "draft": false,
            "ops": 114,
            "attrs": {
              "stage": 2,
              "pupilCapacity": 120,
              "catchment": 12,
              "ages": [
                4,
                11
              ],
              "teachersShare": 0.6,
              "title": "primary school"
            }
          },
          {
            "key": "102:1:1",
            "index": 1,
            "name": "flat-roofed 1960s school with strip windows, a covered way, a mobile classroom and a playing field",
            "height": 0.35,
            "draft": false,
            "ops": 68,
            "attrs": {
              "stage": 2,
              "pupilCapacity": 120,
              "catchment": 12,
              "ages": [
                4,
                11
              ],
              "teachersShare": 0.6,
              "title": "primary school"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ]
    },
    "group": "education",
    "tier": 2,
    "blurb": "A hundred and twenty places for ages four to eleven, with ten staff and a playground. Children go to the nearest school with room, so a school near homes fills fast.",
    "howTo": "A 2×2 plot beside a road, the door on the frontage. Homes within twelve tiles can send children here. Under-eights are walked in, so keep it close to homes. Needs Schools."
  },
  {
    "id": "secondary-school",
    "name": "secondary school",
    "kindId": 103,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "secondary",
      "key": "",
      "label": "Secondary school (3×3)",
      "color": "#d9962f",
      "cost": 2000
    },
    "tech": [
      "edu2"
    ],
    "occupation": {
      "name": "secondary teacher",
      "rotate": false,
      "shifts": [
        {
          "start": 8,
          "hours": 8,
          "weight": 0.65
        },
        {
          "start": 8.5,
          "hours": 8,
          "weight": 0.35
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "stage": 3,
      "pupilCapacity": 300,
      "catchment": 20,
      "ages": [
        11,
        16
      ],
      "teachersShare": 0.6,
      "title": "secondary school"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 26,
        "upkeep": 60,
        "cost": 2000,
        "work": 1500,
        "parking": {
          "surface": 14,
          "underground": 24
        },
        "tech": [
          "edu2"
        ],
        "attrs": {
          "stage": 3,
          "pupilCapacity": 300,
          "catchment": 20,
          "ages": [
            11,
            16
          ],
          "teachersShare": 0.6,
          "title": "secondary school"
        },
        "designs": [
          {
            "key": "103:1:0",
            "index": 0,
            "name": "2000s academy with a curved glazed atrium, coloured render and a floodlit 3G pitch",
            "height": 0.73,
            "draft": false,
            "ops": 148,
            "attrs": {
              "stage": 3,
              "pupilCapacity": 300,
              "catchment": 20,
              "ages": [
                11,
                16
              ],
              "teachersShare": 0.6,
              "title": "secondary school"
            }
          },
          {
            "key": "103:1:1",
            "index": 1,
            "name": "1950s brick secondary modern with a four-storey teaching block, a stair tower, a boiler-house chimney and playing fields",
            "height": 1.09,
            "draft": false,
            "ops": 127,
            "attrs": {
              "stage": 3,
              "pupilCapacity": 300,
              "catchment": 20,
              "ages": [
                11,
                16
              ],
              "teachersShare": 0.6,
              "title": "secondary school"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "education",
    "tier": 3,
    "blurb": "Three hundred places for ages eleven to sixteen and twenty-four staff: GCSEs, a sports hall and a floodlit pitch. Big enough to draw from a whole district, and it runs a school bus.",
    "howTo": "A 3×3 plot with the door in the middle of the frontage. Homes within twenty tiles can send pupils; give it a road the buses can use. Needs Secondary education."
  },
  {
    "id": "sixth-form",
    "name": "sixth-form college",
    "kindId": 104,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "sixthform",
      "key": "",
      "label": "Sixth-form college (2×2)",
      "color": "#c4802a",
      "cost": 1400
    },
    "tech": [
      "edu3"
    ],
    "occupation": {
      "name": "sixth-form tutor",
      "rotate": false,
      "shifts": [
        {
          "start": 8.5,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 9,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "stage": 4,
      "pupilCapacity": 120,
      "catchment": 24,
      "ages": [
        16,
        18
      ],
      "teachersShare": 0.7,
      "title": "sixth-form college"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 10,
        "wage": 26,
        "upkeep": 40,
        "cost": 1400,
        "work": 750,
        "parking": {
          "surface": 8,
          "underground": 12
        },
        "tech": [
          "edu3"
        ],
        "attrs": {
          "stage": 4,
          "pupilCapacity": 120,
          "catchment": 24,
          "ages": [
            16,
            18
          ],
          "teachersShare": 0.7,
          "title": "sixth-form college"
        },
        "designs": [
          {
            "key": "104:1:0",
            "index": 0,
            "name": "Edwardian grammar school in red brick with a clock gable, a cupola and a new glass wing",
            "height": 0.93,
            "draft": false,
            "ops": 106,
            "attrs": {
              "stage": 4,
              "pupilCapacity": 120,
              "catchment": 24,
              "ages": [
                16,
                18
              ],
              "teachersShare": 0.7,
              "title": "sixth-form college"
            }
          },
          {
            "key": "104:1:1",
            "index": 1,
            "name": "modern three-storey sixth-form block with a café front, outdoor tables and a glass stair core",
            "height": 0.85,
            "draft": false,
            "ops": 88,
            "attrs": {
              "stage": 4,
              "pupilCapacity": 120,
              "catchment": 24,
              "ages": [
                16,
                18
              ],
              "teachersShare": 0.7,
              "title": "sixth-form college"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ]
    },
    "group": "education",
    "tier": 4,
    "blurb": "A hundred and twenty places for sixteen- to eighteen-year-olds studying for A-levels: seven tutors in ten are graduates. Leavers go on to university or straight into skilled jobs.",
    "howTo": "A 2×2 plot beside a road, door on the frontage. Students come from homes within twenty-four tiles and travel as adults, so a bus stop or station nearby helps. Needs Further education."
  },
  {
    "id": "fe-college",
    "name": "further-education college",
    "kindId": 105,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "fecollege",
      "key": "",
      "label": "FE college (3×2)",
      "color": "#b87a2e",
      "cost": 2400
    },
    "tech": [
      "edu3"
    ],
    "occupation": {
      "name": "FE lecturer",
      "rotate": false,
      "shifts": [
        {
          "start": 8,
          "hours": 8,
          "weight": 0.55
        },
        {
          "start": 12,
          "hours": 8,
          "weight": 0.45
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "stage": 5,
      "pupilCapacity": 160,
      "eveningPlaces": 60,
      "catchment": 30,
      "ages": [
        16,
        99
      ],
      "teachersShare": 0.5,
      "title": "further-education college"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 18,
        "wage": 26,
        "upkeep": 70,
        "cost": 2400,
        "work": 1050,
        "parking": {
          "surface": 14,
          "underground": 20
        },
        "tech": [
          "edu3"
        ],
        "attrs": {
          "stage": 5,
          "pupilCapacity": 160,
          "eveningPlaces": 60,
          "catchment": 30,
          "ages": [
            16,
            99
          ],
          "teachersShare": 0.5,
          "title": "further-education college"
        },
        "designs": [
          {
            "key": "105:1:0",
            "index": 0,
            "name": "1970s concrete tower on a podium with workshop sheds, roller doors, a motor-vehicle bay and a bricklaying yard",
            "height": 1.55,
            "draft": false,
            "ops": 86,
            "attrs": {
              "stage": 5,
              "pupilCapacity": 160,
              "eveningPlaces": 60,
              "catchment": 30,
              "ages": [
                16,
                99
              ],
              "teachersShare": 0.5,
              "title": "further-education college"
            }
          },
          {
            "key": "105:1:1",
            "index": 1,
            "name": "new glazed campus with a curtain-walled atrium, a drum entrance and an apprenticeship hall with roller doors",
            "height": 0.55,
            "draft": false,
            "ops": 88,
            "attrs": {
              "stage": 5,
              "pupilCapacity": 160,
              "eveningPlaces": 60,
              "catchment": 30,
              "ages": [
                16,
                99
              ],
              "teachersShare": 0.5,
              "title": "further-education college"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "education",
    "tier": 5,
    "blurb": "A college for trades, A-levels and adult courses: a hundred and sixty day places and sixty evening ones, with workshops for builders, mechanics and electricians. Where the unemployed retrain.",
    "howTo": "A 3×2 plot beside a road, door in the middle of the frontage. Students from homes within thirty tiles come by bus or car. Needs Further education."
  },
  {
    "id": "university",
    "name": "university campus",
    "kindId": 106,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "university",
      "key": "",
      "label": "University campus (6×6)",
      "color": "#a8671f",
      "cost": 7000
    },
    "tech": [
      "edu4"
    ],
    "occupation": {
      "name": "lecturer",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.55
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "stage": 6,
      "pupilCapacity": 600,
      "catchment": 0,
      "ages": [
        18,
        99
      ],
      "teachersShare": 0.6,
      "postgradShare": 0.4,
      "title": "university campus"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 60,
        "wage": 28,
        "upkeep": 180,
        "cost": 7000,
        "work": 5550,
        "parking": {
          "surface": 60,
          "underground": 120
        },
        "tech": [
          "edu4"
        ],
        "attrs": {
          "stage": 6,
          "pupilCapacity": 600,
          "catchment": 0,
          "ages": [
            18,
            99
          ],
          "teachersShare": 0.6,
          "postgradShare": 0.4,
          "title": "university campus"
        },
        "designs": [
          {
            "key": "106:1:0",
            "index": 0,
            "name": "redbrick Victorian Gothic quad with a clock tower, gabled ranges, a domed library and lamp-lit paths",
            "height": 2.36,
            "draft": false,
            "ops": 236,
            "attrs": {
              "stage": 6,
              "pupilCapacity": 600,
              "catchment": 0,
              "ages": [
                18,
                99
              ],
              "teachersShare": 0.6,
              "postgradShare": 0.4,
              "title": "university campus"
            }
          },
          {
            "key": "106:1:1",
            "index": 1,
            "name": "plate-glass 1960s campus of concrete slabs on a podium with walkways, a lecture drum and a lake with a causeway",
            "height": 2.11,
            "draft": false,
            "ops": 133,
            "attrs": {
              "stage": 6,
              "pupilCapacity": 600,
              "catchment": 0,
              "ages": [
                18,
                99
              ],
              "teachersShare": 0.6,
              "postgradShare": 0.4,
              "title": "university campus"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 6,
      "h": 6,
      "door": [
        3,
        5
      ]
    },
    "group": "education",
    "tier": 6,
    "blurb": "A whole campus on thirty-six tiles: lecture halls, a library and a quad, with six hundred places and sixty staff. It takes your own school leavers, draws students from far away, and turns out the graduates that fill offices and labs.",
    "howTo": "A 6×6 plot with the gate on the frontage, right of the middle. Students come from the whole city, so put it near a station or bus stop, and build halls of residence beside it. Needs Higher education."
  },
  {
    "id": "research-institute",
    "name": "research institute",
    "kindId": 107,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "research",
      "key": "",
      "label": "Research institute (3×3)",
      "color": "#8a8f9c",
      "cost": 5000
    },
    "tech": [
      "edu5"
    ],
    "occupation": {
      "name": "research scientist",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.5
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 12,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "stage": 7,
      "pupilCapacity": 0,
      "catchment": 0,
      "ages": [
        21,
        99
      ],
      "teachersShare": 0.6,
      "postgradShare": 0.6,
      "title": "research institute"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 32,
        "upkeep": 150,
        "cost": 5000,
        "work": 1500,
        "parking": {
          "surface": 16,
          "underground": 30
        },
        "tech": [
          "edu5"
        ],
        "attrs": {
          "stage": 7,
          "pupilCapacity": 0,
          "catchment": 0,
          "ages": [
            21,
            99
          ],
          "teachersShare": 0.6,
          "postgradShare": 0.6,
          "title": "research institute"
        },
        "designs": [
          {
            "key": "107:1:0",
            "index": 0,
            "name": "glass and zinc laboratory block with a saw-tooth roof, a glazed atrium tube, rooftop plant and fume stacks",
            "height": 1.1,
            "draft": false,
            "ops": 133,
            "attrs": {
              "stage": 7,
              "pupilCapacity": 0,
              "catchment": 0,
              "ages": [
                21,
                99
              ],
              "teachersShare": 0.6,
              "postgradShare": 0.6,
              "title": "research institute"
            }
          },
          {
            "key": "107:1:1",
            "index": 1,
            "name": "science-park cluster of brick and pale pavilions round a pyramid-roofed glass atrium, with an observatory dome and a wind turbine",
            "height": 0.84,
            "draft": false,
            "ops": 102,
            "attrs": {
              "stage": 7,
              "pupilCapacity": 0,
              "catchment": 0,
              "ages": [
                21,
                99
              ],
              "teachersShare": 0.6,
              "postgradShare": 0.6,
              "title": "research institute"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "education",
    "tier": 7,
    "blurb": "Forty scientists in glass and steel laboratories: postgraduate research, the best-paid jobs in town, and a pull on high-end offices nearby. It takes graduates and gives back specialists.",
    "howTo": "A 3×3 plot with the entrance in the middle of the frontage, ideally near a university. It needs a steady supply of graduates and postgraduates to staff its labs. Needs Research."
  },
  {
    "id": "halls",
    "name": "halls of residence",
    "kindId": 108,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tool": {
      "id": "halls",
      "key": "",
      "label": "Halls of residence (2×2)",
      "color": "#9c6a2a",
      "cost": 1500
    },
    "tech": [
      "edu4"
    ],
    "occupation": {
      "name": "hall warden",
      "rotate": false,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "stage": 0,
      "pupilCapacity": 0,
      "beds": 80,
      "ages": [
        18,
        99
      ],
      "title": "halls of residence"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 2,
        "wage": 18,
        "upkeep": 25,
        "cost": 1500,
        "work": 750,
        "parking": {
          "surface": 4,
          "underground": 8
        },
        "tech": [
          "edu4"
        ],
        "attrs": {
          "stage": 0,
          "pupilCapacity": 0,
          "beds": 80,
          "ages": [
            18,
            99
          ],
          "title": "halls of residence"
        },
        "designs": [
          {
            "key": "108:1:0",
            "index": 0,
            "name": "1960s concrete slab of student rooms with access decks, a common room and a bike shed",
            "height": 1.44,
            "draft": false,
            "ops": 73,
            "attrs": {
              "stage": 0,
              "pupilCapacity": 0,
              "beds": 80,
              "ages": [
                18,
                99
              ],
              "title": "halls of residence"
            }
          },
          {
            "key": "108:1:1",
            "index": 1,
            "name": "modern cluster flats in cream and white cladding round a courtyard with balconies and a bike shed",
            "height": 0.75,
            "draft": false,
            "ops": 79,
            "attrs": {
              "stage": 0,
              "pupilCapacity": 0,
              "beds": 80,
              "ages": [
                18,
                99
              ],
              "title": "halls of residence"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "education",
    "tier": 8,
    "blurb": "Eighty beds for students, with two wardens. Students who come to study from far away live here rather than taking a home from a resident, and a student quarter next to a campus keeps the shops busy.",
    "howTo": "A 2×2 plot beside a road, close to a university or FE college. It houses only enrolled students and does nothing on its own. Needs Higher education."
  },
  {
    "id": "ucl",
    "name": "University College London",
    "kindId": 111,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "ucl",
      "key": "",
      "label": "UCL",
      "color": "#500778",
      "cost": 9000
    },
    "tech": [
      "lnd2"
    ],
    "occupation": {
      "name": "lecturer",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.55
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "stage": 6,
      "pupilCapacity": 360,
      "catchment": 0,
      "ages": [
        18,
        99
      ],
      "teachersShare": 0.6,
      "postgradShare": 0.4,
      "title": "University College London"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 36,
        "wage": 28,
        "upkeep": 110,
        "cost": 9000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 30
        },
        "tech": [
          "lnd2"
        ],
        "attrs": {
          "stage": 6,
          "pupilCapacity": 360,
          "catchment": 0,
          "ages": [
            18,
            99
          ],
          "teachersShare": 0.6,
          "postgradShare": 0.4,
          "title": "University College London"
        },
        "designs": [
          {
            "key": "111:1:0",
            "index": 0,
            "name": "Portland-stone front with a Corinthian portico, forward wings and a green dome",
            "height": 1.45,
            "draft": false,
            "ops": 113,
            "attrs": {
              "stage": 6,
              "pupilCapacity": 360,
              "catchment": 0,
              "ages": [
                18,
                99
              ],
              "teachersShare": 0.6,
              "postgradShare": 0.4,
              "title": "University College London"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 3,
      "door": [
        2,
        2
      ]
    },
    "group": "london",
    "tier": 11,
    "blurb": "University College London's Wilkins Building in Bloomsbury: a Portland-stone front between two wings, a portico of Corinthian columns on a flight of steps, and the low green dome behind. The first university in England to admit anyone, whatever their faith.",
    "howTo": "A 4×3 plot on a street in a district of homes and offices; students come from the whole city, so put it near a station or bus stop. It takes your sixth-form leavers, employs lecturers and turns out graduates. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "imperial",
    "name": "Imperial College London",
    "kindId": 112,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "imperial",
      "key": "",
      "label": "Imperial College",
      "color": "#003e74",
      "cost": 8500
    },
    "tech": [
      "lnd2"
    ],
    "occupation": {
      "name": "lecturer",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.55
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "stage": 6,
      "pupilCapacity": 320,
      "catchment": 0,
      "ages": [
        18,
        99
      ],
      "teachersShare": 0.6,
      "postgradShare": 0.4,
      "title": "Imperial College London"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 32,
        "wage": 28,
        "upkeep": 105,
        "cost": 8500,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 30
        },
        "tech": [
          "lnd2"
        ],
        "attrs": {
          "stage": 6,
          "pupilCapacity": 320,
          "catchment": 0,
          "ages": [
            18,
            99
          ],
          "teachersShare": 0.6,
          "postgradShare": 0.4,
          "title": "Imperial College London"
        },
        "designs": [
          {
            "key": "112:1:0",
            "index": 0,
            "name": "red-brick Queen's Tower with a stone clock stage and copper dome, between brick ranges on a lawn",
            "height": 3.05,
            "draft": false,
            "ops": 115,
            "attrs": {
              "stage": 6,
              "pupilCapacity": 320,
              "catchment": 0,
              "ages": [
                18,
                99
              ],
              "teachersShare": 0.6,
              "postgradShare": 0.4,
              "title": "Imperial College London"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "london",
    "tier": 12,
    "blurb": "Imperial College in South Kensington: the Queen's Tower, the last of the Imperial Institute, rising out of red-brick ranges round the Queen's Lawn. Science, engineering and medicine.",
    "howTo": "A 3×3 plot with the lawn towards the street, near the museums or a station. Students come from the whole city; it takes your sixth-form leavers, employs lecturers and graduates scientists. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "kings",
    "name": "King's College London",
    "kindId": 113,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "kings",
      "key": "",
      "label": "King's College",
      "color": "#c8102e",
      "cost": 8000
    },
    "tech": [
      "lnd2"
    ],
    "occupation": {
      "name": "lecturer",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.55
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "stage": 6,
      "pupilCapacity": 300,
      "catchment": 0,
      "ages": [
        18,
        99
      ],
      "teachersShare": 0.6,
      "postgradShare": 0.4,
      "title": "King's College London"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 28,
        "upkeep": 100,
        "cost": 8000,
        "work": 2700,
        "parking": {
          "surface": 0,
          "underground": 30
        },
        "tech": [
          "lnd2"
        ],
        "attrs": {
          "stage": 6,
          "pupilCapacity": 300,
          "catchment": 0,
          "ages": [
            18,
            99
          ],
          "teachersShare": 0.6,
          "postgradShare": 0.4,
          "title": "King's College London"
        },
        "designs": [
          {
            "key": "113:1:0",
            "index": 0,
            "name": "four-storey stone front on the Strand with a pedimented pavilion, a balustrade and a fountain court behind",
            "height": 0.9,
            "draft": false,
            "ops": 104,
            "attrs": {
              "stage": 6,
              "pupilCapacity": 300,
              "catchment": 0,
              "ages": [
                18,
                99
              ],
              "teachersShare": 0.6,
              "postgradShare": 0.4,
              "title": "King's College London"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 3,
      "door": [
        2,
        2
      ]
    },
    "group": "london",
    "tier": 13,
    "blurb": "King's College London's Strand building beside Somerset House: a long stone front of four storeys with a pedimented pavilion and a balustrade, and the courtyard and its fountain behind. Founded by the King and the Duke of Wellington in 1829.",
    "howTo": "A 4×3 plot on a main street, the front on the road and the courtyard behind. Students come from the whole city; it takes your sixth-form leavers, employs lecturers and graduates doctors, lawyers and historians. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "lse",
    "name": "London School of Economics",
    "kindId": 114,
    "code": 14,
    "family": "civic",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "lse",
      "key": "",
      "label": "LSE",
      "color": "#e4002b",
      "cost": 7500
    },
    "tech": [
      "lnd2"
    ],
    "occupation": {
      "name": "lecturer",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.55
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 13,
          "hours": 8,
          "weight": 0.15
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ]
      ]
    },
    "attrs": {
      "stage": 6,
      "pupilCapacity": 240,
      "catchment": 0,
      "ages": [
        18,
        99
      ],
      "teachersShare": 0.6,
      "postgradShare": 0.4,
      "title": "London School of Economics"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 28,
        "upkeep": 95,
        "cost": 7500,
        "work": 2500,
        "parking": {
          "surface": 0,
          "underground": 30
        },
        "tech": [
          "lnd2"
        ],
        "attrs": {
          "stage": 6,
          "pupilCapacity": 240,
          "catchment": 0,
          "ages": [
            18,
            99
          ],
          "teachersShare": 0.6,
          "postgradShare": 0.4,
          "title": "London School of Economics"
        },
        "designs": [
          {
            "key": "114:1:0",
            "index": 0,
            "name": "stepped stack of cream masonry and glass with a cantilever, a glazed corner atrium and a plaza",
            "height": 2.75,
            "draft": false,
            "ops": 58,
            "attrs": {
              "stage": 6,
              "pupilCapacity": 240,
              "catchment": 0,
              "ages": [
                18,
                99
              ],
              "teachersShare": 0.6,
              "postgradShare": 0.4,
              "title": "London School of Economics"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "london",
    "tier": 14,
    "blurb": "The London School of Economics on Houghton Street: the Centre Building, a stepped stack of cream masonry and glass with cantilevered floors and a glazed corner atrium over a plaza. Economists, lawyers and politicians.",
    "howTo": "A 3×3 plot with the plaza on the street, close to offices and the courts. Students come from the whole city; it takes your sixth-form leavers, employs lecturers and graduates the people offices and councils hire. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "piccadilly-circus",
    "name": "Piccadilly Circus",
    "kindId": 116,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "piccadilly",
      "key": "",
      "label": "Piccadilly Circus",
      "color": "#e8b923",
      "cost": 12000
    },
    "tech": [
      "lnd1"
    ],
    "occupation": {
      "name": "theatre and venue staff",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        14,
        24
      ],
      "visitorCapacity": 120,
      "ticket": 16,
      "stay": [
        1.5,
        3
      ],
      "leisureValue": 9,
      "radius": 28,
      "eventNights": [
        3,
        4,
        5,
        6
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.5,
      "eveningAppeal": 1.2,
      "retireeAppeal": 1.3,
      "childAppeal": 0.4,
      "eventSize": 1.4,
      "title": "Piccadilly Circus"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 17,
        "upkeep": 80,
        "cost": 12000,
        "work": 2400,
        "parking": {
          "surface": 0,
          "underground": 20
        },
        "tech": [
          "lnd1"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            14,
            24
          ],
          "visitorCapacity": 120,
          "ticket": 16,
          "stay": [
            1.5,
            3
          ],
          "leisureValue": 9,
          "radius": 28,
          "eventNights": [
            3,
            4,
            5,
            6
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.5,
          "eveningAppeal": 1.2,
          "retireeAppeal": 1.3,
          "childAppeal": 0.4,
          "eventSize": 1.4,
          "title": "Piccadilly Circus"
        },
        "designs": [
          {
            "key": "116:1:0",
            "index": 0,
            "name": "the Piccadilly Lights round a curved corner, the Criterion and the Shaftesbury fountain with Eros",
            "height": 1.11,
            "draft": false,
            "ops": 118,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                14,
                24
              ],
              "visitorCapacity": 120,
              "ticket": 16,
              "stay": [
                1.5,
                3
              ],
              "leisureValue": 9,
              "radius": 28,
              "eventNights": [
                3,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.5,
              "eveningAppeal": 1.2,
              "retireeAppeal": 1.3,
              "childAppeal": 0.4,
              "eventSize": 1.4,
              "title": "Piccadilly Circus"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "london",
    "tier": 15,
    "blurb": "The West End's meeting place: the Piccadilly Lights on the curved corner of the London Pavilion, the Shaftesbury Memorial Fountain with its winged archer (Eros, properly Anteros), the Criterion Theatre and the Underground below. The screens are the most expensive advert slots in town, shared in turns.",
    "howTo": "A 4×2 plot facing a main road in the busiest part of town. Its six big screens take turns: rent one through the Campaigns panel (pick a screen) to put your campaign on all of them in turn. London landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "london"
    ]
  },
  {
    "id": "big-screens",
    "name": "big screens corner",
    "kindId": 117,
    "code": 11,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "bigscreens",
      "key": "",
      "label": "Big screens corner",
      "color": "#ff4fa8",
      "cost": 4200
    },
    "tech": [
      "cul5"
    ],
    "occupation": {
      "name": "cinema usher",
      "rotate": true,
      "shifts": [
        {
          "start": 12,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "cinema",
      "openHours": [
        12,
        24
      ],
      "visitorCapacity": 100,
      "ticket": 10,
      "stay": [
        2,
        2.6
      ],
      "leisureValue": 7,
      "radius": 22,
      "eventNights": [
        3,
        4,
        5
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.25,
      "eveningAppeal": 1.6,
      "retireeAppeal": 0.7,
      "childAppeal": 1.2,
      "eventSize": 1.5,
      "title": "big screens corner"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 16,
        "wage": 15,
        "upkeep": 45,
        "cost": 4200,
        "work": 800,
        "parking": {
          "surface": 0,
          "underground": 30
        },
        "tech": [
          "cul5"
        ],
        "attrs": {
          "venueType": "cinema",
          "openHours": [
            12,
            24
          ],
          "visitorCapacity": 100,
          "ticket": 10,
          "stay": [
            2,
            2.6
          ],
          "leisureValue": 7,
          "radius": 22,
          "eventNights": [
            3,
            4,
            5
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.25,
          "eveningAppeal": 1.6,
          "retireeAppeal": 0.7,
          "childAppeal": 1.2,
          "eventSize": 1.5,
          "title": "big screens corner"
        },
        "designs": [
          {
            "key": "117:1:0",
            "index": 0,
            "name": "cinema on a corner with six big screens round its curve",
            "height": 1.35,
            "draft": false,
            "ops": 21,
            "attrs": {
              "venueType": "cinema",
              "openHours": [
                12,
                24
              ],
              "visitorCapacity": 100,
              "ticket": 10,
              "stay": [
                2,
                2.6
              ],
              "leisureValue": 7,
              "radius": 22,
              "eventNights": [
                3,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.25,
              "eveningAppeal": 1.6,
              "retireeAppeal": 0.7,
              "childAppeal": 1.2,
              "eventSize": 1.5,
              "title": "big screens corner"
            }
          },
          {
            "key": "117:1:1",
            "index": 1,
            "name": "terracotta corner with big screens under a copper dome",
            "height": 1.51,
            "draft": false,
            "ops": 23,
            "attrs": {
              "venueType": "cinema",
              "openHours": [
                12,
                24
              ],
              "visitorCapacity": 100,
              "ticket": 10,
              "stay": [
                2,
                2.6
              ],
              "leisureValue": 7,
              "radius": 22,
              "eventNights": [
                3,
                4,
                5
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.25,
              "eveningAppeal": 1.6,
              "retireeAppeal": 0.7,
              "childAppeal": 1.2,
              "eventSize": 1.5,
              "title": "big screens corner"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "cinema",
    "tier": 4,
    "blurb": "A cinema on a street corner with six big screens round its rounded corner, lit day and night: the town's answer to Piccadilly Circus. Campaigns take turns on the screens, the dearest advert slots there are.",
    "howTo": "A 2×2 corner plot with roads on its front and its right side, on the busiest junction you have. Rent a turn on its screens from the Campaigns panel (pick a screen). Needs Landmarks."
  },
  {
    "id": "camp",
    "name": "pioneer camp",
    "kindId": 120,
    "code": 1,
    "family": "residential",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": false
    },
    "windows": "home",
    "tool": {
      "id": "camp",
      "key": "",
      "label": "Pioneer camp (2×2)",
      "color": "#c98a3c",
      "cost": 150
    },
    "tech": [],
    "attrs": {
      "style": "camp",
      "rentBand": "low"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 8,
        "wage": 0,
        "upkeep": 4,
        "cost": 150,
        "work": 300,
        "parking": {
          "surface": 2,
          "underground": 0
        },
        "tech": [],
        "attrs": {
          "style": "camp",
          "rentBand": "low"
        },
        "designs": [
          {
            "key": "120:1:0",
            "index": 0,
            "name": "ridge tents and a caravan round a fire pit, festoon lights over the path",
            "height": 0.4,
            "draft": false,
            "ops": 74,
            "attrs": {
              "style": "camp",
              "rentBand": "low"
            }
          },
          {
            "key": "120:1:1",
            "index": 1,
            "name": "bell tent, dome tent and two caravans by a fire pit and a lantern",
            "height": 0.44,
            "draft": false,
            "ops": 67,
            "attrs": {
              "style": "camp",
              "rentBand": "low"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ],
      "marks": [
        {
          "kind": "door",
          "at": [
            0,
            1
          ],
          "label": "camp gate"
        }
      ]
    },
    "blurb": "Tents and caravans round a fire pit: the first eight settlers of a new town. It opens the moment it is pitched, with no builders needed, and its people arrive within the hour to work your builders' yard and first shops. One camp per player at a time.",
    "howTo": "Two tiles by two beside a road on your land (Z and C turn it), ideally next to where your builders' yard and first homes will go. It never grows; bulldoze it once proper homes stand and its people move into free beds nearby."
  },
  {
    "id": "empire-state",
    "name": "the Empire State Building",
    "kindId": 121,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "empirestate",
      "key": "",
      "label": "Empire State",
      "color": "#c9a35a",
      "cost": 28000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 400,
        "wage": 46,
        "upkeep": 140,
        "cost": 28000,
        "work": 5000,
        "parking": {
          "surface": 0,
          "underground": 80
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "121:1:0",
            "index": 0,
            "name": "five limestone setbacks under a silver mooring-mast spire",
            "height": 7.3,
            "draft": false,
            "ops": 39,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "121:1:1",
            "index": 1,
            "name": "cool limestone, a broad storefront podium and three tapering shafts beneath a ribbed mooring mast",
            "height": 7.2,
            "draft": true,
            "ops": 41,
            "attrs": {},
            "author": "k3.1-pro"
          },
          {
            "key": "121:1:2",
            "index": 2,
            "name": "a limestone slab narrow to the avenue and long down the block, four setbacks to the art-deco crown, the round mooring mast",
            "height": 6.6,
            "draft": true,
            "ops": 37,
            "attrs": {},
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "new-york",
    "tier": 1,
    "blurb": "Fifth Avenue's art-deco sentinel: a limestone shaft of setbacks climbing to the mooring-mast spire that has crowned the Manhattan skyline since 1931.",
    "howTo": "A 3×3 plot on a main avenue among offices; it holds crowds of jobs, so give it a station or buses and leave the street in front clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "new-york"
    ]
  },
  {
    "id": "chrysler",
    "name": "the Chrysler Building",
    "kindId": 122,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "chrysler",
      "key": "",
      "label": "Chrysler Building",
      "color": "#9fb3c8",
      "cost": 22000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 320,
        "wage": 44,
        "upkeep": 120,
        "cost": 22000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 70
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "122:1:0",
            "index": 0,
            "name": "dark shaft under four shrinking chrome crown terraces, a dome and a needle",
            "height": 5.14,
            "draft": false,
            "ops": 27,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "122:1:1",
            "index": 1,
            "name": "pale glazed brick in three stages, the eagles at the setback corners, seven chrome tiers each with its dark window band, the needle",
            "height": 5.36,
            "draft": true,
            "ops": 49,
            "attrs": {},
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "new-york",
    "tier": 2,
    "blurb": "The silver crown of the Midtown skyline: William Van Alen's dark-brick shaft whose seven terraced chrome arches climb through a dome to a needle.",
    "howTo": "A 3×3 plot among offices on an avenue; a big workplace, so give it buses or a station. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "new-york"
    ]
  },
  {
    "id": "statue-of-liberty",
    "name": "the Statue of Liberty",
    "kindId": 123,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "liberty",
      "key": "",
      "label": "Statue of Liberty",
      "color": "#6fae94",
      "cost": 13000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "monument guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17.5
      ],
      "visitorCapacity": 120,
      "ticket": 24,
      "stay": [
        1.2,
        2.2
      ],
      "leisureValue": 8,
      "radius": 30,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.1,
      "retireeAppeal": 2.2,
      "childAppeal": 1.9,
      "title": "Statue of Liberty"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 17,
        "upkeep": 60,
        "cost": 13000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17.5
          ],
          "visitorCapacity": 120,
          "ticket": 24,
          "stay": [
            1.2,
            2.2
          ],
          "leisureValue": 8,
          "radius": 30,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.1,
          "retireeAppeal": 2.2,
          "childAppeal": 1.9,
          "title": "Statue of Liberty"
        },
        "designs": [
          {
            "key": "123:1:0",
            "index": 0,
            "name": "star-fort pedestal on the island under the green copper figure and her raised torch",
            "height": 1.6,
            "draft": false,
            "ops": 85,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 120,
              "ticket": 24,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 8,
              "radius": 30,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.1,
              "retireeAppeal": 2.2,
              "childAppeal": 1.9,
              "title": "Statue of Liberty"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "123:1:1",
            "index": 1,
            "name": "an octagonal island fort, a tall stone pedestal and a robed figure with tablet held close and torch aloft",
            "height": 1.83,
            "draft": true,
            "ops": 39,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 120,
              "ticket": 24,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 8,
              "radius": 30,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.1,
              "retireeAppeal": 2.2,
              "childAppeal": 1.9,
              "title": "Statue of Liberty"
            },
            "author": "k3.1-pro"
          },
          {
            "key": "123:1:2",
            "index": 2,
            "name": "the star fort, a pedestal as tall as the figure, the copper lady with her torch raised, the ferry at the landing",
            "height": 1.86,
            "draft": true,
            "ops": 45,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 120,
              "ticket": 24,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 8,
              "radius": 30,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.1,
              "retireeAppeal": 2.2,
              "childAppeal": 1.9,
              "title": "Statue of Liberty"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "new-york",
    "tier": 3,
    "blurb": "Liberty Island in the harbour: the star-fort pedestal Bartholdi's green copper lady has stood on since 1886, her torch raised over the bay for the ferries from Manhattan.",
    "howTo": "A 2×2 plot by the water, its door on the street side. A ticketed day out that draws families and retirees from across the city, so give it a bus or a station. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "new-york"
    ]
  },
  {
    "id": "one-world-trade-center",
    "name": "One World Trade Center",
    "kindId": 124,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "onewtc",
      "key": "",
      "label": "One World Trade Center",
      "color": "#8fb4cc",
      "cost": 26000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 380,
        "wage": 46,
        "upkeep": 140,
        "cost": 26000,
        "work": 4800,
        "parking": {
          "surface": 0,
          "underground": 75
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "124:1:0",
            "index": 0,
            "name": "glass podium under the gently tapering square shaft, the flat crown and the spire",
            "height": 4.88,
            "draft": false,
            "ops": 22,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "124:1:1",
            "index": 1,
            "name": "a square glass prism turned a quarter turn between foot and crown so every face splits into two long triangles, the spire",
            "height": 7,
            "draft": true,
            "ops": 26,
            "attrs": {},
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "new-york",
    "tier": 4,
    "blurb": "The glass shaft of the rebuilt World Trade Center: long triangles of glazing rising the full height to the flat crown, the spire climbing from it over the memorial pools.",
    "howTo": "A 3×3 plot downtown among offices; one of the city's biggest workplaces, so give it buses or a station and leave the street in front clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "new-york"
    ]
  },
  {
    "id": "brooklyn-bridge",
    "name": "the Brooklyn Bridge",
    "kindId": 125,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "brooklyn",
      "key": "",
      "label": "Brooklyn Bridge",
      "color": "#b8ab90",
      "cost": 15000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "bridge walk guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9.5,
        18
      ],
      "visitorCapacity": 90,
      "ticket": 12,
      "stay": [
        0.8,
        1.6
      ],
      "leisureValue": 7,
      "radius": 26,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.15,
      "retireeAppeal": 1.5,
      "childAppeal": 1.5,
      "title": "Brooklyn Bridge"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 16,
        "wage": 16,
        "upkeep": 65,
        "cost": 15000,
        "work": 3200,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9.5,
            18
          ],
          "visitorCapacity": 90,
          "ticket": 12,
          "stay": [
            0.8,
            1.6
          ],
          "leisureValue": 7,
          "radius": 26,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.15,
          "retireeAppeal": 1.5,
          "childAppeal": 1.5,
          "title": "Brooklyn Bridge"
        },
        "designs": [
          {
            "key": "125:1:0",
            "index": 0,
            "name": "two stone towers with arched openings and diagonal cable fans over the road deck",
            "height": 1.86,
            "draft": false,
            "ops": 63,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9.5,
                18
              ],
              "visitorCapacity": 90,
              "ticket": 12,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.15,
              "retireeAppeal": 1.5,
              "childAppeal": 1.5,
              "title": "Brooklyn Bridge"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "125:1:1",
            "index": 1,
            "name": "granite towers with twin pointed arches over the river, four cables over the saddles, the fan of stays, the raised promenade",
            "height": 1.79,
            "draft": true,
            "ops": 84,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9.5,
                18
              ],
              "visitorCapacity": 90,
              "ticket": 12,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.15,
              "retireeAppeal": 1.5,
              "childAppeal": 1.5,
              "title": "Brooklyn Bridge"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 4,
      "door": [
        0,
        3
      ]
    },
    "group": "new-york",
    "tier": 5,
    "blurb": "The 1883 crossing over the East River: twin stone towers with tall arches, diagonal fans of cable stays and a promenade visitors walk for the harbour view.",
    "howTo": "Placed with its tool it is a 1×4 landmark on dry land, its door on the road at one end; in a real city it would span the river it crosses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "new-york"
    ]
  },
  {
    "id": "flatiron",
    "name": "the Flatiron Building",
    "kindId": 126,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "flatiron",
      "key": "",
      "label": "Flatiron Building",
      "color": "#c8a37a",
      "cost": 15000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 240,
        "wage": 44,
        "upkeep": 95,
        "cost": 15000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 50
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "126:1:0",
            "index": 0,
            "name": "rusticated base under the limestone wedge that tapers along one axis to the knife edge",
            "height": 2.25,
            "draft": false,
            "ops": 21,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "126:1:1",
            "index": 1,
            "name": "a true three-sided prism with its prow on the avenue, the office grid on every face, the heavy cornice and attic",
            "height": 2.38,
            "draft": true,
            "ops": 32,
            "attrs": {},
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "new-york",
    "tier": 6,
    "blurb": "The narrow wedge where Fifth Avenue meets Broadway: Burnham's limestone and terracotta flatiron rising twenty storeys to the knife edge over the pavement.",
    "howTo": "A 3×3 plot where two avenues fork, the wide face and door on the street. An office like any other, so give it transit and leave the front clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "new-york"
    ]
  },
  {
    "id": "rockefeller-center",
    "name": "Rockefeller Center",
    "kindId": 127,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "rockefeller",
      "key": "",
      "label": "Rockefeller Center",
      "color": "#d0c49a",
      "cost": 24000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 320,
        "wage": 46,
        "upkeep": 150,
        "cost": 24000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 80
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "127:1:0",
            "index": 0,
            "name": "limestone setbacks behind the sunken plaza, the pale rink with its flags and gilded Prometheus",
            "height": 2.66,
            "draft": false,
            "ops": 41,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "127:1:1",
            "index": 1,
            "name": "the Channel Gardens between two low blocks, the sunken rink ringed with flags, the thin slab of 30 Rock stepped at its ends",
            "height": 3.47,
            "draft": true,
            "ops": 63,
            "attrs": {},
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        1,
        3
      ]
    },
    "group": "new-york",
    "tier": 7,
    "blurb": "The GE slab behind its sunken plaza: limestone setbacks climbing to the flat top, the pale rink below with Prometheus gilded over it and the avenue of flags.",
    "howTo": "A 4×4 plot on an avenue, the plaza and rink towards the street. One of the city's biggest workplaces, so give it a station or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "new-york"
    ]
  },
  {
    "id": "radio-city",
    "name": "Radio City Music Hall",
    "kindId": 128,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "radiocity",
      "key": "",
      "label": "Radio City Music Hall",
      "color": "#c9463c",
      "cost": 12000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "music hall staff",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        12,
        24
      ],
      "visitorCapacity": 220,
      "ticket": 26,
      "stay": [
        2,
        3
      ],
      "leisureValue": 10,
      "radius": 30,
      "eventNights": [
        2,
        4,
        5,
        6
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.15,
      "eveningAppeal": 1.4,
      "retireeAppeal": 1.6,
      "childAppeal": 0.4,
      "title": "Radio City Music Hall"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 35,
        "wage": 19,
        "upkeep": 95,
        "cost": 12000,
        "work": 2600,
        "parking": {
          "surface": 0,
          "underground": 40
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            12,
            24
          ],
          "visitorCapacity": 220,
          "ticket": 26,
          "stay": [
            2,
            3
          ],
          "leisureValue": 10,
          "radius": 30,
          "eventNights": [
            2,
            4,
            5,
            6
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.15,
          "eveningAppeal": 1.4,
          "retireeAppeal": 1.6,
          "childAppeal": 0.4,
          "title": "Radio City Music Hall"
        },
        "designs": [
          {
            "key": "128:1:0",
            "index": 0,
            "name": "long limestone facade under an even longer lit marquee, the stage house rising behind",
            "height": 1.02,
            "draft": false,
            "ops": 55,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                12,
                24
              ],
              "visitorCapacity": 220,
              "ticket": 26,
              "stay": [
                2,
                3
              ],
              "leisureValue": 10,
              "radius": 30,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.4,
              "retireeAppeal": 1.6,
              "childAppeal": 0.4,
              "title": "Radio City Music Hall"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "128:1:1",
            "index": 1,
            "name": "the windowless limestone block, the marquee wrapping the corner with its lit fascia, two neon blades, the stage house behind",
            "height": 1.02,
            "draft": true,
            "ops": 41,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                12,
                24
              ],
              "visitorCapacity": 220,
              "ticket": 26,
              "stay": [
                2,
                3
              ],
              "leisureValue": 10,
              "radius": 30,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.4,
              "retireeAppeal": 1.6,
              "childAppeal": 0.4,
              "title": "Radio City Music Hall"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 3,
      "door": [
        2,
        2
      ]
    },
    "group": "new-york",
    "tier": 8,
    "blurb": "The show palace of Sixth Avenue: the long limestone facade under an even longer marquee of bulbs, and the great auditorium behind it that fills for the Christmas Spectacular.",
    "howTo": "A 4×3 plot on a busy avenue, the marquee towards the street, near restaurants and bars for the pre-show crowd. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "new-york"
    ]
  },
  {
    "id": "tv-studio",
    "name": "local TV studio",
    "kindId": 130,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "tvstudio",
      "key": "",
      "label": "TV studio",
      "color": "#c8463c",
      "cost": 900
    },
    "tech": [
      "med1"
    ],
    "occupation": {
      "name": "broadcast staff",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 9,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 14,
          "hours": 9,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "newsRadius": 24,
      "newsTier": 1,
      "newsHelicopters": 0,
      "skill": [
        4,
        0.4
      ],
      "title": "TV studio"
    },
    "tints": [
      16777215,
      15660026,
      16183786,
      15397360,
      15986422
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 14,
        "wage": 22,
        "upkeep": 35,
        "cost": 900,
        "work": 260,
        "parking": {
          "surface": 3,
          "underground": 6
        },
        "tech": [
          "med1"
        ],
        "attrs": {
          "newsRadius": 24,
          "newsTier": 1,
          "newsHelicopters": 0,
          "skill": [
            4,
            0.4
          ],
          "title": "TV studio"
        },
        "designs": [
          {
            "key": "130:1:0",
            "index": 0,
            "name": "brick newsroom with a sound stage behind and a lattice mast",
            "height": 0.98,
            "draft": false,
            "ops": 24,
            "attrs": {
              "newsRadius": 24,
              "newsTier": 1,
              "newsHelicopters": 0,
              "skill": [
                4,
                0.4
              ],
              "title": "TV studio"
            }
          },
          {
            "key": "130:1:1",
            "index": 1,
            "name": "white single-storey studio with a roof dish farm and a tall mast",
            "height": 1,
            "draft": false,
            "ops": 21,
            "attrs": {
              "newsRadius": 24,
              "newsTier": 1,
              "newsHelicopters": 0,
              "skill": [
                4,
                0.4
              ],
              "title": "TV studio"
            }
          }
        ]
      }
    ],
    "group": "media",
    "tier": 1,
    "blurb": "A local radio and television studio: a newsroom, a small sound stage and a mast. It reports the news of its own town and, later, sells TV airtime to advertisers.",
    "howTo": "One tile beside a road. Its channel covers 24 tiles round it, about a town; a rival player's channel that reaches the same streets competes for the stories. Needs Local television."
  },
  {
    "id": "broadcast-centre",
    "name": "broadcast centre",
    "kindId": 131,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "broadcast",
      "key": "",
      "label": "Broadcast centre",
      "color": "#b13a5a",
      "cost": 3000
    },
    "tech": [
      "med2"
    ],
    "occupation": {
      "name": "broadcast staff",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 9,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 14,
          "hours": 9,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "newsRadius": 48,
      "newsTier": 2,
      "newsHelicopters": 0,
      "skill": [
        4,
        0.5
      ],
      "title": "broadcasting house"
    },
    "tints": [
      16777215,
      15660026,
      16183786,
      15397360,
      15986422
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 26,
        "upkeep": 90,
        "cost": 3000,
        "work": 900,
        "parking": {
          "surface": 10,
          "underground": 24
        },
        "tech": [
          "med2"
        ],
        "attrs": {
          "newsRadius": 48,
          "newsTier": 2,
          "newsHelicopters": 0,
          "skill": [
            4,
            0.5
          ],
          "title": "broadcasting house"
        },
        "designs": [
          {
            "key": "131:1:0",
            "index": 0,
            "name": "glass studio block, sound stages behind, a dish yard and a lattice mast",
            "height": 1.48,
            "draft": false,
            "ops": 47,
            "attrs": {
              "newsRadius": 48,
              "newsTier": 2,
              "newsHelicopters": 0,
              "skill": [
                4,
                0.5
              ],
              "title": "broadcasting house"
            }
          },
          {
            "key": "131:1:1",
            "index": 1,
            "name": "stone broadcasting house with a round studio drum and a row of roof dishes",
            "height": 1.33,
            "draft": false,
            "ops": 42,
            "attrs": {
              "newsRadius": 48,
              "newsTier": 2,
              "newsHelicopters": 0,
              "skill": [
                4,
                0.5
              ],
              "title": "broadcasting house"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ],
      "marks": [
        {
          "kind": "stand",
          "at": [
            1,
            0
          ],
          "label": "satellite dishes"
        }
      ]
    },
    "group": "media",
    "tier": 2,
    "blurb": "A regional broadcast centre: live studios, a satellite dish yard and a lit logo. Its channel covers a whole district, and its outside-broadcast vans go out to the stories.",
    "howTo": "Two tiles by two, entrance on the left of the frontage. Covers 48 tiles round it. Needs Broadcasting."
  },
  {
    "id": "media-centre",
    "name": "media centre",
    "kindId": 132,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "mediacentre",
      "key": "",
      "label": "Media centre",
      "color": "#8e2f6e",
      "cost": 7500
    },
    "tech": [
      "med3"
    ],
    "occupation": {
      "name": "broadcast staff",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.3
        },
        {
          "start": 9,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 14,
          "hours": 9,
          "weight": 0.3
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "newsRadius": 0,
      "newsTier": 3,
      "newsHelicopters": 1,
      "skill": [
        4,
        0.6
      ],
      "title": "media centre"
    },
    "tints": [
      16777215,
      15660026,
      16183786,
      15397360,
      15986422
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 90,
        "wage": 30,
        "upkeep": 200,
        "cost": 7500,
        "work": 2000,
        "parking": {
          "surface": 20,
          "underground": 60
        },
        "tech": [
          "med3"
        ],
        "attrs": {
          "newsRadius": 0,
          "newsTier": 3,
          "newsHelicopters": 1,
          "skill": [
            4,
            0.6
          ],
          "title": "media centre"
        },
        "designs": [
          {
            "key": "132:1:0",
            "index": 0,
            "name": "glass tower with the news helipad on its roof, a big screen and a dish array",
            "height": 1.7,
            "draft": false,
            "ops": 64,
            "attrs": {
              "newsRadius": 0,
              "newsTier": 3,
              "newsHelicopters": 1,
              "skill": [
                4,
                0.6
              ],
              "title": "media centre"
            }
          },
          {
            "key": "132:1:1",
            "index": 1,
            "name": "stepped broadcast centre with a glass newsroom drum carrying the helipad, a forecourt screen and dish terraces",
            "height": 1.6,
            "draft": false,
            "ops": 60,
            "attrs": {
              "newsRadius": 0,
              "newsTier": 3,
              "newsHelicopters": 1,
              "skill": [
                4,
                0.6
              ],
              "title": "media centre"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 2,
      "door": [
        1,
        1
      ],
      "marks": [
        {
          "kind": "stand",
          "at": [
            0,
            0
          ],
          "label": "news helipad"
        },
        {
          "kind": "stand",
          "at": [
            2,
            0
          ],
          "label": "dish array"
        }
      ]
    },
    "group": "media",
    "tier": 3,
    "blurb": "A national media centre: a tower with the news helicopter on its roof, a big screen, a satellite dish array and studios for every channel. Its channel reaches the whole map.",
    "howTo": "Three tiles across and two deep, entrance in the middle of the frontage. Covers the whole map, so rival channels compete with it everywhere. Needs Media centres."
  },
  {
    "id": "eiffel-tower",
    "name": "the Eiffel Tower",
    "kindId": 133,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "eiffeltower",
      "key": "",
      "label": "Eiffel Tower",
      "color": "#6e5b48",
      "cost": 16000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "tower steward",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        23.5
      ],
      "visitorCapacity": 180,
      "ticket": 22,
      "stay": [
        1,
        2
      ],
      "leisureValue": 9,
      "radius": 34,
      "dayAppeal": 1.6,
      "eveningAppeal": 1.2,
      "retireeAppeal": 2,
      "childAppeal": 1.8,
      "title": "Eiffel Tower"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 45,
        "wage": 18,
        "upkeep": 70,
        "cost": 16000,
        "work": 3400,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            23.5
          ],
          "visitorCapacity": 180,
          "ticket": 22,
          "stay": [
            1,
            2
          ],
          "leisureValue": 9,
          "radius": 34,
          "dayAppeal": 1.6,
          "eveningAppeal": 1.2,
          "retireeAppeal": 2,
          "childAppeal": 1.8,
          "title": "Eiffel Tower"
        },
        "designs": [
          {
            "key": "133:1:0",
            "index": 0,
            "name": "the iron lace of four legs leaning together over the Champ de Mars, the two floors and the antenna above the city",
            "height": 5.13,
            "draft": false,
            "ops": 45,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                23.5
              ],
              "visitorCapacity": 180,
              "ticket": 22,
              "stay": [
                1,
                2
              ],
              "leisureValue": 9,
              "radius": 34,
              "dayAppeal": 1.6,
              "eveningAppeal": 1.2,
              "retireeAppeal": 2,
              "childAppeal": 1.8,
              "title": "Eiffel Tower"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "133:1:1",
            "index": 1,
            "name": "the iron tower on its stone plinth, the tapering legs rising to two galleries, the antenna with its red light",
            "height": 4.95,
            "draft": true,
            "ops": 19,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                23.5
              ],
              "visitorCapacity": 180,
              "ticket": 22,
              "stay": [
                1,
                2
              ],
              "leisureValue": 9,
              "radius": 34,
              "dayAppeal": 1.6,
              "eveningAppeal": 1.2,
              "retireeAppeal": 2,
              "childAppeal": 1.8,
              "title": "Eiffel Tower"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "133:1:2",
            "index": 2,
            "name": "the four-legged iron lattice with its girder belts, two galleries, the slender shaft and the red-lit antenna",
            "height": 4.95,
            "draft": true,
            "ops": 35,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                23.5
              ],
              "visitorCapacity": 180,
              "ticket": 22,
              "stay": [
                1,
                2
              ],
              "leisureValue": 9,
              "radius": 34,
              "dayAppeal": 1.6,
              "eveningAppeal": 1.2,
              "retireeAppeal": 2,
              "childAppeal": 1.8,
              "title": "Eiffel Tower"
            },
            "author": "claude-sonnet-5-5"
          },
          {
            "key": "133:1:3",
            "index": 3,
            "name": "the four splayed legs and their lattice belts, the two floors, the long shaft to the summit room and red-lit antenna",
            "height": 5.02,
            "draft": true,
            "ops": 26,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                23.5
              ],
              "visitorCapacity": 180,
              "ticket": 22,
              "stay": [
                1,
                2
              ],
              "leisureValue": 9,
              "radius": 34,
              "dayAppeal": 1.6,
              "eveningAppeal": 1.2,
              "retireeAppeal": 2,
              "childAppeal": 1.8,
              "title": "Eiffel Tower"
            },
            "author": "claude-opus-5-5"
          },
          {
            "key": "133:1:4",
            "index": 4,
            "name": "the legs bending in from four stone feet through the great arches to the first floor, the second stage, the needle in three shades of brown",
            "height": 5.06,
            "draft": true,
            "ops": 65,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                23.5
              ],
              "visitorCapacity": 180,
              "ticket": 22,
              "stay": [
                1,
                2
              ],
              "leisureValue": 9,
              "radius": 34,
              "dayAppeal": 1.6,
              "eveningAppeal": 1.2,
              "retireeAppeal": 2,
              "childAppeal": 1.8,
              "title": "Eiffel Tower"
            },
            "author": "claude-fable-5-1"
          },
          {
            "key": "133:1:5",
            "index": 5,
            "name": "the bronze needle: slimmer legs, two cross-braced rings and one long taper to the antenna",
            "height": 5.51,
            "draft": true,
            "ops": 45,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                23.5
              ],
              "visitorCapacity": 180,
              "ticket": 22,
              "stay": [
                1,
                2
              ],
              "leisureValue": 9,
              "radius": 34,
              "dayAppeal": 1.6,
              "eveningAppeal": 1.2,
              "retireeAppeal": 2,
              "childAppeal": 1.8,
              "title": "Eiffel Tower"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "paris",
    "tier": 1,
    "blurb": "The 1889 iron lady of the Champ de Mars: four arched legs leaning 312 metres into the sky, the two galleries with the whole of Paris below, and the sparking antenna over it all.",
    "howTo": "A 2×2 plot open to the street, lawns around. A day-and-night attraction that draws everyone in the city, so give it a metro or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "paris"
    ]
  },
  {
    "id": "arc-de-triomphe",
    "name": "the Arc de Triomphe",
    "kindId": 134,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "arcdetriomphe",
      "key": "",
      "label": "Arc de Triomphe",
      "color": "#cfc5ae",
      "cost": 11000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "memorial keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        10,
        19
      ],
      "visitorCapacity": 110,
      "ticket": 14,
      "stay": [
        0.6,
        1.2
      ],
      "leisureValue": 7,
      "radius": 26,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.3,
      "retireeAppeal": 2.4,
      "childAppeal": 1.2,
      "title": "Arc de Triomphe"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 26,
        "wage": 16,
        "upkeep": 55,
        "cost": 11000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            10,
            19
          ],
          "visitorCapacity": 110,
          "ticket": 14,
          "stay": [
            0.6,
            1.2
          ],
          "leisureValue": 7,
          "radius": 26,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.3,
          "retireeAppeal": 2.4,
          "childAppeal": 1.2,
          "title": "Arc de Triomphe"
        },
        "designs": [
          {
            "key": "134:1:0",
            "index": 0,
            "name": "the great arch on its roundabout, the vault over the unknown soldier, the friezes of the attic above",
            "height": 1.66,
            "draft": false,
            "ops": 31,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 14,
              "stay": [
                0.6,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Arc de Triomphe"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "134:1:1",
            "index": 1,
            "name": "an open stepped vault with eleven voussoirs, sculpted piers and a friezed attic over the eternal flame",
            "height": 1.5,
            "draft": true,
            "ops": 74,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 14,
              "stay": [
                0.6,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Arc de Triomphe"
            },
            "author": "k3.1-pro"
          },
          {
            "key": "134:1:2",
            "index": 2,
            "name": "the arch on its roundabout, two piers and the dark archway, the attic and stepped roof above",
            "height": 1.34,
            "draft": true,
            "ops": 21,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 14,
              "stay": [
                0.6,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Arc de Triomphe"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "134:1:3",
            "index": 3,
            "name": "the great arch on its roundabout, two sculpted piers around the dark vault, the friezed attic and stepped crown",
            "height": 1.27,
            "draft": true,
            "ops": 28,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 14,
              "stay": [
                0.6,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Arc de Triomphe"
            },
            "author": "claude-sonnet-5-5"
          },
          {
            "key": "134:1:4",
            "index": 4,
            "name": "the arch on the paved Étoile, two sculpted piers and the open vault, side arches, the attic and its cornices",
            "height": 1.44,
            "draft": true,
            "ops": 25,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 14,
              "stay": [
                0.6,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Arc de Triomphe"
            },
            "author": "claude-opus-5-5"
          },
          {
            "key": "134:1:5",
            "index": 5,
            "name": "the arch in its true proportions on the twelve-avenue star, the round-headed vault, the frieze, the attic and its shields",
            "height": 1.5,
            "draft": true,
            "ops": 44,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 14,
              "stay": [
                0.6,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Arc de Triomphe"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "paris",
    "tier": 2,
    "blurb": "Napoleon's 50-metre arch at the top of the Champs-Elysees: the vault over the unknown soldier, his flame still lit, the friezes of the great attic above the roundabout.",
    "howTo": "A 2×2 plot open to the street; a daytime outing for retirees and school trips, best with a metro or buses nearby. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "paris"
    ]
  },
  {
    "id": "notre-dame",
    "name": "Notre-Dame",
    "kindId": 135,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "notredame",
      "key": "",
      "label": "Notre-Dame",
      "color": "#c9c0a8",
      "cost": 12000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "verger",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        19.5
      ],
      "visitorCapacity": 150,
      "ticket": 0,
      "stay": [
        0.6,
        1.4
      ],
      "leisureValue": 8,
      "radius": 28,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.4,
      "retireeAppeal": 2.2,
      "childAppeal": 1.3,
      "title": "Notre-Dame"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 15,
        "upkeep": 50,
        "cost": 12000,
        "work": 2600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            19.5
          ],
          "visitorCapacity": 150,
          "ticket": 0,
          "stay": [
            0.6,
            1.4
          ],
          "leisureValue": 8,
          "radius": 28,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.4,
          "retireeAppeal": 2.2,
          "childAppeal": 1.3,
          "title": "Notre-Dame"
        },
        "designs": [
          {
            "key": "135:1:0",
            "index": 0,
            "name": "the twin-towered west front with the rose window, the lead spire over the crossing, the flying buttresses of the apse",
            "height": 1.4,
            "draft": false,
            "ops": 47,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19.5
              ],
              "visitorCapacity": 150,
              "ticket": 0,
              "stay": [
                0.6,
                1.4
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2.2,
              "childAppeal": 1.3,
              "title": "Notre-Dame"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "135:1:1",
            "index": 1,
            "name": "double aisles and a transept, open belfries, a round rose and eight flying buttresses under the flèche",
            "height": 1.69,
            "draft": true,
            "ops": 71,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19.5
              ],
              "visitorCapacity": 150,
              "ticket": 0,
              "stay": [
                0.6,
                1.4
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2.2,
              "childAppeal": 1.3,
              "title": "Notre-Dame"
            },
            "author": "k3.1-pro"
          },
          {
            "key": "135:1:2",
            "index": 2,
            "name": "the nave under its slate roof, the west front with two towers and the rose window, the lead spire at the crossing",
            "height": 1.25,
            "draft": true,
            "ops": 31,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19.5
              ],
              "visitorCapacity": 150,
              "ticket": 0,
              "stay": [
                0.6,
                1.4
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2.2,
              "childAppeal": 1.3,
              "title": "Notre-Dame"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "135:1:3",
            "index": 3,
            "name": "the high nave with aisles and flying buttresses, the flat-topped west towers and rose window, the lead flèche",
            "height": 1.31,
            "draft": true,
            "ops": 48,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19.5
              ],
              "visitorCapacity": 150,
              "ticket": 0,
              "stay": [
                0.6,
                1.4
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2.2,
              "childAppeal": 1.3,
              "title": "Notre-Dame"
            },
            "author": "claude-sonnet-5-5"
          },
          {
            "key": "135:1:4",
            "index": 4,
            "name": "the cruciform nave and transept under lead, the round apse, flat-topped twin towers and rose, the flèche",
            "height": 1.67,
            "draft": true,
            "ops": 35,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19.5
              ],
              "visitorCapacity": 150,
              "ticket": 0,
              "stay": [
                0.6,
                1.4
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2.2,
              "childAppeal": 1.3,
              "title": "Notre-Dame"
            },
            "author": "claude-opus-5-5"
          },
          {
            "key": "135:1:5",
            "index": 5,
            "name": "the whole plan in one piece: double aisles, the fan of flyers round the chevet, the round rose between flat-topped towers, the lead flèche",
            "height": 1.5,
            "draft": true,
            "ops": 69,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19.5
              ],
              "visitorCapacity": 150,
              "ticket": 0,
              "stay": [
                0.6,
                1.4
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2.2,
              "childAppeal": 1.3,
              "title": "Notre-Dame"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "paris",
    "tier": 3,
    "blurb": "The cathedral of Paris on its island: the twin west towers over the rose window, the lead spire flying from the crossing, buttresses stepping over the Seine-side apse.",
    "howTo": "A 2×2 plot by the water suits it; a quiet day out for retirees and school trips, no ticket needed. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "paris"
    ]
  },
  {
    "id": "louvre",
    "name": "the Louvre",
    "kindId": 136,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "louvre",
      "key": "",
      "label": "the Louvre",
      "color": "#d6cbb2",
      "cost": 20000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "museum curator",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        21
      ],
      "visitorCapacity": 260,
      "ticket": 26,
      "stay": [
        1.4,
        2.6
      ],
      "leisureValue": 9,
      "radius": 32,
      "dayAppeal": 1.7,
      "eveningAppeal": 0.5,
      "retireeAppeal": 1.8,
      "childAppeal": 1.6,
      "title": "the Louvre"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 60,
        "wage": 19,
        "upkeep": 85,
        "cost": 20000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            21
          ],
          "visitorCapacity": 260,
          "ticket": 26,
          "stay": [
            1.4,
            2.6
          ],
          "leisureValue": 9,
          "radius": 32,
          "dayAppeal": 1.7,
          "eveningAppeal": 0.5,
          "retireeAppeal": 1.8,
          "childAppeal": 1.6,
          "title": "the Louvre"
        },
        "designs": [
          {
            "key": "136:1:0",
            "index": 0,
            "name": "the three wings of the Cour Napoleon under their slate roofs, the glass pyramid between the two fountains",
            "height": 0.66,
            "draft": false,
            "ops": 20,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 260,
              "ticket": 26,
              "stay": [
                1.4,
                2.6
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.8,
              "childAppeal": 1.6,
              "title": "the Louvre"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "136:1:1",
            "index": 1,
            "name": "four steep-roofed pavilions around the Cour Napoléon, a clock dome and a banded glass pyramid with two smaller companions",
            "height": 1.22,
            "draft": true,
            "ops": 74,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 260,
              "ticket": 26,
              "stay": [
                1.4,
                2.6
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.8,
              "childAppeal": 1.6,
              "title": "the Louvre"
            },
            "author": "k3.1-pro"
          },
          {
            "key": "136:1:2",
            "index": 2,
            "name": "three stone wings under slate roofs around the court, the glass pyramid and its fountain basins",
            "height": 0.68,
            "draft": true,
            "ops": 20,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 260,
              "ticket": 26,
              "stay": [
                1.4,
                2.6
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.8,
              "childAppeal": 1.6,
              "title": "the Louvre"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "136:1:3",
            "index": 3,
            "name": "the mansard-roofed wings round the Cour Napoléon, the tall central pavilion, the glass pyramid and its satellites",
            "height": 0.77,
            "draft": true,
            "ops": 29,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 260,
              "ticket": 26,
              "stay": [
                1.4,
                2.6
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.8,
              "childAppeal": 1.6,
              "title": "the Louvre"
            },
            "author": "claude-sonnet-5-5"
          },
          {
            "key": "136:1:4",
            "index": 4,
            "name": "the mansarded wings and corner pavilions round the court, the Pavillon de l'Horloge, the pyramid and its sisters",
            "height": 0.86,
            "draft": true,
            "ops": 26,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 260,
              "ticket": 26,
              "stay": [
                1.4,
                2.6
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.8,
              "childAppeal": 1.6,
              "title": "the Louvre"
            },
            "author": "claude-opus-5-5"
          },
          {
            "key": "136:1:5",
            "index": 5,
            "name": "three pavilions a wing under steep slate roofs, the Horloge dome, the pyramid in its real ratio, the Carrousel arch at the open end",
            "height": 0.9,
            "draft": true,
            "ops": 54,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                21
              ],
              "visitorCapacity": 260,
              "ticket": 26,
              "stay": [
                1.4,
                2.6
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.8,
              "childAppeal": 1.6,
              "title": "the Louvre"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "paris",
    "tier": 4,
    "blurb": "The palace of the kings turned museum: three wings closing the Cour Napoleon under their slate roofs, and the glass pyramid rising between the fountains to light the halls below.",
    "howTo": "A 2×2 plot open to the street, lawns suit it; the grandest museum in the city, drawing visitors all day, so give it a metro or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "paris"
    ]
  },
  {
    "id": "opera-garnier",
    "name": "the Opéra Garnier",
    "kindId": 137,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "operagarnier",
      "key": "",
      "label": "Opéra Garnier",
      "color": "#5f8f6f",
      "cost": 14000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "opera house staff",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        13,
        24
      ],
      "visitorCapacity": 200,
      "ticket": 30,
      "stay": [
        2.2,
        3.2
      ],
      "leisureValue": 10,
      "radius": 30,
      "eventNights": [
        2,
        4,
        5,
        6
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.15,
      "eveningAppeal": 1.5,
      "retireeAppeal": 1.4,
      "childAppeal": 0.4,
      "title": "the Opéra Garnier"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 20,
        "upkeep": 100,
        "cost": 14000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 30
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            13,
            24
          ],
          "visitorCapacity": 200,
          "ticket": 30,
          "stay": [
            2.2,
            3.2
          ],
          "leisureValue": 10,
          "radius": 30,
          "eventNights": [
            2,
            4,
            5,
            6
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.15,
          "eveningAppeal": 1.5,
          "retireeAppeal": 1.4,
          "childAppeal": 0.4,
          "title": "the Opéra Garnier"
        },
        "designs": [
          {
            "key": "137:1:0",
            "index": 0,
            "name": "the columned opera house under its green dome, the stage tower rising behind",
            "height": 1.1,
            "draft": false,
            "ops": 32,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                13,
                24
              ],
              "visitorCapacity": 200,
              "ticket": 30,
              "stay": [
                2.2,
                3.2
              ],
              "leisureValue": 10,
              "radius": 30,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.5,
              "retireeAppeal": 1.4,
              "childAppeal": 0.4,
              "title": "the Opéra Garnier"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "137:1:1",
            "index": 1,
            "name": "the colonnaded opera front under its roof, the green dome at the corner, the stage house behind",
            "height": 1.08,
            "draft": true,
            "ops": 26,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                13,
                24
              ],
              "visitorCapacity": 200,
              "ticket": 30,
              "stay": [
                2.2,
                3.2
              ],
              "leisureValue": 10,
              "radius": 30,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.5,
              "retireeAppeal": 1.4,
              "childAppeal": 0.4,
              "title": "the Opéra Garnier"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "137:1:2",
            "index": 2,
            "name": "the arcaded front between two gilded pavilions, the great green cupola and the stage house behind",
            "height": 1.24,
            "draft": true,
            "ops": 42,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                13,
                24
              ],
              "visitorCapacity": 200,
              "ticket": 30,
              "stay": [
                2.2,
                3.2
              ],
              "leisureValue": 10,
              "radius": 30,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.5,
              "retireeAppeal": 1.4,
              "childAppeal": 0.4,
              "title": "the Opéra Garnier"
            },
            "author": "claude-sonnet-5-5"
          },
          {
            "key": "137:1:3",
            "index": 3,
            "name": "the loggia between domed end pavilions, the crowned copper dome, the gabled stage house with Apollo",
            "height": 1.28,
            "draft": true,
            "ops": 31,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                13,
                24
              ],
              "visitorCapacity": 200,
              "ticket": 30,
              "stay": [
                2.2,
                3.2
              ],
              "leisureValue": 10,
              "radius": 30,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.5,
              "retireeAppeal": 1.4,
              "childAppeal": 0.4,
              "title": "the Opéra Garnier"
            },
            "author": "claude-opus-5-5"
          },
          {
            "key": "137:1:4",
            "index": 4,
            "name": "the arcaded loggia between the two rotundas, the low wide copper dome, the stone pediment of the stage house with Apollo",
            "height": 1.29,
            "draft": true,
            "ops": 44,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                13,
                24
              ],
              "visitorCapacity": 200,
              "ticket": 30,
              "stay": [
                2.2,
                3.2
              ],
              "leisureValue": 10,
              "radius": 30,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.5,
              "retireeAppeal": 1.4,
              "childAppeal": 0.4,
              "title": "the Opéra Garnier"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "paris",
    "tier": 5,
    "blurb": "The opera house Charles Garnier built for Napoleon the Third: the columned front under the green copper dome, and behind it the great stage where the chandelier fell.",
    "howTo": "A 2×2 plot on a busy street near restaurants and bars for the pre-show crowd; it fills on show nights. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "paris"
    ]
  },
  {
    "id": "sacre-coeur",
    "name": "the Sacré-Cœur",
    "kindId": 138,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "sacrecoeur",
      "key": "",
      "label": "Sacré-Cœur",
      "color": "#f2ede4",
      "cost": 10000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "sacristan",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        20
      ],
      "visitorCapacity": 130,
      "ticket": 0,
      "stay": [
        0.5,
        1.2
      ],
      "leisureValue": 7,
      "radius": 26,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.5,
      "retireeAppeal": 2.4,
      "childAppeal": 1.2,
      "title": "Sacré-Cœur"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 15,
        "upkeep": 45,
        "cost": 10000,
        "work": 2200,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            20
          ],
          "visitorCapacity": 130,
          "ticket": 0,
          "stay": [
            0.5,
            1.2
          ],
          "leisureValue": 7,
          "radius": 26,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.5,
          "retireeAppeal": 2.4,
          "childAppeal": 1.2,
          "title": "Sacré-Cœur"
        },
        "designs": [
          {
            "key": "138:1:0",
            "index": 0,
            "name": "the white basilica on its terrace above the steps, the great dome and the bell tower over the city",
            "height": 1.13,
            "draft": false,
            "ops": 31,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                20
              ],
              "visitorCapacity": 130,
              "ticket": 0,
              "stay": [
                0.5,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.5,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Sacré-Cœur"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "138:1:1",
            "index": 1,
            "name": "a triple-arched portico and ribbed central dome above the Montmartre stair, with four small domes and a rear campanile",
            "height": 1.78,
            "draft": true,
            "ops": 61,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                20
              ],
              "visitorCapacity": 130,
              "ticket": 0,
              "stay": [
                0.5,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.5,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Sacré-Cœur"
            },
            "author": "k3.1-pro"
          },
          {
            "key": "138:1:2",
            "index": 2,
            "name": "the white basilica on its terrace over the steps, the great dome and the square bell tower",
            "height": 1.27,
            "draft": true,
            "ops": 26,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                20
              ],
              "visitorCapacity": 130,
              "ticket": 0,
              "stay": [
                0.5,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.5,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Sacré-Cœur"
            },
            "author": "claude-haiku-5-5"
          },
          {
            "key": "138:1:3",
            "index": 3,
            "name": "the white basilica on its terrace, the portico, the great ovoid dome with four lesser domes, the campanile",
            "height": 1.37,
            "draft": true,
            "ops": 32,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                20
              ],
              "visitorCapacity": 130,
              "ticket": 0,
              "stay": [
                0.5,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.5,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Sacré-Cœur"
            },
            "author": "claude-sonnet-5-5"
          },
          {
            "key": "138:1:4",
            "index": 4,
            "name": "the white basilica above its steps, the tall ovoid dome and lantern, four lesser domes, the campanile behind",
            "height": 1.48,
            "draft": true,
            "ops": 36,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                20
              ],
              "visitorCapacity": 130,
              "ticket": 0,
              "stay": [
                0.5,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.5,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Sacré-Cœur"
            },
            "author": "claude-opus-5-5"
          },
          {
            "key": "138:1:5",
            "index": 5,
            "name": "the ovoid domes over the grass embankment and its stair, the arcaded drum, the campanile as tall as the dome",
            "height": 1.46,
            "draft": true,
            "ops": 71,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                20
              ],
              "visitorCapacity": 130,
              "ticket": 0,
              "stay": [
                0.5,
                1.2
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.5,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "Sacré-Cœur"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "paris",
    "tier": 6,
    "blurb": "The white basilica on the hill of Montmartre, its travertine bright over the rooftops: the great dome over the crossing, the bell tower, and the steps where the city lies below.",
    "howTo": "A 2×2 plot, lawns below the terrace; a quiet free visit for retirees and evening strollers, best with a metro nearby. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "paris"
    ]
  },
  {
    "id": "colosseum",
    "name": "the Colosseum",
    "kindId": 141,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "colosseum",
      "key": "",
      "label": "Colosseum",
      "color": "#d8c9a4",
      "cost": 15000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "amphitheatre guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        19.5
      ],
      "visitorCapacity": 200,
      "ticket": 18,
      "stay": [
        1,
        2
      ],
      "leisureValue": 8,
      "radius": 30,
      "dayAppeal": 1.7,
      "eveningAppeal": 0.3,
      "retireeAppeal": 2,
      "childAppeal": 1.9,
      "title": "the Colosseum"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 48,
        "wage": 17,
        "upkeep": 65,
        "cost": 15000,
        "work": 3200,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            19.5
          ],
          "visitorCapacity": 200,
          "ticket": 18,
          "stay": [
            1,
            2
          ],
          "leisureValue": 8,
          "radius": 30,
          "dayAppeal": 1.7,
          "eveningAppeal": 0.3,
          "retireeAppeal": 2,
          "childAppeal": 1.9,
          "title": "the Colosseum"
        },
        "designs": [
          {
            "key": "141:1:0",
            "index": 0,
            "name": "the amphitheatre of the emperors, the arena and the receding rings of arches",
            "height": 0.7,
            "draft": false,
            "ops": 17,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19.5
              ],
              "visitorCapacity": 200,
              "ticket": 18,
              "stay": [
                1,
                2
              ],
              "leisureValue": 8,
              "radius": 30,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2,
              "childAppeal": 1.9,
              "title": "the Colosseum"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "141:1:1",
            "index": 1,
            "name": "three open arcaded rings, a broken upper rim and the excavated hypogeum in the arena",
            "height": 0.82,
            "draft": true,
            "ops": 176,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19.5
              ],
              "visitorCapacity": 200,
              "ticket": 18,
              "stay": [
                1,
                2
              ],
              "leisureValue": 8,
              "radius": 30,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.3,
              "retireeAppeal": 2,
              "childAppeal": 1.9,
              "title": "the Colosseum"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rome",
    "tier": 1,
    "blurb": "The amphitheatre of the emperors on the Via Sacra, fifty thousand Romans roaring over the sand below: the arena, the bowl of the cavea, and the three receding storeys of arches.",
    "howTo": "A 2×2 plot open to the street; a busy daytime outing for the whole city, so give it a metro or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rome"
    ]
  },
  {
    "id": "st-peters",
    "name": "St Peter's Basilica",
    "kindId": 142,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "stpeters",
      "key": "",
      "label": "St Peter's",
      "color": "#e8e0cc",
      "cost": 18000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "basilica verger",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        7,
        19
      ],
      "visitorCapacity": 240,
      "ticket": 0,
      "stay": [
        0.8,
        1.8
      ],
      "leisureValue": 9,
      "radius": 32,
      "dayAppeal": 1.7,
      "eveningAppeal": 0.5,
      "retireeAppeal": 2.2,
      "childAppeal": 1.4,
      "title": "St Peter's Basilica"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 55,
        "wage": 16,
        "upkeep": 70,
        "cost": 18000,
        "work": 3600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            7,
            19
          ],
          "visitorCapacity": 240,
          "ticket": 0,
          "stay": [
            0.8,
            1.8
          ],
          "leisureValue": 9,
          "radius": 32,
          "dayAppeal": 1.7,
          "eveningAppeal": 0.5,
          "retireeAppeal": 2.2,
          "childAppeal": 1.4,
          "title": "St Peter's Basilica"
        },
        "designs": [
          {
            "key": "142:1:0",
            "index": 0,
            "name": "the great church of the popes, the dome over the crossing, the colonnaded square with the obelisk",
            "height": 1.03,
            "draft": false,
            "ops": 45,
            "attrs": {
              "venueType": "library",
              "openHours": [
                7,
                19
              ],
              "visitorCapacity": 240,
              "ticket": 0,
              "stay": [
                0.8,
                1.8
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.5,
              "retireeAppeal": 2.2,
              "childAppeal": 1.4,
              "title": "St Peter's Basilica"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "142:1:1",
            "index": 1,
            "name": "a columned facade with rooftop saints, a ribbed great dome and two small domes around the elliptical square",
            "height": 1.45,
            "draft": true,
            "ops": 106,
            "attrs": {
              "venueType": "library",
              "openHours": [
                7,
                19
              ],
              "visitorCapacity": 240,
              "ticket": 0,
              "stay": [
                0.8,
                1.8
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.5,
              "retireeAppeal": 2.2,
              "childAppeal": 1.4,
              "title": "St Peter's Basilica"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rome",
    "tier": 2,
    "blurb": "The great church of the popes west of the Tiber: Michelangelo's dome swelling over the crossing, and before it the colonnaded square where the obelisk has stood since the year 1586.",
    "howTo": "A 2×2 plot open at the front for the square; the grandest free visit in the city, drawing visitors all day, so give it a metro or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rome"
    ]
  },
  {
    "id": "pantheon",
    "name": "the Pantheon",
    "kindId": 143,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "pantheon",
      "key": "",
      "label": "Pantheon",
      "color": "#a5765a",
      "cost": 9000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "temple keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        19
      ],
      "visitorCapacity": 90,
      "ticket": 0,
      "stay": [
        0.4,
        1
      ],
      "leisureValue": 7,
      "radius": 22,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.8,
      "childAppeal": 1.2,
      "title": "the Pantheon"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 18,
        "wage": 14,
        "upkeep": 40,
        "cost": 9000,
        "work": 2000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            19
          ],
          "visitorCapacity": 90,
          "ticket": 0,
          "stay": [
            0.4,
            1
          ],
          "leisureValue": 7,
          "radius": 22,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.8,
          "childAppeal": 1.2,
          "title": "the Pantheon"
        },
        "designs": [
          {
            "key": "143:1:0",
            "index": 0,
            "name": "the temple of all the gods, the columns and pediment before the great dome with its rings",
            "height": 0.54,
            "draft": false,
            "ops": 24,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 90,
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "leisureValue": 7,
              "radius": 22,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.8,
              "childAppeal": 1.2,
              "title": "the Pantheon"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "143:1:1",
            "index": 1,
            "name": "sixteen granite columns before the brick drum, a five-stepped dome with an open oculus and the piazza obelisk",
            "height": 0.853,
            "draft": true,
            "ops": 88,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 90,
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "leisureValue": 7,
              "radius": 22,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.8,
              "childAppeal": 1.2,
              "title": "the Pantheon"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rome",
    "tier": 3,
    "blurb": "The temple of all the gods, two thousand years a church: the columns and pediment on the piazza, and behind them the brick rotunda whose dome, a perfect hemisphere, still has no equal.",
    "howTo": "A 2×2 plot in the old town among shops and cafes; a short quiet visit between the grander sights, no ticket needed. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rome"
    ]
  },
  {
    "id": "trevi-fountain",
    "name": "the Trevi Fountain",
    "kindId": 144,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "trevi",
      "key": "",
      "label": "Trevi Fountain",
      "color": "#d0bf9c",
      "cost": 8000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "fountain keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        21.5
      ],
      "visitorCapacity": 100,
      "ticket": 0,
      "stay": [
        0.3,
        0.8
      ],
      "leisureValue": 7,
      "radius": 20,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.8,
      "retireeAppeal": 1.6,
      "childAppeal": 1.6,
      "title": "the Trevi Fountain"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 16,
        "wage": 14,
        "upkeep": 35,
        "cost": 8000,
        "work": 1600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            21.5
          ],
          "visitorCapacity": 100,
          "ticket": 0,
          "stay": [
            0.3,
            0.8
          ],
          "leisureValue": 7,
          "radius": 20,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.8,
          "retireeAppeal": 1.6,
          "childAppeal": 1.6,
          "title": "the Trevi Fountain"
        },
        "designs": [
          {
            "key": "144:1:0",
            "index": 0,
            "name": "the fountain of the waters, the arch and Oceanus above the cascade into the great basin",
            "height": 0.52,
            "draft": false,
            "ops": 20,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                21.5
              ],
              "visitorCapacity": 100,
              "ticket": 0,
              "stay": [
                0.3,
                0.8
              ],
              "leisureValue": 7,
              "radius": 20,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.8,
              "retireeAppeal": 1.6,
              "childAppeal": 1.6,
              "title": "the Trevi Fountain"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rome",
    "tier": 4,
    "blurb": "The fountain of the waters against the palace wall: the arch and its niche, the little figure of Oceanus white above the cascade, and the basin where a coin promises a return to Rome.",
    "howTo": "A 2×2 plot tucked into the old town among shops and cafes; a short free visit that glows at night, best near restaurants. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rome"
    ]
  },
  {
    "id": "altare-della-patria",
    "name": "the Altare della Patria",
    "kindId": 145,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "altare",
      "key": "",
      "label": "Altare della Patria",
      "color": "#f0ece2",
      "cost": 9000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "memorial guard",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        20
      ],
      "visitorCapacity": 80,
      "ticket": 0,
      "stay": [
        0.4,
        0.9
      ],
      "leisureValue": 6,
      "radius": 22,
      "dayAppeal": 1.2,
      "eveningAppeal": 0.4,
      "retireeAppeal": 2,
      "childAppeal": 1,
      "title": "the Altare della Patria"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 14,
        "wage": 15,
        "upkeep": 40,
        "cost": 9000,
        "work": 1800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            20
          ],
          "visitorCapacity": 80,
          "ticket": 0,
          "stay": [
            0.4,
            0.9
          ],
          "leisureValue": 6,
          "radius": 22,
          "dayAppeal": 1.2,
          "eveningAppeal": 0.4,
          "retireeAppeal": 2,
          "childAppeal": 1,
          "title": "the Altare della Patria"
        },
        "designs": [
          {
            "key": "145:1:0",
            "index": 0,
            "name": "the white terraces and colonnades of the Vittoriano, the unknown soldier with his flame",
            "height": 0.51,
            "draft": false,
            "ops": 30,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                20
              ],
              "visitorCapacity": 80,
              "ticket": 0,
              "stay": [
                0.4,
                0.9
              ],
              "leisureValue": 6,
              "radius": 22,
              "dayAppeal": 1.2,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2,
              "childAppeal": 1,
              "title": "the Altare della Patria"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rome",
    "tier": 5,
    "blurb": "The wedding cake of white marble at Piazza Venezia: the terraces, the grand staircase, the colonnade across the top, and between its columns the unknown soldier, his flame never out.",
    "howTo": "A 2×2 plot on a grand avenue; a short free visit that suits a ceremonial part of town. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rome"
    ]
  },
  {
    "id": "castel-sant-angelo",
    "name": "Castel Sant'Angelo",
    "kindId": 146,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "castelsangelo",
      "key": "",
      "label": "Castel Sant'Angelo",
      "color": "#cbbfa5",
      "cost": 8000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "castle warder",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        19.5
      ],
      "visitorCapacity": 70,
      "ticket": 12,
      "stay": [
        0.6,
        1.2
      ],
      "leisureValue": 6,
      "radius": 22,
      "dayAppeal": 1.2,
      "eveningAppeal": 0.5,
      "retireeAppeal": 1.6,
      "childAppeal": 1.2,
      "title": "Castel Sant'Angelo"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 12,
        "wage": 15,
        "upkeep": 35,
        "cost": 8000,
        "work": 1600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            19.5
          ],
          "visitorCapacity": 70,
          "ticket": 12,
          "stay": [
            0.6,
            1.2
          ],
          "leisureValue": 6,
          "radius": 22,
          "dayAppeal": 1.2,
          "eveningAppeal": 0.5,
          "retireeAppeal": 1.6,
          "childAppeal": 1.2,
          "title": "Castel Sant'Angelo"
        },
        "designs": [
          {
            "key": "146:1:0",
            "index": 0,
            "name": "the mausoleum of Hadrian, the round keep with the archangel on his tower",
            "height": 0.8,
            "draft": false,
            "ops": 32,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19.5
              ],
              "visitorCapacity": 70,
              "ticket": 12,
              "stay": [
                0.6,
                1.2
              ],
              "leisureValue": 6,
              "radius": 22,
              "dayAppeal": 1.2,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.6,
              "childAppeal": 1.2,
              "title": "Castel Sant'Angelo"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rome",
    "tier": 6,
    "blurb": "The mausoleum of Hadrian on the Tiber, a castle for a thousand years: the great round drum, the keep with its battlements, and the archangel on his tower whose sheathed sword marks the end of the plague.",
    "howTo": "A 2×2 plot by the water suits the old fortress; a modest ticketed visit, prettiest from across the river. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rome"
    ]
  },
  {
    "id": "funeral-director",
    "name": "funeral director",
    "kindId": 150,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "shop",
    "tool": {
      "id": "funeral",
      "key": "",
      "label": "Funeral director",
      "color": "#2b2b33",
      "cost": 600
    },
    "tech": [
      "rem1"
    ],
    "occupation": {
      "name": "funeral staff",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 9,
          "weight": 0.75
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.25
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          1,
          1,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          0,
          1,
          1,
          0,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "funeral": 1,
      "fee": 220,
      "title": "funeral director"
    },
    "tints": [
      16777215,
      15921128,
      15659250
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 6,
        "wage": 18,
        "upkeep": 12,
        "cost": 600,
        "work": 300,
        "parking": {
          "surface": 2,
          "underground": 4
        },
        "tech": [
          "rem1"
        ],
        "attrs": {
          "funeral": 1,
          "fee": 220,
          "title": "funeral director"
        },
        "designs": [
          {
            "key": "150:1:0",
            "index": 0,
            "name": "Victorian brick undertaker's with a black fascia and a coach arch",
            "height": 0.6,
            "draft": false,
            "ops": 13,
            "attrs": {
              "funeral": 1,
              "fee": 220,
              "title": "funeral director"
            }
          },
          {
            "key": "150:1:1",
            "index": 1,
            "name": "pale stone chapel of rest with a porch and a hearse at the door",
            "height": 0.52,
            "draft": false,
            "ops": 19,
            "attrs": {
              "funeral": 1,
              "fee": 220,
              "title": "funeral director"
            }
          }
        ]
      }
    ],
    "blurb": "An undertaker's on the high street: a chapel of rest, a hearse and the staff to arrange a funeral. It collects the dead, holds the service at a chapel or crematorium and is paid from the estate.",
    "howTo": "One tile beside a road, within 60 tiles of the homes it serves. It needs a churchyard, cemetery or crematorium to take its funerals to. Needs Remembrance."
  },
  {
    "id": "churchyard",
    "name": "churchyard",
    "kindId": 151,
    "code": 10,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "churchyard",
      "key": "",
      "label": "Churchyard",
      "color": "#6f8a5c",
      "cost": 700
    },
    "tech": [
      "rem1"
    ],
    "attrs": {
      "venueType": "park",
      "openHours": [
        8,
        20
      ],
      "ticket": 0,
      "stay": [
        0.4,
        1
      ],
      "dayAppeal": 0.3,
      "eveningAppeal": 0.04,
      "retireeAppeal": 1.1,
      "childAppeal": 0.05,
      "trees": 0,
      "benches": 0,
      "rest": "burial"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 6,
        "cost": 700,
        "work": 360,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "rem1"
        ],
        "attrs": {
          "venueType": "park",
          "openHours": [
            8,
            20
          ],
          "ticket": 0,
          "stay": [
            0.4,
            1
          ],
          "dayAppeal": 0.3,
          "eveningAppeal": 0.04,
          "retireeAppeal": 1.1,
          "childAppeal": 0.05,
          "trees": 0,
          "benches": 0,
          "rest": "burial",
          "title": "churchyard",
          "visitorCapacity": 6,
          "leisureValue": 1.5,
          "radius": 8,
          "fee": 120,
          "plotCount": 29
        },
        "designs": [
          {
            "key": "151:1:0",
            "index": 0,
            "name": "flint chapel with a bell-cote, a lych-gate and old yews",
            "height": 0.76,
            "draft": false,
            "ops": 34,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "dayAppeal": 0.3,
              "eveningAppeal": 0.04,
              "retireeAppeal": 1.1,
              "childAppeal": 0.05,
              "trees": 0,
              "benches": 0,
              "rest": "burial",
              "title": "churchyard",
              "visitorCapacity": 6,
              "leisureValue": 1.5,
              "radius": 8,
              "fee": 120,
              "plotCount": 29,
              "plots": [
                -0.18,
                -0.66,
                0.78,
                0.74,
                5,
                5,
                -0.92,
                0.2,
                -0.6,
                0.76,
                2,
                2
              ]
            }
          },
          {
            "key": "151:1:1",
            "index": 1,
            "name": "stone chapel with a squat tower and a gravel walk round the graves",
            "height": 0.82,
            "draft": false,
            "ops": 36,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "dayAppeal": 0.3,
              "eveningAppeal": 0.04,
              "retireeAppeal": 1.1,
              "childAppeal": 0.05,
              "trees": 0,
              "benches": 0,
              "rest": "burial",
              "title": "churchyard",
              "visitorCapacity": 6,
              "leisureValue": 1.5,
              "radius": 8,
              "fee": 120,
              "plotCount": 29,
              "plots": [
                -0.92,
                -0.86,
                -0.62,
                0.22,
                2,
                5,
                -0.32,
                -0.22,
                0.82,
                0.8,
                6,
                4
              ]
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ]
    },
    "group": "remembrance",
    "tier": 1,
    "blurb": "A small chapel in a walled yard of graves under the yews: the cheapest place to bury your dead, with room for about thirty.",
    "howTo": "A 2×2 plot beside a road among homes. A funeral director brings its funerals here; when the plots are full, build a cemetery or a crematorium. Needs Remembrance."
  },
  {
    "id": "municipal-cemetery",
    "name": "municipal cemetery",
    "kindId": 152,
    "code": 10,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "cemetery",
      "key": "",
      "label": "Cemetery",
      "color": "#5d7a52",
      "cost": 1400
    },
    "tech": [
      "rem1"
    ],
    "attrs": {
      "venueType": "park",
      "openHours": [
        8,
        20
      ],
      "ticket": 0,
      "stay": [
        0.4,
        1
      ],
      "dayAppeal": 0.3,
      "eveningAppeal": 0.04,
      "retireeAppeal": 1.1,
      "childAppeal": 0.05,
      "trees": 0,
      "benches": 0,
      "rest": "burial"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 12,
        "cost": 1400,
        "work": 620,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "rem1"
        ],
        "attrs": {
          "venueType": "park",
          "openHours": [
            8,
            20
          ],
          "ticket": 0,
          "stay": [
            0.4,
            1
          ],
          "dayAppeal": 0.3,
          "eveningAppeal": 0.04,
          "retireeAppeal": 1.1,
          "childAppeal": 0.05,
          "trees": 0,
          "benches": 0,
          "rest": "burial",
          "title": "municipal cemetery",
          "visitorCapacity": 10,
          "leisureValue": 2,
          "radius": 10,
          "fee": 150,
          "plotCount": 84
        },
        "designs": [
          {
            "key": "152:1:0",
            "index": 0,
            "name": "twin Victorian chapels under a spire, an avenue of limes and a memorial cross",
            "height": 1,
            "draft": false,
            "ops": 136,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "dayAppeal": 0.3,
              "eveningAppeal": 0.04,
              "retireeAppeal": 1.1,
              "childAppeal": 0.05,
              "trees": 0,
              "benches": 0,
              "rest": "burial",
              "title": "municipal cemetery",
              "visitorCapacity": 10,
              "leisureValue": 2,
              "radius": 10,
              "fee": 150,
              "plotCount": 84,
              "plots": [
                -1.35,
                -0.66,
                -0.3,
                0.12,
                6,
                3,
                -1.35,
                0.38,
                -0.3,
                1.3,
                6,
                4,
                0.3,
                -0.66,
                1.35,
                0.12,
                6,
                3,
                0.3,
                0.38,
                1.35,
                1.3,
                6,
                4
              ]
            }
          },
          {
            "key": "152:1:1",
            "index": 1,
            "name": "modern brick chapel by the gate and hedged rooms of graves",
            "height": 0.86,
            "draft": false,
            "ops": 33,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "dayAppeal": 0.3,
              "eveningAppeal": 0.04,
              "retireeAppeal": 1.1,
              "childAppeal": 0.05,
              "trees": 0,
              "benches": 0,
              "rest": "burial",
              "title": "municipal cemetery",
              "visitorCapacity": 10,
              "leisureValue": 2,
              "radius": 10,
              "fee": 150,
              "plotCount": 84,
              "plots": [
                -1.35,
                -1.35,
                -0.15,
                -0.6,
                7,
                3,
                0.15,
                -1.35,
                1.35,
                -0.6,
                7,
                3,
                -1.35,
                -0.25,
                -0.15,
                0.6,
                7,
                3,
                0.15,
                -0.25,
                1.35,
                0.75,
                7,
                4
              ]
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "remembrance",
    "tier": 2,
    "blurb": "The town's cemetery: a chapel at the end of an avenue of limes and plot fields for nearly a hundred graves.",
    "howTo": "A 3×3 plot beside a road. Funerals come here from the funeral directors in reach; its lawns count as quiet green space for the homes round it. Needs Remembrance."
  },
  {
    "id": "garden-cemetery",
    "name": "garden cemetery",
    "kindId": 153,
    "code": 10,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "gardencemetery",
      "key": "",
      "label": "Garden cemetery",
      "color": "#4a6b45",
      "cost": 2600
    },
    "tech": [
      "rem1"
    ],
    "attrs": {
      "venueType": "park",
      "openHours": [
        8,
        20
      ],
      "ticket": 0,
      "stay": [
        0.4,
        1
      ],
      "dayAppeal": 0.4,
      "eveningAppeal": 0.04,
      "retireeAppeal": 1.3,
      "childAppeal": 0.05,
      "trees": 0,
      "benches": 0,
      "rest": "burial"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 22,
        "cost": 2600,
        "work": 1150,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "rem1"
        ],
        "attrs": {
          "venueType": "park",
          "openHours": [
            8,
            20
          ],
          "ticket": 0,
          "stay": [
            0.4,
            1
          ],
          "dayAppeal": 0.4,
          "eveningAppeal": 0.04,
          "retireeAppeal": 1.3,
          "childAppeal": 0.05,
          "trees": 0,
          "benches": 0,
          "rest": "burial",
          "title": "garden cemetery",
          "visitorCapacity": 16,
          "leisureValue": 3,
          "radius": 12,
          "fee": 260,
          "plotCount": 118,
          "plotJitter": 0.05
        },
        "designs": [
          {
            "key": "153:1:0",
            "index": 0,
            "name": "Egyptian avenue to a circle of catacombs under a cedar, winding paths and monuments",
            "height": 0.7,
            "draft": false,
            "ops": 87,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "dayAppeal": 0.4,
              "eveningAppeal": 0.04,
              "retireeAppeal": 1.3,
              "childAppeal": 0.05,
              "trees": 0,
              "benches": 0,
              "rest": "burial",
              "title": "garden cemetery",
              "visitorCapacity": 16,
              "leisureValue": 3,
              "radius": 12,
              "fee": 260,
              "plotCount": 118,
              "plotJitter": 0.05,
              "plots": [
                -1.86,
                -1.8,
                -1.18,
                -0.42,
                3,
                6,
                -0.92,
                -1.8,
                0.9,
                -0.48,
                8,
                5,
                1.12,
                -1,
                1.86,
                0.46,
                3,
                5,
                -1.86,
                0.02,
                -1.18,
                1.46,
                3,
                5,
                0.2,
                0.96,
                1.86,
                1.8,
                7,
                3,
                0.26,
                -0.18,
                0.92,
                0.68,
                3,
                3
              ]
            }
          },
          {
            "key": "153:1:1",
            "index": 1,
            "name": "Doric chapel over the catacomb, colonnades and avenues to a monument",
            "height": 0.86,
            "draft": false,
            "ops": 183,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "dayAppeal": 0.4,
              "eveningAppeal": 0.04,
              "retireeAppeal": 1.3,
              "childAppeal": 0.05,
              "trees": 0,
              "benches": 0,
              "rest": "burial",
              "title": "garden cemetery",
              "visitorCapacity": 16,
              "leisureValue": 3,
              "radius": 12,
              "fee": 260,
              "plotCount": 118,
              "plotJitter": 0.05,
              "plots": [
                -1.86,
                -1,
                -0.8,
                -0.02,
                5,
                4,
                -0.2,
                -1,
                1.86,
                -0.02,
                9,
                4,
                -1.86,
                0.44,
                -0.8,
                1.76,
                5,
                5,
                -0.2,
                0.44,
                1.86,
                1.76,
                9,
                5
              ]
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        1,
        3
      ]
    },
    "group": "remembrance",
    "tier": 3,
    "blurb": "A great Victorian garden cemetery: winding paths, catacombs and monuments under old trees, with room for well over a hundred graves. The finest burial ground in town, and the dearest.",
    "howTo": "A 4×4 plot beside a road. A good walk for retirees and a quiet park for the streets round it. Needs Remembrance."
  },
  {
    "id": "crematorium",
    "name": "crematorium",
    "kindId": 154,
    "code": 10,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": false,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "crematorium",
      "key": "",
      "label": "Crematorium",
      "color": "#8a5040",
      "cost": 2200
    },
    "tech": [
      "rem1"
    ],
    "attrs": {
      "venueType": "park",
      "openHours": [
        8,
        20
      ],
      "ticket": 0,
      "stay": [
        0.4,
        1
      ],
      "dayAppeal": 0.3,
      "eveningAppeal": 0.04,
      "retireeAppeal": 0.8,
      "childAppeal": 0.05,
      "trees": 0,
      "benches": 0,
      "rest": "cremation"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 0,
        "wage": 0,
        "upkeep": 30,
        "cost": 2200,
        "work": 560,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "rem1"
        ],
        "attrs": {
          "venueType": "park",
          "openHours": [
            8,
            20
          ],
          "ticket": 0,
          "stay": [
            0.4,
            1
          ],
          "dayAppeal": 0.3,
          "eveningAppeal": 0.04,
          "retireeAppeal": 0.8,
          "childAppeal": 0.05,
          "trees": 0,
          "benches": 0,
          "rest": "cremation",
          "title": "crematorium",
          "visitorCapacity": 8,
          "leisureValue": 1.5,
          "radius": 12,
          "fee": 180,
          "cremations": 6,
          "plotCount": 24
        },
        "designs": [
          {
            "key": "154:1:0",
            "index": 0,
            "name": "red-brick Italianate chapels with a campanile chimney, a cloister and a garden of remembrance",
            "height": 1.42,
            "draft": false,
            "ops": 64,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "dayAppeal": 0.3,
              "eveningAppeal": 0.04,
              "retireeAppeal": 0.8,
              "childAppeal": 0.05,
              "trees": 0,
              "benches": 0,
              "rest": "cremation",
              "title": "crematorium",
              "visitorCapacity": 8,
              "leisureValue": 1.5,
              "radius": 12,
              "fee": 180,
              "cremations": 6,
              "plotCount": 24,
              "plots": [
                0.6,
                -0.22,
                1.36,
                0.76,
                6,
                4
              ]
            }
          },
          {
            "key": "154:1:1",
            "index": 1,
            "name": "pale stone hall with a slim steel chimney, a reflecting pool and a walled garden",
            "height": 1.5,
            "draft": false,
            "ops": 49,
            "attrs": {
              "venueType": "park",
              "openHours": [
                8,
                20
              ],
              "ticket": 0,
              "stay": [
                0.4,
                1
              ],
              "dayAppeal": 0.3,
              "eveningAppeal": 0.04,
              "retireeAppeal": 0.8,
              "childAppeal": 0.05,
              "trees": 0,
              "benches": 0,
              "rest": "cremation",
              "title": "crematorium",
              "visitorCapacity": 8,
              "leisureValue": 1.5,
              "radius": 12,
              "fee": 180,
              "cremations": 6,
              "plotCount": 24,
              "plots": [
                0.42,
                -0.82,
                1.4,
                0,
                6,
                3,
                0.42,
                0.3,
                1.4,
                0.82,
                6,
                2
              ]
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "remembrance",
    "tier": 4,
    "blurb": "Chapels, a chimney and a garden of remembrance with memorial plaques. A crematorium takes several funerals a day and never fills up, but it costs more to run.",
    "howTo": "A 3×2 plot beside a road, away from the busiest streets. The funeral directors' own staff hold the services, so it hires nobody, but its upkeep is the highest of the four. Needs Remembrance."
  },
  {
    "id": "great-pyramid",
    "name": "the Great Pyramid of Giza",
    "kindId": 155,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "greatpyramid",
      "key": "",
      "label": "Great Pyramid",
      "color": "#d8b25a",
      "cost": 9000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "pyramid guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17.5
      ],
      "visitorCapacity": 150,
      "ticket": 20,
      "stay": [
        1.5,
        2.5
      ],
      "leisureValue": 9,
      "radius": 32,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.1,
      "retireeAppeal": 2,
      "childAppeal": 2,
      "title": "the Great Pyramid of Giza"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 16,
        "upkeep": 60,
        "cost": 9000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17.5
          ],
          "visitorCapacity": 150,
          "ticket": 20,
          "stay": [
            1.5,
            2.5
          ],
          "leisureValue": 9,
          "radius": 32,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.1,
          "retireeAppeal": 2,
          "childAppeal": 2,
          "title": "the Great Pyramid of Giza"
        },
        "designs": [
          {
            "key": "155:1:0",
            "index": 0,
            "name": "the smooth golden pyramid to a point, the entrance passage on the north face",
            "height": 2.32,
            "draft": false,
            "ops": 19,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 150,
              "ticket": 20,
              "stay": [
                1.5,
                2.5
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.1,
              "retireeAppeal": 2,
              "childAppeal": 2,
              "title": "the Great Pyramid of Giza"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        1,
        3
      ]
    },
    "group": "cairo",
    "tier": 1,
    "blurb": "The last wonder of the ancient world: two million golden blocks rising in one smooth slope to a point, the tomb of Khufu on the Giza plateau west of the Nile, entered down a passage on its north face.",
    "howTo": "A 4×4 plot on the edge of town, its north face and entrance passage towards the road. A daytime attraction that draws families, retirees and visitors from across the map. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "cairo"
    ]
  },
  {
    "id": "sphinx",
    "name": "the Sphinx",
    "kindId": 156,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "sphinx",
      "key": "",
      "label": "Sphinx",
      "color": "#c9ae74",
      "cost": 8000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "sphinx guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17.5
      ],
      "visitorCapacity": 100,
      "ticket": 15,
      "stay": [
        1,
        2
      ],
      "leisureValue": 8,
      "radius": 26,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.1,
      "retireeAppeal": 2.2,
      "childAppeal": 1.8,
      "title": "the Sphinx"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 16,
        "wage": 16,
        "upkeep": 55,
        "cost": 8000,
        "work": 2600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17.5
          ],
          "visitorCapacity": 100,
          "ticket": 15,
          "stay": [
            1,
            2
          ],
          "leisureValue": 8,
          "radius": 26,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.1,
          "retireeAppeal": 2.2,
          "childAppeal": 1.8,
          "title": "the Sphinx"
        },
        "designs": [
          {
            "key": "156:1:0",
            "index": 0,
            "name": "the reclining lion body and the head with its nemes headdress, on the sand plateau",
            "height": 0.9,
            "draft": false,
            "ops": 13,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 100,
              "ticket": 15,
              "stay": [
                1,
                2
              ],
              "leisureValue": 8,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.1,
              "retireeAppeal": 2.2,
              "childAppeal": 1.8,
              "title": "the Sphinx"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "cairo",
    "tier": 2,
    "blurb": "The sentinel of the necropolis: the body of a lion couchant with the head of a pharaoh in his nemes headdress, carved from the living rock of the plateau and gazing east over the Nile.",
    "howTo": "A 3×3 plot beside the road, its paws and face towards the street. A quiet daytime attraction that children and retirees especially love. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "cairo"
    ]
  },
  {
    "id": "pyramid-of-khafre",
    "name": "the Pyramid of Khafre",
    "kindId": 157,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "khafre",
      "key": "",
      "label": "Pyramid of Khafre",
      "color": "#d4b168",
      "cost": 9500
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "egyptologist",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17.5
      ],
      "visitorCapacity": 90,
      "ticket": 15,
      "stay": [
        1,
        2
      ],
      "leisureValue": 8,
      "radius": 26,
      "dayAppeal": 1.35,
      "eveningAppeal": 0.1,
      "retireeAppeal": 2,
      "childAppeal": 1.7,
      "title": "the Pyramid of Khafre"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 16,
        "wage": 16,
        "upkeep": 60,
        "cost": 9500,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17.5
          ],
          "visitorCapacity": 90,
          "ticket": 15,
          "stay": [
            1,
            2
          ],
          "leisureValue": 8,
          "radius": 26,
          "dayAppeal": 1.35,
          "eveningAppeal": 0.1,
          "retireeAppeal": 2,
          "childAppeal": 1.7,
          "title": "the Pyramid of Khafre"
        },
        "designs": [
          {
            "key": "157:1:0",
            "index": 0,
            "name": "the smaller golden slope with its flat capstone of polished stone",
            "height": 1.67,
            "draft": false,
            "ops": 9,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 90,
              "ticket": 15,
              "stay": [
                1,
                2
              ],
              "leisureValue": 8,
              "radius": 26,
              "dayAppeal": 1.35,
              "eveningAppeal": 0.1,
              "retireeAppeal": 2,
              "childAppeal": 1.7,
              "title": "the Pyramid of Khafre"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "cairo",
    "tier": 3,
    "blurb": "The second pyramid of Giza, Khafre's tomb: a little smaller than the Great Pyramid but keeping its polished casing capstone at the top of the slope, which is why it can seem the taller from below.",
    "howTo": "A 3×3 plot near the road. A daytime attraction; pair it with the Sphinx or the Great Pyramid so visitors wander between them. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "cairo"
    ]
  },
  {
    "id": "cairo-tower",
    "name": "the Cairo Tower",
    "kindId": 158,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "cairotower",
      "key": "",
      "label": "Cairo Tower",
      "color": "#9fb0c9",
      "cost": 18000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 300,
        "wage": 45,
        "upkeep": 120,
        "cost": 18000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 65
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "158:1:0",
            "index": 0,
            "name": "the lattice concrete cylinder on its podium, the restaurant ring under the mast",
            "height": 4.57,
            "draft": false,
            "ops": 30,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "cairo",
    "tier": 4,
    "blurb": "The concrete lotus of Zamalek: a lattice-work cylinder 187 metres high, built in the sixties, its revolving restaurant under the mast the best view in Cairo.",
    "howTo": "A 3×3 plot on an avenue among offices; a big workplace, so give it buses or a station. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "cairo"
    ]
  },
  {
    "id": "sultan-hassan",
    "name": "the Sultan Hassan Mosque",
    "kindId": 159,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "sultanhassan",
      "key": "",
      "label": "Sultan Hassan Mosque",
      "color": "#8f9c7a",
      "cost": 13000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "mosque guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17.5
      ],
      "visitorCapacity": 120,
      "ticket": 12,
      "stay": [
        1,
        1.8
      ],
      "leisureValue": 9,
      "radius": 30,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.15,
      "retireeAppeal": 1.9,
      "childAppeal": 1.6,
      "title": "the Sultan Hassan Mosque"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 17,
        "upkeep": 80,
        "cost": 13000,
        "work": 3200,
        "parking": {
          "surface": 0,
          "underground": 20
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17.5
          ],
          "visitorCapacity": 120,
          "ticket": 12,
          "stay": [
            1,
            1.8
          ],
          "leisureValue": 9,
          "radius": 30,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.15,
          "retireeAppeal": 1.9,
          "childAppeal": 1.6,
          "title": "the Sultan Hassan Mosque"
        },
        "designs": [
          {
            "key": "159:1:0",
            "index": 0,
            "name": "the prayer hall with its dome behind the tall portal, courtyard and two pencil minarets",
            "height": 2.01,
            "draft": false,
            "ops": 28,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 120,
              "ticket": 12,
              "stay": [
                1,
                1.8
              ],
              "leisureValue": 9,
              "radius": 30,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.15,
              "retireeAppeal": 1.9,
              "childAppeal": 1.6,
              "title": "the Sultan Hassan Mosque"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "cairo",
    "tier": 5,
    "blurb": "The fourteenth-century mosque and madrasa below the citadel: the tallest portal in Cairo, the great dome over the prayer hall, and two pencil minarets that ruled the skyline for five hundred years.",
    "howTo": "A 3×3 plot facing a street, the portal and courtyard towards the road. A daytime attraction that draws visitors of every age from across the city. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "cairo"
    ]
  },
  {
    "id": "substation",
    "name": "substation",
    "kindId": 160,
    "code": 15,
    "family": "utility",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "substation",
      "key": "",
      "label": "Substation",
      "color": "#d9a43a",
      "cost": 900
    },
    "tech": [
      "ut1"
    ],
    "occupation": {
      "name": "lineworker",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "utility": "power",
      "nodeRadius": 12,
      "nodeCapacity": 300,
      "importCap": 300,
      "title": "substation"
    },
    "tints": [
      16777215,
      15921128,
      15659508,
      16052198
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 2,
        "wage": 20,
        "upkeep": 15,
        "cost": 900,
        "work": 180,
        "parking": {
          "surface": 1,
          "underground": 1
        },
        "tech": [
          "ut1"
        ],
        "attrs": {
          "utility": "power",
          "nodeRadius": 12,
          "nodeCapacity": 300,
          "importCap": 300,
          "title": "substation"
        },
        "designs": [
          {
            "key": "160:1:0",
            "index": 0,
            "name": "palisade yard with two transformers, a gantry and a danger plate",
            "height": 0.42,
            "draft": false,
            "ops": 53,
            "attrs": {
              "utility": "power",
              "nodeRadius": 12,
              "nodeCapacity": 300,
              "importCap": 300,
              "title": "substation"
            }
          },
          {
            "key": "160:1:1",
            "index": 1,
            "name": "brick-walled compound with a transformer bay and a switch room",
            "height": 0.4,
            "draft": false,
            "ops": 27,
            "attrs": {
              "utility": "power",
              "nodeRadius": 12,
              "nodeCapacity": 300,
              "importCap": 300,
              "title": "substation"
            }
          }
        ]
      }
    ],
    "group": "grid",
    "tier": 1,
    "blurb": "A fenced yard of transformers: the local node. Power spreads 12 road tiles along the streets from its gate, up to 300 units an hour, and it takes in the National Grid when a motorway connection is within reach.",
    "howTo": "One tile beside a road in the middle of the streets it should serve. Supply follows the roads, not the crow: a good street grid reaches further. Homes need power to grow to two storeys. Needs Electrification."
  },
  {
    "id": "grid-supply-point",
    "name": "grid supply point",
    "kindId": 161,
    "code": 15,
    "family": "utility",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "civic",
    "tool": {
      "id": "gridsupply",
      "key": "",
      "label": "Grid supply point (2×2)",
      "color": "#c98f2c",
      "cost": 6000
    },
    "tech": [
      "ut2"
    ],
    "occupation": {
      "name": "lineworker",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "utility": "power",
      "nodeRadius": 16,
      "nodeCapacity": 1500,
      "importCap": 1500,
      "title": "grid supply point"
    },
    "tints": [
      16777215,
      15921128,
      15659508,
      16052198
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 6,
        "wage": 22,
        "upkeep": 90,
        "cost": 6000,
        "work": 520,
        "parking": {
          "surface": 3,
          "underground": 3
        },
        "tech": [
          "ut2"
        ],
        "attrs": {
          "utility": "power",
          "nodeRadius": 16,
          "nodeCapacity": 1500,
          "importCap": 1500,
          "title": "grid supply point"
        },
        "designs": [
          {
            "key": "161:1:0",
            "index": 0,
            "name": "switching yard: three gantries, four transformers and a control building",
            "height": 0.72,
            "draft": false,
            "ops": 105,
            "attrs": {
              "utility": "power",
              "nodeRadius": 16,
              "nodeCapacity": 1500,
              "importCap": 1500,
              "title": "grid supply point"
            }
          },
          {
            "key": "161:1:1",
            "index": 1,
            "name": "indoor switch hall with a transformer row and a line gantry behind",
            "height": 0.7,
            "draft": false,
            "ops": 85,
            "attrs": {
              "utility": "power",
              "nodeRadius": 16,
              "nodeCapacity": 1500,
              "importCap": 1500,
              "title": "grid supply point"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ]
    },
    "group": "grid",
    "tier": 2,
    "blurb": "A big switching yard with gantries and busbars: a node that passes on 1,500 units an hour along 16 road tiles of street, and brings in up to 1,500 from the National Grid near a motorway connection.",
    "howTo": "Two tiles by two, the gate on a road. Put one near the motorway connection to bring the grid into a growing town, or where a power station's trunk line comes in. Needs Power stations."
  },
  {
    "id": "power-depot",
    "name": "power depot",
    "kindId": 162,
    "code": 15,
    "family": "utility",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tool": {
      "id": "powerdepot",
      "key": "",
      "label": "Power depot (2×1)",
      "color": "#b07d2a",
      "cost": 2500
    },
    "tech": [
      "ut2"
    ],
    "occupation": {
      "name": "lineworker",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.45
        },
        {
          "start": 15,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 23,
          "hours": 8,
          "weight": 0.2
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ]
      ]
    },
    "attrs": {
      "utility": "power",
      "crews": 1,
      "title": "power depot"
    },
    "tints": [
      16777215,
      15921128,
      15659508,
      16052198
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 8,
        "wage": 21,
        "upkeep": 40,
        "cost": 2500,
        "work": 340,
        "parking": {
          "surface": 4,
          "underground": 6
        },
        "tech": [
          "ut2"
        ],
        "attrs": {
          "utility": "power",
          "crews": 1,
          "title": "power depot"
        },
        "designs": [
          {
            "key": "162:1:0",
            "index": 0,
            "name": "corrugated shed, cable drums and two vans on the yard",
            "height": 0.42,
            "draft": false,
            "ops": 19,
            "attrs": {
              "utility": "power",
              "crews": 1,
              "title": "power depot"
            }
          },
          {
            "key": "162:1:1",
            "index": 1,
            "name": "brick office, a vehicle bay and a pole stack",
            "height": 0.46,
            "draft": false,
            "ops": 21,
            "attrs": {
              "utility": "power",
              "crews": 1,
              "title": "power depot"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 1,
      "door": [
        0,
        0
      ]
    },
    "group": "grid",
    "tier": 3,
    "blurb": "A yard of cable drums and repair vans. Its lineworkers drive out to faults on your network: the sooner they get there, the sooner the lights come back.",
    "howTo": "Two tiles wide beside a road, central to your network: a fault stays dark while the van drives to it and the crew digs. Without a depot a contractor takes ten hours. Needs Power stations."
  },
  {
    "id": "gas-plant",
    "name": "gas power station",
    "kindId": 163,
    "code": 15,
    "family": "utility",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tool": {
      "id": "gasplant",
      "key": "",
      "label": "Gas power station (3×3)",
      "color": "#8f9aa6",
      "cost": 8000
    },
    "tech": [
      "ut2"
    ],
    "occupation": {
      "name": "plant operator",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.3
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "utility": "power",
      "supply": 1200,
      "availability": "steady",
      "fuel": 0.02,
      "pollution": 3,
      "title": "gas power station"
    },
    "tints": [
      16777215,
      15921128,
      15659508,
      16052198
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 24,
        "upkeep": 180,
        "cost": 8000,
        "work": 900,
        "parking": {
          "surface": 8,
          "underground": 12
        },
        "tech": [
          "ut2"
        ],
        "attrs": {
          "utility": "power",
          "supply": 1200,
          "availability": "steady",
          "fuel": 0.02,
          "pollution": 3,
          "title": "gas power station"
        },
        "designs": [
          {
            "key": "163:1:0",
            "index": 0,
            "name": "clad turbine hall, two slim stacks, a transformer yard and a line tower",
            "height": 2,
            "draft": false,
            "ops": 48,
            "attrs": {
              "utility": "power",
              "supply": 1200,
              "availability": "steady",
              "fuel": 0.02,
              "pollution": 3,
              "title": "gas power station"
            }
          },
          {
            "key": "163:1:1",
            "index": 1,
            "name": "brick-and-glass hall under a barrel roof, a single tall stack and a heat recovery block",
            "height": 2.1,
            "draft": false,
            "ops": 31,
            "attrs": {
              "utility": "power",
              "supply": 1200,
              "availability": "steady",
              "fuel": 0.02,
              "pollution": 3,
              "title": "gas power station"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "power",
    "tier": 3,
    "blurb": "A turbine hall and two slim stacks: 1,200 units an hour whenever it is staffed, quick to follow the evening peak. It burns gas at $0.02 a unit and dirties the air a little.",
    "howTo": "Three tiles by three beside a road at the edge of town, near a substation whose streets reach its gate, or joined to one by pylons or a buried cable. Needs Power stations."
  },
  {
    "id": "coal-plant",
    "name": "coal power station",
    "kindId": 164,
    "code": 15,
    "family": "utility",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "factory",
    "tool": {
      "id": "coalplant",
      "key": "",
      "label": "Coal power station (4×4)",
      "color": "#5a5048",
      "cost": 15000
    },
    "tech": [
      "ut2"
    ],
    "occupation": {
      "name": "plant operator",
      "rotate": true,
      "shifts": [
        {
          "start": 6,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.35
        },
        {
          "start": 22,
          "hours": 8,
          "weight": 0.3
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "utility": "power",
      "supply": 2000,
      "availability": "steady",
      "fuel": 0.012,
      "pollution": 8,
      "title": "coal power station"
    },
    "tints": [
      16777215,
      15921128,
      15659508,
      16052198
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 23,
        "upkeep": 250,
        "cost": 15000,
        "work": 1400,
        "parking": {
          "surface": 10,
          "underground": 14
        },
        "tech": [
          "ut2"
        ],
        "attrs": {
          "utility": "power",
          "supply": 2000,
          "availability": "steady",
          "fuel": 0.012,
          "pollution": 8,
          "title": "coal power station"
        },
        "designs": [
          {
            "key": "164:1:0",
            "index": 0,
            "name": "brick hall with four chimneys at the corners and a coal yard",
            "height": 2.6,
            "draft": false,
            "ops": 38,
            "attrs": {
              "utility": "power",
              "supply": 2000,
              "availability": "steady",
              "fuel": 0.012,
              "pollution": 8,
              "title": "coal power station"
            }
          },
          {
            "key": "164:1:1",
            "index": 1,
            "name": "concrete boiler house, one tall stack and two cooling towers by the coal stage",
            "height": 2.9,
            "draft": false,
            "ops": 25,
            "attrs": {
              "utility": "power",
              "supply": 2000,
              "availability": "steady",
              "fuel": 0.012,
              "pollution": 8,
              "title": "coal power station"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 4,
      "h": 4,
      "door": [
        1,
        3
      ]
    },
    "group": "power",
    "tier": 4,
    "blurb": "A brick cathedral of power with chimneys, a coal yard and cooling towers: 2,000 units an hour at the cheapest fuel there is ($0.012 a unit), and the dirtiest.",
    "howTo": "Four tiles by four, the gate on a road, well away from homes. Its trunk line to town can run on pylons (cheap) or buried cable. Needs Power stations."
  },
  {
    "id": "wind-turbine",
    "name": "wind turbine",
    "kindId": 165,
    "code": 15,
    "family": "utility",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "windturbine",
      "key": "",
      "label": "Wind turbine",
      "color": "#e8eef2",
      "cost": 900
    },
    "tech": [
      "ut3"
    ],
    "occupation": {
      "name": "wind technician",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 8,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "utility": "power",
      "supply": 40,
      "availability": "wind",
      "pollution": 0,
      "title": "wind turbine"
    },
    "tints": [
      16777215,
      15921128,
      15659508,
      16052198
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 1,
        "wage": 20,
        "upkeep": 8,
        "cost": 900,
        "work": 160,
        "parking": {
          "surface": 1,
          "underground": 1
        },
        "tech": [
          "ut3"
        ],
        "attrs": {
          "utility": "power",
          "supply": 40,
          "availability": "wind",
          "pollution": 0,
          "title": "wind turbine"
        },
        "designs": [
          {
            "key": "165:1:0",
            "index": 0,
            "name": "tall white tower on a grass pad, rotor at ten o'clock",
            "height": 1.6,
            "draft": false,
            "ops": 30,
            "attrs": {
              "utility": "power",
              "supply": 40,
              "availability": "wind",
              "pollution": 0,
              "title": "wind turbine"
            }
          },
          {
            "key": "165:1:1",
            "index": 1,
            "name": "shorter tower beside its kiosk, rotor turned further",
            "height": 1.4,
            "draft": false,
            "ops": 33,
            "attrs": {
              "utility": "power",
              "supply": 40,
              "availability": "wind",
              "pollution": 0,
              "title": "wind turbine"
            }
          }
        ]
      }
    ],
    "group": "power",
    "tier": 1,
    "blurb": "A white tower and a three-blade rotor: up to 40 units an hour when the wind blows, nothing to burn and next to no upkeep. Its output rises and falls with the weather.",
    "howTo": "One tile beside a road, on open ground; a row of them adds up. Pair them with a power station for the calm hours. Needs Renewables."
  },
  {
    "id": "solar-farm",
    "name": "solar farm",
    "kindId": 166,
    "code": 15,
    "family": "utility",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "none",
    "tool": {
      "id": "solarfarm",
      "key": "",
      "label": "Solar farm (2×2)",
      "color": "#3b5a8a",
      "cost": 3000
    },
    "tech": [
      "ut3"
    ],
    "occupation": {
      "name": "solar technician",
      "rotate": true,
      "shifts": [
        {
          "start": 8,
          "hours": 8,
          "weight": 1
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "utility": "power",
      "supply": 100,
      "availability": "sun",
      "pollution": 0,
      "title": "solar farm"
    },
    "tints": [
      16777215,
      15921128,
      15659508,
      16052198
    ],
    "levels": [
      {
        "level": 1,
        "capacity": 2,
        "wage": 20,
        "upkeep": 15,
        "cost": 3000,
        "work": 300,
        "parking": {
          "surface": 1,
          "underground": 1
        },
        "tech": [
          "ut3"
        ],
        "attrs": {
          "utility": "power",
          "supply": 100,
          "availability": "sun",
          "pollution": 0,
          "title": "solar farm"
        },
        "designs": [
          {
            "key": "166:1:0",
            "index": 0,
            "name": "five rows of panels, an inverter kiosk and a fence",
            "height": 0.2,
            "draft": false,
            "ops": 74,
            "attrs": {
              "utility": "power",
              "supply": 100,
              "availability": "sun",
              "pollution": 0,
              "title": "solar farm"
            }
          },
          {
            "key": "166:1:1",
            "index": 1,
            "name": "four long arrays with a track between them and a hedge",
            "height": 0.2,
            "draft": false,
            "ops": 29,
            "attrs": {
              "utility": "power",
              "supply": 100,
              "availability": "sun",
              "pollution": 0,
              "title": "solar farm"
            }
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "power",
    "tier": 2,
    "blurb": "Rows of panels tilted to the sun: up to 100 units an hour at noon, less morning and evening, none at night. Nothing to burn and quiet.",
    "howTo": "Two tiles by two beside a road. It covers the daytime load; the evening peak comes after sunset, so keep a power station or the grid for that. Needs Renewables."
  },
  {
    "id": "burj-khalifa",
    "name": "the Burj Khalifa",
    "kindId": 167,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "burjkhalifa",
      "key": "",
      "label": "Burj Khalifa",
      "color": "#9fb4c7",
      "cost": 30000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 450,
        "wage": 48,
        "upkeep": 160,
        "cost": 30000,
        "work": 5400,
        "parking": {
          "surface": 0,
          "underground": 90
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "167:1:0",
            "index": 0,
            "name": "eight silver setbacks spiralling under the needle",
            "height": 11.63,
            "draft": false,
            "ops": 52,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "167:1:1",
            "index": 1,
            "name": "nine three-wing setbacks around a buttressed core, a silver needle and seven fountain jets",
            "height": 9.71,
            "draft": true,
            "ops": 62,
            "attrs": {},
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "dubai",
    "tier": 1,
    "blurb": "Downtown's silver spiral: eight setbacks winding round the shaft to the needle, the tallest thing in the world set and the biggest workplace in the game.",
    "howTo": "A 3×3 plot on a main avenue among offices; it holds more jobs than anything else, so give it a station or buses and leave the street in front clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "dubai"
    ]
  },
  {
    "id": "burj-al-arab",
    "name": "the Burj Al Arab",
    "kindId": 168,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "burjalarab",
      "key": "",
      "label": "Burj Al Arab",
      "color": "#dfe7ec",
      "cost": 24000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 340,
        "wage": 45,
        "upkeep": 130,
        "cost": 24000,
        "work": 4400,
        "parking": {
          "surface": 0,
          "underground": 65
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "168:1:0",
            "index": 0,
            "name": "the sail: curving glass shells on an island, the helipad off the flank",
            "height": 3.98,
            "draft": false,
            "ops": 38,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "dubai",
    "tier": 2,
    "blurb": "The sail of the Gulf: curving glass shells billowing up from an island in the sea, the helipad cantilevered off the flank and a gold tip at the mast.",
    "howTo": "A 3×3 plot with its causeway to the street; it works as an office tower, so give it buses or parking and let the sea show round the island. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "dubai"
    ]
  },
  {
    "id": "dubai-frame",
    "name": "the Dubai Frame",
    "kindId": 169,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "dubaiframe",
      "key": "",
      "label": "Dubai Frame",
      "color": "#d8b25a",
      "cost": 10000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "frame concierge",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17.5
      ],
      "visitorCapacity": 120,
      "ticket": 18,
      "stay": [
        1,
        1.8
      ],
      "leisureValue": 8,
      "radius": 28,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.1,
      "retireeAppeal": 1.6,
      "childAppeal": 1.7,
      "title": "Dubai Frame"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 16,
        "upkeep": 60,
        "cost": 10000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 15
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17.5
          ],
          "visitorCapacity": 120,
          "ticket": 18,
          "stay": [
            1,
            1.8
          ],
          "leisureValue": 8,
          "radius": 28,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.1,
          "retireeAppeal": 1.6,
          "childAppeal": 1.7,
          "title": "Dubai Frame"
        },
        "designs": [
          {
            "key": "169:1:0",
            "index": 0,
            "name": "two gold towers holding the sky bridge over the frame",
            "height": 2.86,
            "draft": false,
            "ops": 27,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 120,
              "ticket": 18,
              "stay": [
                1,
                1.8
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.1,
              "retireeAppeal": 1.6,
              "childAppeal": 1.7,
              "title": "Dubai Frame"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "dubai",
    "tier": 3,
    "blurb": "Zabeel Park's golden picture frame: two gold-clad towers holding a sky bridge with a glass floor, old Dubai below on one side and the new towers on the other.",
    "howTo": "A 2×2 plot on a street by a park or promenade; visitors come by day for the view, so give it buses and leave the front walk clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "dubai"
    ]
  },
  {
    "id": "museum-of-the-future",
    "name": "the Museum of the Future",
    "kindId": 170,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "motf",
      "key": "",
      "label": "Museum of the Future",
      "color": "#6fb7c9",
      "cost": 18000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "gallery host",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        10,
        18
      ],
      "visitorCapacity": 160,
      "ticket": 25,
      "stay": [
        1.2,
        2
      ],
      "leisureValue": 9,
      "radius": 30,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.15,
      "retireeAppeal": 1.5,
      "childAppeal": 1.8,
      "title": "Museum of the Future"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 17,
        "upkeep": 90,
        "cost": 18000,
        "work": 3200,
        "parking": {
          "surface": 0,
          "underground": 25
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            10,
            18
          ],
          "visitorCapacity": 160,
          "ticket": 25,
          "stay": [
            1.2,
            2
          ],
          "leisureValue": 9,
          "radius": 30,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.15,
          "retireeAppeal": 1.5,
          "childAppeal": 1.8,
          "title": "Museum of the Future"
        },
        "designs": [
          {
            "key": "170:1:0",
            "index": 0,
            "name": "the glass torus on its side, steel ribs round the ring",
            "height": 2.58,
            "draft": false,
            "ops": 24,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                18
              ],
              "visitorCapacity": 160,
              "ticket": 25,
              "stay": [
                1.2,
                2
              ],
              "leisureValue": 9,
              "radius": 30,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.15,
              "retireeAppeal": 1.5,
              "childAppeal": 1.8,
              "title": "Museum of the Future"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "dubai",
    "tier": 4,
    "blurb": "The torus on Sheikh Zayed Road: a ring of glass and steel standing on its edge, glowing from within after dark, an exhibition of the world seventy years from now.",
    "howTo": "A 3×3 plot facing a main road so the ring faces the traffic; a daytime attraction, so put it near hotels and buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "dubai"
    ]
  },
  {
    "id": "jumeirah-mosque",
    "name": "the Jumeirah Mosque",
    "kindId": 171,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "jumeirah",
      "key": "",
      "label": "Jumeirah Mosque",
      "color": "#efe9db",
      "cost": 8000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "mosque caretaker",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17
      ],
      "visitorCapacity": 80,
      "ticket": 12,
      "stay": [
        0.8,
        1.5
      ],
      "leisureValue": 7,
      "radius": 24,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.2,
      "retireeAppeal": 1.9,
      "childAppeal": 1.4,
      "title": "Jumeirah Mosque"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 12,
        "wage": 16,
        "upkeep": 50,
        "cost": 8000,
        "work": 2600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17
          ],
          "visitorCapacity": 80,
          "ticket": 12,
          "stay": [
            0.8,
            1.5
          ],
          "leisureValue": 7,
          "radius": 24,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.2,
          "retireeAppeal": 1.9,
          "childAppeal": 1.4,
          "title": "Jumeirah Mosque"
        },
        "designs": [
          {
            "key": "171:1:0",
            "index": 0,
            "name": "the white mosque: dome and twin minarets round the courtyard",
            "height": 1.52,
            "draft": false,
            "ops": 49,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17
              ],
              "visitorCapacity": 80,
              "ticket": 12,
              "stay": [
                0.8,
                1.5
              ],
              "leisureValue": 7,
              "radius": 24,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.2,
              "retireeAppeal": 1.9,
              "childAppeal": 1.4,
              "title": "Jumeirah Mosque"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "dubai",
    "tier": 5,
    "blurb": "The white mosque by the sea: a dome and twin minarets in the Fatimid style, floodlit warm at night and open to visitors of every faith.",
    "howTo": "A 3×3 plot on a quiet avenue; a daytime attraction that retirees and children love, so put it near homes and a bus stop. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "dubai"
    ]
  },
  {
    "id": "oriental-pearl",
    "name": "the Oriental Pearl Tower",
    "kindId": 172,
    "code": 13,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "orientalpearl",
      "key": "",
      "label": "Oriental Pearl Tower",
      "color": "#d97f92",
      "cost": 15000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "pearl tower crew",
      "rotate": true,
      "shifts": [
        {
          "start": 7,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 14,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "sports",
      "openHours": [
        9,
        22
      ],
      "visitorCapacity": 140,
      "ticket": 16,
      "stay": [
        0.8,
        1.4
      ],
      "leisureValue": 10,
      "radius": 32,
      "eventNights": [],
      "eventStart": 19,
      "dayAppeal": 1.2,
      "eveningAppeal": 1.3,
      "retireeAppeal": 0.9,
      "childAppeal": 1.9,
      "title": "Oriental Pearl Tower"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 32,
        "wage": 16,
        "upkeep": 80,
        "cost": 15000,
        "work": 3200,
        "parking": {
          "surface": 0,
          "underground": 40
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "sports",
          "openHours": [
            9,
            22
          ],
          "visitorCapacity": 140,
          "ticket": 16,
          "stay": [
            0.8,
            1.4
          ],
          "leisureValue": 10,
          "radius": 32,
          "eventNights": [],
          "eventStart": 19,
          "dayAppeal": 1.2,
          "eveningAppeal": 1.3,
          "retireeAppeal": 0.9,
          "childAppeal": 1.9,
          "title": "Oriental Pearl Tower"
        },
        "designs": [
          {
            "key": "172:1:0",
            "index": 0,
            "name": "three pink pearls on a tapering shaft over slanted columns, the mast and beacon above",
            "height": 6.1,
            "draft": false,
            "ops": 41,
            "attrs": {
              "venueType": "sports",
              "openHours": [
                9,
                22
              ],
              "visitorCapacity": 140,
              "ticket": 16,
              "stay": [
                0.8,
                1.4
              ],
              "leisureValue": 10,
              "radius": 32,
              "eventNights": [],
              "eventStart": 19,
              "dayAppeal": 1.2,
              "eveningAppeal": 1.3,
              "retireeAppeal": 0.9,
              "childAppeal": 1.9,
              "title": "Oriental Pearl Tower"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "shanghai",
    "tier": 1,
    "blurb": "The tower of spheres over the Lujiazui promenade: three pink pearls on a tapering shaft, glowing red and gold at night, with observation decks running from morning to late evening.",
    "howTo": "A 3×3 plot by the water or a main avenue; it draws visitors from across the city, day and evening, so give it a station or buses and leave the street in front clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "shanghai"
    ]
  },
  {
    "id": "shanghai-tower",
    "name": "the Shanghai Tower",
    "kindId": 173,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "shanghaitower",
      "key": "",
      "label": "Shanghai Tower",
      "color": "#7fb3c4",
      "cost": 30000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 450,
        "wage": 48,
        "upkeep": 160,
        "cost": 30000,
        "work": 5400,
        "parking": {
          "surface": 0,
          "underground": 90
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "173:1:0",
            "index": 0,
            "name": "six shrinking glass tiers stepped round so the shaft twists, a crown, mast and beacon",
            "height": 8.53,
            "draft": false,
            "ops": 26,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "shanghai",
    "tier": 2,
    "blurb": "The twisting glass spiral of Lujiazui: the tallest building in China, its shrinking tiers turning a little with every floor so the shaft winds up into the sky.",
    "howTo": "A 3×3 plot among offices; it holds the most jobs of any building, so give it rail or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "shanghai"
    ]
  },
  {
    "id": "jin-mao",
    "name": "the Jin Mao Tower",
    "kindId": 174,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "jinmao",
      "key": "",
      "label": "Jin Mao Tower",
      "color": "#b8c0cc",
      "cost": 24000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 360,
        "wage": 46,
        "upkeep": 130,
        "cost": 24000,
        "work": 4600,
        "parking": {
          "surface": 0,
          "underground": 70
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "174:1:0",
            "index": 0,
            "name": "five stainless setback tiers under a flaring pagoda crown of eaves, mast and beacon",
            "height": 6.8,
            "draft": false,
            "ops": 28,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "shanghai",
    "tier": 3,
    "blurb": "The pagoda in steel and glass: stainless setbacks climbing to the flared neon crown, for years the tallest building in China and still the tallest hotel in the world.",
    "howTo": "A 3×3 plot among offices on an avenue; a big workplace, so give it buses or a station. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "shanghai"
    ]
  },
  {
    "id": "swfc",
    "name": "the Shanghai World Financial Center",
    "kindId": 175,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "swfc",
      "key": "",
      "label": "World Financial Center",
      "color": "#8fa9c9",
      "cost": 22000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 320,
        "wage": 45,
        "upkeep": 120,
        "cost": 22000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 60
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "175:1:0",
            "index": 0,
            "name": "trapezoid glass shaft split into two piers at the top, the slot between, the bridge over it",
            "height": 6.46,
            "draft": false,
            "ops": 25,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "shanghai",
    "tier": 4,
    "blurb": "The bottle-opener of Lujiazui: a trapezoid glass shaft whose two faces taper to the bridge at the top, the sky seen through the slot below it; the observation deck rides the bridge.",
    "howTo": "A 3×3 plot among offices; a big workplace, so give it buses or a station and leave the street in front clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "shanghai"
    ]
  },
  {
    "id": "yu-garden",
    "name": "the Yu Garden",
    "kindId": 176,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "yugarden",
      "key": "",
      "label": "Yu Garden",
      "color": "#6e8f5a",
      "cost": 14000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "garden keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17.5
      ],
      "visitorCapacity": 120,
      "ticket": 18,
      "stay": [
        1.5,
        2.5
      ],
      "leisureValue": 8,
      "radius": 28,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.1,
      "retireeAppeal": 2.2,
      "childAppeal": 1.9,
      "title": "Yu Garden"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 16,
        "upkeep": 80,
        "cost": 14000,
        "work": 3200,
        "parking": {
          "surface": 0,
          "underground": 20
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17.5
          ],
          "visitorCapacity": 120,
          "ticket": 18,
          "stay": [
            1.5,
            2.5
          ],
          "leisureValue": 8,
          "radius": 28,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.1,
          "retireeAppeal": 2.2,
          "childAppeal": 1.9,
          "title": "Yu Garden"
        },
        "designs": [
          {
            "key": "176:1:0",
            "index": 0,
            "name": "walled garden of pavilions, the pond under its zigzag bridge and the craggy rockery",
            "height": 0.7,
            "draft": false,
            "ops": 59,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17.5
              ],
              "visitorCapacity": 120,
              "ticket": 18,
              "stay": [
                1.5,
                2.5
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.1,
              "retireeAppeal": 2.2,
              "childAppeal": 1.9,
              "title": "Yu Garden"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 3,
      "h": 3,
      "door": [
        1,
        2
      ]
    },
    "group": "shanghai",
    "tier": 5,
    "blurb": "The Ming-dynasty garden behind its tiled walls: the pond crossed by the zigzag bridge, flared-roof pavilions for tea, and the rockery - four hundred years of the old city.",
    "howTo": "A 3×3 plot in a neighbourhood among homes; a day out that draws retirees and children, quiet after it closes at dusk. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "shanghai"
    ]
  },
  {
    "id": "forbidden-city",
    "name": "the Forbidden City",
    "kindId": 177,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "forbiddencity",
      "key": "",
      "label": "Forbidden City",
      "color": "#9e2b22",
      "cost": 16000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "palace guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8.5,
        17
      ],
      "visitorCapacity": 220,
      "ticket": 24,
      "stay": [
        1.2,
        2.4
      ],
      "leisureValue": 9,
      "radius": 32,
      "dayAppeal": 1.7,
      "eveningAppeal": 0.1,
      "retireeAppeal": 1.9,
      "childAppeal": 1.7,
      "title": "the Forbidden City"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 50,
        "wage": 17,
        "upkeep": 70,
        "cost": 16000,
        "work": 3400,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8.5,
            17
          ],
          "visitorCapacity": 220,
          "ticket": 24,
          "stay": [
            1.2,
            2.4
          ],
          "leisureValue": 9,
          "radius": 32,
          "dayAppeal": 1.7,
          "eveningAppeal": 0.1,
          "retireeAppeal": 1.9,
          "childAppeal": 1.7,
          "title": "the Forbidden City"
        },
        "designs": [
          {
            "key": "177:1:0",
            "index": 0,
            "name": "the hall of supreme harmony on its triple white terrace under the golden double eaves",
            "height": 0.88,
            "draft": false,
            "ops": 22,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8.5,
                17
              ],
              "visitorCapacity": 220,
              "ticket": 24,
              "stay": [
                1.2,
                2.4
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.1,
              "retireeAppeal": 1.9,
              "childAppeal": 1.7,
              "title": "the Forbidden City"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "beijing",
    "tier": 1,
    "blurb": "The greatest of the imperial halls, nine thousand rooms behind the vermilion walls: the hall of supreme harmony on its triple terrace of white marble under the golden double eaves.",
    "howTo": "A 2×2 plot on a grand axis, walled courts around; a heavy daytime draw from across the city, so give it a metro or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "beijing"
    ]
  },
  {
    "id": "temple-of-heaven",
    "name": "the Temple of Heaven",
    "kindId": 178,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "templeofheaven",
      "key": "",
      "label": "Temple of Heaven",
      "color": "#3f6fb5",
      "cost": 12000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "temple keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        18
      ],
      "visitorCapacity": 140,
      "ticket": 14,
      "stay": [
        0.8,
        1.6
      ],
      "leisureValue": 8,
      "radius": 26,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.2,
      "retireeAppeal": 2.4,
      "childAppeal": 1.2,
      "title": "the Temple of Heaven"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 16,
        "upkeep": 55,
        "cost": 12000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            18
          ],
          "visitorCapacity": 140,
          "ticket": 14,
          "stay": [
            0.8,
            1.6
          ],
          "leisureValue": 8,
          "radius": 26,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.2,
          "retireeAppeal": 2.4,
          "childAppeal": 1.2,
          "title": "the Temple of Heaven"
        },
        "designs": [
          {
            "key": "178:1:0",
            "index": 0,
            "name": "the blue triple-eaved hall of prayer on its round marble terrace among the pines",
            "height": 0.68,
            "draft": false,
            "ops": 22,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                18
              ],
              "visitorCapacity": 140,
              "ticket": 14,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 8,
              "radius": 26,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.2,
              "retireeAppeal": 2.4,
              "childAppeal": 1.2,
              "title": "the Temple of Heaven"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "beijing",
    "tier": 2,
    "blurb": "The hall of prayer for good harvests in the temple park: the blue triple eaves stepping in over the red drum, the marble terrace round it, and the old pines that guard the fasting ground.",
    "howTo": "A 2×2 plot with lawns and pines, a park setting suits it; a calm daytime visit for retirees and school trips. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "beijing"
    ]
  },
  {
    "id": "great-wall",
    "name": "the Great Wall",
    "kindId": 179,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "greatwall",
      "key": "",
      "label": "Great Wall",
      "color": "#8a8578",
      "cost": 11000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "wall warden",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8.5,
        18
      ],
      "visitorCapacity": 120,
      "ticket": 16,
      "stay": [
        0.8,
        1.6
      ],
      "leisureValue": 7,
      "radius": 26,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.2,
      "retireeAppeal": 1.8,
      "childAppeal": 1.6,
      "title": "the Great Wall"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 16,
        "upkeep": 50,
        "cost": 11000,
        "work": 2400,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8.5,
            18
          ],
          "visitorCapacity": 120,
          "ticket": 16,
          "stay": [
            0.8,
            1.6
          ],
          "leisureValue": 7,
          "radius": 26,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.2,
          "retireeAppeal": 1.8,
          "childAppeal": 1.6,
          "title": "the Great Wall"
        },
        "designs": [
          {
            "key": "179:1:0",
            "index": 0,
            "name": "the wall climbing over the ridge, the watchtower at the crest with its beacon",
            "height": 1.05,
            "draft": false,
            "ops": 22,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8.5,
                18
              ],
              "visitorCapacity": 120,
              "ticket": 16,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.2,
              "retireeAppeal": 1.8,
              "childAppeal": 1.6,
              "title": "the Great Wall"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 4,
      "door": [
        0,
        3
      ]
    },
    "group": "beijing",
    "tier": 3,
    "blurb": "The wall over the mountains north of the capital, twenty thousand li of stone and watchfire: the battlements climbing the ridge, the tower cresting the pass, the beacon that once called the alarm.",
    "howTo": "Placed with its tool it is a 1×4 landmark on dry land, its door at one end; in a real city it would run the ridge it defends. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "beijing"
    ]
  },
  {
    "id": "tiananmen-gate",
    "name": "Tiananmen Gate",
    "kindId": 180,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "tiananmen",
      "key": "",
      "label": "Tiananmen Gate",
      "color": "#d8a83c",
      "cost": 8000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "gate keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8.5,
        17.5
      ],
      "visitorCapacity": 90,
      "ticket": 0,
      "stay": [
        0.4,
        0.9
      ],
      "leisureValue": 6,
      "radius": 20,
      "dayAppeal": 1.2,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.6,
      "childAppeal": 1,
      "title": "Tiananmen Gate"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 14,
        "wage": 14,
        "upkeep": 35,
        "cost": 8000,
        "work": 1600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8.5,
            17.5
          ],
          "visitorCapacity": 90,
          "ticket": 0,
          "stay": [
            0.4,
            0.9
          ],
          "leisureValue": 6,
          "radius": 20,
          "dayAppeal": 1.2,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.6,
          "childAppeal": 1,
          "title": "Tiananmen Gate"
        },
        "designs": [
          {
            "key": "180:1:0",
            "index": 0,
            "name": "the rostrum and double-eaved tower over the gate of heavenly peace, the golden-water bridges before it",
            "height": 0.77,
            "draft": false,
            "ops": 25,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8.5,
                17.5
              ],
              "visitorCapacity": 90,
              "ticket": 0,
              "stay": [
                0.4,
                0.9
              ],
              "leisureValue": 6,
              "radius": 20,
              "dayAppeal": 1.2,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.6,
              "childAppeal": 1,
              "title": "Tiananmen Gate"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "beijing",
    "tier": 4,
    "blurb": "The gate of heavenly peace at the head of the imperial way: the red rostrum with its arch, the tower of yellow tile above, and the golden-water stream with its five marble bridges before it.",
    "howTo": "A 2×2 plot at the head of an axis, open to the square; a short free visit that anchors a ceremonial district. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "beijing"
    ]
  },
  {
    "id": "cctv-tower",
    "name": "the CCTV Headquarters",
    "kindId": 181,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "cctv",
      "key": "",
      "label": "CCTV Tower",
      "color": "#5a6b7a",
      "cost": 24000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 340,
        "wage": 44,
        "upkeep": 130,
        "cost": 24000,
        "work": 4600,
        "parking": {
          "surface": 0,
          "underground": 65
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "181:1:0",
            "index": 0,
            "name": "the leaning towers joined head to heel, the loop of glass over the avenue",
            "height": 2.12,
            "draft": false,
            "ops": 15,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "beijing",
    "tier": 5,
    "blurb": "The great loop of glass in the new CBD: two leaning towers tipping toward each other until they cross, joined at the waist and the crown, an Escher figure on the skyline.",
    "howTo": "A 2×2 plot among offices on an avenue; a big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "beijing"
    ]
  },
  {
    "id": "summer-palace",
    "name": "the Summer Palace",
    "kindId": 182,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "summerpalace",
      "key": "",
      "label": "Summer Palace",
      "color": "#3f6fb5",
      "cost": 12000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "garden keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8.5,
        18
      ],
      "visitorCapacity": 130,
      "ticket": 16,
      "stay": [
        1,
        2
      ],
      "leisureValue": 8,
      "radius": 26,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.2,
      "retireeAppeal": 2.2,
      "childAppeal": 1.4,
      "title": "the Summer Palace"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 28,
        "wage": 16,
        "upkeep": 55,
        "cost": 12000,
        "work": 2600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8.5,
            18
          ],
          "visitorCapacity": 130,
          "ticket": 16,
          "stay": [
            1,
            2
          ],
          "leisureValue": 8,
          "radius": 26,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.2,
          "retireeAppeal": 2.2,
          "childAppeal": 1.4,
          "title": "the Summer Palace"
        },
        "designs": [
          {
            "key": "182:1:0",
            "index": 0,
            "name": "the tower of buddhist incense on its hill above the lake, the marble causeway over the water",
            "height": 0.94,
            "draft": false,
            "ops": 27,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8.5,
                18
              ],
              "visitorCapacity": 130,
              "ticket": 16,
              "stay": [
                1,
                2
              ],
              "leisureValue": 8,
              "radius": 26,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.2,
              "retireeAppeal": 2.2,
              "childAppeal": 1.4,
              "title": "the Summer Palace"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "beijing",
    "tier": 6,
    "blurb": "The garden of the empress by the western lake: the water of Kunming, the marble causeway, and the hill of longevity with the tower of Buddhist incense rising over it all, four storeys under the golden eaves.",
    "howTo": "A 2×2 plot with lawns and water, a park setting suits it; a calm daytime visit for retirees and school trips. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "beijing"
    ]
  },
  {
    "id": "christ-the-redeemer",
    "name": "Christ the Redeemer",
    "kindId": 183,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "christredeemer",
      "key": "",
      "label": "Christ the Redeemer",
      "color": "#cfd4d8",
      "cost": 14000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "sanctuary keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        19
      ],
      "visitorCapacity": 160,
      "ticket": 12,
      "stay": [
        0.8,
        1.6
      ],
      "leisureValue": 9,
      "radius": 34,
      "dayAppeal": 1.7,
      "eveningAppeal": 0.4,
      "retireeAppeal": 2,
      "childAppeal": 1.5,
      "title": "Christ the Redeemer"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 36,
        "wage": 16,
        "upkeep": 60,
        "cost": 14000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            19
          ],
          "visitorCapacity": 160,
          "ticket": 12,
          "stay": [
            0.8,
            1.6
          ],
          "leisureValue": 9,
          "radius": 34,
          "dayAppeal": 1.7,
          "eveningAppeal": 0.4,
          "retireeAppeal": 2,
          "childAppeal": 1.5,
          "title": "Christ the Redeemer"
        },
        "designs": [
          {
            "key": "183:1:0",
            "index": 0,
            "name": "the soapstone Christ with his outstretched arms on the peak of Corcovado",
            "height": 1.08,
            "draft": false,
            "ops": 9,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19
              ],
              "visitorCapacity": 160,
              "ticket": 12,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 9,
              "radius": 34,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2,
              "childAppeal": 1.5,
              "title": "Christ the Redeemer"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "183:1:1",
            "index": 1,
            "name": "a monumental robed figure with wide sleeves and open hands above the Corcovado lookout",
            "height": 1.41,
            "draft": true,
            "ops": 34,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19
              ],
              "visitorCapacity": 160,
              "ticket": 12,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 9,
              "radius": 34,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.4,
              "retireeAppeal": 2,
              "childAppeal": 1.5,
              "title": "Christ the Redeemer"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rio",
    "tier": 1,
    "blurb": "The soapstone Christ on the peak of Corcovado, thirty metres of open arms over the city and the bay: the jungle mountain, the lookout at his feet, and the figure himself against the sky.",
    "howTo": "A 2×2 plot high over the city, lawns below; a day out with a view that draws everyone, so give it a bus route. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rio"
    ]
  },
  {
    "id": "sugarloaf",
    "name": "Sugarloaf Mountain",
    "kindId": 184,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "sugarloaf",
      "key": "",
      "label": "Sugarloaf",
      "color": "#8a8f96",
      "cost": 13000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "cable car operator",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8.5,
        20
      ],
      "visitorCapacity": 130,
      "ticket": 20,
      "stay": [
        1,
        1.8
      ],
      "leisureValue": 8,
      "radius": 28,
      "dayAppeal": 1.6,
      "eveningAppeal": 0.6,
      "retireeAppeal": 1.6,
      "childAppeal": 1.7,
      "title": "Sugarloaf Mountain"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 16,
        "upkeep": 60,
        "cost": 13000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8.5,
            20
          ],
          "visitorCapacity": 130,
          "ticket": 20,
          "stay": [
            1,
            1.8
          ],
          "leisureValue": 8,
          "radius": 28,
          "dayAppeal": 1.6,
          "eveningAppeal": 0.6,
          "retireeAppeal": 1.6,
          "childAppeal": 1.7,
          "title": "Sugarloaf Mountain"
        },
        "designs": [
          {
            "key": "184:1:0",
            "index": 0,
            "name": "the granite dome from the sea, the cable car climbing to its station on the summit",
            "height": 0.64,
            "draft": false,
            "ops": 15,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8.5,
                20
              ],
              "visitorCapacity": 130,
              "ticket": 20,
              "stay": [
                1,
                1.8
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.6,
              "eveningAppeal": 0.6,
              "retireeAppeal": 1.6,
              "childAppeal": 1.7,
              "title": "Sugarloaf Mountain"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rio",
    "tier": 2,
    "blurb": "The sugarloaf of granite rising sheer from the sea at the mouth of the bay: the cable car climbing to the little station on the summit, the beach and the palms below.",
    "howTo": "A 2×2 plot by the water; a ride and a view that fills all afternoon, so give it a bus route. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rio"
    ]
  },
  {
    "id": "rio-cathedral",
    "name": "the Metropolitan Cathedral",
    "kindId": 185,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "riocathedral",
      "key": "",
      "label": "Rio Cathedral",
      "color": "#b8b4ac",
      "cost": 7000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "verger",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        18
      ],
      "visitorCapacity": 70,
      "ticket": 0,
      "stay": [
        0.3,
        0.8
      ],
      "leisureValue": 6,
      "radius": 18,
      "dayAppeal": 1.1,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.6,
      "childAppeal": 0.9,
      "title": "the Metropolitan Cathedral"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 12,
        "wage": 14,
        "upkeep": 30,
        "cost": 7000,
        "work": 1400,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            18
          ],
          "visitorCapacity": 70,
          "ticket": 0,
          "stay": [
            0.3,
            0.8
          ],
          "leisureValue": 6,
          "radius": 18,
          "dayAppeal": 1.1,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.6,
          "childAppeal": 0.9,
          "title": "the Metropolitan Cathedral"
        },
        "designs": [
          {
            "key": "185:1:0",
            "index": 0,
            "name": "the great cone of the crown of thorns with its ring of concrete ribs",
            "height": 0.68,
            "draft": false,
            "ops": 28,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                18
              ],
              "visitorCapacity": 70,
              "ticket": 0,
              "stay": [
                0.3,
                0.8
              ],
              "leisureValue": 6,
              "radius": 18,
              "dayAppeal": 1.1,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.6,
              "childAppeal": 0.9,
              "title": "the Metropolitan Cathedral"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rio",
    "tier": 3,
    "blurb": "The crown of thorns the archbishop built in the new centre: the dark glass cone of the nave between its ring of concrete ribs, four thousand souls under the skylight at Mass.",
    "howTo": "A 2×2 plot in the middle of the modern city among offices; a short free visit that adds quiet to a busy district. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rio"
    ]
  },
  {
    "id": "maracana",
    "name": "the Maracana",
    "kindId": 186,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "maracana",
      "key": "",
      "label": "Maracana",
      "color": "#4a8a4a",
      "cost": 17000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "stadium steward",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        10,
        22
      ],
      "visitorCapacity": 300,
      "ticket": 22,
      "stay": [
        1.6,
        2.6
      ],
      "leisureValue": 9,
      "radius": 30,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.9,
      "retireeAppeal": 1.2,
      "childAppeal": 2,
      "title": "the Maracana"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 60,
        "wage": 17,
        "upkeep": 80,
        "cost": 17000,
        "work": 3800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            10,
            22
          ],
          "visitorCapacity": 300,
          "ticket": 22,
          "stay": [
            1.6,
            2.6
          ],
          "leisureValue": 9,
          "radius": 30,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.9,
          "retireeAppeal": 1.2,
          "childAppeal": 2,
          "title": "the Maracana"
        },
        "designs": [
          {
            "key": "186:1:0",
            "index": 0,
            "name": "the great bowl with its green pitch and floodlight towers",
            "height": 0.44,
            "draft": false,
            "ops": 21,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                22
              ],
              "visitorCapacity": 300,
              "ticket": 22,
              "stay": [
                1.6,
                2.6
              ],
              "leisureValue": 9,
              "radius": 30,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.9,
              "retireeAppeal": 1.2,
              "childAppeal": 2,
              "title": "the Maracana"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "rio",
    "tier": 4,
    "blurb": "The house of football where two hundred thousand once roared at the World Cup final: the great bowl, the green pitch, the floodlight towers, and the noise that never quite dies.",
    "howTo": "A 2×2 plot near transit; it fills on match nights and pays for itself, so give it a metro or buses and leave the streets clear after the whistle. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rio"
    ]
  },
  {
    "id": "sambadrome",
    "name": "the Sambadrome",
    "kindId": 187,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "sambadrome",
      "key": "",
      "label": "Sambadrome",
      "color": "#e8c53c",
      "cost": 14000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "carnival steward",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        18,
        24
      ],
      "visitorCapacity": 260,
      "ticket": 28,
      "stay": [
        2.5,
        3.5
      ],
      "leisureValue": 10,
      "radius": 30,
      "eventNights": [
        5,
        6
      ],
      "eventStart": 20,
      "dayAppeal": 0.15,
      "eveningAppeal": 1.8,
      "retireeAppeal": 0.8,
      "childAppeal": 1.8,
      "title": "the Sambadrome"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 45,
        "wage": 18,
        "upkeep": 90,
        "cost": 14000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            18,
            24
          ],
          "visitorCapacity": 260,
          "ticket": 28,
          "stay": [
            2.5,
            3.5
          ],
          "leisureValue": 10,
          "radius": 30,
          "eventNights": [
            5,
            6
          ],
          "eventStart": 20,
          "dayAppeal": 0.15,
          "eveningAppeal": 1.8,
          "retireeAppeal": 0.8,
          "childAppeal": 1.8,
          "title": "the Sambadrome"
        },
        "designs": [
          {
            "key": "187:1:0",
            "index": 0,
            "name": "the parade avenue between the coloured grandstands to the square of the apotheosis",
            "height": 0.44,
            "draft": false,
            "ops": 18,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                18,
                24
              ],
              "visitorCapacity": 260,
              "ticket": 28,
              "stay": [
                2.5,
                3.5
              ],
              "leisureValue": 10,
              "radius": 30,
              "eventNights": [
                5,
                6
              ],
              "eventStart": 20,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.8,
              "retireeAppeal": 0.8,
              "childAppeal": 1.8,
              "title": "the Sambadrome"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 4,
      "door": [
        0,
        3
      ]
    },
    "group": "rio",
    "tier": 5,
    "blurb": "The avenue Oscar Niemeyer built for the carnival: the parade street between the coloured grandstands, and at the far end the square of the apotheosis where the schools of samba make their last turn.",
    "howTo": "Placed with its tool it is a 1×4 landmark on dry land, its door at one end; it fills on carnival nights, so give it a metro and leave the avenue clear for the parade. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "rio"
    ]
  },
  {
    "id": "sydney-opera-house",
    "name": "the Opera House",
    "kindId": 188,
    "code": 12,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "venue",
    "tool": {
      "id": "operahouse",
      "key": "",
      "label": "Opera House",
      "color": "#f4f2ec",
      "cost": 15000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "opera house staff",
      "rotate": true,
      "shifts": [
        {
          "start": 13,
          "hours": 8,
          "weight": 0.4
        },
        {
          "start": 16,
          "hours": 8,
          "weight": 0.6
        }
      ],
      "cycles": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          1,
          1,
          0,
          0,
          1,
          1,
          1
        ],
        [
          1,
          1,
          1,
          0,
          0,
          1,
          1
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "theatre",
      "openHours": [
        12,
        23
      ],
      "visitorCapacity": 210,
      "ticket": 28,
      "stay": [
        2,
        3
      ],
      "leisureValue": 10,
      "radius": 32,
      "eventNights": [
        2,
        4,
        5,
        6
      ],
      "eventStart": 19.5,
      "dayAppeal": 0.15,
      "eveningAppeal": 1.5,
      "retireeAppeal": 1.6,
      "childAppeal": 1.6,
      "title": "the Opera House"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 20,
        "upkeep": 100,
        "cost": 15000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 30
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "theatre",
          "openHours": [
            12,
            23
          ],
          "visitorCapacity": 210,
          "ticket": 28,
          "stay": [
            2,
            3
          ],
          "leisureValue": 10,
          "radius": 32,
          "eventNights": [
            2,
            4,
            5,
            6
          ],
          "eventStart": 19.5,
          "dayAppeal": 0.15,
          "eveningAppeal": 1.5,
          "retireeAppeal": 1.6,
          "childAppeal": 1.6,
          "title": "the Opera House"
        },
        "designs": [
          {
            "key": "188:1:0",
            "index": 0,
            "name": "the white sails over the harbour on their grand podium",
            "height": 0.6,
            "draft": false,
            "ops": 12,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                12,
                23
              ],
              "visitorCapacity": 210,
              "ticket": 28,
              "stay": [
                2,
                3
              ],
              "leisureValue": 10,
              "radius": 32,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.5,
              "retireeAppeal": 1.6,
              "childAppeal": 1.6,
              "title": "the Opera House"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "188:1:1",
            "index": 1,
            "name": "six curved shell segments in two clusters over a broad harbour podium and monumental steps",
            "height": 0.9,
            "draft": true,
            "ops": 44,
            "attrs": {
              "venueType": "theatre",
              "openHours": [
                12,
                23
              ],
              "visitorCapacity": 210,
              "ticket": 28,
              "stay": [
                2,
                3
              ],
              "leisureValue": 10,
              "radius": 32,
              "eventNights": [
                2,
                4,
                5,
                6
              ],
              "eventStart": 19.5,
              "dayAppeal": 0.15,
              "eveningAppeal": 1.5,
              "retireeAppeal": 1.6,
              "childAppeal": 1.6,
              "title": "the Opera House"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "sydney",
    "tier": 1,
    "blurb": "Utzon's sails on Bennelong Point, the young architect's shells that became the harbour itself: the grand podium on the water, the white sails rising highest at the back, the ferries passing below.",
    "howTo": "A 2×2 plot at the water's edge, open to the harbour; a night-time venue that fills on show nights, so give it ferries or buses and restaurants near. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "sydney"
    ]
  },
  {
    "id": "harbour-bridge",
    "name": "the Harbour Bridge",
    "kindId": 189,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "harbourbridge",
      "key": "",
      "label": "Harbour Bridge",
      "color": "#8a8f96",
      "cost": 13000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "bridge walk guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        19
      ],
      "visitorCapacity": 100,
      "ticket": 14,
      "stay": [
        0.8,
        1.6
      ],
      "leisureValue": 8,
      "radius": 26,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.5,
      "retireeAppeal": 1.5,
      "childAppeal": 1.5,
      "title": "the Harbour Bridge"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 22,
        "wage": 16,
        "upkeep": 60,
        "cost": 13000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            19
          ],
          "visitorCapacity": 100,
          "ticket": 14,
          "stay": [
            0.8,
            1.6
          ],
          "leisureValue": 8,
          "radius": 26,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.5,
          "retireeAppeal": 1.5,
          "childAppeal": 1.5,
          "title": "the Harbour Bridge"
        },
        "designs": [
          {
            "key": "189:1:0",
            "index": 0,
            "name": "the great arch in its granite pylons over the harbour crossing",
            "height": 0.81,
            "draft": false,
            "ops": 32,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 100,
              "ticket": 14,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 8,
              "radius": 26,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.5,
              "childAppeal": 1.5,
              "title": "the Harbour Bridge"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 4,
      "door": [
        0,
        3
      ]
    },
    "group": "sydney",
    "tier": 2,
    "blurb": "The coathanger over the harbour, the arch the climbers pay to scale at dawn: the deck between the granite pylons, the great curve of steel, and the harbour shining through the hangers.",
    "howTo": "Placed with its tool it is a 1×4 landmark on dry land, its door at one end; in a real city it would span the water it crosses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "sydney"
    ]
  },
  {
    "id": "sydney-tower",
    "name": "Sydney Tower",
    "kindId": 190,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "sydneytower",
      "key": "",
      "label": "Sydney Tower",
      "color": "#d8a83c",
      "cost": 12000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "lookout host",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        10,
        21
      ],
      "visitorCapacity": 110,
      "ticket": 20,
      "stay": [
        0.8,
        1.4
      ],
      "leisureValue": 8,
      "radius": 26,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.9,
      "retireeAppeal": 1.5,
      "childAppeal": 1.7,
      "title": "Sydney Tower"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 26,
        "wage": 16,
        "upkeep": 60,
        "cost": 12000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 40
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            10,
            21
          ],
          "visitorCapacity": 110,
          "ticket": 20,
          "stay": [
            0.8,
            1.4
          ],
          "leisureValue": 8,
          "radius": 26,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.9,
          "retireeAppeal": 1.5,
          "childAppeal": 1.7,
          "title": "Sydney Tower"
        },
        "designs": [
          {
            "key": "190:1:0",
            "index": 0,
            "name": "the golden turret on its slender shaft over the shopping centre",
            "height": 1.83,
            "draft": false,
            "ops": 17,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                21
              ],
              "visitorCapacity": 110,
              "ticket": 20,
              "stay": [
                0.8,
                1.4
              ],
              "leisureValue": 8,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.9,
              "retireeAppeal": 1.5,
              "childAppeal": 1.7,
              "title": "Sydney Tower"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "sydney",
    "tier": 3,
    "blurb": "The golden turret over the shopping centre in the middle of the city: the slender shaft, the observation deck three hundred metres up, and the harbour and the bridge in one glance.",
    "howTo": "A 2×2 plot in the retail heart; a day-and-night lookout that draws the young, best with a station under it. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "sydney"
    ]
  },
  {
    "id": "st-marys-cathedral",
    "name": "St Mary's Cathedral",
    "kindId": 191,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "stmarys",
      "key": "",
      "label": "St Mary's",
      "color": "#cfc0a0",
      "cost": 8000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "verger",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        19
      ],
      "visitorCapacity": 80,
      "ticket": 0,
      "stay": [
        0.4,
        0.9
      ],
      "leisureValue": 6,
      "radius": 20,
      "dayAppeal": 1.2,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.8,
      "childAppeal": 1,
      "title": "St Mary's Cathedral"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 14,
        "wage": 14,
        "upkeep": 35,
        "cost": 8000,
        "work": 1600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            19
          ],
          "visitorCapacity": 80,
          "ticket": 0,
          "stay": [
            0.4,
            0.9
          ],
          "leisureValue": 6,
          "radius": 20,
          "dayAppeal": 1.2,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.8,
          "childAppeal": 1,
          "title": "St Mary's Cathedral"
        },
        "designs": [
          {
            "key": "191:1:0",
            "index": 0,
            "name": "the sandstone cathedral with its twin spires over the square",
            "height": 1,
            "draft": false,
            "ops": 26,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19
              ],
              "visitorCapacity": 80,
              "ticket": 0,
              "stay": [
                0.4,
                0.9
              ],
              "leisureValue": 6,
              "radius": 20,
              "dayAppeal": 1.2,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.8,
              "childAppeal": 1,
              "title": "St Mary's Cathedral"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "sydney",
    "tier": 4,
    "blurb": "The sandstone cathedral across the square from the green: the long nave, the rose window, and the twin spires that watched the city for a hundred years before they were finished.",
    "howTo": "A 2×2 plot facing a park or square; a short free visit that adds quiet to the civic heart. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "sydney"
    ]
  },
  {
    "id": "golden-gate",
    "name": "the Golden Gate Bridge",
    "kindId": 192,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "goldengate",
      "key": "",
      "label": "Golden Gate",
      "color": "#c0362c",
      "cost": 14000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "bridge walk guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        19
      ],
      "visitorCapacity": 110,
      "ticket": 10,
      "stay": [
        0.8,
        1.6
      ],
      "leisureValue": 8,
      "radius": 28,
      "dayAppeal": 1.6,
      "eveningAppeal": 0.5,
      "retireeAppeal": 1.5,
      "childAppeal": 1.6,
      "title": "the Golden Gate Bridge"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 16,
        "upkeep": 65,
        "cost": 14000,
        "work": 3200,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            19
          ],
          "visitorCapacity": 110,
          "ticket": 10,
          "stay": [
            0.8,
            1.6
          ],
          "leisureValue": 8,
          "radius": 28,
          "dayAppeal": 1.6,
          "eveningAppeal": 0.5,
          "retireeAppeal": 1.5,
          "childAppeal": 1.6,
          "title": "the Golden Gate Bridge"
        },
        "designs": [
          {
            "key": "192:1:0",
            "index": 0,
            "name": "the orange towers tall over the strait between the two headlands, the cables sagging to the deck and the hangers dropping from them",
            "height": 2,
            "draft": false,
            "ops": 72,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 10,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.6,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.5,
              "childAppeal": 1.6,
              "title": "the Golden Gate Bridge"
            },
            "author": "claude-fable-5-1"
          },
          {
            "key": "192:1:1",
            "index": 1,
            "name": "tall art-deco towers, continuous side-span cables, separate suspenders and tiny traffic above the water",
            "height": 1.46,
            "draft": true,
            "ops": 97,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 10,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.6,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.5,
              "childAppeal": 1.6,
              "title": "the Golden Gate Bridge"
            },
            "author": "k3.1-pro"
          },
          {
            "key": "192:1:2",
            "index": 2,
            "name": "the orange towers and the great cables over the strait",
            "height": 0.74,
            "draft": true,
            "ops": 37,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 110,
              "ticket": 10,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.6,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.5,
              "childAppeal": 1.6,
              "title": "the Golden Gate Bridge"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 1,
      "h": 4,
      "door": [
        0,
        3
      ]
    },
    "group": "san-francisco",
    "tier": 1,
    "blurb": "The bridge they said could not be built, the orange towers wading through the fog of the strait: the deck a mile and a half long, the cables sagging between the tower tops, the whole bay in one glance from the middle.",
    "howTo": "Placed with its tool it is a 1×4 landmark on dry land, its door at one end; in a real city it would span the strait it crosses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "san-francisco"
    ]
  },
  {
    "id": "transamerica-pyramid",
    "name": "the Transamerica Pyramid",
    "kindId": 193,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "transamerica",
      "key": "",
      "label": "Transamerica Pyramid",
      "color": "#e8e4da",
      "cost": 20000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 260,
        "wage": 42,
        "upkeep": 110,
        "cost": 20000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 55
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "193:1:0",
            "index": 0,
            "name": "the white pyramid with its wings and spire",
            "height": 1.8,
            "draft": false,
            "ops": 17,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "193:1:1",
            "index": 1,
            "name": "the pyramid at its real slenderness over the open truss base, the wings following its slope, the aluminium spire",
            "height": 3.58,
            "draft": true,
            "ops": 24,
            "attrs": {},
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "san-francisco",
    "tier": 2,
    "blurb": "The pyramid on the skyline, the tallest thing in the city for a generation: the white shaft tapering to its point, the little wings on its flanks, and the spire that blinks over the fog.",
    "howTo": "A 2×2 plot downtown among offices; a big workplace, so give it buses or a station. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "san-francisco"
    ]
  },
  {
    "id": "coit-tower",
    "name": "Coit Tower",
    "kindId": 194,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "coittower",
      "key": "",
      "label": "Coit Tower",
      "color": "#f0ece2",
      "cost": 7000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "lookout host",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        10,
        18.5
      ],
      "visitorCapacity": 70,
      "ticket": 10,
      "stay": [
        0.4,
        0.9
      ],
      "leisureValue": 6,
      "radius": 20,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.4,
      "retireeAppeal": 1.6,
      "childAppeal": 1.1,
      "title": "Coit Tower"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 12,
        "wage": 14,
        "upkeep": 30,
        "cost": 7000,
        "work": 1400,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            10,
            18.5
          ],
          "visitorCapacity": 70,
          "ticket": 10,
          "stay": [
            0.4,
            0.9
          ],
          "leisureValue": 6,
          "radius": 20,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.4,
          "retireeAppeal": 1.6,
          "childAppeal": 1.1,
          "title": "Coit Tower"
        },
        "designs": [
          {
            "key": "194:1:0",
            "index": 0,
            "name": "the white tower on its hill above the bay, the dark observation band under its cap",
            "height": 0.76,
            "draft": false,
            "ops": 16,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                18.5
              ],
              "visitorCapacity": 70,
              "ticket": 10,
              "stay": [
                0.4,
                0.9
              ],
              "leisureValue": 6,
              "radius": 20,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.4,
              "retireeAppeal": 1.6,
              "childAppeal": 1.1,
              "title": "Coit Tower"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "194:1:1",
            "index": 1,
            "name": "the fluted column flared at its top on a higher Telegraph Hill, the arcaded lookout, the Filbert steps down the front",
            "height": 1.64,
            "draft": true,
            "ops": 35,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                18.5
              ],
              "visitorCapacity": 70,
              "ticket": 10,
              "stay": [
                0.4,
                0.9
              ],
              "leisureValue": 6,
              "radius": 20,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.4,
              "retireeAppeal": 1.6,
              "childAppeal": 1.1,
              "title": "Coit Tower"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "san-francisco",
    "tier": 3,
    "blurb": "The plain white column on Telegraph Hill, the gift of a firemen's friend who loved the city's heroes: the shaft over the bay, the dark band of the observation windows, the wild parrots in the trees below.",
    "howTo": "A 2×2 plot high over the water, lawns below; a short cheap visit for the view, prettiest at dusk. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "san-francisco"
    ]
  },
  {
    "id": "ferry-building",
    "name": "the Ferry Building",
    "kindId": 195,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "ferrybuilding",
      "key": "",
      "label": "Ferry Building",
      "color": "#d9c9a8",
      "cost": 9000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "pier master",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        19
      ],
      "visitorCapacity": 90,
      "ticket": 0,
      "stay": [
        0.5,
        1.1
      ],
      "leisureValue": 6,
      "radius": 22,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.6,
      "childAppeal": 1.1,
      "title": "the Ferry Building"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 16,
        "wage": 15,
        "upkeep": 40,
        "cost": 9000,
        "work": 1800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            19
          ],
          "visitorCapacity": 90,
          "ticket": 0,
          "stay": [
            0.5,
            1.1
          ],
          "leisureValue": 6,
          "radius": 22,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.6,
          "childAppeal": 1.1,
          "title": "the Ferry Building"
        },
        "designs": [
          {
            "key": "195:1:0",
            "index": 0,
            "name": "the arched hall on the pier with its clock tower over the embarkation front",
            "height": 0.92,
            "draft": false,
            "ops": 27,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 90,
              "ticket": 0,
              "stay": [
                0.5,
                1.1
              ],
              "leisureValue": 6,
              "radius": 22,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.6,
              "childAppeal": 1.1,
              "title": "the Ferry Building"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "195:1:1",
            "index": 1,
            "name": "the long arcade of thirteen arches under a stepped clock tower with four dials, the bay and a ferry behind",
            "height": 1.59,
            "draft": true,
            "ops": 70,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19
              ],
              "visitorCapacity": 90,
              "ticket": 0,
              "stay": [
                0.5,
                1.1
              ],
              "leisureValue": 6,
              "radius": 22,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.6,
              "childAppeal": 1.1,
              "title": "the Ferry Building"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "san-francisco",
    "tier": 4,
    "blurb": "The great hall of the ferries at the foot of the market street: the three arches on the embarkation front, the row of little windows above, and the clock tower whose gold faces greeted every boat from the bay.",
    "howTo": "A 2×2 plot at the water's edge with the pier towards it; a free visit that anchors the market district, best near shops. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "san-francisco"
    ]
  },
  {
    "id": "alcatraz",
    "name": "Alcatraz",
    "kindId": 196,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "alcatraz",
      "key": "",
      "label": "Alcatraz",
      "color": "#8a8578",
      "cost": 10000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "island warden",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        18.5
      ],
      "visitorCapacity": 80,
      "ticket": 18,
      "stay": [
        1,
        1.8
      ],
      "leisureValue": 7,
      "radius": 26,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.4,
      "childAppeal": 1.6,
      "title": "Alcatraz"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 20,
        "wage": 16,
        "upkeep": 45,
        "cost": 10000,
        "work": 2000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            18.5
          ],
          "visitorCapacity": 80,
          "ticket": 18,
          "stay": [
            1,
            1.8
          ],
          "leisureValue": 7,
          "radius": 26,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.4,
          "childAppeal": 1.6,
          "title": "Alcatraz"
        },
        "designs": [
          {
            "key": "196:1:0",
            "index": 0,
            "name": "the rock in the bay, the cellhouse and the lighthouse on their island",
            "height": 0.4,
            "draft": false,
            "ops": 15,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                18.5
              ],
              "visitorCapacity": 80,
              "ticket": 18,
              "stay": [
                1,
                1.8
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.4,
              "childAppeal": 1.6,
              "title": "Alcatraz"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "196:1:1",
            "index": 1,
            "name": "the oval rock in the bay, the cellhouse along its top, the lighthouse, the water tower and the dock with its ferry",
            "height": 0.54,
            "draft": true,
            "ops": 34,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                18.5
              ],
              "visitorCapacity": 80,
              "ticket": 18,
              "stay": [
                1,
                1.8
              ],
              "leisureValue": 7,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.4,
              "childAppeal": 1.6,
              "title": "Alcatraz"
            },
            "author": "claude-fable-5-1"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "san-francisco",
    "tier": 5,
    "blurb": "The rock in the bay, the prison they said no one escaped: the ferry out past the island, the cellhouse with its rows of window slits, the lighthouse still sweeping the gate of the bay.",
    "howTo": "A 2×2 plot on the water suits the island; a ticketed day trip for the curious, best with a ferry pier or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "san-francisco"
    ]
  },
  {
    "id": "sagrada-familia",
    "name": "the Sagrada Familia",
    "kindId": 197,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "sagradafamilia",
      "key": "",
      "label": "Sagrada Familia",
      "color": "#e3d5b8",
      "cost": 16000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "works guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        19.5
      ],
      "visitorCapacity": 240,
      "ticket": 22,
      "stay": [
        1,
        2.2
      ],
      "leisureValue": 9,
      "radius": 32,
      "dayAppeal": 1.7,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.8,
      "childAppeal": 1.5,
      "title": "the Sagrada Familia"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 52,
        "wage": 17,
        "upkeep": 70,
        "cost": 16000,
        "work": 3400,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            19.5
          ],
          "visitorCapacity": 240,
          "ticket": 22,
          "stay": [
            1,
            2.2
          ],
          "leisureValue": 9,
          "radius": 32,
          "dayAppeal": 1.7,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.8,
          "childAppeal": 1.5,
          "title": "the Sagrada Familia"
        },
        "designs": [
          {
            "key": "197:1:0",
            "index": 0,
            "name": "the spires of the unfinished basilica with their crane still on the job",
            "height": 1.1,
            "draft": false,
            "ops": 34,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19.5
              ],
              "visitorCapacity": 240,
              "ticket": 22,
              "stay": [
                1,
                2.2
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.8,
              "childAppeal": 1.5,
              "title": "the Sagrada Familia"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "197:1:1",
            "index": 1,
            "name": "thirteen perforated towers with mosaic tips around the central cross, plus the perennial crane",
            "height": 1.9,
            "draft": true,
            "ops": 168,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                19.5
              ],
              "visitorCapacity": 240,
              "ticket": 22,
              "stay": [
                1,
                2.2
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.7,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.8,
              "childAppeal": 1.5,
              "title": "the Sagrada Familia"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "barcelona",
    "tier": 1,
    "blurb": "The basilica the architect left unfinished on purpose, so the work would never stop: the sandstone spires with their gilded tips, the nativity front in its green shade, and the yellow crane that has stood over the crossing for a hundred years.",
    "howTo": "A 2×2 plot in the Eixample grid among apartments; a heavy daytime draw from across the city, so give it a metro or buses. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "barcelona"
    ]
  },
  {
    "id": "casa-batllo",
    "name": "Casa Batllo",
    "kindId": 198,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "casabatllol",
      "key": "",
      "label": "Casa Batllo",
      "color": "#d8b86a",
      "cost": 10000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "house guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9.5,
        20
      ],
      "visitorCapacity": 80,
      "ticket": 18,
      "stay": [
        0.6,
        1.2
      ],
      "leisureValue": 8,
      "radius": 24,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.6,
      "retireeAppeal": 1.5,
      "childAppeal": 1.6,
      "title": "Casa Batllo"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 18,
        "wage": 16,
        "upkeep": 50,
        "cost": 10000,
        "work": 2200,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9.5,
            20
          ],
          "visitorCapacity": 80,
          "ticket": 18,
          "stay": [
            0.6,
            1.2
          ],
          "leisureValue": 8,
          "radius": 24,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.6,
          "retireeAppeal": 1.5,
          "childAppeal": 1.6,
          "title": "Casa Batllo"
        },
        "designs": [
          {
            "key": "198:1:0",
            "index": 0,
            "name": "the house of bones with its dragon roof on the grand avenue",
            "height": 0.95,
            "draft": false,
            "ops": 25,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9.5,
                20
              ],
              "visitorCapacity": 80,
              "ticket": 18,
              "stay": [
                0.6,
                1.2
              ],
              "leisureValue": 8,
              "radius": 24,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.6,
              "retireeAppeal": 1.5,
              "childAppeal": 1.6,
              "title": "Casa Batllo"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "barcelona",
    "tier": 2,
    "blurb": "The house of bones the master rebuilt for the Batllo family: the sand-gold facade, the windows like the mouths of fish, the white balconies of skulls, and the blue back of the dragon curving over the roof.",
    "howTo": "A 2×2 plot on a shopping avenue among apartments; a ticketed visit that glows at dusk, best near restaurants and cafes. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "barcelona"
    ]
  },
  {
    "id": "camp-nou",
    "name": "Camp Nou",
    "kindId": 199,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "campnou",
      "key": "",
      "label": "Camp Nou",
      "color": "#2c5f9e",
      "cost": 19000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "stadium steward",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        10,
        22.5
      ],
      "visitorCapacity": 400,
      "ticket": 24,
      "stay": [
        1.6,
        2.6
      ],
      "leisureValue": 9,
      "radius": 32,
      "dayAppeal": 1.3,
      "eveningAppeal": 1,
      "retireeAppeal": 1.1,
      "childAppeal": 2,
      "title": "Camp Nou"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 65,
        "wage": 17,
        "upkeep": 85,
        "cost": 19000,
        "work": 4000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            10,
            22.5
          ],
          "visitorCapacity": 400,
          "ticket": 24,
          "stay": [
            1.6,
            2.6
          ],
          "leisureValue": 9,
          "radius": 32,
          "dayAppeal": 1.3,
          "eveningAppeal": 1,
          "retireeAppeal": 1.1,
          "childAppeal": 2,
          "title": "Camp Nou"
        },
        "designs": [
          {
            "key": "199:1:0",
            "index": 0,
            "name": "the great blue bowl with its green pitch and floodlight masts",
            "height": 0.52,
            "draft": false,
            "ops": 22,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                22.5
              ],
              "visitorCapacity": 400,
              "ticket": 24,
              "stay": [
                1.6,
                2.6
              ],
              "leisureValue": 9,
              "radius": 32,
              "dayAppeal": 1.3,
              "eveningAppeal": 1,
              "retireeAppeal": 1.1,
              "childAppeal": 2,
              "title": "Camp Nou"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "barcelona",
    "tier": 3,
    "blurb": "The great bowl of the football club, the biggest stadium in Europe for a hundred years: the two tiers of concrete, the ring of blue seats, the green pitch sunk in the middle, and the floodlights leaning over it all.",
    "howTo": "A 2×2 plot near transit; it fills on match nights and pays for itself, so give it a metro and leave the streets clear after the whistle. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "barcelona"
    ]
  },
  {
    "id": "torre-glories",
    "name": "Torre Glories",
    "kindId": 200,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "torreglories",
      "key": "",
      "label": "Torre Glories",
      "color": "#2c4f8a",
      "cost": 21000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 260,
        "wage": 42,
        "upkeep": 120,
        "cost": 21000,
        "work": 4400,
        "parking": {
          "surface": 0,
          "underground": 60
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "200:1:0",
            "index": 0,
            "name": "the blue bullet with its collar of red over the new district",
            "height": 1.22,
            "draft": false,
            "ops": 14,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "barcelona",
    "tier": 4,
    "blurb": "The blue bullet by the old waterfront: the glass body swelling out of the ground, the collar of red where it begins to climb, and the dome of the crown that lights the whole district at night.",
    "howTo": "A 2×2 plot among offices on an avenue; a big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "barcelona"
    ]
  },
  {
    "id": "petronas-towers",
    "name": "the Petronas Towers",
    "kindId": 201,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "petronas",
      "key": "",
      "label": "Petronas Towers",
      "color": "#9fb8cc",
      "cost": 26000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 520,
        "wage": 46,
        "upkeep": 150,
        "cost": 26000,
        "work": 4800,
        "parking": {
          "surface": 0,
          "underground": 90
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "201:1:0",
            "index": 0,
            "name": "the twin steel spires joined by the double-decker skybridge over the fountain court",
            "height": 6.55,
            "draft": false,
            "ops": 21,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "kuala-lumpur",
    "tier": 1,
    "blurb": "The twin towers the prime minister willed into being: two faceted shafts of steel and glass rising out of the fountain court, joined at the forty-first floor by the double-decker skybridge, each crowned with its spire.",
    "howTo": "A 2×2 plot among offices on an avenue; a very big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "kuala-lumpur"
    ]
  },
  {
    "id": "kl-tower",
    "name": "the KL Tower",
    "kindId": 202,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "kltower",
      "key": "",
      "label": "KL Tower",
      "color": "#b0a89a",
      "cost": 18000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 300,
        "wage": 44,
        "upkeep": 120,
        "cost": 18000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 60
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "202:1:0",
            "index": 0,
            "name": "the observatory needle above the forest hill, the bulb of the deck under the mast",
            "height": 5.45,
            "draft": false,
            "ops": 25,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "kuala-lumpur",
    "tier": 2,
    "blurb": "The needle above the forest hill: the tower raised on Bukit Nanas, the last patch of jungle in the centre of the city, its shaft swelling into the great bulb of the observation deck, the whole town spread out below.",
    "howTo": "A 2×2 plot among offices on an avenue; a big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "kuala-lumpur"
    ]
  },
  {
    "id": "merdeka-118",
    "name": "Merdeka 118",
    "kindId": 203,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "merdeka118",
      "key": "",
      "label": "Merdeka 118",
      "color": "#8fa8b8",
      "cost": 28000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 560,
        "wage": 48,
        "upkeep": 160,
        "cost": 28000,
        "work": 5000,
        "parking": {
          "surface": 0,
          "underground": 100
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "203:1:0",
            "index": 0,
            "name": "the diamond-cut glass megatall with its spire over the old stadium",
            "height": 8.5,
            "draft": false,
            "ops": 14,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "kuala-lumpur",
    "tier": 3,
    "blurb": "The megatall beside the old stadium: a shaft of faceted glass, diamond-cut from plinth to crown, a hundred and eighteen storeys to the tip of its spire — the second tallest thing on Earth.",
    "howTo": "A 2×2 plot among offices on an avenue; a very big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "kuala-lumpur"
    ]
  },
  {
    "id": "batu-caves",
    "name": "the Batu Caves",
    "kindId": 204,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "batucaves",
      "key": "",
      "label": "Batu Caves",
      "color": "#c9a227",
      "cost": 13000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "cave temple keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        19
      ],
      "visitorCapacity": 260,
      "ticket": 12,
      "stay": [
        1.2,
        2.2
      ],
      "leisureValue": 8,
      "radius": 28,
      "dayAppeal": 1.6,
      "eveningAppeal": 0.2,
      "retireeAppeal": 1.7,
      "childAppeal": 1.5,
      "title": "the Batu Caves"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 15,
        "upkeep": 55,
        "cost": 13000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            19
          ],
          "visitorCapacity": 260,
          "ticket": 12,
          "stay": [
            1.2,
            2.2
          ],
          "leisureValue": 8,
          "radius": 28,
          "dayAppeal": 1.6,
          "eveningAppeal": 0.2,
          "retireeAppeal": 1.7,
          "childAppeal": 1.5,
          "title": "the Batu Caves"
        },
        "designs": [
          {
            "key": "204:1:0",
            "index": 0,
            "name": "the limestone hill with its gold statue and the rainbow staircase",
            "height": 0.78,
            "draft": false,
            "ops": 32,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19
              ],
              "visitorCapacity": 260,
              "ticket": 12,
              "stay": [
                1.2,
                2.2
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.6,
              "eveningAppeal": 0.2,
              "retireeAppeal": 1.7,
              "childAppeal": 1.5,
              "title": "the Batu Caves"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "kuala-lumpur",
    "tier": 4,
    "blurb": "The limestone hill where the great cave temple keeps its silence: the jungle round it, the gold statue of the god standing forty metres high, and the two hundred and seventy-two steps the pilgrims climb, painted in bands of the rainbow.",
    "howTo": "A 2×2 plot at the city's green edge; a heavy daytime draw, so give it a bus stop and leave the forecourt walkable. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "kuala-lumpur"
    ]
  },
  {
    "id": "cn-tower",
    "name": "the CN Tower",
    "kindId": 205,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "cntower",
      "key": "",
      "label": "CN Tower",
      "color": "#b8b4a8",
      "cost": 20000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 320,
        "wage": 45,
        "upkeep": 130,
        "cost": 20000,
        "work": 4400,
        "parking": {
          "surface": 0,
          "underground": 70
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "205:1:0",
            "index": 0,
            "name": "the concrete needle with its pod in the sky over the harbour",
            "height": 5.25,
            "draft": false,
            "ops": 22,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "205:1:1",
            "index": 1,
            "name": "three concrete buttresses, two dark glazing bands and a separate SkyPod below the striped antenna",
            "height": 5.38,
            "draft": true,
            "ops": 34,
            "attrs": {},
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "toronto",
    "tier": 1,
    "blurb": "The needle the railway built over the harbour: the concrete shaft climbing out of the rail lands, the great pod with its glass-floor lookouts three hundred and fifty metres up, and the antenna painted in bands of red and white.",
    "howTo": "A 2×2 plot among offices on an avenue; a big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "toronto"
    ]
  },
  {
    "id": "casa-loma",
    "name": "Casa Loma",
    "kindId": 206,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "casaloma",
      "key": "",
      "label": "Casa Loma",
      "color": "#cabf9f",
      "cost": 11000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "castle caretaker",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        17
      ],
      "visitorCapacity": 140,
      "ticket": 18,
      "stay": [
        0.8,
        1.6
      ],
      "leisureValue": 8,
      "radius": 24,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.6,
      "childAppeal": 1.6,
      "title": "Casa Loma"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 16,
        "upkeep": 50,
        "cost": 11000,
        "work": 2400,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            17
          ],
          "visitorCapacity": 140,
          "ticket": 18,
          "stay": [
            0.8,
            1.6
          ],
          "leisureValue": 8,
          "radius": 24,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.6,
          "childAppeal": 1.6,
          "title": "Casa Loma"
        },
        "designs": [
          {
            "key": "206:1:0",
            "index": 0,
            "name": "the millionaire castle on the hill with its tower and gardens",
            "height": 0.98,
            "draft": false,
            "ops": 40,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                17
              ],
              "visitorCapacity": 140,
              "ticket": 18,
              "stay": [
                0.8,
                1.6
              ],
              "leisureValue": 8,
              "radius": 24,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.6,
              "childAppeal": 1.6,
              "title": "Casa Loma"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "toronto",
    "tier": 2,
    "blurb": "The castle the millionaire built on the hill and never quite finished paying for: the great hall with its rows of windows, the square tower with its battlements, the turret with its cone roof, and the gardens falling away below.",
    "howTo": "A 2×2 plot above a shopping avenue; a ticketed daytime visit, best near restaurants and cafes. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "toronto"
    ]
  },
  {
    "id": "royal-ontario-museum",
    "name": "the Royal Ontario Museum",
    "kindId": 207,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "rom",
      "key": "",
      "label": "Royal Ontario Museum",
      "color": "#bfd4e0",
      "cost": 13000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "museum guide",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        10,
        17.5
      ],
      "visitorCapacity": 200,
      "ticket": 16,
      "stay": [
        0.9,
        1.8
      ],
      "leisureValue": 8,
      "radius": 26,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.4,
      "retireeAppeal": 1.6,
      "childAppeal": 1.8,
      "title": "the Royal Ontario Museum"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 30,
        "wage": 16,
        "upkeep": 55,
        "cost": 13000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            10,
            17.5
          ],
          "visitorCapacity": 200,
          "ticket": 16,
          "stay": [
            0.9,
            1.8
          ],
          "leisureValue": 8,
          "radius": 26,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.4,
          "retireeAppeal": 1.6,
          "childAppeal": 1.8,
          "title": "the Royal Ontario Museum"
        },
        "designs": [
          {
            "key": "207:1:0",
            "index": 0,
            "name": "the stone museum with the glass crystal bursting out of its corner",
            "height": 1.35,
            "draft": false,
            "ops": 25,
            "attrs": {
              "venueType": "library",
              "openHours": [
                10,
                17.5
              ],
              "visitorCapacity": 200,
              "ticket": 16,
              "stay": [
                0.9,
                1.8
              ],
              "leisureValue": 8,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.4,
              "retireeAppeal": 1.6,
              "childAppeal": 1.8,
              "title": "the Royal Ontario Museum"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "toronto",
    "tier": 3,
    "blurb": "The museum of stone and crystal on the avenue: the pale 1914 building with its arched windows, and the crystal bolted onto its front corner — five glass prisms stepping out over the pavement, jagged as a quartz seam.",
    "howTo": "A 2×2 plot on a shopping avenue among apartments; a ticketed visit that glows at dusk, best near cafes and a bus stop. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "toronto"
    ]
  },
  {
    "id": "old-city-hall",
    "name": "Old City Hall",
    "kindId": 208,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "oldcityhall",
      "key": "",
      "label": "Old City Hall",
      "color": "#9a7a5a",
      "cost": 19000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 340,
        "wage": 44,
        "upkeep": 110,
        "cost": 19000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 50
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "208:1:0",
            "index": 0,
            "name": "the Romanesque sandstone pile with its clock tower over the square",
            "height": 1.2,
            "draft": false,
            "ops": 32,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "toronto",
    "tier": 4,
    "blurb": "The Romanesque pile over the old market square: the sandstone mass with its round-arched windows, the grand arch of the door, and the clock tower that has kept the courts' time for over a hundred years.",
    "howTo": "A 2×2 plot among offices near a square; a big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "toronto"
    ]
  },
  {
    "id": "space-needle",
    "name": "the Space Needle",
    "kindId": 209,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "spaceneedle",
      "key": "",
      "label": "Space Needle",
      "color": "#d97c2c",
      "cost": 19000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 280,
        "wage": 44,
        "upkeep": 120,
        "cost": 19000,
        "work": 4200,
        "parking": {
          "surface": 0,
          "underground": 60
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "209:1:0",
            "index": 0,
            "name": "the flying saucer on its tripod legs over the fairground",
            "height": 3.1,
            "draft": false,
            "ops": 17,
            "attrs": {},
            "author": "kimi-2.8-preview"
          },
          {
            "key": "209:1:1",
            "index": 1,
            "name": "six splayed legs around a lift core, a dark observation band and an orange halo roof",
            "height": 3.11,
            "draft": true,
            "ops": 34,
            "attrs": {},
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "seattle",
    "tier": 1,
    "blurb": "The saucer the fairground built and the city refused to give back: three tripod legs leaning together, the flying-saucer top with its ring of windows a hundred and sixty metres up, and the orange roof disc over it all.",
    "howTo": "A 2×2 plot among offices on an avenue; a big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "seattle"
    ]
  },
  {
    "id": "pike-place",
    "name": "Pike Place Market",
    "kindId": 210,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "pikeplace",
      "key": "",
      "label": "Pike Place",
      "color": "#a83a2c",
      "cost": 12000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "market keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        18
      ],
      "visitorCapacity": 160,
      "ticket": 0,
      "stay": [
        0.6,
        1.4
      ],
      "leisureValue": 8,
      "radius": 24,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.5,
      "retireeAppeal": 1.6,
      "childAppeal": 1.5,
      "title": "Pike Place Market"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 28,
        "wage": 15,
        "upkeep": 50,
        "cost": 12000,
        "work": 2600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            18
          ],
          "visitorCapacity": 160,
          "ticket": 0,
          "stay": [
            0.6,
            1.4
          ],
          "leisureValue": 8,
          "radius": 24,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.5,
          "retireeAppeal": 1.6,
          "childAppeal": 1.5,
          "title": "Pike Place Market"
        },
        "designs": [
          {
            "key": "210:1:0",
            "index": 0,
            "name": "the market sheds sloping to the harbour with their neon sign",
            "height": 0.5,
            "draft": false,
            "ops": 24,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                18
              ],
              "visitorCapacity": 160,
              "ticket": 0,
              "stay": [
                0.6,
                1.4
              ],
              "leisureValue": 8,
              "radius": 24,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.6,
              "childAppeal": 1.5,
              "title": "Pike Place Market"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "seattle",
    "tier": 2,
    "blurb": "The market the city kept when the bulldozers came for the waterfront: the long sheds with their stepped gable roofs, the neon sign over the door, and the stalls out front where they throw the fish.",
    "howTo": "A 2×2 plot on a shopping avenue near the water; a free-to-wander daytime draw, best near cafes and a bus stop. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "seattle"
    ]
  },
  {
    "id": "columbia-center",
    "name": "the Columbia Center",
    "kindId": 211,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "columbiacenter",
      "key": "",
      "label": "Columbia Center",
      "color": "#2c3038",
      "cost": 25000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 460,
        "wage": 47,
        "upkeep": 140,
        "cost": 25000,
        "work": 4700,
        "parking": {
          "surface": 0,
          "underground": 90
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "211:1:0",
            "index": 0,
            "name": "the black glass monolith with its three white fins",
            "height": 3.85,
            "draft": false,
            "ops": 17,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "seattle",
    "tier": 3,
    "blurb": "The black monolith the bank raised over the downtown: seventy-six storeys of smoked glass, the tallest thing on the coast, its crown stepping back under the three white fins that run up the front.",
    "howTo": "A 2×2 plot among offices on an avenue; a very big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "seattle"
    ]
  },
  {
    "id": "smith-tower",
    "name": "the Smith Tower",
    "kindId": 212,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tool": {
      "id": "smithtower",
      "key": "",
      "label": "Smith Tower",
      "color": "#e8e2d4",
      "cost": 17000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 300,
        "wage": 43,
        "upkeep": 100,
        "cost": 17000,
        "work": 4000,
        "parking": {
          "surface": 0,
          "underground": 45
        },
        "tech": [
          "wld1"
        ],
        "attrs": {},
        "designs": [
          {
            "key": "212:1:0",
            "index": 0,
            "name": "the white terra-cotta tower of 1914 with its pyramid roof and cupola",
            "height": 3.4,
            "draft": false,
            "ops": 15,
            "attrs": {},
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "seattle",
    "tier": 4,
    "blurb": "The white tower of 1914 that was the city's boast for half a century: the terra-cotta shaft with its lattice of windows, the four-sided pyramid of the roof, and the little cupola with its ball on top, built by the typewriter magnate.",
    "howTo": "A 2×2 plot among offices on an avenue; a big workplace, so give it buses or a station and leave the street clear. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "seattle"
    ]
  },
  {
    "id": "taj-mahal",
    "name": "the Taj Mahal",
    "kindId": 213,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "tajmahal",
      "key": "",
      "label": "Taj Mahal",
      "color": "#f2ede2",
      "cost": 20000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "monument keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8,
        19
      ],
      "visitorCapacity": 320,
      "ticket": 20,
      "stay": [
        1.2,
        2.4
      ],
      "leisureValue": 10,
      "radius": 34,
      "dayAppeal": 1.9,
      "eveningAppeal": 0.6,
      "retireeAppeal": 1.9,
      "childAppeal": 1.3,
      "title": "the Taj Mahal"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 55,
        "wage": 17,
        "upkeep": 80,
        "cost": 20000,
        "work": 3600,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8,
            19
          ],
          "visitorCapacity": 320,
          "ticket": 20,
          "stay": [
            1.2,
            2.4
          ],
          "leisureValue": 10,
          "radius": 34,
          "dayAppeal": 1.9,
          "eveningAppeal": 0.6,
          "retireeAppeal": 1.9,
          "childAppeal": 1.3,
          "title": "the Taj Mahal"
        },
        "designs": [
          {
            "key": "213:1:0",
            "index": 0,
            "name": "the white marble mausoleum with its dome, minarets and reflecting pool",
            "height": 1,
            "draft": false,
            "ops": 41,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19
              ],
              "visitorCapacity": 320,
              "ticket": 20,
              "stay": [
                1.2,
                2.4
              ],
              "leisureValue": 10,
              "radius": 34,
              "dayAppeal": 1.9,
              "eveningAppeal": 0.6,
              "retireeAppeal": 1.9,
              "childAppeal": 1.3,
              "title": "the Taj Mahal"
            },
            "author": "kimi-2.8-preview"
          },
          {
            "key": "213:1:1",
            "index": 1,
            "name": "the marble crown: rooftop chhatris, banded minarets and a charbagh reflecting pool",
            "height": 0.96,
            "draft": true,
            "ops": 42,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8,
                19
              ],
              "visitorCapacity": 320,
              "ticket": 20,
              "stay": [
                1.2,
                2.4
              ],
              "leisureValue": 10,
              "radius": 34,
              "dayAppeal": 1.9,
              "eveningAppeal": 0.6,
              "retireeAppeal": 1.9,
              "childAppeal": 1.3,
              "title": "the Taj Mahal"
            },
            "author": "k3.1-pro"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "agra",
    "tier": 1,
    "blurb": "The marble teardrop the emperor built for his wife and the whole world came to see: the riverfront terrace, the cube of the mausoleum under its onion dome, the four minarets standing guard, and the long reflecting pool down the garden axis.",
    "howTo": "A 2×2 plot at the city's green edge or on the river; the heaviest daytime draw of the world set, so give it a bus stop and leave the garden walkable. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "agra"
    ]
  },
  {
    "id": "agra-fort",
    "name": "the Agra Fort",
    "kindId": 214,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "agrafort",
      "key": "",
      "label": "Agra Fort",
      "color": "#a8503c",
      "cost": 15000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "fort keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8.5,
        18.5
      ],
      "visitorCapacity": 220,
      "ticket": 14,
      "stay": [
        1,
        2
      ],
      "leisureValue": 8,
      "radius": 28,
      "dayAppeal": 1.5,
      "eveningAppeal": 0.3,
      "retireeAppeal": 1.6,
      "childAppeal": 1.4,
      "title": "the Agra Fort"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 40,
        "wage": 16,
        "upkeep": 60,
        "cost": 15000,
        "work": 3000,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8.5,
            18.5
          ],
          "visitorCapacity": 220,
          "ticket": 14,
          "stay": [
            1,
            2
          ],
          "leisureValue": 8,
          "radius": 28,
          "dayAppeal": 1.5,
          "eveningAppeal": 0.3,
          "retireeAppeal": 1.6,
          "childAppeal": 1.4,
          "title": "the Agra Fort"
        },
        "designs": [
          {
            "key": "214:1:0",
            "index": 0,
            "name": "the red sandstone walls of the emperors' palace above the river",
            "height": 0.55,
            "draft": false,
            "ops": 21,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8.5,
                18.5
              ],
              "visitorCapacity": 220,
              "ticket": 14,
              "stay": [
                1,
                2
              ],
              "leisureValue": 8,
              "radius": 28,
              "dayAppeal": 1.5,
              "eveningAppeal": 0.3,
              "retireeAppeal": 1.6,
              "childAppeal": 1.4,
              "title": "the Agra Fort"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "agra",
    "tier": 2,
    "blurb": "The red walls the emperors kept above the river: the sandstone ramparts with their battlements, the great gate, the white mosque inside, and the gardens where the court once walked.",
    "howTo": "A 2×2 plot near the river or the old town; a ticketed daytime visit, best near the Taj Mahal for the tourist trail and a bus stop. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "agra"
    ]
  },
  {
    "id": "fatehpur-sikri",
    "name": "Fatehpur Sikri",
    "kindId": 215,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "fatehpursikri",
      "key": "",
      "label": "Fatehpur Sikri",
      "color": "#c09a6a",
      "cost": 14000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "ridge city keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8.5,
        18
      ],
      "visitorCapacity": 180,
      "ticket": 12,
      "stay": [
        1,
        2
      ],
      "leisureValue": 8,
      "radius": 26,
      "dayAppeal": 1.4,
      "eveningAppeal": 0.2,
      "retireeAppeal": 1.6,
      "childAppeal": 1.4,
      "title": "Fatehpur Sikri"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 34,
        "wage": 15,
        "upkeep": 55,
        "cost": 14000,
        "work": 2800,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8.5,
            18
          ],
          "visitorCapacity": 180,
          "ticket": 12,
          "stay": [
            1,
            2
          ],
          "leisureValue": 8,
          "radius": 26,
          "dayAppeal": 1.4,
          "eveningAppeal": 0.2,
          "retireeAppeal": 1.6,
          "childAppeal": 1.4,
          "title": "Fatehpur Sikri"
        },
        "designs": [
          {
            "key": "215:1:0",
            "index": 0,
            "name": "the abandoned city on the ridge, its great gate still standing",
            "height": 0.95,
            "draft": false,
            "ops": 26,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8.5,
                18
              ],
              "visitorCapacity": 180,
              "ticket": 12,
              "stay": [
                1,
                2
              ],
              "leisureValue": 8,
              "radius": 26,
              "dayAppeal": 1.4,
              "eveningAppeal": 0.2,
              "retireeAppeal": 1.6,
              "childAppeal": 1.4,
              "title": "Fatehpur Sikri"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "agra",
    "tier": 3,
    "blurb": "The city the emperor built on the ridge and abandoned in a single generation: the great gate of the mosque still standing over the court, its domed chhatris against the sky, and beside it the white marble tomb of the saint whose blessing founded the place.",
    "howTo": "A 2×2 plot at the city's edge; a ticketed daytime visit, best near the Taj Mahal for the tourist trail and a bus stop. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "agra"
    ]
  },
  {
    "id": "itimad-ud-daulah",
    "name": "the Itimad-ud-Daulah",
    "kindId": 216,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tool": {
      "id": "itimad",
      "key": "",
      "label": "Itimad-ud-Daulah",
      "color": "#f2ede2",
      "cost": 11000
    },
    "tech": [
      "wld1"
    ],
    "occupation": {
      "name": "tomb keeper",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        8.5,
        18.5
      ],
      "visitorCapacity": 120,
      "ticket": 12,
      "stay": [
        0.7,
        1.4
      ],
      "leisureValue": 8,
      "radius": 24,
      "dayAppeal": 1.3,
      "eveningAppeal": 0.5,
      "retireeAppeal": 1.6,
      "childAppeal": 1.3,
      "title": "the Itimad-ud-Daulah"
    },
    "levels": [
      {
        "level": 1,
        "capacity": 22,
        "wage": 15,
        "upkeep": 45,
        "cost": 11000,
        "work": 2400,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [
          "wld1"
        ],
        "attrs": {
          "venueType": "library",
          "openHours": [
            8.5,
            18.5
          ],
          "visitorCapacity": 120,
          "ticket": 12,
          "stay": [
            0.7,
            1.4
          ],
          "leisureValue": 8,
          "radius": 24,
          "dayAppeal": 1.3,
          "eveningAppeal": 0.5,
          "retireeAppeal": 1.6,
          "childAppeal": 1.3,
          "title": "the Itimad-ud-Daulah"
        },
        "designs": [
          {
            "key": "216:1:0",
            "index": 0,
            "name": "the marble jewel box on the river they call the Baby Taj",
            "height": 0.55,
            "draft": false,
            "ops": 27,
            "attrs": {
              "venueType": "library",
              "openHours": [
                8.5,
                18.5
              ],
              "visitorCapacity": 120,
              "ticket": 12,
              "stay": [
                0.7,
                1.4
              ],
              "leisureValue": 8,
              "radius": 24,
              "dayAppeal": 1.3,
              "eveningAppeal": 0.5,
              "retireeAppeal": 1.6,
              "childAppeal": 1.3,
              "title": "the Itimad-ud-Daulah"
            },
            "author": "kimi-2.8-preview"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        1,
        1
      ]
    },
    "group": "agra",
    "tier": 4,
    "blurb": "The marble jewel box on the east bank of the river that they call the Baby Taj: the white plinth in the water garden, the cube of the tomb with its screens of pierced marble, the four hexagonal turrets, and the dome floating over it all.",
    "howTo": "A 2×2 plot on the river or the green edge; a quiet ticketed visit, best near the Taj Mahal for the tourist trail and a bus stop. World landmark: unlock rule to be decided.",
    "landmark": true,
    "tags": [
      "world",
      "agra"
    ]
  },
  {
    "id": "landmark-template",
    "name": "landmark template",
    "kindId": 230,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tech": [],
    "occupation": {
      "name": "office worker",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 20,
        "wage": 20,
        "upkeep": 30,
        "cost": 3000,
        "work": 800,
        "parking": {
          "surface": 2,
          "underground": 6
        },
        "tech": [],
        "attrs": {},
        "designs": [
          {
            "key": "230:1:0",
            "index": 0,
            "name": "<short description of the model>",
            "height": 0.9,
            "draft": true,
            "ops": 6,
            "attrs": {},
            "author": "<your name or model id>"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ]
    },
    "draft": true,
    "blurb": "A starting point for a landmark: a paved plot, a windowed block with its door on the front, a roof and a finial.",
    "howTo": "A 2×2 plot with its door on the street. Staffed like any office. Draft: not placed in the city.",
    "landmark": true,
    "tags": [
      "draft"
    ]
  },
  {
    "id": "town-clock-tower",
    "name": "the town hall clock tower",
    "kindId": 231,
    "code": 4,
    "family": "office",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": false
    },
    "windows": "office",
    "tech": [],
    "occupation": {
      "name": "town clerk's staff",
      "rotate": false,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 8,
          "hours": 8,
          "weight": 0.2
        },
        {
          "start": 10,
          "hours": 8,
          "weight": 0.15
        },
        {
          "start": 7,
          "hours": 8,
          "weight": 0.05
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ]
      ]
    },
    "attrs": {},
    "levels": [
      {
        "level": 1,
        "capacity": 24,
        "wage": 22,
        "upkeep": 40,
        "cost": 4000,
        "work": 1000,
        "parking": {
          "surface": 2,
          "underground": 6
        },
        "tech": [],
        "attrs": {},
        "designs": [
          {
            "key": "231:1:0",
            "index": 0,
            "name": "sandstone town hall with a clock tower, four dials and a slate spire",
            "height": 2.5,
            "draft": true,
            "ops": 51,
            "attrs": {},
            "author": "docs example"
          }
        ]
      }
    ],
    "footprint": {
      "w": 2,
      "h": 2,
      "door": [
        0,
        1
      ]
    },
    "draft": true,
    "blurb": "A Victorian town hall in sandstone with a clock tower on its front: four dials that light at dusk and keep the city's time under a slate spire.",
    "howTo": "A 2×2 plot in the middle of town, the door on the main street. The town's offices work here, and the clock is the square's meeting place.",
    "landmark": true,
    "tags": [
      "draft",
      "victorian"
    ]
  },
  {
    "id": "war-memorial",
    "name": "the war memorial",
    "kindId": 232,
    "code": 14,
    "family": "leisure",
    "flags": {
      "growable": false,
      "civic": true,
      "service": false,
      "workplace": true,
      "parking": false,
      "leisureReady": true
    },
    "windows": "civic",
    "tech": [],
    "occupation": {
      "name": "librarian",
      "rotate": true,
      "shifts": [
        {
          "start": 9,
          "hours": 8,
          "weight": 0.6
        },
        {
          "start": 11,
          "hours": 8,
          "weight": 0.4
        }
      ],
      "cycles": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          0
        ]
      ]
    },
    "attrs": {
      "venueType": "library",
      "openHours": [
        9,
        18
      ],
      "visitorCapacity": 40,
      "ticket": 4,
      "stay": [
        0.5,
        1.5
      ],
      "leisureValue": 4,
      "radius": 16,
      "dayAppeal": 1.2,
      "eveningAppeal": 0.1,
      "retireeAppeal": 1.8,
      "childAppeal": 1.2
    },
    "levels": [
      {
        "level": 1,
        "capacity": 2,
        "wage": 16,
        "upkeep": 8,
        "cost": 800,
        "work": 300,
        "parking": {
          "surface": 0,
          "underground": 0
        },
        "tech": [],
        "attrs": {
          "venueType": "library",
          "openHours": [
            9,
            18
          ],
          "visitorCapacity": 40,
          "ticket": 4,
          "stay": [
            0.5,
            1.5
          ],
          "leisureValue": 4,
          "radius": 16,
          "dayAppeal": 1.2,
          "eveningAppeal": 0.1,
          "retireeAppeal": 1.8,
          "childAppeal": 1.2
        },
        "designs": [
          {
            "key": "232:1:0",
            "index": 0,
            "name": "stone obelisk on a stepped plinth in a railed green with a flag",
            "height": 0.84,
            "draft": true,
            "ops": 20,
            "attrs": {
              "venueType": "library",
              "openHours": [
                9,
                18
              ],
              "visitorCapacity": 40,
              "ticket": 4,
              "stay": [
                0.5,
                1.5
              ],
              "leisureValue": 4,
              "radius": 16,
              "dayAppeal": 1.2,
              "eveningAppeal": 0.1,
              "retireeAppeal": 1.8,
              "childAppeal": 1.2
            },
            "author": "docs example"
          }
        ]
      }
    ],
    "draft": true,
    "blurb": "A stone obelisk on a stepped plinth in a railed green with a flag: the town's quiet place to remember, where people stop on the way past.",
    "howTo": "One tile on a corner or square, its front on the street. Visitors come by to pay their respects, mostly in the daytime and mostly the older ones.",
    "landmark": true,
    "tags": [
      "draft",
      "memorial"
    ]
  }
];

export const CATALOGUE_HASH = '2dfa3b89';
